import React, { Component, createRef, PureComponent, createElement, Children, isValidElement, cloneElement } from 'react';
import PropTypes__default, { string, oneOf, oneOfType, func, element, bool } from 'prop-types';
import moment$1__default, { isMoment } from 'moment';
import ReactDOM, { findDOMNode, createPortal } from 'react-dom';
import memoize from 'lodash/memoize';
import cloneDeep$1 from 'lodash/cloneDeep';
import { cloneDeep } from 'lodash';
import isEqual$1 from 'lodash/isEqual';
import { withRouter } from 'react-router-dom';
import isFunction$1 from 'lodash/isFunction';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function _typeof2(obj) {
        return typeof obj;
      };
    } else {
      _typeof2 = function _typeof2(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof2(obj);
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return _typeof2(obj);
      };
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
      };
    }

    return _typeof(obj);
  }

  module.exports = _typeof;
});

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;
var getPrototypeOf = createCommonjsModule(function (module) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  module.exports = _getPrototypeOf;
});
var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  module.exports = _setPrototypeOf;
});

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".btn-content {\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.21429em; }\n\n.title-main {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 3rem;\n  text-transform: capitalize;\n  color: #787878; }\n\n.title-main-subtitle {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 2.25rem;\n  text-transform: uppercase;\n  color: #ff5859; }\n\n.title-form {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 1.25rem;\n  text-transform: uppercase;\n  color: #3fd4ad; }\n\n.title-form-subtitle {\n  font-family: 'Lato Light', sans-serif;\n  font-weight: 400;\n  font-size: 2rem;\n  color: #000000; }\n\n.title-card {\n  font-family: 'Lato Medium', sans-serif;\n  font-weight: 400;\n  font-size: 1.5rem;\n  line-height: 1.375em;\n  color: #000000; }\n\n.title-card-subtitle {\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  color: #787878; }\n\n.paragraph {\n  margin-bottom: 1.5rem;\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.78947em;\n  color: #787878; }\n  .paragraph_large {\n    font-size: 1.5rem; }\n\n._conflower-blue._filled.btn-round,\n._conflower-blue._filled.btn-square, ._shamrock._filled.btn-round,\n._shamrock._filled.btn-square, ._orange._filled.btn-round,\n._orange._filled.btn-square, ._pomegranate._filled.btn-round,\n._pomegranate._filled.btn-square, ._persimmon._filled.btn-round,\n._persimmon._filled.btn-square {\n  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12); }\n\n._conflower-blue.btn-round:not(._filled):not([disabled]):hover,\n._conflower-blue.btn-square:not(._filled):not([disabled]):hover, ._conflower-blue._filled.btn-round:not([disabled]):hover,\n._conflower-blue._filled.btn-square:not([disabled]):hover, ._shamrock.btn-round:not(._filled):not([disabled]):hover,\n._shamrock.btn-square:not(._filled):not([disabled]):hover, ._shamrock._filled.btn-round:not([disabled]):hover,\n._shamrock._filled.btn-square:not([disabled]):hover, ._orange.btn-round:not(._filled):not([disabled]):hover,\n._orange.btn-square:not(._filled):not([disabled]):hover, ._orange._filled.btn-round:not([disabled]):hover,\n._orange._filled.btn-square:not([disabled]):hover, ._pomegranate.btn-round:not(._filled):not([disabled]):hover,\n._pomegranate.btn-square:not(._filled):not([disabled]):hover, ._persimmon.btn-round:not(._filled):not([disabled]):hover,\n._persimmon.btn-square:not(._filled):not([disabled]):hover, ._pomegranate._filled.btn-round:not([disabled]):hover,\n._pomegranate._filled.btn-square:not([disabled]):hover, ._persimmon._filled.btn-round:not([disabled]):hover,\n._persimmon._filled.btn-square:not([disabled]):hover {\n  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12); }\n\n._conflower-blue.btn-round:not(._filled):not([disabled]):hover:active,\n._conflower-blue.btn-square:not(._filled):not([disabled]):hover:active, ._conflower-blue._filled.btn-round:not([disabled]):hover:active,\n._conflower-blue._filled.btn-square:not([disabled]):hover:active, ._shamrock.btn-round:not(._filled):not([disabled]):hover:active,\n._shamrock.btn-square:not(._filled):not([disabled]):hover:active, ._shamrock._filled.btn-round:not([disabled]):hover:active,\n._shamrock._filled.btn-square:not([disabled]):hover:active, ._orange.btn-round:not(._filled):not([disabled]):hover:active,\n._orange.btn-square:not(._filled):not([disabled]):hover:active, ._orange._filled.btn-round:not([disabled]):hover:active,\n._orange._filled.btn-square:not([disabled]):hover:active, ._pomegranate.btn-round:not(._filled):not([disabled]):hover:active,\n._pomegranate.btn-square:not(._filled):not([disabled]):hover:active, ._persimmon.btn-round:not(._filled):not([disabled]):hover:active,\n._persimmon.btn-square:not(._filled):not([disabled]):hover:active, ._pomegranate._filled.btn-round:not([disabled]):hover:active,\n._pomegranate._filled.btn-square:not([disabled]):hover:active, ._persimmon._filled.btn-round:not([disabled]):hover:active,\n._persimmon._filled.btn-square:not([disabled]):hover:active {\n  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12); }\n\n@keyframes hover-ripples {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.btn-round,\n.btn-square {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 7.125em;\n  height: 1.5625em;\n  padding: 0 2em;\n  outline: none;\n  background: #fff;\n  transition: border 0.25s, box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1), background 0.25s, opacity 0.25s, color 0.25s;\n  cursor: pointer;\n  font-size: 1rem;\n  text-decoration: none;\n  white-space: nowrap; }\n  .btn-round:focus,\n  .btn-square:focus {\n    outline: none; }\n  .btn-round[class*=\"btn-\"][disabled],\n  .btn-square[class*=\"btn-\"][disabled] {\n    opacity: .5;\n    cursor: default; }\n  ._conflower-blue.btn-round:not(._filled),\n  ._conflower-blue.btn-square:not(._filled) {\n    border: 0.0625em solid #6075ff;\n    background: transparent;\n    color: #6075ff; }\n    ._conflower-blue.btn-round:not(._filled):not([disabled]):hover,\n    ._conflower-blue.btn-square:not(._filled):not([disabled]):hover {\n      border-color: #4d5ecc;\n      background: transparent;\n      color: #4d5ecc; }\n      ._conflower-blue.btn-round:not(._filled):not([disabled]):hover._ripple-hover:before,\n      ._conflower-blue.btn-square:not(._filled):not([disabled]):hover._ripple-hover:before {\n        content: '';\n        position: absolute;\n        top: -0.1875em;\n        left: -0.1875em;\n        right: -0.1875em;\n        bottom: -0.1875em;\n        border-radius: 0.1875em;\n        border: 0.0625em solid #4d5ecc;\n        pointer-events: none;\n        animation: hover-ripples 1s forwards; }\n  ._conflower-blue._filled.btn-round,\n  ._conflower-blue._filled.btn-square {\n    border: none;\n    background: #6075ff;\n    color: #fff; }\n    ._conflower-blue._filled.btn-round:not([disabled]):hover,\n    ._conflower-blue._filled.btn-square:not([disabled]):hover {\n      border-color: #fff;\n      background: #4d5ecc;\n      color: #fff; }\n      ._conflower-blue._filled.btn-round:not([disabled]):hover._ripple-hover:before,\n      ._conflower-blue._filled.btn-square:not([disabled]):hover._ripple-hover:before {\n        content: '';\n        position: absolute;\n        top: -0.1875em;\n        left: -0.1875em;\n        right: -0.1875em;\n        bottom: -0.1875em;\n        border-radius: 0.1875em;\n        border: 0.0625em solid #fff;\n        pointer-events: none;\n        animation: hover-ripples 1s forwards; }\n  ._shamrock.btn-round:not(._filled),\n  ._shamrock.btn-square:not(._filled) {\n    border: 0.0625em solid #3fd4ad;\n    background: transparent;\n    color: #3fd4ad; }\n    ._shamrock.btn-round:not(._filled):not([disabled]):hover,\n    ._shamrock.btn-square:not(._filled):not([disabled]):hover {\n      border-color: #0FB68A;\n      background: transparent;\n      color: #0FB68A; }\n      ._shamrock.btn-round:not(._filled):not([disabled]):hover._ripple-hover:before,\n      ._shamrock.btn-square:not(._filled):not([disabled]):hover._ripple-hover:before {\n        content: '';\n        position: absolute;\n        top: -0.1875em;\n        left: -0.1875em;\n        right: -0.1875em;\n        bottom: -0.1875em;\n        border-radius: 0.1875em;\n        border: 0.0625em solid #0FB68A;\n        pointer-events: none;\n        animation: hover-ripples 1s forwards; }\n  ._shamrock._filled.btn-round,\n  ._shamrock._filled.btn-square {\n    border: none;\n    background: #3fd4ad;\n    color: #fff; }\n    ._shamrock._filled.btn-round:not([disabled]):hover,\n    ._shamrock._filled.btn-square:not([disabled]):hover {\n      border-color: #fff;\n      background: #0FB68A;\n      color: #fff; }\n      ._shamrock._filled.btn-round:not([disabled]):hover._ripple-hover:before,\n      ._shamrock._filled.btn-square:not([disabled]):hover._ripple-hover:before {\n        content: '';\n        position: absolute;\n        top: -0.1875em;\n        left: -0.1875em;\n        right: -0.1875em;\n        bottom: -0.1875em;\n        border-radius: 0.1875em;\n        border: 0.0625em solid #fff;\n        pointer-events: none;\n        animation: hover-ripples 1s forwards; }\n  ._orange.btn-round:not(._filled),\n  ._orange.btn-square:not(._filled) {\n    border: 0.0625em solid #ffa300;\n    background: transparent;\n    color: #ffa300; }\n    ._orange.btn-round:not(._filled):not([disabled]):hover,\n    ._orange.btn-square:not(._filled):not([disabled]):hover {\n      border-color: #BB7C0D;\n      background: transparent;\n      color: #BB7C0D; }\n      ._orange.btn-round:not(._filled):not([disabled]):hover._ripple-hover:before,\n      ._orange.btn-square:not(._filled):not([disabled]):hover._ripple-hover:before {\n        content: '';\n        position: absolute;\n        top: -0.1875em;\n        left: -0.1875em;\n        right: -0.1875em;\n        bottom: -0.1875em;\n        border-radius: 0.1875em;\n        border: 0.0625em solid #BB7C0D;\n        pointer-events: none;\n        animation: hover-ripples 1s forwards; }\n  ._orange._filled.btn-round,\n  ._orange._filled.btn-square {\n    border: none;\n    background: #ffa300;\n    color: #fff; }\n    ._orange._filled.btn-round:not([disabled]):hover,\n    ._orange._filled.btn-square:not([disabled]):hover {\n      border-color: #fff;\n      background: #BB7C0D;\n      color: #fff; }\n      ._orange._filled.btn-round:not([disabled]):hover._ripple-hover:before,\n      ._orange._filled.btn-square:not([disabled]):hover._ripple-hover:before {\n        content: '';\n        position: absolute;\n        top: -0.1875em;\n        left: -0.1875em;\n        right: -0.1875em;\n        bottom: -0.1875em;\n        border-radius: 0.1875em;\n        border: 0.0625em solid #fff;\n        pointer-events: none;\n        animation: hover-ripples 1s forwards; }\n  ._pomegranate.btn-round:not(._filled),\n  ._pomegranate.btn-square:not(._filled), ._persimmon.btn-round:not(._filled),\n  ._persimmon.btn-square:not(._filled) {\n    border: 0.0625em solid #f44336;\n    background: transparent;\n    color: #f44336; }\n    ._pomegranate.btn-round:not(._filled):not([disabled]):hover,\n    ._pomegranate.btn-square:not(._filled):not([disabled]):hover, ._persimmon.btn-round:not(._filled):not([disabled]):hover,\n    ._persimmon.btn-square:not(._filled):not([disabled]):hover {\n      border-color: #D93536;\n      background: transparent;\n      color: #D93536; }\n      ._pomegranate.btn-round:not(._filled):not([disabled]):hover._ripple-hover:before,\n      ._pomegranate.btn-square:not(._filled):not([disabled]):hover._ripple-hover:before, ._persimmon.btn-round:not(._filled):not([disabled]):hover._ripple-hover:before,\n      ._persimmon.btn-square:not(._filled):not([disabled]):hover._ripple-hover:before {\n        content: '';\n        position: absolute;\n        top: -0.1875em;\n        left: -0.1875em;\n        right: -0.1875em;\n        bottom: -0.1875em;\n        border-radius: 0.1875em;\n        border: 0.0625em solid #D93536;\n        pointer-events: none;\n        animation: hover-ripples 1s forwards; }\n  ._pomegranate._filled.btn-round,\n  ._pomegranate._filled.btn-square, ._persimmon._filled.btn-round,\n  ._persimmon._filled.btn-square {\n    border: none;\n    background: #f44336;\n    color: #fff; }\n    ._pomegranate._filled.btn-round:not([disabled]):hover,\n    ._pomegranate._filled.btn-square:not([disabled]):hover, ._persimmon._filled.btn-round:not([disabled]):hover,\n    ._persimmon._filled.btn-square:not([disabled]):hover {\n      border-color: #fff;\n      background: #D93536;\n      color: #fff; }\n      ._pomegranate._filled.btn-round:not([disabled]):hover._ripple-hover:before,\n      ._pomegranate._filled.btn-square:not([disabled]):hover._ripple-hover:before, ._persimmon._filled.btn-round:not([disabled]):hover._ripple-hover:before,\n      ._persimmon._filled.btn-square:not([disabled]):hover._ripple-hover:before {\n        content: '';\n        position: absolute;\n        top: -0.1875em;\n        left: -0.1875em;\n        right: -0.1875em;\n        bottom: -0.1875em;\n        border-radius: 0.1875em;\n        border: 0.0625em solid #fff;\n        pointer-events: none;\n        animation: hover-ripples 1s forwards; }\n  ._md.btn-round,\n  ._md.btn-square {\n    padding: 0 2.5em;\n    min-width: 4.8125em;\n    height: 1.875em; }\n  ._lg.btn-round,\n  ._lg.btn-square {\n    padding: 0 2.5em;\n    min-width: 5.9375em;\n    height: 2.5em; }\n\n.btn-round__prefix,\n.btn-square__prefix {\n  position: absolute;\n  top: 50%;\n  left: 0.625em;\n  width: 0.75em;\n  display: flex;\n  justify-content: center;\n  transform: translateY(-50%);\n  font-size: 1.28571em; }\n\n.btn-round._md .btn-round__prefix,\n.btn-round._lg .btn-round__prefix,\n.btn-square._md .btn-round__prefix,\n.btn-square._lg .btn-round__prefix, .btn-round._md\n.btn-square__prefix,\n.btn-round._lg\n.btn-square__prefix,\n.btn-square._md\n.btn-square__prefix,\n.btn-square._lg\n.btn-square__prefix {\n  left: 1.11111em;\n  transform: translateX(-50%) translateY(-50%); }\n\n.btn-round._md .btn-content, .btn-round._lg .btn-content,\n.btn-square._md .btn-content,\n.btn-square._lg .btn-content {\n  padding-bottom: 0.0625rem; }\n\n.btn-square {\n  border-radius: 0.25em; }\n\n.btn-round {\n  border-radius: 0.78125em; }\n  .btn-round._md {\n    border-radius: 0.9375em; }\n  .btn-round._lg {\n    border-radius: 1.25em; }\n\n.btn-circle {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 0;\n  height: 2.5em;\n  width: 2.5em;\n  border: 0.0625em solid #a2a2a2;\n  border-radius: 50%;\n  background: transparent;\n  cursor: pointer;\n  font-size: 1rem; }\n  .btn-circle:focus {\n    outline: none; }\n  .btn-circle svg {\n    fill: #a2a2a2;\n    width: 1.5em;\n    height: auto;\n    position: relative; }\n  .btn-circle._size-14 svg {\n    width: 0.875em; }\n  .btn-circle._size-15 svg {\n    width: 0.9375em; }\n  .btn-circle._size-16 svg {\n    width: 1em; }\n  .btn-circle._size-17 svg {\n    width: 1.0625em; }\n  .btn-circle._size-18 svg {\n    width: 1.125em; }\n  .btn-circle._size-19 svg {\n    width: 1.1875em; }\n  .btn-circle._size-20 svg {\n    width: 1.25em; }\n  .btn-circle._size-21 svg {\n    width: 1.3125em; }\n  .btn-circle._size-22 svg {\n    width: 1.375em; }\n  .btn-circle._size-23 svg {\n    width: 1.4375em; }\n  .btn-circle._size-24 svg {\n    width: 1.5em; }\n  .btn-circle:hover:not(._outline) {\n    background-color: #a2a2a2; }\n    .btn-circle:hover:not(._outline) svg {\n      fill: #787878; }\n  .btn-circle._outline {\n    border: none; }\n    .btn-circle._outline:before {\n      content: \"\";\n      display: block;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      transform: scale(0);\n      opacity: 0;\n      transition: transform .3s,opacity .3s;\n      background-color: #f4f4f4;\n      border-radius: 50%;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0; }\n    .btn-circle._outline._inverse:before {\n      background-color: #a2a2a2; }\n    .btn-circle._outline:hover svg {\n      fill: #787878; }\n    .btn-circle._outline:hover:before {\n      transform: scale(1);\n      opacity: 1; }\n    .btn-circle._outline:active {\n      border: 0.0625em solid #787878; }\n  .btn-circle._inverse {\n    border-color: #787878;\n    background-color: transparent; }\n    .btn-circle._inverse svg {\n      fill: #ffffff; }\n    .btn-circle._inverse:hover:not(._outline) {\n      background-color: #a2a2a2; }\n      .btn-circle._inverse:hover:not(._outline) svg {\n        fill: #787878; }\n  .btn-circle .btn-content {\n    font-size: 1em; }\n\n.btn-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none; }\n";
styleInject(css);
var css$1 = ".svg-icon {\n  fill: #a2a2a2;\n  width: 1.5em;\n  height: 1.5em;\n  font-size: 1rem; }\n  .svg-icon._default {\n    width: auto;\n    height: auto; }\n  .svg-icon._size-14 {\n    width: 0.875em;\n    height: auto; }\n  .svg-icon._size-15 {\n    width: 0.9375em;\n    height: auto; }\n  .svg-icon._size-16 {\n    width: 1em;\n    height: auto; }\n  .svg-icon._size-17 {\n    width: 1.0625em;\n    height: auto; }\n  .svg-icon._size-18 {\n    width: 1.125em;\n    height: auto; }\n  .svg-icon._size-19 {\n    width: 1.1875em;\n    height: auto; }\n  .svg-icon._size-20 {\n    width: 1.25em;\n    height: auto; }\n  .svg-icon._size-21 {\n    width: 1.3125em;\n    height: auto; }\n  .svg-icon._size-22 {\n    width: 1.375em;\n    height: auto; }\n  .svg-icon._size-23 {\n    width: 1.4375em;\n    height: auto; }\n  .svg-icon._size-24 {\n    width: 1.5em;\n    height: auto; }\n";
styleInject(css$1);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.65.136c.336.005.663.11.938.303a16.7 16.7 0 011.787 1.52c1.166 1.157 2.3 2.348 3.442 3.532.167.18.313.386.47.58.41.505.626 1.14.608 1.79 0 .375 0 .75-.004 1.127l-.011.568v10.727c0 2.073-1.363 3.494-3.378 3.584l-.204.004h-2.713c-2.17.004-8.377.047-9.284-.067a3.278 3.278 0 01-2.798-3.094l-.003-.18V3.552A3.43 3.43 0 015.927.136L8.5.12h2.574zm5.222 18.874H4.554c-.006.912-.097 1.978.78 2.528.277.167.59.265.912.286.566.023 6.063.006 8.223 0h2.725a1.75 1.75 0 001.674-1.66v-.163l.004-.99zM6.364 11.543h-1.85v5.7h1.058v-2h.792c.329.007.656-.04.97-.14.253-.078.488-.209.69-.382.182-.168.322-.376.41-.608.095-.24.143-.497.14-.756a1.987 1.987 0 00-.135-.732 1.519 1.519 0 00-.4-.575 1.966 1.966 0 00-.69-.373 3.254 3.254 0 00-.985-.134zm5.183-.009H9.381v5.693l2.163.003c.403.007.803-.063 1.179-.206.342-.13.652-.33.911-.587.256-.26.456-.57.587-.911a3.25 3.25 0 000-2.297 2.57 2.57 0 00-1.495-1.482 3.108 3.108 0 00-1.179-.213zm7.4 0h-3.584v5.684h1.063v-2.315h2.127v-.835l-2.127-.01v-1.682h2.522v-.842zm-7.4.842c.257-.005.513.042.75.14.217.086.41.221.566.394.162.182.285.396.358.63.166.546.166 1.13 0 1.676a1.723 1.723 0 01-.358.629 1.519 1.519 0 01-.565.395 1.953 1.953 0 01-.75.14h-1.104v-4.004zm-5.183-.01c.173-.003.345.02.51.067.133.04.255.108.36.198a.823.823 0 01.209.304c.05.131.075.272.073.413.002.148-.023.295-.073.434a.842.842 0 01-.213.331 1 1 0 01-.361.207 1.577 1.577 0 01-.505.085h-.792v-2.039zM6.331 2.18a1.744 1.744 0 00-1.808 1.71c-.02 1.492-.006 3.168-.001 4.74l.001.93 14.306.005c0-.33.018-.635 0-.938-.04-.59-.278-.852-.822-.887l-.132-.003h-3.478c-.754 0-1.009-.256-1.024-1.021-.021-1.1-.042-2.476-.064-3.576-.009-.574-.313-.96-.79-.96a323.23 323.23 0 00-6.188 0zm3.196 1.461V6.31h1.343l.015.042-2.084 1.89-2.309-1.923h1.37V3.64h1.665zm5.733.63v1.68h1.725L15.26 4.27z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var _ref$1 = /*#__PURE__*/React.createElement("path", {
  d: "M6.745 6.261h1.384V3.558h1.68v2.694h1.339l.018.043-2.105 1.908-2.316-1.942zM21.288 7.82c-.003.567-.003 1.135-.015 1.706v10.839c0 2.163-1.47 3.624-3.618 3.624h-2.148c-1.224-.01-8.946.061-9.968-.068a3.31 3.31 0 01-2.829-3.307V3.469A3.464 3.464 0 016.171.017c2.599-.021 5.198-.024 7.796 0 .34.005.67.112.948.307.638.468 1.24.98 1.804 1.534 1.182 1.17 2.326 2.372 3.477 3.568.171.181.319.39.478.586.415.51.632 1.151.614 1.808zm-5.695-3.627V5.89h1.74l-1.74-1.697zM5.837 14.855l.006-.01c-.1-.272-.15-.56-.15-.85-.006-.29.038-.579.128-.855.074-.234.195-.45.356-.635.151-.173.339-.309.55-.4a1.82 1.82 0 01.705-.134 2.136 2.136 0 01.706.116c.08.031.156.068.23.11l.175.108c.044.031.09.059.138.083a.24.24 0 00.123.034.255.255 0 00.138-.034.307.307 0 00.08-.083l.358-.497a2.617 2.617 0 00-.828-.54 2.826 2.826 0 00-1.114-.208 2.967 2.967 0 00-1.15.217 2.67 2.67 0 00-1.476 1.535c-.142.38-.213.782-.209 1.187-.004.4.061.8.194 1.178.12.341.31.655.555.92.244.264.54.473.871.614a2.9 2.9 0 001.148.218c.42.012.839-.067 1.227-.23.336-.15.631-.377.862-.663l-.423-.457a.202.202 0 00-.154-.067.193.193 0 00-.092.021.454.454 0 00-.083.058 1.657 1.657 0 01-.546.335c-.105.035-.214.06-.325.073a3.04 3.04 0 01-.396.025 1.69 1.69 0 01-.68-.138 1.534 1.534 0 01-.553-.396 1.896 1.896 0 01-.371-.635zm13.401 5.216l.007-1H4.793c-.003.92-.098 1.997.789 2.552.28.168.595.267.92.289.66.027 7.873 0 9.027 0h1.868a1.767 1.767 0 001.841-1.841zm-6.75-5.216l.019-.015a.57.57 0 01.132.386.782.782 0 01-.249.614 1.052 1.052 0 01-.709.215 1.479 1.479 0 01-.509-.08 2.455 2.455 0 01-.371-.181c-.104-.068-.196-.126-.273-.181a.371.371 0 00-.215-.083.267.267 0 00-.135.04.337.337 0 00-.104.092l-.307.512c.115.116.243.219.38.307.147.093.3.173.46.24.165.066.336.116.51.15.178.037.359.055.54.055.289.004.576-.045.847-.144.229-.09.438-.226.613-.4a1.66 1.66 0 00.39-.588c.09-.233.137-.48.135-.73.006-.21-.033-.42-.113-.614a1.325 1.325 0 00-.307-.423 1.84 1.84 0 00-.424-.286 4.565 4.565 0 00-.49-.2c-.166-.054-.329-.11-.488-.159a2.586 2.586 0 01-.424-.172.89.89 0 01-.307-.23.515.515 0 01-.113-.337.758.758 0 01.055-.292.614.614 0 01.169-.227.825.825 0 01.282-.15c.126-.036.256-.054.387-.052a1.347 1.347 0 01.733.2c.092.048.169.094.233.134.053.038.116.06.181.062a.224.224 0 00.132-.037.322.322 0 00.101-.123l.267-.503a2.148 2.148 0 00-.73-.445 2.715 2.715 0 00-.939-.16 2.17 2.17 0 00-.8.142 1.737 1.737 0 00-.587.368 1.583 1.583 0 00-.49 1.138c-.006.226.032.451.113.663.07.168.174.32.307.445.124.119.267.217.423.291.158.073.32.137.485.19l.457.163c.147.041.29.097.427.166a.899.899 0 01.306.239zm1.264-3.74l2.32 5.74h.963l2.32-5.74h-.862a.34.34 0 00-.227.077.38.38 0 00-.126.165l-1.347 3.501a4.896 4.896 0 00-.224.804 7.116 7.116 0 00-.117-.427 4.838 4.838 0 00-.131-.377l-1.354-3.5a.393.393 0 00-.131-.176.359.359 0 00-.224-.067h-.86zm-8.998-1.59l14.46.007c0-.335.021-.642 0-.948-.04-.642-.316-.9-.96-.9H14.74c-.76 0-1.018-.257-1.034-1.03-.021-1.111-.042-2.5-.064-3.612-.012-.58-.316-.97-.798-.97a326.442 326.442 0 00-6.25 0A1.764 1.764 0 004.754 3.8c-.025 1.807 0 3.885 0 5.726z"
});

var SvgComponent$1 = function SvgComponent(props) {
  return React.createElement("svg", _extends$1({
    viewBox: "0 0 24 24"
  }, props), _ref$1);
};

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

var _ref$2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.29 6.207h1.37V3.53h1.665v2.667h1.324l.018.043-2.084 1.89z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.126 21.409c.277.166.59.264.911.285.654.04 7.796 0 8.938 0h1.85a1.75 1.75 0 001.823-1.823v-1H2.345c-.003.921-.097 1.997.781 2.538z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.868.009l2.573.015c.336.005.663.11.939.304.63.463 1.228.97 1.786 1.52 1.17 1.157 2.303 2.347 3.442 3.532.057.06.11.123.163.187l.311.394c.41.504.626 1.139.608 1.789-.003.562-.003 1.124-.016 1.689v10.733c0 2.142-1.455 3.588-3.581 3.588h-2.239c-1.509-.005-8.774.057-9.758-.067a3.278 3.278 0 01-2.801-3.275V3.442A3.43 3.43 0 013.722.024a441.25 441.25 0 017.718 0zm7.798 18.881H2.357c-.003.912-.097 1.978.781 2.528.277.166.59.264.912.285.584.025 6.363.005 8.392.001h2.395a1.75 1.75 0 001.823-1.823l.006-.99zM10.33 2.06a323.23 323.23 0 00-6.188 0 1.747 1.747 0 00-1.823 1.71c-.024 1.79 0 3.846 0 5.669l14.318.006c0-.331.021-.635 0-.939-.04-.635-.313-.89-.95-.89h-3.48c-.753 0-1.008-.255-1.023-1.02-.021-1.1-.043-2.477-.064-3.576-.012-.574-.313-.96-.79-.96zm2.722 2.099v1.68h1.723l-1.723-1.68z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.188 17h-.932a.23.23 0 01-.156-.052.437.437 0 01-.096-.116l-1.432-2.308-.034.092-.042.084-1.384 2.132a.751.751 0 01-.098.116.196.196 0 01-.142.052H2l1.944-2.96-1.864-2.8h.928c.067 0 .115.01.146.03.03.02.058.05.082.09l1.4 2.2.04-.096a.722.722 0 01.052-.1l1.304-1.988a.323.323 0 01.088-.102.195.195 0 01.116-.034h.892L5.248 14l1.94 3zm4.482-.784V17H8.342v-5.76h.936v4.976h2.392zm4.63-3.992a.353.353 0 01-.091.106.202.202 0 01-.12.034.311.311 0 01-.17-.064 3.333 3.333 0 00-.232-.142c-.092-.052-.2-.1-.326-.144a1.356 1.356 0 00-.448-.066c-.16 0-.3.02-.422.06a.878.878 0 00-.306.168.693.693 0 00-.186.254.805.805 0 00-.062.318.57.57 0 00.116.366c.077.097.18.18.306.25.127.07.271.13.434.182.163.052.329.107.498.166.17.059.335.125.498.2.163.075.307.17.434.284.127.115.229.255.306.42.077.165.116.367.116.604 0 .256-.044.496-.132.72a1.696 1.696 0 01-.998.98 2.264 2.264 0 01-.834.144 2.788 2.788 0 01-1.038-.206 2.503 2.503 0 01-.446-.238 2.239 2.239 0 01-.372-.312l.272-.448a.264.264 0 01.092-.088.245.245 0 01.124-.032c.061 0 .13.029.204.086.075.057.165.12.27.188.105.068.233.13.382.188.15.057.328.086.536.086.339 0 .6-.083.786-.248.185-.165.278-.393.278-.684a.644.644 0 00-.116-.398.942.942 0 00-.306-.258 2.198 2.198 0 00-.434-.176l-.496-.154a4.88 4.88 0 01-.496-.192 1.579 1.579 0 01-.434-.288 1.334 1.334 0 01-.306-.44 1.618 1.618 0 01-.116-.654 1.552 1.552 0 01.478-1.122c.156-.15.349-.271.578-.362.23-.09.49-.136.784-.136.33 0 .634.052.91.156.276.104.514.252.714.444l-.228.448z"
});

var SvgComponent$2 = function SvgComponent(props) {
  return React.createElement("svg", _extends$2({
    transform: "translate(3)",
    viewBox: "0 0 24 24"
  }, props), _ref$2, _ref2, _ref3, _ref4);
};

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

var _ref$3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 5v17a2 2 0 01-2 2H6a2 2 0 01-2-2V5h16zm-2 2H6v15h12V7zm-2.317-7L18 2h4v2H2V2h4l2.347-2h7.336z"
});

var SvgComponent$3 = function SvgComponent(props) {
  return React.createElement("svg", _extends$3({
    viewBox: "0 0 24 24"
  }, props), _ref$3);
};

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

var _ref$4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.476 4.001l2.168.013c.283.005.558.094.79.256.53.39 1.033.817 1.503 1.278.982.975 1.936 1.977 2.897 2.974.14.15.266.325.396.488.346.425.527.96.512 1.506v1.422h-.013v9.033c0 1.803-1.225 3.02-3.015 3.02h-2.38c-1.907.004-6.966.038-7.716-.057a2.759 2.759 0 01-2.358-2.756V6.891a2.887 2.887 0 012.884-2.877c2.166-.017 4.332-.02 6.5 0zm1.232 1.742c-1.69-.013-3.52-.02-5.208 0a1.468 1.468 0 00-1.534 1.44c-.018 1.393 0 2.98 0 4.417h.023v8.46c-.008.73-.028 1.535.66 1.967a1.7 1.7 0 00.766.24c.498.021 5.513.004 7.141.001h1.951a1.473 1.473 0 001.534-1.535v-.631l.003-8.144s-.01-.534-.026-.79c-.035-.534-.265-.749-.802-.749h-2.928c-.634 0-.849-.215-.862-.859-.017-.925-.035-2.084-.053-3.01-.008-.482-.264-.807-.665-.807zM15.835 0a1 1 0 110 2H4.26v10.543a1 1 0 01-2 0V1a1 1 0 011-1zm1.169 7.494l.013 1.406h1.452l-1.465-1.406z"
});

var SvgComponent$4 = function SvgComponent(props) {
  return React.createElement("svg", _extends$4({
    viewBox: "0 0 24 24"
  }, props), _ref$4);
};

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

var _ref$5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
});

var SvgComponent$5 = function SvgComponent(props) {
  return React.createElement("svg", _extends$5({
    viewBox: "0 0 24 24"
  }, props), _ref$5);
};

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

var _ref$6 = /*#__PURE__*/React.createElement("path", {
  d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
});

var SvgComponent$6 = function SvgComponent(props) {
  return React.createElement("svg", _extends$6({
    viewBox: "0 0 24 24"
  }, props), _ref$6);
};

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

var _ref$7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var _ref2$1 = /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z"
});

var SvgComponent$7 = function SvgComponent(props) {
  return React.createElement("svg", _extends$7({
    viewBox: "0 0 24 24"
  }, props), _ref$7, _ref2$1);
};

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

var _ref$8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var _ref2$2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
});

var SvgComponent$8 = function SvgComponent(props) {
  return React.createElement("svg", _extends$8({
    viewBox: "0 0 24 24"
  }, props), _ref$8, _ref2$2);
};

function _extends$9() {
  _extends$9 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$9.apply(this, arguments);
}

var _ref$9 = /*#__PURE__*/React.createElement("path", {
  d: "M17 0a1 1 0 011 1v3h3a1 1 0 011 1v18a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h2.5V1a1 1 0 01.883-.993L6.5 0a1 1 0 011 1v3H16V1a1 1 0 01.883-.993zm3.001 9.914a.997.997 0 01-.406.086H4v12h16zM12 13a1 1 0 011 1v1.587a1 1 0 11-2 0V14a1 1 0 011-1zm5 0a1 1 0 011 1v1.587a1 1 0 11-2 0V14a1 1 0 011-1zM7 13a1 1 0 011 1v1.587a1 1 0 11-2 0V14a1 1 0 011-1zm13-7H4v2h15.595c.145 0 .282.03.406.086L20 6z"
});

var SvgComponent$9 = function SvgComponent(props) {
  return React.createElement("svg", _extends$9({
    viewBox: "0 0 24 24"
  }, props), _ref$9);
};

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

var _ref$a = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 21c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3 3 1.35 3 3zm-3-12c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0-9c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm9 6c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0 3c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 9c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3z"
});

var SvgComponent$a = function SvgComponent(props) {
  return React.createElement("svg", _extends$a({
    viewBox: "0 0 24 24"
  }, props), _ref$a);
};

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

var _ref$b = /*#__PURE__*/React.createElement("path", {
  d: "M6 21c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3 3 1.35 3 3zM3 9c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm0-9c1.65 0 3 1.35 3 3S4.65 6 3 6 0 4.65 0 3s1.35-3 3-3zm9 6c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0 3c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm0 9c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm9-12c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0 3c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm0 9c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3z"
});

var SvgComponent$b = function SvgComponent(props) {
  return React.createElement("svg", _extends$b({
    viewBox: "0 0 24 24"
  }, props), _ref$b);
};

function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$c.apply(this, arguments);
}

var _ref$c = /*#__PURE__*/React.createElement("path", {
  d: "M17.001 21c-.827 1.776-2.526 3-4.505 3S8.818 22.776 8 21zm-5-21a2 2 0 011.985 2.249A8.002 8.002 0 0120.001 10v5.382l3.448 1.724c.944.471.608 1.894-.448 1.894h-22c-1.055 0-1.39-1.423-.447-1.894l3.447-1.724V10a8.003 8.003 0 016.017-7.752A2 2 0 0112.001 0zm0 4a6 6 0 00-6 6v6a1 1 0 01-.552.894L5.238 17h13.527l-.21-.106A1 1 0 0118 16v-6a6 6 0 00-6-6z"
});

var SvgComponent$c = function SvgComponent(props) {
  return React.createElement("svg", _extends$c({
    viewBox: "0 0 24 24"
  }, props), _ref$c);
};

function _extends$d() {
  _extends$d = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$d.apply(this, arguments);
}

var _ref$d = /*#__PURE__*/React.createElement("path", {
  d: "M11.39 0l2.52.016c.328.005.648.112.918.307.617.468 1.2.98 1.748 1.534 1.141 1.169 2.25 2.372 3.368 3.568.163.181.306.39.46.586A2.8 2.8 0 0121 7.82c0 .378 0 .756-.004 1.138l-.01.574v10.834c0 2.094-1.334 3.529-3.306 3.62l-.2.004h-2.654c-2.124.003-8.196.048-9.084-.068-1.527-.231-2.67-1.55-2.738-3.125L3 20.614V3.468C3.007 1.56 4.506.018 6.353.016L8.871 0h2.519zM6.758 1.964a1.676 1.676 0 00-1.235.481A1.782 1.782 0 005 3.516l-.011.176-.008.767c-.006.976-.002 2.005.002 3.017l.004 1.004v.54h-.021v10.1h.05l.002-.157c-.006.92-.095 1.998.764 2.553.27.169.577.268.892.289.523.022 5.334.008 7.653.002h.204l2.856-.002.158-.014c.366-.051.709-.224.975-.497.266-.272.436-.625.49-1.002l.014-.163.001-.165.003-1-.051-.002V9.423h.01l.003-.326c.004-.212.008-.417-.004-.621-.035-.55-.237-.818-.687-.883l-.118-.012-.128-.004H14.65l-.132-.004c-.635-.03-.855-.303-.87-1.027-.02-1.111-.04-2.501-.062-3.612-.009-.58-.306-.97-.773-.97a306.393 306.393 0 00-6.055 0zm6.314 6.995v3.1h2.888v1.991h-2.888v2.989h-1.925V14.05H8.088v-1.99h3.06V8.959h1.924zm2.413-4.888v1.696h1.688l-1.688-1.696z"
});

var SvgComponent$d = function SvgComponent(props) {
  return React.createElement("svg", _extends$d({
    viewBox: "0 0 24 24"
  }, props), _ref$d);
};

function _extends$e() {
  _extends$e = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$e.apply(this, arguments);
}

var _ref$e = /*#__PURE__*/React.createElement("path", {
  d: "M18 0a1 1 0 011 1v4a5 5 0 015 5v8a1 1 0 01-1 1h-4v4a1 1 0 01-1 1H6a1 1 0 01-1-1v-4H1a1 1 0 01-1-1v-8a5 5 0 015-5h1V1a1 1 0 011-1h11zm-1 16H7v6h10v-6zm2-9H5a3 3 0 00-3 3v7h3v-3a1 1 0 011-1h12a1 1 0 011 1v3h3v-7a3 3 0 00-3-3zm0 4a1 1 0 110 2 1 1 0 010-2zm-2-9H8v3h9V2z"
});

var SvgComponent$e = function SvgComponent(props) {
  return React.createElement("svg", _extends$e({
    viewBox: "0 0 24 24"
  }, props), _ref$e);
};

function _extends$f() {
  _extends$f = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$f.apply(this, arguments);
}

var _ref$f = /*#__PURE__*/React.createElement("path", {
  d: "M20.485 3.515L24 0v10H14l5.071-5.071A9.969 9.969 0 0012 2C6.477 2 2 6.477 2 12s4.477 10 10 10c4.1 0 7.625-2.468 9.168-6h2.15C21.67 20.66 17.224 24 12 24 5.373 24 0 18.627 0 12S5.373 0 12 0c3.314 0 6.314 1.343 8.485 3.515z"
});

var SvgComponent$f = function SvgComponent(props) {
  return React.createElement("svg", _extends$f({
    viewBox: "0 0 24 24"
  }, props), _ref$f);
};

function _extends$g() {
  _extends$g = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$g.apply(this, arguments);
}

var _ref$g = /*#__PURE__*/React.createElement("path", {
  d: "M11.353.127l2.573.015c.337.005.664.11.939.304.631.463 1.228.97 1.786 1.519 1.17 1.157 2.303 2.348 3.442 3.533.17.18.316.386.474.58.41.505.626 1.14.608 1.79v1.689h.015v10.715c0 2.142-1.455 3.588-3.582 3.588l-2.238-.001c-1.509-.005-8.774.058-9.759-.066a3.278 3.278 0 01-2.8-3.275V3.542a3.43 3.43 0 013.396-3.4c2.573-.021 5.146-.024 7.72 0zm1.474 2.05a324.772 324.772 0 00-6.189 0 1.747 1.747 0 00-1.823 1.71c-.02 1.657 0 3.543 0 5.25h.025v10.071c-.012.866-.034 1.823.78 2.337.277.166.59.264.912.285.601.025 6.708.004 8.561 0l2.39.001a1.75 1.75 0 001.675-1.824v-.75l.009-9.694s-.012-.635-.03-.939c-.043-.635-.317-.89-.955-.89h-3.478c-.753 0-1.009-.255-1.024-1.02-.021-1.1-.042-2.477-.064-3.576-.012-.575-.313-.96-.79-.96zm-1.823 6.556c.064-.009.115-.015.115.08.067.592.143 1.181.219 1.77.015.107-.06.092-.106.092a2.95 2.95 0 00-.772.218 3.147 3.147 0 00-1.683 1.705 3.214 3.214 0 002.32 4.384 3.187 3.187 0 003.607-1.908c.245-.581.31-1.223.185-1.841l-1.822.802c.097-.31.185-.587.273-.89.306-.979.61-1.957.911-2.935.022-.058.025-.094.104-.058l3.5 1.644.145.076-.796.364c-.124.052-.27.119-.373.155-.104.037-.113.088-.089.186a5.146 5.146 0 010 2.533 5.201 5.201 0 01-4.037 3.795 5.165 5.165 0 11-1.701-10.172zm4.545-4.456v1.68h1.722l-1.722-1.68z"
});

var SvgComponent$g = function SvgComponent(props) {
  return React.createElement("svg", _extends$g({
    viewBox: "0 0 24 24"
  }, props), _ref$g);
};

function _extends$h() {
  _extends$h = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$h.apply(this, arguments);
}

var _ref$h = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.002a10.658 10.658 0 019.622 6c-1.8 3.676-5.487 6-9.622 6a10.658 10.658 0 01-9.622-6 10.658 10.658 0 019.622-6zm0-2.182c-5.455 0-10.113 3.393-12 8.182 1.887 4.789 6.545 8.182 12 8.182s10.113-3.393 12-8.182c-1.887-4.79-6.545-8.182-12-8.182zm0 5.455a2.727 2.727 0 110 5.454 2.727 2.727 0 010-5.454zm0-2.182a4.916 4.916 0 00-4.91 4.909A4.916 4.916 0 0012 16.91 4.916 4.916 0 0016.91 12 4.916 4.916 0 0012 7.094z"
});

var SvgComponent$h = function SvgComponent(props) {
  return React.createElement("svg", _extends$h({
    viewBox: "0 0 24 24"
  }, props), _ref$h);
};

function _extends$i() {
  _extends$i = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$i.apply(this, arguments);
}

var _ref$i = /*#__PURE__*/React.createElement("path", {
  d: "M.292.292a.997.997 0 011.41 0L12 10.59 22.297.292A.998.998 0 0123.614.21l.094.083a.997.997 0 010 1.41L13.41 12l10.298 10.297c.36.36.387.926.083 1.317l-.083.094a.997.997 0 01-1.41 0L12 13.41 1.703 23.708a.998.998 0 01-1.317.083l-.094-.083a.997.997 0 010-1.41L10.59 12 .292 1.703A.998.998 0 01.21.386z"
});

var SvgComponent$i = function SvgComponent(props) {
  return React.createElement("svg", _extends$i({
    viewBox: "0 0 24 24"
  }, props), _ref$i);
};

function _extends$j() {
  _extends$j = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$j.apply(this, arguments);
}

var _ref$j = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-1.846c5.608 0 10.154-4.546 10.154-10.154S17.608 1.846 12 1.846 1.846 6.392 1.846 12 6.392 22.154 12 22.154zm-.923-5.539v-3.692H7.385a.923.923 0 110-1.846h3.692V7.385a.923.923 0 111.846 0v3.692h3.692a.923.923 0 110 1.846h-3.692v3.692a.923.923 0 11-1.846 0z"
});

var SvgComponent$j = function SvgComponent(props) {
  return React.createElement("svg", _extends$j({
    viewBox: "0 0 24 24"
  }, props), _ref$j);
};

function _extends$k() {
  _extends$k = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$k.apply(this, arguments);
}

var _ref$k = /*#__PURE__*/React.createElement("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
});

var _ref2$3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var SvgComponent$k = function SvgComponent(props) {
  return React.createElement("svg", _extends$k({
    viewBox: "0 0 24 24"
  }, props), _ref$k, _ref2$3);
};

function _extends$l() {
  _extends$l = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$l.apply(this, arguments);
}

var _ref$l = /*#__PURE__*/React.createElement("path", {
  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
});

var _ref2$4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var SvgComponent$l = function SvgComponent(props) {
  return React.createElement("svg", _extends$l({
    viewBox: "0 0 24 24"
  }, props), _ref$l, _ref2$4);
};

function _extends$m() {
  _extends$m = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$m.apply(this, arguments);
}

var _ref$m = /*#__PURE__*/React.createElement("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
});

var _ref2$5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var SvgComponent$m = function SvgComponent(props) {
  return React.createElement("svg", _extends$m({
    viewBox: "0 0 24 24"
  }, props), _ref$m, _ref2$5);
};

function _extends$n() {
  _extends$n = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$n.apply(this, arguments);
}

var _ref$n = /*#__PURE__*/React.createElement("path", {
  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
});

var _ref2$6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var SvgComponent$n = function SvgComponent(props) {
  return React.createElement("svg", _extends$n({
    viewBox: "0 0 24 24"
  }, props), _ref$n, _ref2$6);
};

function _extends$o() {
  _extends$o = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$o.apply(this, arguments);
}

var _ref$o = /*#__PURE__*/React.createElement("path", {
  d: "M.217 8.19a.72.72 0 00-.216.517.65.65 0 00.192.494l3.271 3.384a.754.754 0 001.058 0L7.793 9.2a.696.696 0 00-.024-1.01.734.734 0 00-1.01.023l-2.766 2.843-2.766-2.843a.734.734 0 00-1.01-.024z"
});

var _ref2$7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.783 4.61a.72.72 0 00.216-.517.65.65 0 00-.192-.494L4.536.215a.754.754 0 00-1.058 0L.207 3.6A.696.696 0 00.23 4.61a.734.734 0 001.01-.023l2.766-2.843 2.766 2.843a.734.734 0 001.01.024z"
});

var SvgComponent$o = function SvgComponent(props) {
  return React.createElement("svg", _extends$o({
    viewBox: "0 0 8 13"
  }, props), _ref$o, _ref2$7);
};

function _extends$p() {
  _extends$p = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$p.apply(this, arguments);
}

var _ref$p = /*#__PURE__*/React.createElement("path", {
  d: "M8.293 19.707a1 1 0 01-1.414 0L.586 13.414A1.993 1.993 0 010 12.031V12a1.992 1.992 0 01.586-1.414l6.293-6.293a1 1 0 111.414 1.414L3 11h19.869c.583 0 1.063.39 1.124.891L24 12c0 .552-.507 1-1.131 1H3l5.293 5.293a1 1 0 01.083 1.32z"
});

var SvgComponent$p = function SvgComponent(props) {
  return React.createElement("svg", _extends$p({
    viewBox: "0 0 24 24"
  }, props), _ref$p);
};

function _extends$q() {
  _extends$q = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$q.apply(this, arguments);
}

var _ref$q = /*#__PURE__*/React.createElement("path", {
  d: "M4.293 8.293a1 1 0 010-1.414L10.586.586A1.993 1.993 0 0111.969 0H12a1.992 1.992 0 011.414.586l6.293 6.293a1 1 0 11-1.414 1.414L13 3v19.869c0 .583-.39 1.063-.891 1.124L12 24c-.552 0-1-.507-1-1.131V3L5.707 8.293a1 1 0 01-1.32.083z"
});

var SvgComponent$q = function SvgComponent(props) {
  return React.createElement("svg", _extends$q({
    viewBox: "0 0 24 24"
  }, props), _ref$q);
};

function _extends$r() {
  _extends$r = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$r.apply(this, arguments);
}

var _ref$r = /*#__PURE__*/React.createElement("path", {
  d: "M15.707 4.293a1 1 0 011.414 0l6.293 6.293c.383.383.578.882.586 1.383V12a1.992 1.992 0 01-.586 1.414l-6.293 6.293a1 1 0 11-1.414-1.414L21 13H1.131c-.583 0-1.063-.39-1.124-.891L0 12c0-.552.507-1 1.131-1H21l-5.293-5.293a1 1 0 01-.083-1.32z"
});

var SvgComponent$r = function SvgComponent(props) {
  return React.createElement("svg", _extends$r({
    viewBox: "0 0 24 24"
  }, props), _ref$r);
};

function _extends$s() {
  _extends$s = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$s.apply(this, arguments);
}

var _ref$s = /*#__PURE__*/React.createElement("path", {
  d: "M19.707 15.707a1 1 0 010 1.414l-6.293 6.293a1.993 1.993 0 01-1.383.586H12a1.992 1.992 0 01-1.414-.586l-6.293-6.293a1 1 0 111.414-1.414L11 21V1.131c0-.583.39-1.063.891-1.124L12 0c.552 0 1 .507 1 1.131V21l5.293-5.293a1 1 0 011.32-.083z"
});

var SvgComponent$s = function SvgComponent(props) {
  return React.createElement("svg", _extends$s({
    viewBox: "0 0 24 24"
  }, props), _ref$s);
};

function _extends$t() {
  _extends$t = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$t.apply(this, arguments);
}

var _ref$t = /*#__PURE__*/React.createElement("path", {
  d: "M7 10l5 5 5-5z"
});

var _ref2$8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var SvgComponent$t = function SvgComponent(props) {
  return React.createElement("svg", _extends$t({
    viewBox: "0 0 24 24"
  }, props), _ref$t, _ref2$8);
};

function _extends$u() {
  _extends$u = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$u.apply(this, arguments);
}

var _ref$u = /*#__PURE__*/React.createElement("path", {
  d: "M7 14l5-5 5 5z"
});

var _ref2$9 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var SvgComponent$u = function SvgComponent(props) {
  return React.createElement("svg", _extends$u({
    viewBox: "0 0 24 24"
  }, props), _ref$u, _ref2$9);
};

function _extends$v() {
  _extends$v = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$v.apply(this, arguments);
}

var _ref$v = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var _ref2$a = /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
});

var SvgComponent$v = function SvgComponent(props) {
  return React.createElement("svg", _extends$v({
    viewBox: "0 0 24 24"
  }, props), _ref$v, _ref2$a);
};

function _extends$w() {
  _extends$w = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$w.apply(this, arguments);
}

var _ref$w = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var _ref2$b = /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
});

var SvgComponent$w = function SvgComponent(props) {
  return React.createElement("svg", _extends$w({
    viewBox: "0 0 24 24"
  }, props), _ref$w, _ref2$b);
};

function _extends$x() {
  _extends$x = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$x.apply(this, arguments);
}

var _ref$x = /*#__PURE__*/React.createElement("path", {
  d: "M17.153 15.094h-1.084l-.385-.37a8.88 8.88 0 002.155-5.805 8.92 8.92 0 10-8.92 8.92c2.21 0 4.24-.81 5.805-2.155l.37.385v1.084L21.955 24 24 21.955l-6.847-6.86zm-8.234 0A6.167 6.167 0 012.744 8.92 6.167 6.167 0 018.92 2.744a6.167 6.167 0 016.175 6.175 6.167 6.167 0 01-6.175 6.175z"
});

var SvgComponent$x = function SvgComponent(props) {
  return React.createElement("svg", _extends$x({
    viewBox: "0 0 24 24"
  }, props), _ref$x);
};

function _extends$y() {
  _extends$y = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$y.apply(this, arguments);
}

var _ref$y = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var _ref2$c = /*#__PURE__*/React.createElement("path", {
  d: "M18.36 9l.6 3H5.04l.6-3h12.72M20 4H4v2h16V4zm0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5zM6 18v-4h6v4H6z"
});

var SvgComponent$y = function SvgComponent(props) {
  return React.createElement("svg", _extends$y({
    viewBox: "0 0 24 24"
  }, props), _ref$y, _ref2$c);
};

function _extends$z() {
  _extends$z = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$z.apply(this, arguments);
}

var _ref$z = /*#__PURE__*/React.createElement("path", {
  d: "M19.447 0c.354 0 .694.123.967.395l3.188 3.19a1.358 1.358 0 010 1.921L21.109 8 16 2.89 18.493.394c.259-.259.613-.395.954-.395zM16.1 5.714l2.122 2.122a2 2 0 010 2.828l-12.85 12.85a2 2 0 01-1.414.585h-4.12v-4.121a2 2 0 01.586-1.415L13.273 5.714a2 2 0 012.828 0zM1.838 22.1h2.121l12.85-12.85-2.122-2.12-12.85 12.849V22.1z"
});

var SvgComponent$z = function SvgComponent(props) {
  return React.createElement("svg", _extends$z({
    viewBox: "0 0 24 24"
  }, props), _ref$z);
};

function _extends$A() {
  _extends$A = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$A.apply(this, arguments);
}

var _ref$A = /*#__PURE__*/React.createElement("path", {
  d: "M1 19.5h22a1 1 0 000-2H1a1 1 0 000 2z"
});

var _ref2$d = /*#__PURE__*/React.createElement("path", {
  d: "M1 13h22a1 1 0 000-2H1a1 1 0 000 2z"
});

var _ref3$1 = /*#__PURE__*/React.createElement("path", {
  d: "M1 6.5h22a1 1 0 000-2H1a1 1 0 100 2z"
});

var SvgComponent$A = function SvgComponent(props) {
  return React.createElement("svg", _extends$A({
    viewBox: "0 0 24 24"
  }, props), _ref$A, _ref2$d, _ref3$1);
};

function _extends$B() {
  _extends$B = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$B.apply(this, arguments);
}

var _ref$B = /*#__PURE__*/React.createElement("path", {
  d: "M10.286 19.357a1 1 0 010-2h3.428a1 1 0 110 2h-3.428zM4.57 13.071a1 1 0 010-2h16a1 1 0 110 2h-16zM1 7a1 1 0 110-2h22a1 1 0 010 2H1z"
});

var SvgComponent$B = function SvgComponent(props) {
  return React.createElement("svg", _extends$B({
    viewBox: "0 0 24 24"
  }, props), _ref$B);
};

function _extends$C() {
  _extends$C = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$C.apply(this, arguments);
}

var _ref$C = /*#__PURE__*/React.createElement("path", {
  d: "M15 21c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3 3 1.35 3 3zM12 9c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm0-9c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3z"
});

var SvgComponent$C = function SvgComponent(props) {
  return React.createElement("svg", _extends$C({
    viewBox: "0 0 24 24"
  }, props), _ref$C);
};

function _extends$D() {
  _extends$D = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$D.apply(this, arguments);
}

var _ref$D = /*#__PURE__*/React.createElement("path", {
  d: "M23 16.5a1 1 0 011 1v4a1 1 0 01-1 1H1a1 1 0 01-1-1v-4a1 1 0 011-1h22zm-1 2H2v2h20v-2zM23 9a1 1 0 011 1v4a1 1 0 01-1 1H1a1 1 0 01-1-1v-4a1 1 0 011-1h22zm-1 2H2v2h20v-2zm1-9.5a1 1 0 011 1v4a1 1 0 01-1 1H1a1 1 0 01-1-1v-4a1 1 0 011-1h22zm-1 2H2v2h20v-2z"
});

var SvgComponent$D = function SvgComponent(props) {
  return React.createElement("svg", _extends$D({
    viewBox: "0 0 24 24"
  }, props), _ref$D);
};

function _extends$E() {
  _extends$E = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$E.apply(this, arguments);
}

var _ref$E = /*#__PURE__*/React.createElement("path", {
  d: "M1.768 11.461a1 1 0 00-1.536 1.28l7.315 8.783L23.74 3.672a1 1 0 00-1.482-1.344L7.611 18.476l-5.843-7.015z"
});

var SvgComponent$E = function SvgComponent(props) {
  return React.createElement("svg", _extends$E({
    viewBox: "0 0 24 24"
  }, props), _ref$E);
};

function _extends$F() {
  _extends$F = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$F.apply(this, arguments);
}

var _ref$F = /*#__PURE__*/React.createElement("path", {
  d: "M11.814 21.534l7.125-6.76a1 1 0 011.377 1.452l-7.814 7.411a1 1 0 01-1.376 0l-7.814-7.411a1 1 0 111.376-1.452l7.126 6.76zm0-19.156l-7.126 6.76a1 1 0 01-1.376-1.452L11.126.274a1 1 0 011.376 0l7.814 7.412a1 1 0 11-1.377 1.451l-7.125-6.759z"
});

var SvgComponent$F = function SvgComponent(props) {
  return React.createElement("svg", _extends$F({
    viewBox: "0 0 24 24"
  }, props), _ref$F);
};

function _extends$G() {
  _extends$G = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$G.apply(this, arguments);
}

var _ref$G = /*#__PURE__*/React.createElement("path", {
  d: "M5.706 23.189a1 1 0 01-1.451-1.054l1.202-7.009-5.092-4.964a1 1 0 01.554-1.705l7.037-1.023 3.147-6.377a1 1 0 011.794 0l3.147 6.377 7.037 1.023a1 1 0 01.554 1.705l-5.092 4.964 1.202 7.009a1 1 0 01-1.45 1.054L12 19.879l-6.294 3.31zm5.829-5.324a1 1 0 01.93 0l4.966 2.61-.948-5.53a1 1 0 01.288-.884l4.017-3.916-5.552-.807a1 1 0 01-.753-.547L12 3.76 9.517 8.79a1 1 0 01-.753.548l-5.552.807 4.017 3.916a1 1 0 01.288.885l-.948 5.53 4.966-2.611z"
});

var SvgComponent$G = function SvgComponent(props) {
  return React.createElement("svg", _extends$G({
    viewBox: "0 0 24 24"
  }, props), _ref$G);
};

function _extends$H() {
  _extends$H = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$H.apply(this, arguments);
}

var _ref$H = /*#__PURE__*/React.createElement("path", {
  d: "M19.157 13.074l-3.703-1.851a6.227 6.227 0 002.423-4.937C17.877 2.823 15.054 0 11.591 0 8.13 0 5.306 2.823 5.306 6.286a6.278 6.278 0 003.428 5.588V15.6l-2.103-.446-.114-.023a1.808 1.808 0 00-.366-.034c-.605 0-1.177.24-1.611.674l-1.6 1.623 5.817 5.817a2.645 2.645 0 001.886.789h7.2c1.12 0 2.068-.8 2.251-1.909l.915-5.382a3.42 3.42 0 00-1.852-3.635zm-.4 3.257l-.914 5.383h-7.2a.422.422 0 01-.274-.114l-4.206-4.206 4.857 1.017V6.286c0-.32.251-.572.571-.572.32 0 .572.252.572.572v6.857h2.011l3.955 1.977c.457.229.708.72.628 1.211zM7.591 6.286c0-2.206 1.795-4 4-4 2.206 0 4 1.794 4 4a3.96 3.96 0 01-1.142 2.788V6.286a2.858 2.858 0 00-5.715 0v2.788a3.96 3.96 0 01-1.143-2.788z"
});

var SvgComponent$H = function SvgComponent(props) {
  return React.createElement("svg", _extends$H({
    viewBox: "0 0 24 24"
  }, props), _ref$H);
};

function _extends$I() {
  _extends$I = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$I.apply(this, arguments);
}

var _ref$I = /*#__PURE__*/React.createElement("path", {
  d: "M11 9.5h2V18h-2V9.5zm1-1A1.25 1.25 0 1112 6a1.25 1.25 0 010 2.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
});

var SvgComponent$I = function SvgComponent(props) {
  return React.createElement("svg", _extends$I({
    viewBox: "0 0 24 24"
  }, props), _ref$I);
};

function _extends$J() {
  _extends$J = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$J.apply(this, arguments);
}

var _ref$J = /*#__PURE__*/React.createElement("path", {
  d: "M2 14.929h4.5V9.262H2v5.667zm0 2V21a1 1 0 001 1h3.5v-5.071H2zm20-2V9.262H8.5v5.667H22zm0 2H8.5V22H21a1 1 0 001-1v-4.071zM2 7.262h4.5V2H3a1 1 0 00-1 1v4.262zm20 0V3a1 1 0 00-1-1H8.5v5.262H22zM3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3z"
});

var SvgComponent$J = function SvgComponent(props) {
  return React.createElement("svg", _extends$J({
    viewBox: "0 0 24 24"
  }, props), _ref$J);
};

function _extends$K() {
  _extends$K = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$K.apply(this, arguments);
}

var _ref$K = /*#__PURE__*/React.createElement("path", {
  d: "M3 0h5a3 3 0 013 3v5a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm0 2a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1V3a1 1 0 00-1-1H3zm0 11h5a3 3 0 013 3v5a3 3 0 01-3 3H3a3 3 0 01-3-3v-5a3 3 0 013-3zm0 2a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1v-5a1 1 0 00-1-1H3zM16 0h5a3 3 0 013 3v5a3 3 0 01-3 3h-5a3 3 0 01-3-3V3a3 3 0 013-3zm0 2a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1V3a1 1 0 00-1-1h-5zm0 11h5a3 3 0 013 3v5a3 3 0 01-3 3h-5a3 3 0 01-3-3v-5a3 3 0 013-3zm0 2a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1v-5a1 1 0 00-1-1h-5z"
});

var SvgComponent$K = function SvgComponent(props) {
  return React.createElement("svg", _extends$K({
    viewBox: "0 0 24 24"
  }, props), _ref$K);
};

function _extends$L() {
  _extends$L = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$L.apply(this, arguments);
}

var _ref$L = /*#__PURE__*/React.createElement("path", {
  d: "M17 0a1 1 0 011 1v3h3a1 1 0 011 1v18a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h3V1a1 1 0 01.883-.993L7 0a1 1 0 011 1v3h8V1a1 1 0 01.883-.993zm3.001 9.914a.997.997 0 01-.406.086H4v12h16zM12 13c.552 0 1 .437 1 .976v1.548a.988.988 0 01-1 .976c-.552 0-1-.437-1-.976v-1.548A.988.988 0 0112 13zm8-7H4v2h15.595c.145 0 .282.03.406.086L20 6z"
});

var SvgComponent$L = function SvgComponent(props) {
  return React.createElement("svg", _extends$L({
    viewBox: "0 0 24 24"
  }, props), _ref$L);
};

function _extends$M() {
  _extends$M = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$M.apply(this, arguments);
}

var _ref$M = /*#__PURE__*/React.createElement("path", {
  d: "M12.803 18H2a2 2 0 01-2-2V5a2 2 0 012-2h15a2 2 0 012 2v4.083A6.002 6.002 0 0118 21a5.998 5.998 0 01-5.197-3zm-.72-2A6.002 6.002 0 0117 9.083V7l-7.5 4L2 7v9h10.083zM18 19c2.205 0 4-1.795 4-4s-1.795-4-4-4-4 1.795-4 4 1.795 4 4 4zM17 5H2l7.5 4L17 5zm2 9h2v2h-2v2h-2v-2h-2v-2h2v-2h2v2z"
});

var SvgComponent$M = function SvgComponent(props) {
  return React.createElement("svg", _extends$M({
    viewBox: "0 0 24 24"
  }, props), _ref$M);
};

function _extends$N() {
  _extends$N = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$N.apply(this, arguments);
}

var _ref$N = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var _ref2$e = /*#__PURE__*/React.createElement("path", {
  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
});

var SvgComponent$N = function SvgComponent(props) {
  return React.createElement("svg", _extends$N({
    viewBox: "0 0 24 24"
  }, props), _ref$N, _ref2$e);
};

function _extends$O() {
  _extends$O = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$O.apply(this, arguments);
}

var _ref$O = /*#__PURE__*/React.createElement("path", {
  d: "M22.777 15.512c.56 0 1.015.454 1.015 1.014v4.431A3.043 3.043 0 0120.749 24H3.253A3.043 3.043 0 01.21 20.957v-4.43a1.014 1.014 0 112.029 0v4.43c0 .56.454 1.014 1.014 1.014h17.496c.56 0 1.014-.454 1.014-1.014v-4.43c0-.56.454-1.015 1.014-1.015zM13.303.482l.129.118 6.371 6.372a1.012 1.012 0 01-1.336 1.516l-.095-.085-5.373-5.372L13 15.4a1 1 0 01-.883.993L12 16.4a1 1 0 01-.993-.883L11 15.4l-.001-12.367-5.37 5.37c-.366.365-.94.394-1.337.085l-.095-.085a1.013 1.013 0 01-.085-1.336l.085-.095L10.568.6c.75-.75 1.94-.789 2.735-.118z"
});

var SvgComponent$O = function SvgComponent(props) {
  return React.createElement("svg", _extends$O({
    viewBox: "0 0 24 24"
  }, props), _ref$O);
};

function _extends$P() {
  _extends$P = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$P.apply(this, arguments);
}

var _ref$P = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-1)"
}, React.createElement("g", {
  fill: "#787878",
  transform: "translate(1)"
}, React.createElement("path", {
  fillRule: "nonzero",
  d: "M23.636 0H2.364C1.064 0 0 1.05 0 2.333v14c0 1.284 1.064 2.334 2.364 2.334h5.909V21h9.454v-2.333h5.91c1.3 0 2.363-1.05 2.363-2.334v-14C26 1.05 24.936 0 23.636 0zm1 17.333h-23v-16h23v16z"
})), React.createElement("g", {
  transform: "translate(5 3)"
}, React.createElement("path", {
  fill: "#787878",
  fillRule: "nonzero",
  d: "M1 0h16a1 1 0 011 1v10a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1zm0 1v10h16V1H1z"
}), React.createElement("path", {
  stroke: "#787878",
  d: "M1 7.5L5.863 6 13 11.406"
}), React.createElement("path", {
  fill: "#787878",
  fillRule: "nonzero",
  d: "M9.955 9L18 7.797 17.045 7 9 8.203z"
}), React.createElement("circle", {
  cx: 11,
  cy: 4,
  r: 1,
  fill: "#787878"
}))));

var SvgComponent$P = function SvgComponent(props) {
  return React.createElement("svg", _extends$P({
    viewBox: "0 0 26 21"
  }, props), _ref$P);
};

function _extends$Q() {
  _extends$Q = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$Q.apply(this, arguments);
}

var _ref$Q = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#787878",
  transform: "translate(-1)"
}, React.createElement("path", {
  fillRule: "nonzero",
  d: "M24.636 0H3.364C2.064 0 1 1.05 1 2.333v14c0 1.284 1.064 2.334 2.364 2.334h5.909V21h9.454v-2.333h5.91c1.3 0 2.363-1.05 2.363-2.334v-14C27 1.05 25.936 0 24.636 0zm1 17.333h-23v-16h23v16z"
}), React.createElement("text", {
  fontFamily: "Lato-Black, Lato",
  fontSize: 8,
  fontWeight: 700,
  letterSpacing: -0.19
}, React.createElement("tspan", {
  x: 8.05,
  y: 12
}, "</>"))));

var SvgComponent$Q = function SvgComponent(props) {
  return React.createElement("svg", _extends$Q({
    viewBox: "0 0 26 21"
  }, props), _ref$Q);
};

function _extends$R() {
  _extends$R = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$R.apply(this, arguments);
}

var _ref$R = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#787878",
  fillRule: "nonzero",
  d: "M7 11V8H1v11h24V8h-5v3h1.495c.279 0 .505.448.505 1s-.226 1-.505 1H5.505C5.226 13 5 12.552 5 12s.226-1 .505-1H7zm1 0h11V1H8v10zM7 7V1a1 1 0 011-1h11a1 1 0 011 1v6h5a1 1 0 011 1v11a1 1 0 01-1 1H1a1 1 0 01-1-1V8a1 1 0 011-1h6zm4.34-1.76l1.17 1.09 3.165-2.71.65.76-3.844 3.29-1.822-1.698.682-.732z"
}));

var SvgComponent$R = function SvgComponent(props) {
  return React.createElement("svg", _extends$R({
    viewBox: "0 0 26 20"
  }, props), _ref$R);
};

function _extends$S() {
  _extends$S = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$S.apply(this, arguments);
}

var _ref$S = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("path", {
  fill: "#787878",
  fillRule: "nonzero",
  d: "M23.636 0H2.364C1.064 0 0 1.05 0 2.333v14c0 1.284 1.064 2.334 2.364 2.334h5.909V21h9.454v-2.333h5.91c1.3 0 2.363-1.05 2.363-2.334v-14C26 1.05 24.936 0 23.636 0zm1 17.333h-23v-16h23v16z"
}), React.createElement("path", {
  stroke: "#787878",
  strokeLinecap: "square",
  d: "M5.5 6.5h15.028"
}), React.createElement("path", {
  stroke: "#787878",
  strokeLinecap: "square",
  d: "M5.5 9.5H13"
})));

var SvgComponent$S = function SvgComponent(props) {
  return React.createElement("svg", _extends$S({
    viewBox: "0 0 26 21"
  }, props), _ref$S);
};

function _extends$T() {
  _extends$T = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$T.apply(this, arguments);
}

var _ref$T = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#787878",
  transform: "translate(-1)"
}, React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(1)"
}, React.createElement("path", {
  d: "M23.636 0H2.364C1.064 0 0 1.05 0 2.333v14c0 1.284 1.064 2.334 2.364 2.334h5.909V21h9.454v-2.333h5.91c1.3 0 2.363-1.05 2.363-2.334v-14C26 1.05 24.936 0 23.636 0zm1 17.333h-23v-16h23v16z"
}), React.createElement("path", {
  d: "M11 5v7l6-3.5z"
}))));

var SvgComponent$T = function SvgComponent(props) {
  return React.createElement("svg", _extends$T({
    viewBox: "0 0 26 21"
  }, props), _ref$T);
};

function _extends$U() {
  _extends$U = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$U.apply(this, arguments);
}

var _ref$U = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#787878"
}, React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M23.636 0H2.364C1.064 0 0 1.05 0 2.333v14c0 1.284 1.064 2.334 2.364 2.334h5.909V21h9.454v-2.333h5.91c1.3 0 2.363-1.05 2.363-2.334v-14C26 1.05 24.936 0 23.636 0zm1 17.333h-23v-16h23v16z"
}), React.createElement("path", {
  d: "M16.963 5.978v6.037C18.169 11.467 19 10.327 19 9c0-1.327-.831-2.468-2.037-3.022zM8 6.75v4.5h3.26L15.332 15V3L11.26 6.75H8zm5.704-.128v4.755L11.936 9.75H9.63v-1.5h2.306l1.768-1.628z"
}))));

var SvgComponent$U = function SvgComponent(props) {
  return React.createElement("svg", _extends$U({
    viewBox: "0 0 26 21"
  }, props), _ref$U);
};

function _extends$V() {
  _extends$V = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$V.apply(this, arguments);
}

var _ref$V = /*#__PURE__*/React.createElement("path", {
  d: "M22 3.5a2 2 0 012 2v13a2 2 0 01-2 2H2a2 2 0 01-2-2v-13a2 2 0 012-2h20zM7.43 11.686L2 14.367V18.5h13.526l-1.494-1.257-.117.044-.08-.21-6.404-5.39zM22 14.255l-5.819 2.182 2.45 2.063H22v-4.245zM22 5.5H2v6.636l5.718-2.822 6.707 5.645L22 12.119V5.5zm-4 2a2 2 0 110 4 2 2 0 010-4z"
});

var SvgComponent$V = function SvgComponent(props) {
  return React.createElement("svg", _extends$V({
    viewBox: "0 0 24 24"
  }, props), _ref$V);
};

function _extends$W() {
  _extends$W = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$W.apply(this, arguments);
}

var _ref$W = /*#__PURE__*/React.createElement("path", {
  d: "M22 9.111a2 2 0 012 2v7a2 2 0 01-2 2h-.326v.172c0 2.073-1.362 3.494-3.378 3.584l-.203.004H15.38c-2.171.004-8.38.047-9.284-.067a3.278 3.278 0 01-2.798-3.094l-.003-.18-.001-.419H2a2 2 0 01-2-2v-7a2 2 0 012-2h20zm-2.341 11H5.377c.05.508.197.983.616 1.316l.145.102c.277.166.59.264.912.286.584.024 6.363.005 8.392 0h2.395a1.75 1.75 0 001.823-1.66l-.001-.044zm2.341-9H2v7h20v-7zm-5.47 1.153l.103.073 1.78 1.456a1 1 0 01.11 1.444l-.087.085-1.78 1.545a1 1 0 01-1.4-1.423l.089-.088.883-.766-.86-.705a1 1 0 011.163-1.621zm-7.994.192a1 1 0 01-.01 1.323l-.09.088-.884.766.861.704a1 1 0 01-1.163 1.622l-.102-.074-1.781-1.455a1 1 0 01-.11-1.444l.088-.086 1.78-1.544a1 1 0 011.41.1zm4.864-.145a1 1 0 01.269 1.295l-.069.105-1.8 2.4a1 1 0 01-1.669-1.095l.069-.105 1.8-2.4a1 1 0 011.4-.2zM14.441.136c.336.004.663.11.939.303.63.463 1.228.97 1.786 1.52 1.17 1.157 2.303 2.348 3.442 3.532.17.18.316.386.474.58.41.505.626 1.14.608 1.79l-.005.844-.005.405h-2.037c.002-.063.002-.125.002-.188l-.01-.304c-.036-.59-.274-.852-.819-.887l-.13-.004h-3.48c-.753 0-1.008-.255-1.023-1.02-.021-1.1-.043-2.476-.064-3.576-.012-.574-.313-.96-.79-.96a323.23 323.23 0 00-6.188 0 1.747 1.747 0 00-1.823 1.71c-.02 1.491-.007 3.168-.002 4.74l.001.49H3.294V3.552A3.43 3.43 0 016.535.141l.188-.005L9.295.12h2.573zm1.61 4.134v1.68h1.723L16.05 4.27z"
});

var SvgComponent$W = function SvgComponent(props) {
  return React.createElement("svg", _extends$W({
    viewBox: "0 0 24 24"
  }, props), _ref$W);
};

function _extends$X() {
  _extends$X = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$X.apply(this, arguments);
}

var _ref$X = /*#__PURE__*/React.createElement("path", {
  d: "M16 0a2 2 0 012 2v7h4a2 2 0 012 2v11a2 2 0 01-2 2H2a2 2 0 01-2-2V11a2 2 0 012-2h4V2a2 2 0 012-2h8zM6 11H2v11h20V11h-4v2c0 .173-.022.34-.063.501l.728-.001a1 1 0 010 2H5a1 1 0 010-2l1.063.001A2.004 2.004 0 016 13v-2zm10-9H8v11h8V2zm-1.984 4l.65.76-3.844 3.29L9 8.352l.682-.732 1.168 1.09L14.016 6z"
});

var SvgComponent$X = function SvgComponent(props) {
  return React.createElement("svg", _extends$X({
    viewBox: "0 0 24 24"
  }, props), _ref$X);
};

function _extends$Y() {
  _extends$Y = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$Y.apply(this, arguments);
}

var _ref$Y = /*#__PURE__*/React.createElement("path", {
  d: "M23 5a1 1 0 010 2h-8.686l9.393 9.381c.63.63.184 1.708-.707 1.708H1a1 1 0 01-1-1V6a1 1 0 011-1zM11.582 7H2v9.089h18.584l-8.792-8.782a.997.997 0 01-.21-.307zM15 13a1 1 0 010 2H4.5a1 1 0 010-2zm-4.171-3.5a1 1 0 010 2H4.5a1 1 0 010-2zm11.7 0a1 1 0 110 2h-2.365a1 1 0 010-2z"
});

var SvgComponent$Y = function SvgComponent(props) {
  return React.createElement("svg", _extends$Y({
    viewBox: "0 0 24 24"
  }, props), _ref$Y);
};

function _extends$Z() {
  _extends$Z = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$Z.apply(this, arguments);
}

var _ref$Z = /*#__PURE__*/React.createElement("path", {
  d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-2 6.618a1 1 0 01.447.106l4.764 2.382a1 1 0 010 1.788l-4.764 2.382A1 1 0 019 14.382V9.618a1 1 0 011-1z"
});

var SvgComponent$Z = function SvgComponent(props) {
  return React.createElement("svg", _extends$Z({
    viewBox: "0 0 24 24"
  }, props), _ref$Z);
};

function _extends$_() {
  _extends$_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$_.apply(this, arguments);
}

var _ref$_ = /*#__PURE__*/React.createElement("path", {
  d: "M17 4.057v15.889a1 1 0 01-1.586.81l-5.891-4.255H2a1 1 0 01-1-1v-7a1 1 0 011-1h7.523l5.892-4.255a1 1 0 011.585.81zm-2 1.955l-4.569 3.3a1 1 0 01-.585.189H3v5h6.846a1 1 0 01.586.19L15 17.99V6.012zm5 1.49c1.776.827 3 2.526 3 4.505s-1.224 3.678-3 4.494z"
});

var SvgComponent$_ = function SvgComponent(props) {
  return React.createElement("svg", _extends$_({
    viewBox: "0 0 24 24"
  }, props), _ref$_);
};

function _extends$$() {
  _extends$$ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$$.apply(this, arguments);
}

var _ref$$ = /*#__PURE__*/React.createElement("path", {
  d: "M21 2a1 1 0 011 1v18a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h18zm-1 2H4v16h16V4zM10 7a1 1 0 011 1v8a1 1 0 01-1 1H6a1 1 0 01-1-1V8a1 1 0 011-1h4zm7.912 8a1 1 0 010 2H13a1 1 0 010-2zM9 9H7v6h2V9zm8.912 2a1 1 0 010 2H13a1 1 0 010-2zm0-3.5a1 1 0 010 2H13a1 1 0 010-2z"
});

var SvgComponent$$ = function SvgComponent(props) {
  return React.createElement("svg", _extends$$({
    viewBox: "0 0 24 24"
  }, props), _ref$$);
};

function _extends$10() {
  _extends$10 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$10.apply(this, arguments);
}

var _ref$10 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#787878",
  fillRule: "nonzero",
  d: "M61.75 29.575l-14.134 5.82L53.546 41h8.204V29.575zm0-4.326V17h-41v12.225l13.318-6.638 10.36 9.794L61.75 25.25zM47.723 41L33.351 27.413 20.75 33.695V41h26.973zM76.818 0C81.043 0 84.5 3.25 84.5 7.222v43.334c0 3.972-3.457 7.222-7.682 7.222H57.614V65H26.886v-7.222H7.682C3.457 57.778 0 54.528 0 50.556V7.222C0 3.25 3.457 0 7.682 0h69.136zm0 50.556V7.222H7.682v43.334h69.136zM18.75 13h45a2 2 0 012 2v28a2 2 0 01-2 2h-45a2 2 0 01-2-2V15a2 2 0 012-2zm27 14a3 3 0 110-6 3 3 0 010 6z"
}));

var SvgComponent$10 = function SvgComponent(props) {
  return React.createElement("svg", _extends$10({
    viewBox: "0 0 85 65"
  }, props), _ref$10);
};

function _extends$11() {
  _extends$11 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$11.apply(this, arguments);
}

var _ref$11 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#787878"
}, React.createElement("path", {
  fillRule: "nonzero",
  d: "M77.068 0H7.932C3.707 0 .25 3.25.25 7.222v43.334c0 3.972 3.457 7.222 7.682 7.222h19.204V65h30.728v-7.222h19.204c4.225 0 7.682-3.25 7.682-7.222V7.222C84.75 3.25 81.293 0 77.068 0zm0 50.556H7.932V7.222h69.136v43.334z"
}), React.createElement("text", {
  fontFamily: "Lato-Black, Lato",
  fontSize: 35,
  fontWeight: 700,
  letterSpacing: -0.84
}, React.createElement("tspan", {
  x: 16.47,
  y: 41
}, "</>"))));

var SvgComponent$11 = function SvgComponent(props) {
  return React.createElement("svg", _extends$11({
    viewBox: "0 0 85 65"
  }, props), _ref$11);
};

function _extends$12() {
  _extends$12 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$12.apply(this, arguments);
}

var _ref$12 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#787878",
  fillRule: "nonzero",
  d: "M29 26.016V23H4v38h78V23H57v3.016h5a2 2 0 110 4H25.5a2 2 0 110-4H29zM29 19V3a3 3 0 013-3h22a3 3 0 013 3v16h26a3 3 0 013 3v40a3 3 0 01-3 3H3a3 3 0 01-3-3V22a3 3 0 013-3h26zm5-14v19h18V5H34zm6.138 8.235l1.302 1.517 4.464-4.776 2.192 2.048-6.751 7.224-3.483-4.059 2.276-1.954z"
}));

var SvgComponent$12 = function SvgComponent(props) {
  return React.createElement("svg", _extends$12({
    viewBox: "0 0 86 65"
  }, props), _ref$12);
};

function _extends$13() {
  _extends$13 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$13.apply(this, arguments);
}

var _ref$13 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#787878",
  fillRule: "nonzero",
  d: "M73.364 0c4.011 0 7.293 3.25 7.293 7.222v43.334c0 3.972-3.282 7.222-7.293 7.222H55.13V65H25.956v-7.222H7.722c-4.011 0-7.293-3.25-7.293-7.222V7.222C.429 3.25 3.71 0 7.722 0h65.642zm0 50.556V7.222H7.722v43.334h65.642zm-57.507-28.89H65.23v6.191H15.857v-6.19zm0 12.382h30.857v6.19H15.857v-6.19z"
}));

var SvgComponent$13 = function SvgComponent(props) {
  return React.createElement("svg", _extends$13({
    viewBox: "0 0 81 65"
  }, props), _ref$13);
};

function _extends$14() {
  _extends$14 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$14.apply(this, arguments);
}

var _ref$14 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#787878",
  fillRule: "nonzero",
  d: "M73.549 0c4.039 0 7.344 3.25 7.344 7.222v43.334c0 3.972-3.305 7.222-7.344 7.222h-18.36V65H25.811v-7.222H7.452c-4.04 0-7.345-3.25-7.345-7.222V7.222C.107 3.25 3.412 0 7.451 0H73.55zm0 50.556V7.222H7.45v43.334h66.1zM29.484 14.444L55.188 28.89 29.484 43.333V14.444z"
}));

var SvgComponent$14 = function SvgComponent(props) {
  return React.createElement("svg", _extends$14({
    viewBox: "0 0 81 65"
  }, props), _ref$14);
};

function _extends$15() {
  _extends$15 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$15.apply(this, arguments);
}

var _ref$15 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#787878",
  fillRule: "nonzero",
  d: "M52.365 17.677c3.957 1.804 6.684 5.509 6.684 9.823s-2.727 8.02-6.684 9.799V17.677zm-29.411 2.51h10.695L47.017 8v39L33.65 34.812H22.954V20.188zm18.716-.414l-5.802 5.29H28.3v4.875h7.567l5.802 5.289V19.773zM73.636 0C77.686 0 81 3.25 81 7.222v43.334c0 3.972-3.314 7.222-7.364 7.222H55.227V65H25.773v-7.222H7.363c-4.05 0-7.363-3.25-7.363-7.222V7.222C0 3.25 3.314 0 7.364 0h66.272zm0 50.556V7.222H7.364v43.334h66.272z"
}));

var SvgComponent$15 = function SvgComponent(props) {
  return React.createElement("svg", _extends$15({
    viewBox: "0 0 81 65"
  }, props), _ref$15);
};

function _extends$16() {
  _extends$16 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$16.apply(this, arguments);
}

var _ref$16 = /*#__PURE__*/React.createElement("path", {
  d: "M12 0c.92 0 1.815.103 2.676.3.13.02.25.05.362.088C20.194 1.733 24 6.422 24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zM4.087 10.587l-2.078.985a10.002 10.002 0 005.933 9.57l1.986-.799v-1.5l-.253-.138A2.5 2.5 0 018.37 16.51v-1.662l-4.284-4.26zm11.847-7.783l-.018.153c-.098.712-.282 1.51-.55 2.395a1.5 1.5 0 01-1.37 1.064l-2.524.11-.123 1.49a1.5 1.5 0 01-1.494 1.376H8.197v1.982H11.5a4.5 4.5 0 014.5 4.5v.282l.143.016a5.502 5.502 0 013.693 2.04A9.953 9.953 0 0022 12c0-4.126-2.499-7.668-6.066-9.196z"
});

var SvgComponent$16 = function SvgComponent(props) {
  return React.createElement("svg", _extends$16({
    viewBox: "0 0 24 24"
  }, props), _ref$16);
};

function _extends$17() {
  _extends$17 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$17.apply(this, arguments);
}

var _ref$17 = /*#__PURE__*/React.createElement("path", {
  d: "M6.857.005L1.143 0C.514 0 0 .49 0 1.09v9.82C0 11.51.514 12 1.143 12h5.714C7.486 12 8 11.51 8 10.91V1.09C8 .49 7.486.006 6.857.006zm0 9.813H1.143V2.182h5.714v7.636z"
});

var SvgComponent$17 = function SvgComponent(props) {
  return React.createElement("svg", _extends$17({
    viewBox: "0 0 8 12"
  }, props), _ref$17);
};

function _extends$18() {
  _extends$18 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$18.apply(this, arguments);
}

var _ref$18 = /*#__PURE__*/React.createElement("path", {
  d: "M10.91 0H1.09C.49 0 0 .506 0 1.125v6.75C0 8.494.49 9 1.09 9h9.82c.6 0 1.085-.506 1.085-1.125L12 1.125C12 .506 11.51 0 10.91 0zM9.817 7.875H2.182v-6.75h7.636v6.75z"
});

var SvgComponent$18 = function SvgComponent(props) {
  return React.createElement("svg", _extends$18({
    viewBox: "0 0 12 9"
  }, props), _ref$18);
};

function _extends$19() {
  _extends$19 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$19.apply(this, arguments);
}

var _ref$19 = /*#__PURE__*/React.createElement("path", {
  d: "M14.167 9.625c.779 0 1.41-.619 1.41-1.375l.006-6.875C15.583.619 14.946 0 14.167 0H2.833c-.779 0-1.416.619-1.416 1.375V8.25c0 .756.637 1.375 1.416 1.375H0V11h17V9.625h-2.833zM2.833 1.375h11.334V8.25H2.833V1.375z"
});

var SvgComponent$19 = function SvgComponent(props) {
  return React.createElement("svg", _extends$19({
    viewBox: "0 0 17 11"
  }, props), _ref$19);
};

function _extends$1a() {
  _extends$1a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1a.apply(this, arguments);
}

var _ref$1a = /*#__PURE__*/React.createElement("path", {
  d: "M6.696 1.834h4.213c.6 0 1.091.5 1.091 1.11l-.005 6.667c0 .612-.486 1.112-1.086 1.112H8.182v1.11H3.818v-1.11H1.091c-.6 0-1.091-.5-1.091-1.112V2.945c0-.611.49-1.111 1.09-1.111h4.305l-.789-.83A.5.5 0 015.33.316l.717.754.774-.765a.5.5 0 01.703.712l-.828.818zm4.213 7.777V2.945H1.091V9.61h9.818z"
});

var SvgComponent$1a = function SvgComponent(props) {
  return React.createElement("svg", _extends$1a({
    viewBox: "0 0 12 12"
  }, props), _ref$1a);
};

function _extends$1b() {
  _extends$1b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1b.apply(this, arguments);
}

var _ref$1b = /*#__PURE__*/React.createElement("path", {
  d: "M5 2h.65V.3h1V2h.65V.3h1v1.9c.243.182.4.473.4.8v7a.998.998 0 01-.4.8v1.9h-1V11h-.65v1.7h-1V11H5v1.7H4V11h-.65v1.7h-1V11H1.7v1.7h-1v-1.9a.998.998 0 01-.4-.8V3c0-.327.157-.618.4-.8V.3h1V2h.65V.3h1V2H4V.3h1V2zm2.7 1.5H1.3v6h6.4v-6zm-4.6.3h2.8a1 1 0 011 1v3.4a1 1 0 01-1 1H3.1a1 1 0 01-1-1V4.8a1 1 0 011-1zm0 1v3.4h2.8V4.8H3.1z"
});

var SvgComponent$1b = function SvgComponent(props) {
  return React.createElement("svg", _extends$1b({
    viewBox: "0 0 9 13"
  }, props), _ref$1b);
};

function _extends$1c() {
  _extends$1c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1c.apply(this, arguments);
}

var _ref$1c = /*#__PURE__*/React.createElement("path", {
  d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm.499 15.429c-1.868 0-3.05.224-3.499.51v5.286a1 1 0 01-.046.302A9.977 9.977 0 0012 22a9.983 9.983 0 003.368-.581l.003-5.643a1.826 1.826 0 00-.296-.109c-.538-.154-1.405-.238-2.576-.238zM12 2C6.477 2 2 6.477 2 12a9.996 9.996 0 004.999 8.662L7 15.538a1 1 0 01.165-.55c.742-1.127 2.494-1.56 5.334-1.56 3.063 0 4.726.478 4.868 2.11v4.901A9.992 9.992 0 0022 12c0-5.523-4.477-10-10-10zm0 3a3.866 3.866 0 013.857 3.857A3.856 3.856 0 0112 12.714a3.856 3.856 0 01-3.857-3.857A3.866 3.866 0 0112 5zm0 2a1.856 1.856 0 10-.002 3.716A1.856 1.856 0 0012 7z"
});

var SvgComponent$1c = function SvgComponent(props) {
  return React.createElement("svg", _extends$1c({
    viewBox: "0 0 24 24"
  }, props), _ref$1c);
};

function _extends$1d() {
  _extends$1d = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1d.apply(this, arguments);
}

var _ref$1d = /*#__PURE__*/React.createElement("path", {
  d: "M16 5.001v13a1 1 0 01-1.363.932C12.323 18.032 10.44 17.415 9 17.08v1.921a1 1 0 01-1 1H4.658a1 1 0 01-1-1l.002-2.215a54.05 54.05 0 00-2.557.21A1 1 0 010 16V7a1 1 0 011.13-.992c2.97.389 5.222.47 6.729.255 1.368-.196 3.351-.81 5.924-1.845l.833-.341A1 1 0 0116 5zM5.66 16.727L5.658 18H7l.002-1.228a19.575 19.575 0 00-1.342-.046zm13.656-2.675l3 1a1 1 0 11-.632 1.898l-3-1a1 1 0 11.632-1.898zM14 6.485l-.429.166c-2.258.866-4.062 1.397-5.43 1.593-.708.101-1.535.146-2.481.135v6.348c.947.003 1.774.055 2.481.156 1.45.207 3.397.764 5.859 1.67V6.485zM2 8.13v6.77a51.13 51.13 0 011.66-.118V8.287A46.991 46.991 0 012 8.13zM23 11a1 1 0 010 2h-4a1 1 0 110-2zm-1.316-3.949a1 1 0 01.632 1.898l-3 1a1 1 0 11-.632-1.898z"
});

var SvgComponent$1d = function SvgComponent(props) {
  return React.createElement("svg", _extends$1d({
    viewBox: "0 0 24 24"
  }, props), _ref$1d);
};

function _extends$1e() {
  _extends$1e = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1e.apply(this, arguments);
}

var _ref$1e = /*#__PURE__*/React.createElement("path", {
  d: "M15.509 1.374l7.07 4.109a2.784 2.784 0 011.384 2.41v8.212a2.784 2.784 0 01-1.384 2.412l-7.073 4.109a2.764 2.764 0 01-2.778 0l-7.053-4.112-.1-.067-.048-.036-.08-.067a1.288 1.288 0 01.226-2.05l7.419-4.34-7.253-4.337a1.281 1.281 0 010-2.214l6.893-4.029a2.763 2.763 0 012.777 0zm-1.77 1.728L7.896 6.517l6.857 4.1a1.558 1.558 0 01-.004 2.685l-7.01 4.1 5.995 3.494a.76.76 0 00.768 0l7.073-4.108a.785.785 0 00.388-.682V7.892a.785.785 0 00-.388-.68l-7.071-4.108a.762.762 0 00-.765-.002zM6.735 16.818l-.309.407-.114.197.21-.225.26-.343-.047-.036zm-4.654-8.69l6.044 2.678c.485.21.827.667.838 1.212.011.548-.315 1.021-.807 1.25l-6.034 2.739c-.41.197-.898.196-1.307-.004-.468-.229-.784-.694-.775-1.214V9.363a1.339 1.339 0 01.641-1.138l.12-.068.153-.065a1.51 1.51 0 011.127.036zm-.04 2.17v3.55l3.958-1.796-3.959-1.755z"
});

var SvgComponent$1e = function SvgComponent(props) {
  return React.createElement("svg", _extends$1e({
    viewBox: "0 0 24 24"
  }, props), _ref$1e);
};

function _extends$1f() {
  _extends$1f = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1f.apply(this, arguments);
}

var _ref$1f = /*#__PURE__*/React.createElement("path", {
  d: "M15.25 3.916a1 1 0 011.415 0l7.854 7.854a1 1 0 010 1.414l-8.793 8.793a1 1 0 11-1.415-1.414l8.086-8.086L15.25 5.33a1 1 0 010-1.414zM9.61 2a1 1 0 01.747.292l9.138 9.138a1 1 0 010 1.414L11.01 21.33a1 1 0 01-1.414 0L.458 12.192a1 1 0 01-.292-.747l.326-8.159a1 1 0 01.96-.959l8.158-.326zm-.357 2.016l-6.8.272-.271 6.799 8.121 8.121 7.071-7.071-8.121-8.121zm.74 2.63a3.5 3.5 0 11-4.95 4.95 3.5 3.5 0 014.95-4.95zM6.458 8.063a1.5 1.5 0 102.121 2.121 1.5 1.5 0 00-2.121-2.12z"
});

var SvgComponent$1f = function SvgComponent(props) {
  return React.createElement("svg", _extends$1f({
    viewBox: "0 0 25 24"
  }, props), _ref$1f);
};

function _extends$1g() {
  _extends$1g = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1g.apply(this, arguments);
}

var _ref$1g = /*#__PURE__*/React.createElement("path", {
  d: "M12 0a8.5 8.5 0 013.107 16.414l-2.153 6.884c-.292.936-1.616.936-1.908 0l-2.152-6.883-.258-.107A8.5 8.5 0 0112 0zm0 2a6.5 6.5 0 00-1.993 12.689 1 1 0 01.648.654L12 19.648l1.346-4.306a1 1 0 01.648-.653A6.5 6.5 0 0012 2zm0 3a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
});

var SvgComponent$1g = function SvgComponent(props) {
  return React.createElement("svg", _extends$1g({
    viewBox: "0 0 24 24"
  }, props), _ref$1g);
};

function _extends$1h() {
  _extends$1h = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1h.apply(this, arguments);
}

var _ref$1h = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 16a3.5 3.5 0 013.465 3H23a1 1 0 01.117 1.993L23 21l-12.337.001a3.5 3.5 0 01-6.326 0L1 21a1 1 0 01-.117-1.993L1 19h3.035A3.5 3.5 0 017.5 16zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm10-9c1.493 0 2.767.935 3.27 2.25H23a1 1 0 01.117 1.993L23 13.25h-2.08a3.501 3.501 0 01-6.84 0H1a1 1 0 01-.117-1.993L1 11.25h13.23A3.501 3.501 0 0117.5 9zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM7.5 1a3.502 3.502 0 013.355 2.5H23a1 1 0 01.117 1.993L23 5.5H10.855a3.502 3.502 0 01-6.71 0H1a1 1 0 01-.117-1.993L1 3.5h3.145A3.502 3.502 0 017.5 1zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
});

var SvgComponent$1h = function SvgComponent(props) {
  return React.createElement("svg", _extends$1h({
    viewBox: "0 0 24 24"
  }, props), _ref$1h);
};

function _extends$1i() {
  _extends$1i = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1i.apply(this, arguments);
}

var _ref$1i = /*#__PURE__*/React.createElement("path", {
  d: "M1 24a1 1 0 01-1-1V1a1 1 0 011-1h22a1 1 0 011 1v22a1 1 0 01-1 1H1zm1-2h6V9.5H2V22zM22 9.5H10V22h12V9.5zm0-2V2H10v5.5h12zM8 2H2v5.5h6V2z"
});

var SvgComponent$1i = function SvgComponent(props) {
  return React.createElement("svg", _extends$1i({
    viewBox: "0 0 24 24"
  }, props), _ref$1i);
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var creativeIcons = {
  xs: {
    BannerSM: SvgComponent$P,
    HtmlSM: SvgComponent$Q,
    gotvSM: SvgComponent$R,
    scrollSM: SvgComponent$S,
    VideoSM: SvgComponent$T,
    VoiceSM: SvgComponent$U
  },
  sm: {
    BannerXS: SvgComponent$V,
    HtmlXS: SvgComponent$W,
    gotvXS: SvgComponent$X,
    scrollXS: SvgComponent$Y,
    VideoXS: SvgComponent$Z,
    VoiceXS: SvgComponent$_,
    NativeAdXs: SvgComponent$$
  },
  "default": {
    Banner: SvgComponent$10,
    Html: SvgComponent$11,
    Gotv: SvgComponent$12,
    Scroll: SvgComponent$13,
    Video: SvgComponent$14,
    Voice: SvgComponent$15
  }
};
var deviceIcons = {
  Phone: SvgComponent$17,
  Tablet: SvgComponent$18,
  Desktop: SvgComponent$19,
  SmartTV: SvgComponent$1a,
  OtherEmbedded: SvgComponent$1b
};
var audienceIcons = {
  CustomAudience: SvgComponent$1c,
  CampaignAudience: SvgComponent$1d,
  SegmentedAudience: SvgComponent$1e,
  TaggedAudience: SvgComponent$1f,
  GeofarmedAudience: SvgComponent$1g,
  Advanced: SvgComponent$1h,
  Template: SvgComponent$1i
};
var commonIcons = {
  PDF: SvgComponent,
  CSV: SvgComponent$1,
  XLS: SvgComponent$2,
  Created: SvgComponent$d,
  Updated: SvgComponent$g,
  Delete: SvgComponent$3,
  Copy: SvgComponent$4,
  Spending: SvgComponent$5,
  Reorder: SvgComponent$6,
  Checkbox: SvgComponent$7,
  CheckboxBlank: SvgComponent$8,
  DateRange: SvgComponent$9,
  OneDate: SvgComponent$L,
  DragIndicator: SvgComponent$a,
  Apps: SvgComponent$b,
  Notification: SvgComponent$c,
  Print: SvgComponent$e,
  Refresh: SvgComponent$f,
  Impressions: SvgComponent$h,
  Close: SvgComponent$i,
  Add: SvgComponent$j,
  Left: SvgComponent$k,
  Collapse: SvgComponent$l,
  Right: SvgComponent$m,
  Expand: SvgComponent$n,
  UnfoldMore: SvgComponent$o,
  ArrowLeft: SvgComponent$p,
  ArrowUp: SvgComponent$q,
  ArrowRight: SvgComponent$r,
  ArrowDown: SvgComponent$s,
  DropDown: SvgComponent$t,
  DropUp: SvgComponent$u,
  Report: SvgComponent$v,
  NoData: SvgComponent$w,
  Search: SvgComponent$x,
  Marketplace: SvgComponent$y,
  Edit: SvgComponent$z,
  Menu: SvgComponent$A,
  Filter: SvgComponent$B,
  More: SvgComponent$C,
  Agenda: SvgComponent$D,
  Done: SvgComponent$E,
  Sort: SvgComponent$F,
  Star: SvgComponent$G,
  Tap: SvgComponent$H,
  Info: SvgComponent$I,
  List: SvgComponent$J,
  Table: SvgComponent$K,
  AddEmail: SvgComponent$M,
  Question: SvgComponent$N,
  Globe: SvgComponent$16,
  Upload: SvgComponent$O
};

var mapIcons = _objectSpread({}, commonIcons, {}, creativeIcons["default"], {}, creativeIcons.sm, {}, creativeIcons.xs, {}, deviceIcons, {}, audienceIcons);

var Icon = /*#__PURE__*/function (_Component) {
  inherits(Icon, _Component);

  function Icon() {
    classCallCheck(this, Icon);
    return possibleConstructorReturn(this, getPrototypeOf(Icon).apply(this, arguments));
  }

  createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          className = _this$props.className,
          rest = objectWithoutProperties(_this$props, ["name", "className"]);
      var Wrapper = mapIcons[name];
      return React.createElement(Wrapper, _extends_1({
        className: "svg-icon ".concat(className || '')
      }, rest));
    }
  }]);
  return Icon;
}(Component);

Icon.propTypes = {
  name: PropTypes__default.oneOf(Object.keys(mapIcons)).isRequired
};
var css$2 = ".ripple {\n  position: absolute;\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  opacity: 1;\n  transform: scale(0); }\n  .ripple.is-reppling {\n    animation: ripple 750ms cubic-bezier(0.4, 0, 0.2, 1); }\n  .ripple-parent {\n    position: relative;\n    overflow: hidden; }\n    .ripple-parent_button {\n      overflow: hidden;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      border-radius: inherit; }\n\n@keyframes ripple {\n  100% {\n    opacity: 0;\n    transform: scale(3); } }\n";
styleInject(css$2);

var Ripple = /*#__PURE__*/function (_React$Component) {
  inherits(Ripple, _React$Component);

  function Ripple() {
    var _this;

    classCallCheck(this, Ripple);
    _this = possibleConstructorReturn(this, getPrototypeOf(Ripple).call(this));
    defineProperty(assertThisInitialized(_this), "ripple", React.createRef());
    _this.state = {
      animate: false,
      width: 0,
      height: 0,
      top: 0,
      left: 0
    };
    return _this;
  }

  createClass(Ripple, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "ripple ".concat(this.state.animate ? 'is-reppling' : ''),
        ref: this.ripple,
        style: {
          top: this.state.top + 'px',
          left: this.state.left + 'px',
          width: this.state.width + 'px',
          height: this.state.height + 'px'
        }
      });
    }
  }, {
    key: "reppling",
    value: function reppling(cursorPos) {
      var ripple = this.ripple.current;
      var parent = ripple.parentElement;
      var buttonPos = parent.getBoundingClientRect();
      var buttonWidth = parent.offsetWidth;
      var buttonHeight = parent.offsetHeight; // Make a Square Ripple

      var rippleWidthShouldBe = Math.max(buttonHeight, buttonWidth); // Make Ripple Position to be center

      var centerize = rippleWidthShouldBe / 2;
      this.setState({
        animate: true,
        width: rippleWidthShouldBe,
        height: rippleWidthShouldBe,
        top: cursorPos.top - buttonPos.top - centerize,
        left: cursorPos.left - buttonPos.left - centerize
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var cursorPos = nextProps.cursorPos; // Prevent Component duplicates do ripple effect at the same time

      if (cursorPos.time !== this.props.cursorPos.time) {
        if (this.state.animate) {
          this.setState({
            animate: false
          }, function () {
            _this2.reppling(cursorPos);
          });
        } else {
          this.reppling(cursorPos);
        }
      }
    }
  }]);
  return Ripple;
}(React.Component);

var defaultClass = 'btn-square _persimmon';

var Button = /*#__PURE__*/function (_Component) {
  inherits(Button, _Component);

  function Button() {
    var _this;

    classCallCheck(this, Button);
    _this = possibleConstructorReturn(this, getPrototypeOf(Button).call(this));
    defineProperty(assertThisInitialized(_this), "rippleOnMouseDown", function (e) {
      var cursorPos = {
        top: e.clientY,
        left: e.clientX,
        time: Date.now()
      };

      _this.setState({
        cursorPos: cursorPos
      });
    });
    _this.state = {
      cursorPos: {}
    };
    return _this;
  }

  createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? defaultClass : _this$props$className,
          size = _this$props.size,
          _this$props$ripple = _this$props.ripple,
          ripple = _this$props$ripple === void 0 ? true : _this$props$ripple,
          rest = objectWithoutProperties(_this$props, ["children", "className", "size", "ripple"]);
      return React.createElement("button", _extends_1({
        className: "".concat(className, " ").concat(size ? "_".concat(size) : ''),
        onMouseDown: this.rippleOnMouseDown
      }, rest), React.createElement("span", {
        className: "btn-content"
      }, children), ripple && React.createElement("div", {
        className: "ripple-parent_button"
      }, React.createElement(Ripple, {
        cursorPos: this.state.cursorPos
      })));
    }
  }]);
  return Button;
}(Component);

var ButtonCircle = function ButtonCircle(_ref) {
  var iconName = _ref.iconName,
      iconClass = _ref.iconClass,
      outline = _ref.outline,
      inverse = _ref.inverse,
      className = _ref.className,
      rest = objectWithoutProperties(_ref, ["iconName", "iconClass", "outline", "inverse", "className"]);
  return React.createElement(Button, _extends_1({}, rest, {
    className: "btn-circle ".concat(outline ? '_outline' : '', " ").concat(inverse ? '_inverse' : '', " ").concat(className ? className : '')
  }), React.createElement(Icon, {
    className: iconClass,
    name: iconName
  }));
};

Button.propTypes = {
  className: PropTypes__default.string,
  size: PropTypes__default.oneOf(['md', 'lg']),
  ripple: PropTypes__default.bool
};
var defaultClass$1 = 'btn-1 _persimmon';

var ButtonLink = function ButtonLink(_ref) {
  var children = _ref.children,
      href = _ref.href,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? defaultClass$1 : _ref$className,
      rest = objectWithoutProperties(_ref, ["children", "href", "className"]);
  return React.createElement("a", _extends_1({
    className: className,
    href: href
  }, rest), children);
};

var css$3 = ".logo {\n  position: relative;\n  display: flex;\n  width: 9em;\n  font-size: 1rem; }\n  .logo__link {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: block;\n    background: transparent;\n    text-decoration: none; }\n  .logo > svg {\n    width: 9em;\n    height: 3.61125em; }\n  .logo._white svg path {\n    fill: #ffffff; }\n  .logo._black svg path {\n    fill: #000000; }\n";
styleInject(css$3);

function _extends$1j() {
  _extends$1j = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1j.apply(this, arguments);
}

var _ref$1j = /*#__PURE__*/React.createElement("g", {
  fill: "#ff5859",
  className: "logo__i"
}, React.createElement("path", {
  d: "M.2 11c.4.3.7.6 1.1.9C6.7 17.3 12 22.7 17.4 28c.7.7 1 1.4 1 2.4v40.3c0 1.6-.1 1.7-1.7 1.7H.2V11z"
}), React.createElement("path", {
  d: "M18.4.2v16.5c0 .4.2 1-.3 1.2-.5.2-.7-.4-1-.7C11.9 12 6.7 6.8 1.4 1.6L.2.4c.2-.5.6-.2 1-.2h17.2z"
}));

var _ref2$f = /*#__PURE__*/React.createElement("g", {
  className: "logo__q"
}, React.createElement("path", {
  fill: "#ffa300",
  d: "M103.2.2v64.7c0 .6.3 1.5-.3 1.7-.5.2-.9-.6-1.3-1-5.3-5.2-10.5-10.4-15.7-15.6-.7-.7-1-1.4-1-2.4V19.9c0-1.6 0-1.6-1.6-1.6H50.5c-1.6 0-1.6 0-1.6 1.6v32.6c0 1.7 0 1.7 1.7 1.7H78c1.1 0 1.9.3 2.6 1.1 8.3 8.3 16.6 16.6 24.9 25 .3.3.8.5.7.9-.2.5-.8.3-1.2.3H82.6c-1 0-1.7-.3-2.3-1-2.3-2.3-4.6-4.6-6.8-6.9-.8-.8-1.5-1.1-2.6-1.1H32.7c-1.9 0-1.9 0-1.9-1.9V.3C54.8.2 79 .2 103.2.2z"
}));

var _ref3$2 = /*#__PURE__*/React.createElement("g", {
  fill: "#3fd4ad",
  className: "logo__m"
}, React.createElement("path", {
  d: "M202.3.2v70.4c0 1.7-.1 1.8-1.9 1.8h-14.9c-1.2 0-1.5-.4-1.5-1.6V18.7c-.7.1-.9.5-1.2.8L160 42.3c-1.1 1.1-1.1 1.1-2.2 0-13.8-13.6-27.5-27.4-41.3-41.1-.3-.3-.6-.7-.9-1H141c5.8 5.8 11.5 11.6 17.3 17.4.5.5.8.3 1.2-.1C165.2 11.7 171 5.9 176.8.2h25.5z"
}), React.createElement("path", {
  d: "M115.6 41.7v-29c0-.4-.2-1 .2-1.2.5-.2.7.4 1 .7 5.3 5.3 10.6 10.6 15.9 15.8.7.7 1 1.4 1 2.4v40.4c0 1.6 0 1.7-1.7 1.7h-14.9c-1.2 0-1.5-.4-1.5-1.5V41.7z"
}));

var SvgComponent$1j = function SvgComponent(props) {
  return React.createElement("svg", _extends$1j({
    viewBox: "0 0 202.1 81.1"
  }, props), _ref$1j, _ref2$f, _ref3$2);
};

var Logo = function Logo(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      type = _ref.type;
  var classes = ['logo', className];

  if (type) {
    classes.push("_".concat(type));
  }

  return React.createElement("span", {
    className: classes.join(' ')
  }, React.createElement(SvgComponent$1j, null));
};

Logo.defaultProps = {};
Logo.propTypes = {
  className: string,
  type: oneOf(['white', 'black'])
};
var css$4 = ".layout-module_arrow__2lmNm {\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: none; }\n  .layout-module_arrow__2lmNm:focus {\n    outline: none; }\n\n.layout-module_container__2FTRa {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 4.375rem 0 0;\n  min-width: 80rem;\n  min-height: 100vh;\n  transition: all 0.3s linear; }\n  @media (min-width: 1280px) {\n    .layout-module_container__2FTRa.layout-module__sidebarOpened__lAUeP {\n      padding-left: 20rem; } }\n  .layout-module_container__2FTRa.layout-module__sidebarOpened__lAUeP .layout-module_arrow__2lmNm {\n    left: 20rem;\n    transition: left .3s linear, transform 0.3s, background 0.3s;\n    transform: translateX(-1.875rem); }\n    .layout-module_container__2FTRa.layout-module__sidebarOpened__lAUeP .layout-module_arrow__2lmNm svg {\n      transform: none; }\n  .layout-module_container__2FTRa:not(.layout-module__sidebarOpened__lAUeP) .layout-module_sidebar__2Ved2 {\n    transform: translateX(-100%); }\n\n.layout-module_sidebar__2Ved2 {\n  position: fixed;\n  z-index: 20;\n  top: 4.375rem;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  align-items: stretch;\n  width: 20rem;\n  border-right: 0.0625rem solid #f4f4f4;\n  background: #fff;\n  transition: transform linear 0.3s; }\n\n.layout-module_main__2L7DT {\n  position: relative;\n  transition: padding linear 0.3s; }\n\n.layout-module_arrow__2lmNm {\n  position: fixed;\n  z-index: 20;\n  bottom: 0.75rem;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1.875rem;\n  height: 1.875rem;\n  background: #99a7ff;\n  cursor: pointer;\n  transition: left .3s linear, transform 0.3s 0.3s, background 0.3s; }\n  .layout-module_arrow__2lmNm:hover {\n    background: #4d5ecc; }\n  .layout-module_arrow__2lmNm svg {\n    transform: rotate(180deg); }\n  .layout-module_arrow__2lmNm path:nth-child(1) {\n    fill: #fff; }\n";
var styles = {
  "arrow": "layout-module_arrow__2lmNm",
  "container": "layout-module_container__2FTRa",
  "_sidebarOpened": "layout-module__sidebarOpened__lAUeP",
  "sidebar": "layout-module_sidebar__2Ved2",
  "main": "layout-module_main__2L7DT"
};
styleInject(css$4);

var Layout = /*#__PURE__*/function (_Component) {
  inherits(Layout, _Component);

  function Layout() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Layout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Layout)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "toggleSidebarOnResize", function () {
      var toggleSidebar = _this.props.toggleSidebar;

      if (_this.windowWidth === undefined) {
        _this.windowWidth = window.innerWidth;

        if (_this.windowWidth < 1280) {
          toggleSidebar(false);
        }
      } else {
        if (_this.windowWidth < 1280) {
          _this.windowWidth = window.innerWidth;
        } else {
          if (window.innerWidth < 1280) {
            _this.windowWidth = window.innerWidth;
            _this.props.opened && toggleSidebar(false);
          }
        }
      }
    });
    return _this;
  }

  createClass(Layout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.toggleSidebarOnResize);
      this.toggleSidebarOnResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.toggleSidebarOnResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          _this$props$opened = _this$props.opened,
          opened = _this$props$opened === void 0 ? true : _this$props$opened,
          toggleSidebar = _this$props.toggleSidebar,
          sidebar = _this$props.sidebar,
          children = _this$props.children;
      return React.createElement("div", {
        className: "".concat(styles.container, " ").concat(opened ? styles._sidebarOpened : '', " ").concat(className)
      }, React.createElement("aside", {
        className: styles.sidebar
      }, sidebar), React.createElement("main", {
        className: "".concat(styles.main)
      }, children, React.createElement("button", {
        className: styles.arrow,
        onClick: toggleSidebar
      }, React.createElement(Icon, {
        name: "Left"
      }))));
    }
  }]);
  return Layout;
}(Component);

Layout.propTypes = {
  className: PropTypes__default.string,
  opened: PropTypes__default.bool,
  toggleSidebar: PropTypes__default.func,
  sidebar: PropTypes__default.element
};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;
var fontfaceobserver_standalone = createCommonjsModule(function (module) {
  /* Font Face Observer v2.1.0 - © Bram Stein. License: BSD-3-Clause */
  (function () {
    function l(a, b) {
      document.addEventListener ? a.addEventListener("scroll", b, !1) : a.attachEvent("scroll", b);
    }

    function m(a) {
      document.body ? a() : document.addEventListener ? document.addEventListener("DOMContentLoaded", function c() {
        document.removeEventListener("DOMContentLoaded", c);
        a();
      }) : document.attachEvent("onreadystatechange", function k() {
        if ("interactive" == document.readyState || "complete" == document.readyState) document.detachEvent("onreadystatechange", k), a();
      });
    }

    function t(a) {
      this.a = document.createElement("div");
      this.a.setAttribute("aria-hidden", "true");
      this.a.appendChild(document.createTextNode(a));
      this.b = document.createElement("span");
      this.c = document.createElement("span");
      this.h = document.createElement("span");
      this.f = document.createElement("span");
      this.g = -1;
      this.b.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
      this.c.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
      this.f.style.cssText = "max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
      this.h.style.cssText = "display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";
      this.b.appendChild(this.h);
      this.c.appendChild(this.f);
      this.a.appendChild(this.b);
      this.a.appendChild(this.c);
    }

    function u(a, b) {
      a.a.style.cssText = "max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:" + b + ";";
    }

    function z(a) {
      var b = a.a.offsetWidth,
          c = b + 100;
      a.f.style.width = c + "px";
      a.c.scrollLeft = c;
      a.b.scrollLeft = a.b.scrollWidth + 100;
      return a.g !== b ? (a.g = b, !0) : !1;
    }

    function A(a, b) {
      function c() {
        var a = k;
        z(a) && a.a.parentNode && b(a.g);
      }

      var k = a;
      l(a.b, c);
      l(a.c, c);
      z(a);
    }

    function B(a, b) {
      var c = b || {};
      this.family = a;
      this.style = c.style || "normal";
      this.weight = c.weight || "normal";
      this.stretch = c.stretch || "normal";
    }

    var C = null,
        D = null,
        E = null,
        F = null;

    function G() {
      if (null === D) if (J() && /Apple/.test(window.navigator.vendor)) {
        var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);
        D = !!a && 603 > parseInt(a[1], 10);
      } else D = !1;
      return D;
    }

    function J() {
      null === F && (F = !!document.fonts);
      return F;
    }

    function K() {
      if (null === E) {
        var a = document.createElement("div");

        try {
          a.style.font = "condensed 100px sans-serif";
        } catch (b) {}

        E = "" !== a.style.font;
      }

      return E;
    }

    function L(a, b) {
      return [a.style, a.weight, K() ? a.stretch : "", "100px", b].join(" ");
    }

    B.prototype.load = function (a, b) {
      var c = this,
          k = a || "BESbswy",
          r = 0,
          n = b || 3E3,
          H = new Date().getTime();
      return new Promise(function (a, b) {
        if (J() && !G()) {
          var M = new Promise(function (a, b) {
            function e() {
              new Date().getTime() - H >= n ? b(Error("" + n + "ms timeout exceeded")) : document.fonts.load(L(c, '"' + c.family + '"'), k).then(function (c) {
                1 <= c.length ? a() : setTimeout(e, 25);
              }, b);
            }

            e();
          }),
              N = new Promise(function (a, c) {
            r = setTimeout(function () {
              c(Error("" + n + "ms timeout exceeded"));
            }, n);
          });
          Promise.race([N, M]).then(function () {
            clearTimeout(r);
            a(c);
          }, b);
        } else m(function () {
          function v() {
            var b;
            if (b = -1 != f && -1 != g || -1 != f && -1 != h || -1 != g && -1 != h) (b = f != g && f != h && g != h) || (null === C && (b = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent), C = !!b && (536 > parseInt(b[1], 10) || 536 === parseInt(b[1], 10) && 11 >= parseInt(b[2], 10))), b = C && (f == w && g == w && h == w || f == x && g == x && h == x || f == y && g == y && h == y)), b = !b;
            b && (d.parentNode && d.parentNode.removeChild(d), clearTimeout(r), a(c));
          }

          function I() {
            if (new Date().getTime() - H >= n) d.parentNode && d.parentNode.removeChild(d), b(Error("" + n + "ms timeout exceeded"));else {
              var a = document.hidden;
              if (!0 === a || void 0 === a) f = e.a.offsetWidth, g = p.a.offsetWidth, h = q.a.offsetWidth, v();
              r = setTimeout(I, 50);
            }
          }

          var e = new t(k),
              p = new t(k),
              q = new t(k),
              f = -1,
              g = -1,
              h = -1,
              w = -1,
              x = -1,
              y = -1,
              d = document.createElement("div");
          d.dir = "ltr";
          u(e, L(c, "sans-serif"));
          u(p, L(c, "serif"));
          u(q, L(c, "monospace"));
          d.appendChild(e.a);
          d.appendChild(p.a);
          d.appendChild(q.a);
          document.body.appendChild(d);
          w = e.a.offsetWidth;
          x = p.a.offsetWidth;
          y = q.a.offsetWidth;
          I();
          A(e, function (a) {
            f = a;
            v();
          });
          u(e, L(c, '"' + c.family + '",sans-serif'));
          A(p, function (a) {
            g = a;
            v();
          });
          u(p, L(c, '"' + c.family + '",serif'));
          A(q, function (a) {
            h = a;
            v();
          });
          u(q, L(c, '"' + c.family + '",monospace'));
        });
      });
    };

    module.exports = B;
  })();
});
var css$5 = ".switch__indicator {\n  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12); }\n\n.switch__item._active:hover ~ .switch__indicator {\n  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12); }\n\n.switch {\n  position: relative;\n  display: inline-flex;\n  align-items: stretch;\n  height: 1.5625rem;\n  border-radius: 0.8125rem;\n  border: 0.0625rem solid #6075ff;\n  background: #fff;\n  transition: border .25s, background .25s, box-shadow .25s, color .25s; }\n  .switch._sm {\n    height: 1.125rem;\n    border-radius: 0.5625rem; }\n    .switch._sm .switch__item {\n      font-size: 0.75rem; }\n  .switch._md {\n    height: 1.875rem;\n    border-radius: 0.9375rem; }\n  .switch._lg {\n    height: 2.5rem;\n    border-radius: 1.25rem; }\n  .switch:hover {\n    border-color: #4d5ecc;\n    box-shadow: 0 0 0.25em 0 rgba(162, 162, 162, 0.5); }\n  .switch__item {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 .5rem;\n    cursor: pointer;\n    transition: color .25s;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.64286em;\n    color: #6075ff;\n    text-align: center;\n    white-space: nowrap; }\n    .switch__item._active {\n      color: #fff; }\n  .switch._md .switch__item {\n    min-width: 6.25rem;\n    line-height: 1.75rem; }\n  .switch._lg .switch__item {\n    min-width: 6.25rem;\n    line-height: 2.375rem; }\n  .switch:hover .switch__item:not(._active) {\n    color: #4d5ecc; }\n  .switch__label {\n    display: flex;\n    align-items: stretch; }\n  .switch__input {\n    display: none; }\n  .switch__indicator {\n    position: absolute;\n    top: -0.0625rem;\n    bottom: -0.0625rem;\n    border-radius: 0.8125rem;\n    background: #6075ff;\n    transition: left .5s, width .5s, background .25s, box-shadow .25s; }\n  .switch__item._active:hover ~ .switch__indicator {\n    background: #4d5ecc; }\n  .switch._md .switch__indicator {\n    border-radius: 0.9375rem; }\n  .switch._lg .switch__indicator {\n    border-radius: 1.25rem; }\n";
styleInject(css$5);

var isEqual = function isEqual(props, first, second) {
  var equal = true;

  for (var ii = 0; ii < props.length; ii++) {
    var property = props[ii];

    if (first[property] !== second[property]) {
      equal = false;
      return equal;
    }
  }

  return equal;
};

var Switch = /*#__PURE__*/function (_Component) {
  inherits(Switch, _Component);

  function Switch(props) {
    var _this;

    classCallCheck(this, Switch);
    _this = possibleConstructorReturn(this, getPrototypeOf(Switch).call(this, props));
    defineProperty(assertThisInitialized(_this), "onFontLoaded", function () {
      var font = new fontfaceobserver_standalone('Lato Regular');
      font.load().then(function () {
        _this.updateStyle();
      });
    });
    defineProperty(assertThisInitialized(_this), "updateStyle", function () {
      _this.getItemsWidths();

      var style = _this._getIndicatorStyle();

      _this.indicator.style.left = style.left;
      _this.indicator.style.width = style.width;
    });
    defineProperty(assertThisInitialized(_this), "_getIndicatorStyle", function () {
      var checked = _this.props.value;

      var _this$switchItemsWidt = slicedToArray(_this.switchItemsWidths, 2),
          first = _this$switchItemsWidt[0],
          second = _this$switchItemsWidt[1];

      return {
        left: "".concat(checked ? first - 1 : -1, "px"),
        width: "".concat(checked ? second + 2 : first + 2, "px")
      };
    });
    _this.switchItems = [];
    _this.switchItemsWidths = [];
    _this.size = props.size;
    _this.state = {};
    return _this;
  }

  createClass(Switch, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !isEqual(['list', 'className', 'value', 'name', 'size'], this.props, nextProps);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getItemsWidths();
      this.forceUpdate();
      this.onFontLoaded();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.size !== this.props.size) {
        this.size = this.props.size;
        this.updateStyle();
      }
    }
  }, {
    key: "_pushSwitchItemRef",
    value: function _pushSwitchItemRef(item) {
      if (item && this.switchItems.indexOf(item) === -1) {
        this.switchItems.push(item);
      }
    }
  }, {
    key: "_setIndicatorRef",
    value: function _setIndicatorRef(item) {
      if (!this.indicator) {
        this.indicator = item;
      }
    }
  }, {
    key: "getItemsWidths",
    value: function getItemsWidths() {
      var _this2 = this;

      this.switchItemsWidths = [];
      this.switchItems.forEach(function (item) {
        _this2.switchItemsWidths.push(item.offsetWidth);
      });
    }
  }, {
    key: "handleOnChange",
    value: function handleOnChange(_ref) {
      var target = _ref.target;
      var value = target.checked;
      this.props.onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          size = _this$props.size,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          list = _this$props.list,
          name = _this$props.name,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? false : _this$props$value;
      return React.createElement("div", {
        className: "switch ".concat(className, " ").concat(size ? "_".concat(size) : ''),
        ref: function ref(el) {
          _this3["switch"] = el;
        }
      }, React.createElement("input", {
        className: "switch__input",
        type: "checkbox",
        name: name,
        id: name,
        checked: value,
        onChange: function onChange(e) {
          return _this3.handleOnChange(e);
        }
      }), React.createElement("label", {
        className: "switch__label",
        htmlFor: name
      }, list.map(function (item, i) {
        return React.createElement("span", {
          key: i,
          className: "switch__item ".concat(value === Boolean(i) ? '_active' : ''),
          ref: function ref(item) {
            return _this3._pushSwitchItemRef(item);
          }
        }, item);
      }), React.createElement("div", {
        className: "switch__indicator",
        ref: function ref(item) {
          return _this3._setIndicatorRef(item);
        },
        style: this._getIndicatorStyle()
      })));
    }
  }]);
  return Switch;
}(Component);

Switch.propTypes = {
  onChange: PropTypes__default.func.isRequired,
  list: PropTypes__default.arrayOf(PropTypes__default.string).isRequired,
  name: PropTypes__default.string.isRequired,
  value: PropTypes__default.bool.isRequired,
  className: PropTypes__default.string,
  size: PropTypes__default.string
};
var css$6 = ".tumbler {\n  display: flex;\n  align-items: center; }\n  .tumbler__label {\n    display: flex;\n    align-items: center;\n    cursor: pointer; }\n  .tumbler:not(._on-off) .tumbler__btn {\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    padding: 0 1px;\n    width: 28px;\n    height: 14px; }\n    .tumbler:not(._on-off) .tumbler__btn:before {\n      content: '';\n      align-self: center;\n      width: 100%;\n      height: 10px;\n      border-radius: 6px;\n      background: #cbcbcb; }\n    .tumbler:not(._on-off) .tumbler__btn:after {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 0;\n      transform: translateY(-50%);\n      width: 14px;\n      height: 14px;\n      border-radius: 7px;\n      background: #787878;\n      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n      transition: left .25s, background .25s; }\n  .tumbler:not(._on-off)._on .tumbler__btn:after {\n    left: calc(100% - 14px);\n    background: #6075ff; }\n  .tumbler._on-off .tumbler__btn {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 5.75rem;\n    height: 1.5625rem; }\n    .tumbler._on-off .tumbler__btn i {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      min-width: 2.875rem;\n      height: 1.5625rem;\n      font-family: 'Lato Regular', sans-serif;\n      font-weight: 400;\n      font-style: normal;\n      font-size: 0.875rem;\n      line-height: 1.21429em;\n      text-transform: uppercase;\n      text-align: center; }\n  .tumbler._disabled {\n    pointer-events: none;\n    opacity: .5; }\n  .tumbler__bg {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n    height: 100%;\n    border-radius: .75rem;\n    background: #f4f4f4; }\n    .tumbler__bg i {\n      color: rgba(162, 162, 162, 0.5); }\n  .tumbler__control {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: stretch;\n    width: 2.875rem;\n    height: 1.5625rem;\n    border: 0.0625rem solid gray;\n    border-radius: .75rem;\n    background: #fff;\n    transition: left .25s, border .25s, box-shadow .25s, background .25s;\n    overflow: hidden; }\n    .tumbler__control i {\n      margin-top: -0.0625rem;\n      transition: margin .25s, color .25s, border .25s;\n      color: #818181; }\n      .tumbler__control i:first-child {\n        margin-left: -0.0625rem; }\n  .tumbler._on .tumbler__control {\n    left: 2.875rem;\n    border-color: #6075ff;\n    background: #6075ff; }\n    .tumbler._on .tumbler__control i:first-child {\n      margin-left: -2.9375rem; }\n    .tumbler._on .tumbler__control i:last-child {\n      border: none;\n      color: #fff; }\n  .tumbler:hover .tumbler__control {\n    border-color: #6075ff;\n    box-shadow: 0 0 0.25rem 0 rgba(162, 162, 162, 0.5); }\n    .tumbler:hover .tumbler__control i {\n      color: #4d5ecc; }\n  .tumbler__title {\n    margin-left: 0.625rem;\n    transition: color .25s;\n    font-family: 'Lato Medium', sans-serif;\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 1.125em;\n    color: #787878; }\n  .tumbler:not(._disabled) .tumbler__label:hover .tumbler__title,\n  .tumbler._on .tumbler__title {\n    color: #000; }\n";
styleInject(css$6);

var Tumbler = /*#__PURE__*/function (_Component) {
  inherits(Tumbler, _Component);

  function Tumbler() {
    classCallCheck(this, Tumbler);
    return possibleConstructorReturn(this, getPrototypeOf(Tumbler).apply(this, arguments));
  }

  createClass(Tumbler, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$onOff = _this$props.onOff,
          onOff = _this$props$onOff === void 0 ? false : _this$props$onOff,
          name = _this$props.name,
          id = _this$props.id,
          className = _this$props.className,
          _this$props$on = _this$props.on,
          on = _this$props$on === void 0 ? false : _this$props$on,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          title = _this$props.title;
      return React.createElement("div", {
        className: "tumbler ".concat(disabled ? '_disabled' : '', " ").concat(onOff ? '_on-off' : '', " ").concat(on ? '_on' : '', " ").concat(className || '')
      }, React.createElement("input", {
        style: {
          display: 'none'
        },
        type: "checkbox",
        name: name,
        id: id,
        checked: on,
        onChange: onChange,
        disabled: disabled
      }), React.createElement("label", {
        htmlFor: id,
        className: "tumbler__label"
      }, React.createElement("span", {
        className: "tumbler__btn"
      }, onOff && React.createElement(React.Fragment, null, React.createElement("span", {
        className: "tumbler__bg"
      }, React.createElement("i", null, "off"), React.createElement("i", null, "on")), React.createElement("span", {
        className: "tumbler__control"
      }, React.createElement("i", null, "off"), React.createElement("i", null, "on")))), title && React.createElement("span", {
        className: "tumbler__title"
      }, title)));
    }
  }]);
  return Tumbler;
}(Component);

Tumbler.propTypes = {
  onOff: PropTypes__default.bool,
  name: PropTypes__default.string,
  id: PropTypes__default.string,
  className: PropTypes__default.string,
  on: PropTypes__default.bool,
  onChange: PropTypes__default.func.isRequired,
  disabled: PropTypes__default.bool,
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element])
};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var emptyObject = {};

if (process.env.NODE_ENV !== 'production') {
  Object.freeze(emptyObject);
}

var emptyObject_1 = emptyObject;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
}

var invariant_1 = invariant;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */


var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);

emptyFunction.thatReturnsThis = function () {
  return this;
};

emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction_1;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1 = warning;

if (process.env.NODE_ENV !== 'production') {
  var warning$1 = warning_1;
}

var MIXINS_KEY = 'mixins'; // Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.

function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;

if (process.env.NODE_ENV !== 'production') {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */
  var injectedMixins = [];
  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */

  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',
    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',
    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };
  /**
   * Similar to ReactClassInterface but for static methods.
   */

  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };
  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */

  var RESERVED_SPEC_KEYS = {
    displayName: function displayName(Constructor, _displayName) {
      Constructor.displayName = _displayName;
    },
    mixins: function mixins(Constructor, _mixins) {
      if (_mixins) {
        for (var i = 0; i < _mixins.length; i++) {
          mixSpecIntoComponent(Constructor, _mixins[i]);
        }
      }
    },
    childContextTypes: function childContextTypes(Constructor, _childContextTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, _childContextTypes, 'childContext');
      }

      Constructor.childContextTypes = objectAssign({}, Constructor.childContextTypes, _childContextTypes);
    },
    contextTypes: function contextTypes(Constructor, _contextTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, _contextTypes, 'context');
      }

      Constructor.contextTypes = objectAssign({}, Constructor.contextTypes, _contextTypes);
    },

    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function getDefaultProps(Constructor, _getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, _getDefaultProps);
      } else {
        Constructor.getDefaultProps = _getDefaultProps;
      }
    },
    propTypes: function propTypes(Constructor, _propTypes) {
      if (process.env.NODE_ENV !== 'production') {
        validateTypeDef(Constructor, _propTypes, 'prop');
      }

      Constructor.propTypes = objectAssign({}, Constructor.propTypes, _propTypes);
    },
    statics: function statics(Constructor, _statics) {
      mixStaticSpecIntoComponent(Constructor, _statics);
    },
    autobind: function autobind() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (process.env.NODE_ENV !== 'production') {
          warning$1(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName);
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null; // Disallow overriding of base class methods unless explicitly allowed.

    if (ReactClassMixin.hasOwnProperty(name)) {
      invariant_1(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
    } // Disallow defining methods more than once unless explicitly allowed.


    if (isAlreadyDefined) {
      invariant_1(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
    }
  }
  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */


  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (process.env.NODE_ENV !== 'production') {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning$1(isMixinValid, "%s: You're attempting to include a mixin that is either null " + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec);
        }
      }

      return;
    }

    invariant_1(typeof spec !== 'function', "ReactClass: You're attempting to " + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
    invariant_1(!isValidElement(spec), "ReactClass: You're attempting to " + 'use a component as a mixin. Instead, just use a regular object.');
    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs; // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.

    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name]; // These cases should already be caught by validateMethodOverride.

            invariant_1(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name); // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.

            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;

            if (process.env.NODE_ENV !== 'production') {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];

      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      invariant_1(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
      var isAlreadyDefined = name in Constructor;

      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
        invariant_1(specPolicy === 'DEFINE_MANY_MERGED', 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
        Constructor[name] = createMergedResultFunction(Constructor[name], property);
        return;
      }

      Constructor[name] = property;
    }
  }
  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */


  function mergeIntoWithNoDuplicateKeys(one, two) {
    invariant_1(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        invariant_1(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
        one[key] = two[key];
      }
    }

    return one;
  }
  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */


  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);

      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }

      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }
  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */


  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }
  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */


  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);

    if (process.env.NODE_ENV !== 'production') {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;

      boundMethod.bind = function (newThis) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        } // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.


        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning$1(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName);
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning$1(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName);
          }

          return boundMethod;
        }

        var reboundMethod = _bind.apply(boundMethod, arguments);

        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }

    return boundMethod;
  }
  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */


  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;

    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function componentDidMount() {
      this.__isMounted = true;
    }
  };
  var IsMountedPostMixin = {
    componentWillUnmount: function componentWillUnmount() {
      this.__isMounted = false;
    }
  };
  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */

  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function replaceState(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function isMounted() {
      if (process.env.NODE_ENV !== 'production') {
        warning$1(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component');
        this.__didWarnIsMounted = true;
      }

      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function ReactClassComponent() {};

  objectAssign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */

  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.
      if (process.env.NODE_ENV !== 'production') {
        warning$1(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory');
      } // Wire up auto-binding


      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject_1;
      this.updater = updater || ReactNoopUpdateQueue;
      this.state = null; // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;

      if (process.env.NODE_ENV !== 'production') {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }

      invariant_1(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];
    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin); // Initialize the defaultProps property after all mixins have been merged.

    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (process.env.NODE_ENV !== 'production') {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }

      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    invariant_1(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

    if (process.env.NODE_ENV !== 'production') {
      warning$1(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component');
      warning$1(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component');
      warning$1(!Constructor.prototype.UNSAFE_componentWillRecieveProps, '%s has a method called UNSAFE_componentWillRecieveProps(). ' + 'Did you mean UNSAFE_componentWillReceiveProps()?', spec.displayName || 'A component');
    } // Reduce time spent doing lookups by setting these on the prototype.


    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

var factory_1 = factory;

if (typeof React === 'undefined') {
  throw Error('create-react-class could not find the React object. If you are using script tags, ' + 'make sure that React is being loaded before create-react-class.');
} // Hack to grab NoopUpdateQueue from isomorphic React


var ReactNoopUpdateQueue = new React.Component().updater;
var createReactClass = factory_1(React.Component, React.isValidElement, ReactNoopUpdateQueue);
var momentRange = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e(moment$1__default);
  }(commonjsGlobal, function (t) {
    return function (t) {
      function e(r) {
        if (n[r]) return n[r].exports;
        var o = n[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
      }

      var n = {};
      return e.m = t, e.c = n, e.i = function (t) {
        return t;
      }, e.d = function (t, n, r) {
        e.o(t, n) || Object.defineProperty(t, n, {
          configurable: !1,
          enumerable: !0,
          get: r
        });
      }, e.n = function (t) {
        var n = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return e.d(n, "a", n), n;
      }, e.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, e.p = "", e(e.s = 3);
    }([function (t, e, n) {
      var r = n(5)();

      t.exports = function (t) {
        return t !== r && null !== t;
      };
    }, function (t, e, n) {
      t.exports = n(18)() ? Symbol : n(20);
    }, function (e, n) {
      e.exports = t;
    }, function (t, e, n) {
      function r(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }

      function o(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }

      function i(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function u(t) {
        return t.range = function (e, n) {
          var r = this;
          return "string" == typeof e && y.hasOwnProperty(e) ? new h(t(r).startOf(e), t(r).endOf(e)) : new h(e, n);
        }, t.rangeFromInterval = function (e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t();
          if (t.isMoment(r) || (r = t(r)), !r.isValid()) throw new Error("Invalid date.");
          var o = r.clone().add(n, e),
              i = [];
          return i.push(t.min(r, o)), i.push(t.max(r, o)), new h(i);
        }, t.rangeFromISOString = function (e) {
          var n = a(e),
              r = t.parseZone(n[0]),
              o = t.parseZone(n[1]);
          return new h(r, o);
        }, t.parseZoneRange = t.rangeFromISOString, t.fn.range = t.range, t.range.constructor = h, t.isRange = function (t) {
          return t instanceof h;
        }, t.fn.within = function (t) {
          return t.contains(this.toDate());
        }, t;
      }

      function a(t) {
        return t.split("/");
      }

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.DateRange = void 0;

      var s = function () {
        function t(t, e) {
          var n = [],
              r = !0,
              o = !1,
              i = void 0;

          try {
            for (var u, a = t[Symbol.iterator](); !(r = (u = a.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
              ;
            }
          } catch (t) {
            o = !0, i = t;
          } finally {
            try {
              !r && a.return && a.return();
            } finally {
              if (o) throw i;
            }
          }

          return n;
        }

        return function (e, n) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return t(e, n);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
          c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      },
          f = function () {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
          }
        }

        return function (e, n, r) {
          return n && t(e.prototype, n), r && t(e, r), e;
        };
      }();

      e.extendMoment = u;

      var l = n(2),
          v = r(l),
          d = n(1),
          p = r(d),
          y = {
        year: !0,
        quarter: !0,
        month: !0,
        week: !0,
        day: !0,
        hour: !0,
        minute: !0,
        second: !0
      },
          h = e.DateRange = function () {
        function t(e, n) {
          i(this, t);
          var r = e,
              o = n;
          if (1 === arguments.length || void 0 === n) if ("object" === (void 0 === e ? "undefined" : c(e)) && 2 === e.length) {
            var u = s(e, 2);
            r = u[0], o = u[1];
          } else if ("string" == typeof e) {
            var f = a(e),
                l = s(f, 2);
            r = l[0], o = l[1];
          }
          this.start = r || 0 === r ? (0, v.default)(r) : (0, v.default)(-864e13), this.end = o || 0 === o ? (0, v.default)(o) : (0, v.default)(864e13);
        }

        return f(t, [{
          key: "adjacent",
          value: function value(t) {
            var e = this.start.isSame(t.end),
                n = this.end.isSame(t.start);
            return e && t.start.valueOf() <= this.start.valueOf() || n && t.end.valueOf() >= this.end.valueOf();
          }
        }, {
          key: "add",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              adjacent: !1
            };
            return this.overlaps(t, e) ? new this.constructor(v.default.min(this.start, t.start), v.default.max(this.end, t.end)) : null;
          }
        }, {
          key: "by",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              excludeEnd: !1,
              step: 1
            },
                n = this;
            return o({}, p.default.iterator, function () {
              var r = e.step || 1,
                  o = Math.abs(n.start.diff(n.end, t)) / r,
                  i = e.excludeEnd || !1,
                  u = 0;
              return e.hasOwnProperty("exclusive") && (i = e.exclusive), {
                next: function next() {
                  var e = n.start.clone().add(u * r, t),
                      a = i ? !(u < o) : !(u <= o);
                  return u++, {
                    done: a,
                    value: a ? void 0 : e
                  };
                }
              };
            });
          }
        }, {
          key: "byRange",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              excludeEnd: !1,
              step: 1
            },
                n = this,
                r = e.step || 1,
                i = this.valueOf() / t.valueOf() / r,
                u = Math.floor(i),
                a = e.excludeEnd || !1,
                s = 0;
            return e.hasOwnProperty("exclusive") && (a = e.exclusive), o({}, p.default.iterator, function () {
              return u === 1 / 0 ? {
                done: !0
              } : {
                next: function next() {
                  var e = (0, v.default)(n.start.valueOf() + t.valueOf() * s * r),
                      o = u === i && a ? !(s < u) : !(s <= u);
                  return s++, {
                    done: o,
                    value: o ? void 0 : e
                  };
                }
              };
            });
          }
        }, {
          key: "center",
          value: function value() {
            var t = this.start.valueOf() + this.diff() / 2;
            return (0, v.default)(t);
          }
        }, {
          key: "clone",
          value: function value() {
            return new this.constructor(this.start.clone(), this.end.clone());
          }
        }, {
          key: "contains",
          value: function value(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              excludeStart: !1,
              excludeEnd: !1
            },
                r = this.start.valueOf(),
                o = this.end.valueOf(),
                i = e.valueOf(),
                u = e.valueOf(),
                a = n.excludeStart || !1,
                s = n.excludeEnd || !1;
            n.hasOwnProperty("exclusive") && (a = s = n.exclusive), e instanceof t && (i = e.start.valueOf(), u = e.end.valueOf());
            var c = r < i || r <= i && !a,
                f = o > u || o >= u && !s;
            return c && f;
          }
        }, {
          key: "diff",
          value: function value(t, e) {
            return this.end.diff(this.start, t, e);
          }
        }, {
          key: "duration",
          value: function value(t, e) {
            return this.diff(t, e);
          }
        }, {
          key: "intersect",
          value: function value(t) {
            var e = this.start.valueOf(),
                n = this.end.valueOf(),
                r = t.start.valueOf(),
                o = t.end.valueOf(),
                i = e == n,
                u = r == o;

            if (i) {
              var a = e;
              if (a == r || a == o) return null;
              if (a > r && a < o) return this.clone();
            } else if (u) {
              var s = r;
              if (s == e || s == n) return null;
              if (s > e && s < n) return new this.constructor(s, s);
            }

            return e <= r && r < n && n < o ? new this.constructor(r, n) : r < e && e < o && o <= n ? new this.constructor(e, o) : r < e && e <= n && n < o ? this.clone() : e <= r && r <= o && o <= n ? new this.constructor(r, o) : null;
          }
        }, {
          key: "isEqual",
          value: function value(t) {
            return this.start.isSame(t.start) && this.end.isSame(t.end);
          }
        }, {
          key: "isSame",
          value: function value(t) {
            return this.isEqual(t);
          }
        }, {
          key: "overlaps",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              adjacent: !1
            },
                n = null !== this.intersect(t);
            return e.adjacent && !n ? this.adjacent(t) : n;
          }
        }, {
          key: "reverseBy",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              excludeStart: !1,
              step: 1
            },
                n = this;
            return o({}, p.default.iterator, function () {
              var r = e.step || 1,
                  o = Math.abs(n.start.diff(n.end, t)) / r,
                  i = e.excludeStart || !1,
                  u = 0;
              return e.hasOwnProperty("exclusive") && (i = e.exclusive), {
                next: function next() {
                  var e = n.end.clone().subtract(u * r, t),
                      a = i ? !(u < o) : !(u <= o);
                  return u++, {
                    done: a,
                    value: a ? void 0 : e
                  };
                }
              };
            });
          }
        }, {
          key: "reverseByRange",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              excludeStart: !1,
              step: 1
            },
                n = this,
                r = e.step || 1,
                i = this.valueOf() / t.valueOf() / r,
                u = Math.floor(i),
                a = e.excludeStart || !1,
                s = 0;
            return e.hasOwnProperty("exclusive") && (a = e.exclusive), o({}, p.default.iterator, function () {
              return u === 1 / 0 ? {
                done: !0
              } : {
                next: function next() {
                  var e = (0, v.default)(n.end.valueOf() - t.valueOf() * s * r),
                      o = u === i && a ? !(s < u) : !(s <= u);
                  return s++, {
                    done: o,
                    value: o ? void 0 : e
                  };
                }
              };
            });
          }
        }, {
          key: "snapTo",
          value: function value(t) {
            var e = this.clone();
            return e.start.isSame((0, v.default)(-864e13)) || (e.start = e.start.startOf(t)), e.end.isSame((0, v.default)(864e13)) || (e.end = e.end.endOf(t)), e;
          }
        }, {
          key: "subtract",
          value: function value(t) {
            var e = this.start.valueOf(),
                n = this.end.valueOf(),
                r = t.start.valueOf(),
                o = t.end.valueOf();
            return null === this.intersect(t) ? [this] : r <= e && e < n && n <= o ? [] : r <= e && e < o && o < n ? [new this.constructor(o, n)] : e < r && r < n && n <= o ? [new this.constructor(e, r)] : e < r && r < o && o < n ? [new this.constructor(e, r), new this.constructor(o, n)] : e < r && r < n && o < n ? [new this.constructor(e, r), new this.constructor(r, n)] : [];
          }
        }, {
          key: "toDate",
          value: function value() {
            return [this.start.toDate(), this.end.toDate()];
          }
        }, {
          key: "toString",
          value: function value() {
            return this.start.format() + "/" + this.end.format();
          }
        }, {
          key: "valueOf",
          value: function value() {
            return this.end.valueOf() - this.start.valueOf();
          }
        }]), t;
      }();
    }, function (t, e, n) {
      var r,
          o = n(6),
          i = n(13),
          u = n(9),
          a = n(15);
      r = t.exports = function (t, e) {
        var n, r, u, s, c;
        return arguments.length < 2 || "string" != typeof t ? (s = e, e = t, t = null) : s = arguments[2], null == t ? (n = u = !0, r = !1) : (n = a.call(t, "c"), r = a.call(t, "e"), u = a.call(t, "w")), c = {
          value: e,
          configurable: n,
          enumerable: r,
          writable: u
        }, s ? o(i(s), c) : c;
      }, r.gs = function (t, e, n) {
        var r, s, c, f;
        return "string" != typeof t ? (c = n, n = e, e = t, t = null) : c = arguments[3], null == e ? e = void 0 : u(e) ? null == n ? n = void 0 : u(n) || (c = n, n = void 0) : (c = e, e = n = void 0), null == t ? (r = !0, s = !1) : (r = a.call(t, "c"), s = a.call(t, "e")), f = {
          get: e,
          set: n,
          configurable: r,
          enumerable: s
        }, c ? o(i(c), f) : f;
      };
    }, function (t, e, n) {
      t.exports = function () {};
    }, function (t, e, n) {
      t.exports = n(7)() ? Object.assign : n(8);
    }, function (t, e, n) {
      t.exports = function () {
        var t,
            e = Object.assign;
        return "function" == typeof e && (t = {
          foo: "raz"
        }, e(t, {
          bar: "dwa"
        }, {
          trzy: "trzy"
        }), t.foo + t.bar + t.trzy === "razdwatrzy");
      };
    }, function (t, e, n) {
      var r = n(10),
          o = n(14),
          i = Math.max;

      t.exports = function (t, e) {
        var n,
            u,
            a,
            s = i(arguments.length, 2);

        for (t = Object(o(t)), a = function a(r) {
          try {
            t[r] = e[r];
          } catch (t) {
            n || (n = t);
          }
        }, u = 1; u < s; ++u) {
          e = arguments[u], r(e).forEach(a);
        }

        if (void 0 !== n) throw n;
        return t;
      };
    }, function (t, e, n) {
      t.exports = function (t) {
        return "function" == typeof t;
      };
    }, function (t, e, n) {
      t.exports = n(11)() ? Object.keys : n(12);
    }, function (t, e, n) {
      t.exports = function () {
        try {
          return Object.keys("primitive"), !0;
        } catch (t) {
          return !1;
        }
      };
    }, function (t, e, n) {
      var r = n(0),
          o = Object.keys;

      t.exports = function (t) {
        return o(r(t) ? Object(t) : t);
      };
    }, function (t, e, n) {
      var r = n(0),
          o = Array.prototype.forEach,
          i = Object.create,
          u = function u(t, e) {
        var n;

        for (n in t) {
          e[n] = t[n];
        }
      };

      t.exports = function (t) {
        var e = i(null);
        return o.call(arguments, function (t) {
          r(t) && u(Object(t), e);
        }), e;
      };
    }, function (t, e, n) {
      var r = n(0);

      t.exports = function (t) {
        if (!r(t)) throw new TypeError("Cannot use null or undefined");
        return t;
      };
    }, function (t, e, n) {
      t.exports = n(16)() ? String.prototype.contains : n(17);
    }, function (t, e, n) {
      var r = "razdwatrzy";

      t.exports = function () {
        return "function" == typeof r.contains && !0 === r.contains("dwa") && !1 === r.contains("foo");
      };
    }, function (t, e, n) {
      var r = String.prototype.indexOf;

      t.exports = function (t) {
        return r.call(this, t, arguments[1]) > -1;
      };
    }, function (t, e, n) {
      var r = {
        object: !0,
        symbol: !0
      };

      t.exports = function () {
        var t;
        if ("function" != typeof Symbol) return !1;
        t = Symbol("test symbol");

        try {
          String(t);
        } catch (t) {
          return !1;
        }

        return !!r[typeof Symbol.iterator] && !!r[typeof Symbol.toPrimitive] && !!r[typeof Symbol.toStringTag];
      };
    }, function (t, e, n) {
      t.exports = function (t) {
        return !!t && ("symbol" == typeof t || !!t.constructor && "Symbol" === t.constructor.name && "Symbol" === t[t.constructor.toStringTag]);
      };
    }, function (t, e, n) {
      var r,
          o,
          _i2,
          u,
          a = n(4),
          s = n(21),
          c = Object.create,
          f = Object.defineProperties,
          l = Object.defineProperty,
          v = Object.prototype,
          d = c(null);

      if ("function" == typeof Symbol) {
        r = Symbol;

        try {
          String(r()), u = !0;
        } catch (t) {}
      }

      var p = function () {
        var t = c(null);
        return function (e) {
          for (var n, r, o = 0; t[e + (o || "")];) {
            ++o;
          }

          return e += o || "", t[e] = !0, n = "@@" + e, l(v, n, a.gs(null, function (t) {
            r || (r = !0, l(this, n, a(t)), r = !1);
          })), n;
        };
      }();

      _i2 = function i(t) {
        if (this instanceof _i2) throw new TypeError("Symbol is not a constructor");
        return o(t);
      }, t.exports = o = function t(e) {
        var n;
        if (this instanceof t) throw new TypeError("Symbol is not a constructor");
        return u ? r(e) : (n = c(_i2.prototype), e = void 0 === e ? "" : String(e), f(n, {
          __description__: a("", e),
          __name__: a("", p(e))
        }));
      }, f(o, {
        for: a(function (t) {
          return d[t] ? d[t] : d[t] = o(String(t));
        }),
        keyFor: a(function (t) {
          var e;
          s(t);

          for (e in d) {
            if (d[e] === t) return e;
          }
        }),
        hasInstance: a("", r && r.hasInstance || o("hasInstance")),
        isConcatSpreadable: a("", r && r.isConcatSpreadable || o("isConcatSpreadable")),
        iterator: a("", r && r.iterator || o("iterator")),
        match: a("", r && r.match || o("match")),
        replace: a("", r && r.replace || o("replace")),
        search: a("", r && r.search || o("search")),
        species: a("", r && r.species || o("species")),
        split: a("", r && r.split || o("split")),
        toPrimitive: a("", r && r.toPrimitive || o("toPrimitive")),
        toStringTag: a("", r && r.toStringTag || o("toStringTag")),
        unscopables: a("", r && r.unscopables || o("unscopables"))
      }), f(_i2.prototype, {
        constructor: a(o),
        toString: a("", function () {
          return this.__name__;
        })
      }), f(o.prototype, {
        toString: a(function () {
          return "Symbol (" + s(this).__description__ + ")";
        }),
        valueOf: a(function () {
          return s(this);
        })
      }), l(o.prototype, o.toPrimitive, a("", function () {
        var t = s(this);
        return "symbol" == typeof t ? t : t.toString();
      })), l(o.prototype, o.toStringTag, a("c", "Symbol")), l(_i2.prototype, o.toStringTag, a("c", o.prototype[o.toStringTag])), l(_i2.prototype, o.toPrimitive, a("c", o.prototype[o.toPrimitive]));
    }, function (t, e, n) {
      var r = n(19);

      t.exports = function (t) {
        if (!r(t)) throw new TypeError(t + " is not a symbol");
        return t;
      };
    }]);
  });
});
var range = unwrapExports(momentRange);
var momentRange$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _moment2 = _interopRequireDefault(moment$1__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var moment = (0, momentRange.extendMoment)(_moment2.default);
  exports.default = moment;
});
unwrapExports(momentRange$1);
var immutable = createCommonjsModule(function (module, exports) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    var SLICE$0 = Array.prototype.slice;

    function createClass(ctor, superClass) {
      if (superClass) {
        ctor.prototype = Object.create(superClass.prototype);
      }

      ctor.prototype.constructor = ctor;
    }

    function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }

    createClass(KeyedIterable, Iterable);

    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }

    createClass(IndexedIterable, Iterable);

    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }

    createClass(SetIterable, Iterable);

    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }

    function isIterable(maybeIterable) {
      return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
    }

    function isKeyed(maybeKeyed) {
      return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
    }

    function isIndexed(maybeIndexed) {
      return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
    }

    function isAssociative(maybeAssociative) {
      return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
    }

    function isOrdered(maybeOrdered) {
      return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
    }

    Iterable.isIterable = isIterable;
    Iterable.isKeyed = isKeyed;
    Iterable.isIndexed = isIndexed;
    Iterable.isAssociative = isAssociative;
    Iterable.isOrdered = isOrdered;
    Iterable.Keyed = KeyedIterable;
    Iterable.Indexed = IndexedIterable;
    Iterable.Set = SetIterable;
    var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@'; // Used for setting prototype methods that IE8 chokes on.

    var DELETE = 'delete'; // Constants describing the size of trie nodes.

    var SHIFT = 5; // Resulted in best performance after ______?

    var SIZE = 1 << SHIFT;
    var MASK = SIZE - 1; // A consistent shared value representing "not set" which equals nothing other
    // than itself, and nothing that could be provided externally.

    var NOT_SET = {}; // Boolean references, Rough equivalent of `bool &`.

    var CHANGE_LENGTH = {
      value: false
    };
    var DID_ALTER = {
      value: false
    };

    function MakeRef(ref) {
      ref.value = false;
      return ref;
    }

    function SetRef(ref) {
      ref && (ref.value = true);
    } // A function which returns a value representing an "owner" for transient writes
    // to tries. The return value will only ever equal itself, and will not equal
    // the return of any subsequent call of this function.


    function OwnerID() {} // http://jsperf.com/copy-array-inline


    function arrCopy(arr, offset) {
      offset = offset || 0;
      var len = Math.max(0, arr.length - offset);
      var newArr = new Array(len);

      for (var ii = 0; ii < len; ii++) {
        newArr[ii] = arr[ii + offset];
      }

      return newArr;
    }

    function ensureSize(iter) {
      if (iter.size === undefined) {
        iter.size = iter.__iterate(returnTrue);
      }

      return iter.size;
    }

    function wrapIndex(iter, index) {
      // This implements "is array index" which the ECMAString spec defines as:
      //
      //     A String property name P is an array index if and only if
      //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
      //     to 2^32−1.
      //
      // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
      if (typeof index !== 'number') {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32

        if ('' + uint32Index !== index || uint32Index === 4294967295) {
          return NaN;
        }

        index = uint32Index;
      }

      return index < 0 ? ensureSize(iter) + index : index;
    }

    function returnTrue() {
      return true;
    }

    function wholeSlice(begin, end, size) {
      return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
    }

    function resolveBegin(begin, size) {
      return resolveIndex(begin, size, 0);
    }

    function resolveEnd(end, size) {
      return resolveIndex(end, size, size);
    }

    function resolveIndex(index, size, defaultIndex) {
      return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
    }
    /* global Symbol */


    var ITERATE_KEYS = 0;
    var ITERATE_VALUES = 1;
    var ITERATE_ENTRIES = 2;
    var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;

    function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function () {
      return '[Iterator]';
    };

    Iterator.KEYS = ITERATE_KEYS;
    Iterator.VALUES = ITERATE_VALUES;
    Iterator.ENTRIES = ITERATE_ENTRIES;

    Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
      return this.toString();
    };

    Iterator.prototype[ITERATOR_SYMBOL] = function () {
      return this;
    };

    function iteratorValue(type, k, v, iteratorResult) {
      var value = type === 0 ? k : type === 1 ? v : [k, v];
      iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
      };
      return iteratorResult;
    }

    function iteratorDone() {
      return {
        value: undefined,
        done: true
      };
    }

    function hasIterator(maybeIterable) {
      return !!getIteratorFn(maybeIterable);
    }

    function isIterator(maybeIterator) {
      return maybeIterator && typeof maybeIterator.next === 'function';
    }

    function getIterator(iterable) {
      var iteratorFn = getIteratorFn(iterable);
      return iteratorFn && iteratorFn.call(iterable);
    }

    function getIteratorFn(iterable) {
      var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);

      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    function isArrayLike(value) {
      return value && typeof value.length === 'number';
    }

    createClass(Seq, Iterable);

    function Seq(value) {
      return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function ()
    /*...values*/
    {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function () {
      return this;
    };

    Seq.prototype.toString = function () {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function () {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }

      return this;
    }; // abstract __iterateUncached(fn, reverse)


    Seq.prototype.__iterate = function (fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    }; // abstract __iteratorUncached(type, reverse)


    Seq.prototype.__iterator = function (type, reverse) {
      return seqIterator(this, type, reverse, true);
    };

    createClass(KeyedSeq, Seq);

    function KeyedSeq(value) {
      return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function () {
      return this;
    };

    createClass(IndexedSeq, Seq);

    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function ()
    /*...values*/
    {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function () {
      return this;
    };

    IndexedSeq.prototype.toString = function () {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function (fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function (type, reverse) {
      return seqIterator(this, type, reverse, false);
    };

    createClass(SetSeq, Seq);

    function SetSeq(value) {
      return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
    }

    SetSeq.of = function ()
    /*...values*/
    {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function () {
      return this;
    };

    Seq.isSeq = isSeq;
    Seq.Keyed = KeyedSeq;
    Seq.Set = SetSeq;
    Seq.Indexed = IndexedSeq;
    var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
    Seq.prototype[IS_SEQ_SENTINEL] = true;
    createClass(ArraySeq, IndexedSeq);

    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function (index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function (fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;

      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }

      return ii;
    };

    ArraySeq.prototype.__iterator = function (type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function () {
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
      });
    };

    createClass(ObjectSeq, KeyedSeq);

    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function (key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }

      return this._object[key];
    };

    ObjectSeq.prototype.has = function (key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function (fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;

      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];

        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }

      return ii;
    };

    ObjectSeq.prototype.__iterator = function (type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function () {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
      });
    };

    ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(IterableSeq, IndexedSeq);

    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function (fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }

      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;

      if (isIterator(iterator)) {
        var step;

        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }

      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function (type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }

      var iterable = this._iterable;
      var iterator = getIterator(iterable);

      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }

      var iterations = 0;
      return new Iterator(function () {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };

    createClass(IteratorSeq, IndexedSeq);

    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function (fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }

      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;

      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }

      var step;

      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;

        if (fn(val, iterations++, this) === false) {
          break;
        }
      }

      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function (type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }

      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function () {
        if (iterations >= cache.length) {
          var step = iterator.next();

          if (step.done) {
            return step;
          }

          cache[iterations] = step.value;
        }

        return iteratorValue(type, iterations, cache[iterations++]);
      });
    }; // # pragma Helper functions


    function isSeq(maybeSeq) {
      return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
    }

    var EMPTY_SEQ;

    function emptySequence() {
      return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
    }

    function keyedSeqFromValue(value) {
      var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === 'object' ? new ObjectSeq(value) : undefined;

      if (!seq) {
        throw new TypeError('Expected Array or iterable object of [k, v] entries, ' + 'or keyed object: ' + value);
      }

      return seq;
    }

    function indexedSeqFromValue(value) {
      var seq = maybeIndexedSeqFromValue(value);

      if (!seq) {
        throw new TypeError('Expected Array or iterable object of values: ' + value);
      }

      return seq;
    }

    function seqFromValue(value) {
      var seq = maybeIndexedSeqFromValue(value) || typeof value === 'object' && new ObjectSeq(value);

      if (!seq) {
        throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
      }

      return seq;
    }

    function maybeIndexedSeqFromValue(value) {
      return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
    }

    function seqIterate(seq, fn, reverse, useKeys) {
      var cache = seq._cache;

      if (cache) {
        var maxIndex = cache.length - 1;

        for (var ii = 0; ii <= maxIndex; ii++) {
          var entry = cache[reverse ? maxIndex - ii : ii];

          if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
            return ii + 1;
          }
        }

        return ii;
      }

      return seq.__iterateUncached(fn, reverse);
    }

    function seqIterator(seq, type, reverse, useKeys) {
      var cache = seq._cache;

      if (cache) {
        var maxIndex = cache.length - 1;
        var ii = 0;
        return new Iterator(function () {
          var entry = cache[reverse ? maxIndex - ii : ii];
          return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
        });
      }

      return seq.__iteratorUncached(type, reverse);
    }

    function fromJS(json, converter) {
      return converter ? fromJSWith(converter, json, '', {
        '': json
      }) : fromJSDefault(json);
    }

    function fromJSWith(converter, json, key, parentJSON) {
      if (Array.isArray(json)) {
        return converter.call(parentJSON, key, IndexedSeq(json).map(function (v, k) {
          return fromJSWith(converter, v, k, json);
        }));
      }

      if (isPlainObj(json)) {
        return converter.call(parentJSON, key, KeyedSeq(json).map(function (v, k) {
          return fromJSWith(converter, v, k, json);
        }));
      }

      return json;
    }

    function fromJSDefault(json) {
      if (Array.isArray(json)) {
        return IndexedSeq(json).map(fromJSDefault).toList();
      }

      if (isPlainObj(json)) {
        return KeyedSeq(json).map(fromJSDefault).toMap();
      }

      return json;
    }

    function isPlainObj(value) {
      return value && (value.constructor === Object || value.constructor === undefined);
    }
    /**
     * An extension of the "same-value" algorithm as [described for use by ES6 Map
     * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
     *
     * NaN is considered the same as NaN, however -0 and 0 are considered the same
     * value, which is different from the algorithm described by
     * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
     *
     * This is extended further to allow Objects to describe the values they
     * represent, by way of `valueOf` or `equals` (and `hashCode`).
     *
     * Note: because of this extension, the key equality of Immutable.Map and the
     * value equality of Immutable.Set will differ from ES6 Map and Set.
     *
     * ### Defining custom values
     *
     * The easiest way to describe the value an object represents is by implementing
     * `valueOf`. For example, `Date` represents a value by returning a unix
     * timestamp for `valueOf`:
     *
     *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
     *     var date2 = new Date(1234567890000);
     *     date1.valueOf(); // 1234567890000
     *     assert( date1 !== date2 );
     *     assert( Immutable.is( date1, date2 ) );
     *
     * Note: overriding `valueOf` may have other implications if you use this object
     * where JavaScript expects a primitive, such as implicit string coercion.
     *
     * For more complex types, especially collections, implementing `valueOf` may
     * not be performant. An alternative is to implement `equals` and `hashCode`.
     *
     * `equals` takes another object, presumably of similar type, and returns true
     * if the it is equal. Equality is symmetrical, so the same result should be
     * returned if this and the argument are flipped.
     *
     *     assert( a.equals(b) === b.equals(a) );
     *
     * `hashCode` returns a 32bit integer number representing the object which will
     * be used to determine how to store the value object in a Map or Set. You must
     * provide both or neither methods, one must not exist without the other.
     *
     * Also, an important relationship between these methods must be upheld: if two
     * values are equal, they *must* return the same hashCode. If the values are not
     * equal, they might have the same hashCode; this is called a hash collision,
     * and while undesirable for performance reasons, it is acceptable.
     *
     *     if (a.equals(b)) {
     *       assert( a.hashCode() === b.hashCode() );
     *     }
     *
     * All Immutable collections implement `equals` and `hashCode`.
     *
     */


    function is(valueA, valueB) {
      if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
        return true;
      }

      if (!valueA || !valueB) {
        return false;
      }

      if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();

        if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
          return true;
        }

        if (!valueA || !valueB) {
          return false;
        }
      }

      if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) {
        return true;
      }

      return false;
    }

    function deepEqual(a, b) {
      if (a === b) {
        return true;
      }

      if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) {
        return false;
      }

      if (a.size === 0 && b.size === 0) {
        return true;
      }

      var notAssociative = !isAssociative(a);

      if (isOrdered(a)) {
        var entries = a.entries();
        return b.every(function (v, k) {
          var entry = entries.next().value;
          return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
      }

      var flipped = false;

      if (a.size === undefined) {
        if (b.size === undefined) {
          if (typeof a.cacheResult === 'function') {
            a.cacheResult();
          }
        } else {
          flipped = true;
          var _ = a;
          a = b;
          b = _;
        }
      }

      var allEqual = true;

      var bSize = b.__iterate(function (v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
          allEqual = false;
          return false;
        }
      });

      return allEqual && a.size === bSize;
    }

    createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }

      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);

      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }

        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function () {
      if (this.size === 0) {
        return 'Repeat []';
      }

      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function (index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function (searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function (begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function () {
      return this;
    };

    Repeat.prototype.indexOf = function (searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }

      return -1;
    };

    Repeat.prototype.lastIndexOf = function (searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }

      return -1;
    };

    Repeat.prototype.__iterate = function (fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }

      return ii;
    };

    Repeat.prototype.__iterator = function (type, reverse) {
      var this$0 = this;
      var ii = 0;
      return new Iterator(function () {
        return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
      });
    };

    Repeat.prototype.equals = function (other) {
      return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
    };

    var EMPTY_REPEAT;

    function invariant(condition, error) {
      if (!condition) throw new Error(error);
    }

    createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }

      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;

      if (end === undefined) {
        end = Infinity;
      }

      step = step === undefined ? 1 : Math.abs(step);

      if (end < start) {
        step = -step;
      }

      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);

      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }

        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function () {
      if (this.size === 0) {
        return 'Range []';
      }

      return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
    };

    Range.prototype.get = function (index, notSetValue) {
      return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };

    Range.prototype.includes = function (searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function (begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }

      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);

      if (end <= begin) {
        return new Range(0, 0);
      }

      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function (searchValue) {
      var offsetValue = searchValue - this._start;

      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;

        if (index >= 0 && index < this.size) {
          return index;
        }
      }

      return -1;
    };

    Range.prototype.lastIndexOf = function (searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function (fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;

      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }

        value += reverse ? -step : step;
      }

      return ii;
    };

    Range.prototype.__iterator = function (type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function () {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function (other) {
      return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };

    var EMPTY_RANGE;
    createClass(Collection, Iterable);

    function Collection() {
      throw TypeError('Abstract');
    }

    createClass(KeyedCollection, Collection);

    function KeyedCollection() {}

    createClass(IndexedCollection, Collection);

    function IndexedCollection() {}

    createClass(SetCollection, Collection);

    function SetCollection() {}

    Collection.Keyed = KeyedCollection;
    Collection.Indexed = IndexedCollection;
    Collection.Set = SetCollection;
    var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
      a = a | 0; // int

      b = b | 0; // int

      var c = a & 0xffff;
      var d = b & 0xffff; // Shift by 0 fixes the sign on the high part.

      return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
    }; // v8 has an optimization for storing 31-bit signed numbers.
    // Values which have either 00 or 11 as the high order bits qualify.
    // This function drops the highest order bit in a signed number, maintaining
    // the sign bit.

    function smi(i32) {
      return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
    }

    function hash(o) {
      if (o === false || o === null || o === undefined) {
        return 0;
      }

      if (typeof o.valueOf === 'function') {
        o = o.valueOf();

        if (o === false || o === null || o === undefined) {
          return 0;
        }
      }

      if (o === true) {
        return 1;
      }

      var type = typeof o;

      if (type === 'number') {
        if (o !== o || o === Infinity) {
          return 0;
        }

        var h = o | 0;

        if (h !== o) {
          h ^= o * 0xFFFFFFFF;
        }

        while (o > 0xFFFFFFFF) {
          o /= 0xFFFFFFFF;
          h ^= o;
        }

        return smi(h);
      }

      if (type === 'string') {
        return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
      }

      if (typeof o.hashCode === 'function') {
        return o.hashCode();
      }

      if (type === 'object') {
        return hashJSObj(o);
      }

      if (typeof o.toString === 'function') {
        return hashString(o.toString());
      }

      throw new Error('Value type ' + type + ' cannot be hashed.');
    }

    function cachedHashString(string) {
      var hash = stringHashCache[string];

      if (hash === undefined) {
        hash = hashString(string);

        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
          STRING_HASH_CACHE_SIZE = 0;
          stringHashCache = {};
        }

        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hash;
      }

      return hash;
    } // http://jsperf.com/hashing-strings


    function hashString(string) {
      // This is the hash from JVM
      // The hash code for a string is computed as
      // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
      // where s[i] is the ith character of the string and n is the length of
      // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
      // (exclusive) by dropping high bits.
      var hash = 0;

      for (var ii = 0; ii < string.length; ii++) {
        hash = 31 * hash + string.charCodeAt(ii) | 0;
      }

      return smi(hash);
    }

    function hashJSObj(obj) {
      var hash;

      if (usingWeakMap) {
        hash = weakMap.get(obj);

        if (hash !== undefined) {
          return hash;
        }
      }

      hash = obj[UID_HASH_KEY];

      if (hash !== undefined) {
        return hash;
      }

      if (!canDefineProperty) {
        hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];

        if (hash !== undefined) {
          return hash;
        }

        hash = getIENodeHash(obj);

        if (hash !== undefined) {
          return hash;
        }
      }

      hash = ++objHashUID;

      if (objHashUID & 0x40000000) {
        objHashUID = 0;
      }

      if (usingWeakMap) {
        weakMap.set(obj, hash);
      } else if (isExtensible !== undefined && isExtensible(obj) === false) {
        throw new Error('Non-extensible objects are not allowed as keys.');
      } else if (canDefineProperty) {
        Object.defineProperty(obj, UID_HASH_KEY, {
          'enumerable': false,
          'configurable': false,
          'writable': false,
          'value': hash
        });
      } else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function () {
          return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };

        obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
      } else if (obj.nodeType !== undefined) {
        // At this point we couldn't get the IE `uniqueID` to use as a hash
        // and we couldn't use a non-enumerable property to exploit the
        // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
        // itself.
        obj[UID_HASH_KEY] = hash;
      } else {
        throw new Error('Unable to set a non-enumerable property on object.');
      }

      return hash;
    } // Get references to ES5 object methods.


    var isExtensible = Object.isExtensible; // True if Object.defineProperty works as expected. IE8 fails this test.

    var canDefineProperty = function () {
      try {
        Object.defineProperty({}, '@', {});
        return true;
      } catch (e) {
        return false;
      }
    }(); // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
    // and avoid memory leaks from the IE cloneNode bug.


    function getIENodeHash(node) {
      if (node && node.nodeType > 0) {
        switch (node.nodeType) {
          case 1:
            // Element
            return node.uniqueID;

          case 9:
            // Document
            return node.documentElement && node.documentElement.uniqueID;
        }
      }
    } // If possible, use a WeakMap.


    var usingWeakMap = typeof WeakMap === 'function';
    var weakMap;

    if (usingWeakMap) {
      weakMap = new WeakMap();
    }

    var objHashUID = 0;
    var UID_HASH_KEY = '__immutablehash__';

    if (typeof Symbol === 'function') {
      UID_HASH_KEY = Symbol(UID_HASH_KEY);
    }

    var STRING_HASH_CACHE_MIN_STRLEN = 16;
    var STRING_HASH_CACHE_MAX_SIZE = 255;
    var STRING_HASH_CACHE_SIZE = 0;
    var stringHashCache = {};

    function assertNotInfinite(size) {
      invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
    }

    createClass(Map, KeyedCollection); // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function (map) {
        var iter = KeyedIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function (v, k) {
          return map.set(k, v);
        });
      });
    }

    Map.of = function () {
      var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function (map) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }

          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function () {
      return this.__toString('Map {', '}');
    }; // @pragma Access


    Map.prototype.get = function (k, notSetValue) {
      return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    }; // @pragma Modification


    Map.prototype.set = function (k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function (keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function () {
        return v;
      });
    };

    Map.prototype.remove = function (k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function (keyPath) {
      return this.updateIn(keyPath, function () {
        return NOT_SET;
      });
    };

    Map.prototype.update = function (k, notSetValue, updater) {
      return arguments.length === 1 ? k(this) : this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function (keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }

      var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function () {
      if (this.size === 0) {
        return this;
      }

      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return emptyMap();
    }; // @pragma Composition


    Map.prototype.merge = function ()
    /*...iters*/
    {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function (merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function (keyPath) {
      var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(keyPath, emptyMap(), function (m) {
        return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
      });
    };

    Map.prototype.mergeDeep = function ()
    /*...iters*/
    {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function (merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function (keyPath) {
      var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(keyPath, emptyMap(), function (m) {
        return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
      });
    };

    Map.prototype.sort = function (comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function (mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    }; // @pragma Mutability


    Map.prototype.withMutations = function (fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function () {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function () {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function () {
      return this.__altered;
    };

    Map.prototype.__iterator = function (type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function (entry) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }

      return makeMap(this.size, this._root, ownerID, this.__hash);
    };

    function isMap(maybeMap) {
      return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
    }

    Map.isMap = isMap;
    var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
    var MapPrototype = Map.prototype;
    MapPrototype[IS_MAP_SENTINEL] = true;
    MapPrototype[DELETE] = MapPrototype.remove;
    MapPrototype.removeIn = MapPrototype.deleteIn; // #pragma Trie Nodes

    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
      var entries = this.entries;

      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }

      return notSetValue;
    };

    ArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var entries = this.entries;
      var idx = 0;

      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }

      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };

    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function (shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & bit - 1);
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };

    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      var newCount = this.count;

      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;

        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };

    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function (shift, keyHash, key, notSetValue) {
      var entries = this.entries;

      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }

      return notSetValue;
    };

    HashCollisionNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }

        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;

      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }

      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };

    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function (shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);

      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }

        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    }; // #pragma Iterators


    ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function (fn, reverse) {
      var entries = this.entries;

      for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
          return false;
        }
      }
    };

    BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function (fn, reverse) {
      var nodes = this.nodes;

      for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
        var node = nodes[reverse ? maxIndex - ii : ii];

        if (node && node.iterate(fn, reverse) === false) {
          return false;
        }
      }
    };

    ValueNode.prototype.iterate = function (fn, reverse) {
      return fn(this.entry);
    };

    createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function () {
      var type = this._type;
      var stack = this._stack;

      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;

        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;

          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;

          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];

            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }

              stack = this._stack = mapIteratorFrame(subNode, stack);
            }

            continue;
          }
        }

        stack = this._stack = this._stack.__prev;
      }

      return iteratorDone();
    };

    function mapIteratorValue(type, entry) {
      return iteratorValue(type, entry[0], entry[1]);
    }

    function mapIteratorFrame(node, prev) {
      return {
        node: node,
        index: 0,
        __prev: prev
      };
    }

    function makeMap(size, root, ownerID, hash) {
      var map = Object.create(MapPrototype);
      map.size = size;
      map._root = root;
      map.__ownerID = ownerID;
      map.__hash = hash;
      map.__altered = false;
      return map;
    }

    var EMPTY_MAP;

    function emptyMap() {
      return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
    }

    function updateMap(map, k, v) {
      var newRoot;
      var newSize;

      if (!map._root) {
        if (v === NOT_SET) {
          return map;
        }

        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
      } else {
        var didChangeSize = MakeRef(CHANGE_LENGTH);
        var didAlter = MakeRef(DID_ALTER);
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);

        if (!didAlter.value) {
          return map;
        }

        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
      }

      if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
      }

      return newRoot ? makeMap(newSize, newRoot) : emptyMap();
    }

    function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (!node) {
        if (value === NOT_SET) {
          return node;
        }

        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [key, value]);
      }

      return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
    }

    function isLeafNode(node) {
      return node.constructor === ValueNode || node.constructor === HashCollisionNode;
    }

    function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
      if (node.keyHash === keyHash) {
        return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
      }

      var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
      var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var newNode;
      var nodes = idx1 === idx2 ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);
      return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
    }

    function createNodes(ownerID, entries, key, value) {
      if (!ownerID) {
        ownerID = new OwnerID();
      }

      var node = new ValueNode(ownerID, hash(key), [key, value]);

      for (var ii = 0; ii < entries.length; ii++) {
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
      }

      return node;
    }

    function packNodes(ownerID, nodes, count, excluding) {
      var bitmap = 0;
      var packedII = 0;
      var packedNodes = new Array(count);

      for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
        var node = nodes[ii];

        if (node !== undefined && ii !== excluding) {
          bitmap |= bit;
          packedNodes[packedII++] = node;
        }
      }

      return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
    }

    function expandNodes(ownerID, nodes, bitmap, including, node) {
      var count = 0;
      var expandedNodes = new Array(SIZE);

      for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
        expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
      }

      expandedNodes[including] = node;
      return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
    }

    function mergeIntoMapWith(map, merger, iterables) {
      var iters = [];

      for (var ii = 0; ii < iterables.length; ii++) {
        var value = iterables[ii];
        var iter = KeyedIterable(value);

        if (!isIterable(value)) {
          iter = iter.map(function (v) {
            return fromJS(v);
          });
        }

        iters.push(iter);
      }

      return mergeIntoCollectionWith(map, merger, iters);
    }

    function deepMerger(existing, value, key) {
      return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
    }

    function deepMergerWith(merger) {
      return function (existing, value, key) {
        if (existing && existing.mergeDeepWith && isIterable(value)) {
          return existing.mergeDeepWith(merger, value);
        }

        var nextValue = merger(existing, value, key);
        return is(existing, nextValue) ? existing : nextValue;
      };
    }

    function mergeIntoCollectionWith(collection, merger, iters) {
      iters = iters.filter(function (x) {
        return x.size !== 0;
      });

      if (iters.length === 0) {
        return collection;
      }

      if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
        return collection.constructor(iters[0]);
      }

      return collection.withMutations(function (collection) {
        var mergeIntoMap = merger ? function (value, key) {
          collection.update(key, NOT_SET, function (existing) {
            return existing === NOT_SET ? value : merger(existing, value, key);
          });
        } : function (value, key) {
          collection.set(key, value);
        };

        for (var ii = 0; ii < iters.length; ii++) {
          iters[ii].forEach(mergeIntoMap);
        }
      });
    }

    function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
      var isNotSet = existing === NOT_SET;
      var step = keyPathIter.next();

      if (step.done) {
        var existingValue = isNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
      }

      invariant(isNotSet || existing && existing.set, 'invalid keyPath');
      var key = step.value;
      var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
      var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
      return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
    }

    function popCount(x) {
      x = x - (x >> 1 & 0x55555555);
      x = (x & 0x33333333) + (x >> 2 & 0x33333333);
      x = x + (x >> 4) & 0x0f0f0f0f;
      x = x + (x >> 8);
      x = x + (x >> 16);
      return x & 0x7f;
    }

    function setIn(array, idx, val, canEdit) {
      var newArray = canEdit ? array : arrCopy(array);
      newArray[idx] = val;
      return newArray;
    }

    function spliceIn(array, idx, val, canEdit) {
      var newLen = array.length + 1;

      if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
      }

      var newArray = new Array(newLen);
      var after = 0;

      for (var ii = 0; ii < newLen; ii++) {
        if (ii === idx) {
          newArray[ii] = val;
          after = -1;
        } else {
          newArray[ii] = array[ii + after];
        }
      }

      return newArray;
    }

    function spliceOut(array, idx, canEdit) {
      var newLen = array.length - 1;

      if (canEdit && idx === newLen) {
        array.pop();
        return array;
      }

      var newArray = new Array(newLen);
      var after = 0;

      for (var ii = 0; ii < newLen; ii++) {
        if (ii === idx) {
          after = 1;
        }

        newArray[ii] = array[ii + after];
      }

      return newArray;
    }

    var MAX_ARRAY_MAP_SIZE = SIZE / 4;
    var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
    var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
    createClass(List, IndexedCollection); // @pragma Construction

    function List(value) {
      var empty = emptyList();

      if (value === null || value === undefined) {
        return empty;
      }

      if (isList(value)) {
        return value;
      }

      var iter = IndexedIterable(value);
      var size = iter.size;

      if (size === 0) {
        return empty;
      }

      assertNotInfinite(size);

      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }

      return empty.withMutations(function (list) {
        list.setSize(size);
        iter.forEach(function (v, i) {
          return list.set(i, v);
        });
      });
    }

    List.of = function ()
    /*...values*/
    {
      return this(arguments);
    };

    List.prototype.toString = function () {
      return this.__toString('List [', ']');
    }; // @pragma Access


    List.prototype.get = function (index, notSetValue) {
      index = wrapIndex(this, index);

      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }

      return notSetValue;
    }; // @pragma Modification


    List.prototype.set = function (index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function (index) {
      return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };

    List.prototype.insert = function (index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function () {
      if (this.size === 0) {
        return this;
      }

      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return emptyList();
    };

    List.prototype.push = function ()
    /*...values*/
    {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function (list) {
        setListBounds(list, 0, oldSize + values.length);

        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function () {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function ()
    /*...values*/
    {
      var values = arguments;
      return this.withMutations(function (list) {
        setListBounds(list, -values.length);

        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function () {
      return setListBounds(this, 1);
    }; // @pragma Composition


    List.prototype.merge = function ()
    /*...iters*/
    {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function (merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function ()
    /*...iters*/
    {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function (merger) {
      var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function (size) {
      return setListBounds(this, 0, size);
    }; // @pragma Iteration


    List.prototype.slice = function (begin, end) {
      var size = this.size;

      if (wholeSlice(begin, end, size)) {
        return this;
      }

      return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };

    List.prototype.__iterator = function (type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function () {
        var value = values();
        return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function (fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;

      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }

      return index;
    };

    List.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }

      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };

    function isList(maybeList) {
      return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
    }

    List.isList = isList;
    var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
    var ListPrototype = List.prototype;
    ListPrototype[IS_LIST_SENTINEL] = true;
    ListPrototype[DELETE] = ListPrototype.remove;
    ListPrototype.setIn = MapPrototype.setIn;
    ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
    ListPrototype.update = MapPrototype.update;
    ListPrototype.updateIn = MapPrototype.updateIn;
    ListPrototype.mergeIn = MapPrototype.mergeIn;
    ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    ListPrototype.withMutations = MapPrototype.withMutations;
    ListPrototype.asMutable = MapPrototype.asMutable;
    ListPrototype.asImmutable = MapPrototype.asImmutable;
    ListPrototype.wasAltered = MapPrototype.wasAltered;

    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    } // TODO: seems like these methods are very similar


    VNode.prototype.removeBefore = function (ownerID, level, index) {
      if (index === level ? 1 << level : this.array.length === 0) {
        return this;
      }

      var originIndex = index >>> level & MASK;

      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }

      var removingFirst = originIndex === 0;
      var newChild;

      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);

        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }

      if (removingFirst && !newChild) {
        return this;
      }

      var editable = editableVNode(this, ownerID);

      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }

      if (newChild) {
        editable.array[originIndex] = newChild;
      }

      return editable;
    };

    VNode.prototype.removeAfter = function (ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }

      var sizeIndex = index - 1 >>> level & MASK;

      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;

      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);

        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);

      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }

      return editable;
    };

    var DONE = {};

    function iterateList(list, reverse) {
      var left = list._origin;
      var right = list._capacity;
      var tailPos = getTailOffset(right);
      var tail = list._tail;
      return iterateNodeOrLeaf(list._root, list._level, 0);

      function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
      }

      function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;

        if (to > SIZE) {
          to = SIZE;
        }

        return function () {
          if (from === to) {
            return DONE;
          }

          var idx = reverse ? --to : from++;
          return array && array[idx];
        };
      }

      function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;

        if (to > SIZE) {
          to = SIZE;
        }

        return function () {
          do {
            if (values) {
              var value = values();

              if (value !== DONE) {
                return value;
              }

              values = null;
            }

            if (from === to) {
              return DONE;
            }

            var idx = reverse ? --to : from++;
            values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
          } while (true);
        };
      }
    }

    function makeList(origin, capacity, level, root, tail, ownerID, hash) {
      var list = Object.create(ListPrototype);
      list.size = capacity - origin;
      list._origin = origin;
      list._capacity = capacity;
      list._level = level;
      list._root = root;
      list._tail = tail;
      list.__ownerID = ownerID;
      list.__hash = hash;
      list.__altered = false;
      return list;
    }

    var EMPTY_LIST;

    function emptyList() {
      return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
    }

    function updateList(list, index, value) {
      index = wrapIndex(list, index);

      if (index !== index) {
        return list;
      }

      if (index >= list.size || index < 0) {
        return list.withMutations(function (list) {
          index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
        });
      }

      index += list._origin;
      var newTail = list._tail;
      var newRoot = list._root;
      var didAlter = MakeRef(DID_ALTER);

      if (index >= getTailOffset(list._capacity)) {
        newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
      } else {
        newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
      }

      if (!didAlter.value) {
        return list;
      }

      if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
      }

      return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
    }

    function updateVNode(node, ownerID, level, index, value, didAlter) {
      var idx = index >>> level & MASK;
      var nodeHas = node && idx < node.array.length;

      if (!nodeHas && value === undefined) {
        return node;
      }

      var newNode;

      if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);

        if (newLowerNode === lowerNode) {
          return node;
        }

        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
      }

      if (nodeHas && node.array[idx] === value) {
        return node;
      }

      SetRef(didAlter);
      newNode = editableVNode(node, ownerID);

      if (value === undefined && idx === newNode.array.length - 1) {
        newNode.array.pop();
      } else {
        newNode.array[idx] = value;
      }

      return newNode;
    }

    function editableVNode(node, ownerID) {
      if (ownerID && node && ownerID === node.ownerID) {
        return node;
      }

      return new VNode(node ? node.array.slice() : [], ownerID);
    }

    function listNodeFor(list, rawIndex) {
      if (rawIndex >= getTailOffset(list._capacity)) {
        return list._tail;
      }

      if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;

        while (node && level > 0) {
          node = node.array[rawIndex >>> level & MASK];
          level -= SHIFT;
        }

        return node;
      }
    }

    function setListBounds(list, begin, end) {
      // Sanitize begin & end using this shorthand for ToInt32(argument)
      // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
      if (begin !== undefined) {
        begin = begin | 0;
      }

      if (end !== undefined) {
        end = end | 0;
      }

      var owner = list.__ownerID || new OwnerID();
      var oldOrigin = list._origin;
      var oldCapacity = list._capacity;
      var newOrigin = oldOrigin + begin;
      var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;

      if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
        return list;
      } // If it's going to end after it starts, it's empty.


      if (newOrigin >= newCapacity) {
        return list.clear();
      }

      var newLevel = list._level;
      var newRoot = list._root; // New origin might need creating a higher root.

      var offsetShift = 0;

      while (newOrigin + offsetShift < 0) {
        newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
        newLevel += SHIFT;
        offsetShift += 1 << newLevel;
      }

      if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
      }

      var oldTailOffset = getTailOffset(oldCapacity);
      var newTailOffset = getTailOffset(newCapacity); // New size might need creating a higher root.

      while (newTailOffset >= 1 << newLevel + SHIFT) {
        newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
        newLevel += SHIFT;
      } // Locate or create the new tail.


      var oldTail = list._tail;
      var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail; // Merge Tail into tree.

      if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;

        for (var level = newLevel; level > SHIFT; level -= SHIFT) {
          var idx = oldTailOffset >>> level & MASK;
          node = node.array[idx] = editableVNode(node.array[idx], owner);
        }

        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
      } // If the size has been reduced, there's a chance the tail needs to be trimmed.


      if (newCapacity < oldCapacity) {
        newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
      } // If the new origin is within the tail, then we do not need a root.


      if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin); // Otherwise, if the root has been trimmed, garbage collect.
      } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0; // Identify the new top root node of the subtree of the old root.

        while (newRoot) {
          var beginIndex = newOrigin >>> newLevel & MASK;

          if (beginIndex !== newTailOffset >>> newLevel & MASK) {
            break;
          }

          if (beginIndex) {
            offsetShift += (1 << newLevel) * beginIndex;
          }

          newLevel -= SHIFT;
          newRoot = newRoot.array[beginIndex];
        } // Trim the new sides of the new root.


        if (newRoot && newOrigin > oldOrigin) {
          newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        }

        if (newRoot && newTailOffset < oldTailOffset) {
          newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        }

        if (offsetShift) {
          newOrigin -= offsetShift;
          newCapacity -= offsetShift;
        }
      }

      if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
      }

      return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
    }

    function mergeIntoListWith(list, merger, iterables) {
      var iters = [];
      var maxSize = 0;

      for (var ii = 0; ii < iterables.length; ii++) {
        var value = iterables[ii];
        var iter = IndexedIterable(value);

        if (iter.size > maxSize) {
          maxSize = iter.size;
        }

        if (!isIterable(value)) {
          iter = iter.map(function (v) {
            return fromJS(v);
          });
        }

        iters.push(iter);
      }

      if (maxSize > list.size) {
        list = list.setSize(maxSize);
      }

      return mergeIntoCollectionWith(list, merger, iters);
    }

    function getTailOffset(size) {
      return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
    }

    createClass(OrderedMap, Map); // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function (map) {
        var iter = KeyedIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function (v, k) {
          return map.set(k, v);
        });
      });
    }

    OrderedMap.of = function ()
    /*...values*/
    {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function () {
      return this.__toString('OrderedMap {', '}');
    }; // @pragma Access


    OrderedMap.prototype.get = function (k, notSetValue) {
      var index = this._map.get(k);

      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    }; // @pragma Modification


    OrderedMap.prototype.clear = function () {
      if (this.size === 0) {
        return this;
      }

      if (this.__ownerID) {
        this.size = 0;

        this._map.clear();

        this._list.clear();

        return this;
      }

      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function (k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function (k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function () {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      return this._list.__iterate(function (entry) {
        return entry && fn(entry[1], entry[0], this$0);
      }, reverse);
    };

    OrderedMap.prototype.__iterator = function (type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      var newMap = this._map.__ensureOwner(ownerID);

      var newList = this._list.__ensureOwner(ownerID);

      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }

      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };

    function isOrderedMap(maybeOrderedMap) {
      return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
    }

    OrderedMap.isOrderedMap = isOrderedMap;
    OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
    OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;

    function makeOrderedMap(map, list, ownerID, hash) {
      var omap = Object.create(OrderedMap.prototype);
      omap.size = map ? map.size : 0;
      omap._map = map;
      omap._list = list;
      omap.__ownerID = ownerID;
      omap.__hash = hash;
      return omap;
    }

    var EMPTY_ORDERED_MAP;

    function emptyOrderedMap() {
      return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
    }

    function updateOrderedMap(omap, k, v) {
      var map = omap._map;
      var list = omap._list;
      var i = map.get(k);
      var has = i !== undefined;
      var newMap;
      var newList;

      if (v === NOT_SET) {
        // removed
        if (!has) {
          return omap;
        }

        if (list.size >= SIZE && list.size >= map.size * 2) {
          newList = list.filter(function (entry, idx) {
            return entry !== undefined && i !== idx;
          });
          newMap = newList.toKeyedSeq().map(function (entry) {
            return entry[0];
          }).flip().toMap();

          if (omap.__ownerID) {
            newMap.__ownerID = newList.__ownerID = omap.__ownerID;
          }
        } else {
          newMap = map.remove(k);
          newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
      } else {
        if (has) {
          if (v === list.get(i)[1]) {
            return omap;
          }

          newMap = map;
          newList = list.set(i, [k, v]);
        } else {
          newMap = map.set(k, list.size);
          newList = list.set(list.size, [k, v]);
        }
      }

      if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        return omap;
      }

      return makeOrderedMap(newMap, newList);
    }

    createClass(ToKeyedSequence, KeyedSeq);

    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function (key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function (key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function () {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function () {
      var this$0 = this;
      var reversedSequence = reverseFactory(this, true);

      if (!this._useKeys) {
        reversedSequence.valueSeq = function () {
          return this$0._iter.toSeq().reverse();
        };
      }

      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function (mapper, context) {
      var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);

      if (!this._useKeys) {
        mappedSequence.valueSeq = function () {
          return this$0._iter.toSeq().map(mapper, context);
        };
      }

      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      var ii;
      return this._iter.__iterate(this._useKeys ? function (v, k) {
        return fn(v, k, this$0);
      } : (ii = reverse ? resolveSize(this) : 0, function (v) {
        return fn(v, reverse ? --ii : ii++, this$0);
      }), reverse);
    };

    ToKeyedSequence.prototype.__iterator = function (type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }

      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function () {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

    ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(ToIndexedSequence, IndexedSeq);

    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function (value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function (v) {
        return fn(v, iterations++, this$0);
      }, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function (type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

      var iterations = 0;
      return new Iterator(function () {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value, step);
      });
    };

    createClass(ToSetSequence, SetSeq);

    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function (key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      return this._iter.__iterate(function (v) {
        return fn(v, v, this$0);
      }, reverse);
    };

    ToSetSequence.prototype.__iterator = function (type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

      return new Iterator(function () {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, step.value, step.value, step);
      });
    };

    createClass(FromEntriesSequence, KeyedSeq);

    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function () {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      return this._iter.__iterate(function (entry) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function (type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);

      return new Iterator(function () {
        while (true) {
          var step = iterator.next();

          if (step.done) {
            return step;
          }

          var entry = step.value; // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.

          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
          }
        }
      });
    };

    ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;

    function flipFactory(iterable) {
      var flipSequence = makeSequence(iterable);
      flipSequence._iter = iterable;
      flipSequence.size = iterable.size;

      flipSequence.flip = function () {
        return iterable;
      };

      flipSequence.reverse = function () {
        var reversedSequence = iterable.reverse.apply(this); // super.reverse()

        reversedSequence.flip = function () {
          return iterable.reverse();
        };

        return reversedSequence;
      };

      flipSequence.has = function (key) {
        return iterable.includes(key);
      };

      flipSequence.includes = function (key) {
        return iterable.has(key);
      };

      flipSequence.cacheResult = cacheResultThrough;

      flipSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;
        return iterable.__iterate(function (v, k) {
          return fn(k, v, this$0) !== false;
        }, reverse);
      };

      flipSequence.__iteratorUncached = function (type, reverse) {
        if (type === ITERATE_ENTRIES) {
          var iterator = iterable.__iterator(type, reverse);

          return new Iterator(function () {
            var step = iterator.next();

            if (!step.done) {
              var k = step.value[0];
              step.value[0] = step.value[1];
              step.value[1] = k;
            }

            return step;
          });
        }

        return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
      };

      return flipSequence;
    }

    function mapFactory(iterable, mapper, context) {
      var mappedSequence = makeSequence(iterable);
      mappedSequence.size = iterable.size;

      mappedSequence.has = function (key) {
        return iterable.has(key);
      };

      mappedSequence.get = function (key, notSetValue) {
        var v = iterable.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
      };

      mappedSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;
        return iterable.__iterate(function (v, k, c) {
          return fn(mapper.call(context, v, k, c), k, this$0) !== false;
        }, reverse);
      };

      mappedSequence.__iteratorUncached = function (type, reverse) {
        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

        return new Iterator(function () {
          var step = iterator.next();

          if (step.done) {
            return step;
          }

          var entry = step.value;
          var key = entry[0];
          return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
        });
      };

      return mappedSequence;
    }

    function reverseFactory(iterable, useKeys) {
      var reversedSequence = makeSequence(iterable);
      reversedSequence._iter = iterable;
      reversedSequence.size = iterable.size;

      reversedSequence.reverse = function () {
        return iterable;
      };

      if (iterable.flip) {
        reversedSequence.flip = function () {
          var flipSequence = flipFactory(iterable);

          flipSequence.reverse = function () {
            return iterable.flip();
          };

          return flipSequence;
        };
      }

      reversedSequence.get = function (key, notSetValue) {
        return iterable.get(useKeys ? key : -1 - key, notSetValue);
      };

      reversedSequence.has = function (key) {
        return iterable.has(useKeys ? key : -1 - key);
      };

      reversedSequence.includes = function (value) {
        return iterable.includes(value);
      };

      reversedSequence.cacheResult = cacheResultThrough;

      reversedSequence.__iterate = function (fn, reverse) {
        var this$0 = this;
        return iterable.__iterate(function (v, k) {
          return fn(v, k, this$0);
        }, !reverse);
      };

      reversedSequence.__iterator = function (type, reverse) {
        return iterable.__iterator(type, !reverse);
      };

      return reversedSequence;
    }

    function filterFactory(iterable, predicate, context, useKeys) {
      var filterSequence = makeSequence(iterable);

      if (useKeys) {
        filterSequence.has = function (key) {
          var v = iterable.get(key, NOT_SET);
          return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
        };

        filterSequence.get = function (key, notSetValue) {
          var v = iterable.get(key, NOT_SET);
          return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
        };
      }

      filterSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;
        var iterations = 0;

        iterable.__iterate(function (v, k, c) {
          if (predicate.call(context, v, k, c)) {
            iterations++;
            return fn(v, useKeys ? k : iterations - 1, this$0);
          }
        }, reverse);

        return iterations;
      };

      filterSequence.__iteratorUncached = function (type, reverse) {
        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

        var iterations = 0;
        return new Iterator(function () {
          while (true) {
            var step = iterator.next();

            if (step.done) {
              return step;
            }

            var entry = step.value;
            var key = entry[0];
            var value = entry[1];

            if (predicate.call(context, value, key, iterable)) {
              return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
          }
        });
      };

      return filterSequence;
    }

    function countByFactory(iterable, grouper, context) {
      var groups = Map().asMutable();

      iterable.__iterate(function (v, k) {
        groups.update(grouper.call(context, v, k, iterable), 0, function (a) {
          return a + 1;
        });
      });

      return groups.asImmutable();
    }

    function groupByFactory(iterable, grouper, context) {
      var isKeyedIter = isKeyed(iterable);
      var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();

      iterable.__iterate(function (v, k) {
        groups.update(grouper.call(context, v, k, iterable), function (a) {
          return a = a || [], a.push(isKeyedIter ? [k, v] : v), a;
        });
      });

      var coerce = iterableClass(iterable);
      return groups.map(function (arr) {
        return reify(iterable, coerce(arr));
      });
    }

    function sliceFactory(iterable, begin, end, useKeys) {
      var originalSize = iterable.size; // Sanitize begin & end using this shorthand for ToInt32(argument)
      // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32

      if (begin !== undefined) {
        begin = begin | 0;
      }

      if (end !== undefined) {
        if (end === Infinity) {
          end = originalSize;
        } else {
          end = end | 0;
        }
      }

      if (wholeSlice(begin, end, originalSize)) {
        return iterable;
      }

      var resolvedBegin = resolveBegin(begin, originalSize);
      var resolvedEnd = resolveEnd(end, originalSize); // begin or end will be NaN if they were provided as negative numbers and
      // this iterable's size is unknown. In that case, cache first so there is
      // a known size and these do not resolve to NaN.

      if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
        return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
      } // Note: resolvedEnd is undefined when the original sequence's length is
      // unknown and this slice did not supply an end and should contain all
      // elements after resolvedBegin.
      // In that case, resolvedSize will be NaN and sliceSize will remain undefined.


      var resolvedSize = resolvedEnd - resolvedBegin;
      var sliceSize;

      if (resolvedSize === resolvedSize) {
        sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
      }

      var sliceSeq = makeSequence(iterable); // If iterable.size is undefined, the size of the realized sliceSeq is
      // unknown at this point unless the number of items to slice is 0

      sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

      if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
        sliceSeq.get = function (index, notSetValue) {
          index = wrapIndex(this, index);
          return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
        };
      }

      sliceSeq.__iterateUncached = function (fn, reverse) {
        var this$0 = this;

        if (sliceSize === 0) {
          return 0;
        }

        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }

        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;

        iterable.__iterate(function (v, k) {
          if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
            iterations++;
            return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
          }
        });

        return iterations;
      };

      sliceSeq.__iteratorUncached = function (type, reverse) {
        if (sliceSize !== 0 && reverse) {
          return this.cacheResult().__iterator(type, reverse);
        } // Don't bother instantiating parent iterator if taking 0.


        var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);

        var skipped = 0;
        var iterations = 0;
        return new Iterator(function () {
          while (skipped++ < resolvedBegin) {
            iterator.next();
          }

          if (++iterations > sliceSize) {
            return iteratorDone();
          }

          var step = iterator.next();

          if (useKeys || type === ITERATE_VALUES) {
            return step;
          } else if (type === ITERATE_KEYS) {
            return iteratorValue(type, iterations - 1, undefined, step);
          } else {
            return iteratorValue(type, iterations - 1, step.value[1], step);
          }
        });
      };

      return sliceSeq;
    }

    function takeWhileFactory(iterable, predicate, context) {
      var takeSequence = makeSequence(iterable);

      takeSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;

        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }

        var iterations = 0;

        iterable.__iterate(function (v, k, c) {
          return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
        });

        return iterations;
      };

      takeSequence.__iteratorUncached = function (type, reverse) {
        var this$0 = this;

        if (reverse) {
          return this.cacheResult().__iterator(type, reverse);
        }

        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

        var iterating = true;
        return new Iterator(function () {
          if (!iterating) {
            return iteratorDone();
          }

          var step = iterator.next();

          if (step.done) {
            return step;
          }

          var entry = step.value;
          var k = entry[0];
          var v = entry[1];

          if (!predicate.call(context, v, k, this$0)) {
            iterating = false;
            return iteratorDone();
          }

          return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
      };

      return takeSequence;
    }

    function skipWhileFactory(iterable, predicate, context, useKeys) {
      var skipSequence = makeSequence(iterable);

      skipSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;

        if (reverse) {
          return this.cacheResult().__iterate(fn, reverse);
        }

        var isSkipping = true;
        var iterations = 0;

        iterable.__iterate(function (v, k, c) {
          if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
            iterations++;
            return fn(v, useKeys ? k : iterations - 1, this$0);
          }
        });

        return iterations;
      };

      skipSequence.__iteratorUncached = function (type, reverse) {
        var this$0 = this;

        if (reverse) {
          return this.cacheResult().__iterator(type, reverse);
        }

        var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);

        var skipping = true;
        var iterations = 0;
        return new Iterator(function () {
          var step, k, v;

          do {
            step = iterator.next();

            if (step.done) {
              if (useKeys || type === ITERATE_VALUES) {
                return step;
              } else if (type === ITERATE_KEYS) {
                return iteratorValue(type, iterations++, undefined, step);
              } else {
                return iteratorValue(type, iterations++, step.value[1], step);
              }
            }

            var entry = step.value;
            k = entry[0];
            v = entry[1];
            skipping && (skipping = predicate.call(context, v, k, this$0));
          } while (skipping);

          return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
      };

      return skipSequence;
    }

    function concatFactory(iterable, values) {
      var isKeyedIterable = isKeyed(iterable);
      var iters = [iterable].concat(values).map(function (v) {
        if (!isIterable(v)) {
          v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
        } else if (isKeyedIterable) {
          v = KeyedIterable(v);
        }

        return v;
      }).filter(function (v) {
        return v.size !== 0;
      });

      if (iters.length === 0) {
        return iterable;
      }

      if (iters.length === 1) {
        var singleton = iters[0];

        if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) {
          return singleton;
        }
      }

      var concatSeq = new ArraySeq(iters);

      if (isKeyedIterable) {
        concatSeq = concatSeq.toKeyedSeq();
      } else if (!isIndexed(iterable)) {
        concatSeq = concatSeq.toSetSeq();
      }

      concatSeq = concatSeq.flatten(true);
      concatSeq.size = iters.reduce(function (sum, seq) {
        if (sum !== undefined) {
          var size = seq.size;

          if (size !== undefined) {
            return sum + size;
          }
        }
      }, 0);
      return concatSeq;
    }

    function flattenFactory(iterable, depth, useKeys) {
      var flatSequence = makeSequence(iterable);

      flatSequence.__iterateUncached = function (fn, reverse) {
        var iterations = 0;
        var stopped = false;

        function flatDeep(iter, currentDepth) {
          var this$0 = this;

          iter.__iterate(function (v, k) {
            if ((!depth || currentDepth < depth) && isIterable(v)) {
              flatDeep(v, currentDepth + 1);
            } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
              stopped = true;
            }

            return !stopped;
          }, reverse);
        }

        flatDeep(iterable, 0);
        return iterations;
      };

      flatSequence.__iteratorUncached = function (type, reverse) {
        var iterator = iterable.__iterator(type, reverse);

        var stack = [];
        var iterations = 0;
        return new Iterator(function () {
          while (iterator) {
            var step = iterator.next();

            if (step.done !== false) {
              iterator = stack.pop();
              continue;
            }

            var v = step.value;

            if (type === ITERATE_ENTRIES) {
              v = v[1];
            }

            if ((!depth || stack.length < depth) && isIterable(v)) {
              stack.push(iterator);
              iterator = v.__iterator(type, reverse);
            } else {
              return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
          }

          return iteratorDone();
        });
      };

      return flatSequence;
    }

    function flatMapFactory(iterable, mapper, context) {
      var coerce = iterableClass(iterable);
      return iterable.toSeq().map(function (v, k) {
        return coerce(mapper.call(context, v, k, iterable));
      }).flatten(true);
    }

    function interposeFactory(iterable, separator) {
      var interposedSequence = makeSequence(iterable);
      interposedSequence.size = iterable.size && iterable.size * 2 - 1;

      interposedSequence.__iterateUncached = function (fn, reverse) {
        var this$0 = this;
        var iterations = 0;

        iterable.__iterate(function (v, k) {
          return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
        }, reverse);

        return iterations;
      };

      interposedSequence.__iteratorUncached = function (type, reverse) {
        var iterator = iterable.__iterator(ITERATE_VALUES, reverse);

        var iterations = 0;
        var step;
        return new Iterator(function () {
          if (!step || iterations % 2) {
            step = iterator.next();

            if (step.done) {
              return step;
            }
          }

          return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
      };

      return interposedSequence;
    }

    function sortFactory(iterable, comparator, mapper) {
      if (!comparator) {
        comparator = defaultComparator;
      }

      var isKeyedIterable = isKeyed(iterable);
      var index = 0;
      var entries = iterable.toSeq().map(function (v, k) {
        return [k, v, index++, mapper ? mapper(v, k, iterable) : v];
      }).toArray();
      entries.sort(function (a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
      }).forEach(isKeyedIterable ? function (v, i) {
        entries[i].length = 2;
      } : function (v, i) {
        entries[i] = v[1];
      });
      return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
    }

    function maxFactory(iterable, comparator, mapper) {
      if (!comparator) {
        comparator = defaultComparator;
      }

      if (mapper) {
        var entry = iterable.toSeq().map(function (v, k) {
          return [v, mapper(v, k, iterable)];
        }).reduce(function (a, b) {
          return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
      } else {
        return iterable.reduce(function (a, b) {
          return maxCompare(comparator, a, b) ? b : a;
        });
      }
    }

    function maxCompare(comparator, a, b) {
      var comp = comparator(b, a); // b is considered the new max if the comparator declares them equal, but
      // they are not equal and b is in fact a nullish value.

      return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
    }

    function zipWithFactory(keyIter, zipper, iters) {
      var zipSequence = makeSequence(keyIter);
      zipSequence.size = new ArraySeq(iters).map(function (i) {
        return i.size;
      }).min(); // Note: this a generic base implementation of __iterate in terms of
      // __iterator which may be more generically useful in the future.

      zipSequence.__iterate = function (fn, reverse) {
        /* generic:
        var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
        var step;
        var iterations = 0;
        while (!(step = iterator.next()).done) {
          iterations++;
          if (fn(step.value[1], step.value[0], this) === false) {
            break;
          }
        }
        return iterations;
        */
        // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);

        var step;
        var iterations = 0;

        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }

        return iterations;
      };

      zipSequence.__iteratorUncached = function (type, reverse) {
        var iterators = iters.map(function (i) {
          return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function () {
          var steps;

          if (!isDone) {
            steps = iterators.map(function (i) {
              return i.next();
            });
            isDone = steps.some(function (s) {
              return s.done;
            });
          }

          if (isDone) {
            return iteratorDone();
          }

          return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function (s) {
            return s.value;
          })));
        });
      };

      return zipSequence;
    } // #pragma Helper Functions


    function reify(iter, seq) {
      return isSeq(iter) ? seq : iter.constructor(seq);
    }

    function validateEntry(entry) {
      if (entry !== Object(entry)) {
        throw new TypeError('Expected [K, V] tuple: ' + entry);
      }
    }

    function resolveSize(iter) {
      assertNotInfinite(iter.size);
      return ensureSize(iter);
    }

    function iterableClass(iterable) {
      return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
    }

    function makeSequence(iterable) {
      return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
    }

    function cacheResultThrough() {
      if (this._iter.cacheResult) {
        this._iter.cacheResult();

        this.size = this._iter.size;
        return this;
      } else {
        return Seq.prototype.cacheResult.call(this);
      }
    }

    function defaultComparator(a, b) {
      return a > b ? 1 : a < b ? -1 : 0;
    }

    function forceIterator(keyPath) {
      var iter = getIterator(keyPath);

      if (!iter) {
        // Array might not be iterable in this environment, so we need a fallback
        // to our wrapped type.
        if (!isArrayLike(keyPath)) {
          throw new TypeError('Expected iterable or array-like: ' + keyPath);
        }

        iter = getIterator(Iterable(keyPath));
      }

      return iter;
    }

    createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }

        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }

        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }

        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;
      return RecordType;
    }

    Record.prototype.toString = function () {
      return this.__toString(recordName(this) + ' {', '}');
    }; // @pragma Access


    Record.prototype.has = function (k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function (k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }

      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    }; // @pragma Modification


    Record.prototype.clear = function () {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }

      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function (k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }

      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];

        if (v === defaultVal) {
          return this;
        }
      }

      var newMap = this._map && this._map.set(k, v);

      if (this.__ownerID || newMap === this._map) {
        return this;
      }

      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function (k) {
      if (!this.has(k)) {
        return this;
      }

      var newMap = this._map && this._map.remove(k);

      if (this.__ownerID || newMap === this._map) {
        return this;
      }

      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function () {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function (type, reverse) {
      var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function (_, k) {
        return this$0.get(k);
      }).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function (_, k) {
        return this$0.get(k);
      }).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      var newMap = this._map && this._map.__ensureOwner(ownerID);

      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }

      return makeRecord(this, newMap, ownerID);
    };

    var RecordPrototype = Record.prototype;
    RecordPrototype[DELETE] = RecordPrototype.remove;
    RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
    RecordPrototype.merge = MapPrototype.merge;
    RecordPrototype.mergeWith = MapPrototype.mergeWith;
    RecordPrototype.mergeIn = MapPrototype.mergeIn;
    RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
    RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
    RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    RecordPrototype.setIn = MapPrototype.setIn;
    RecordPrototype.update = MapPrototype.update;
    RecordPrototype.updateIn = MapPrototype.updateIn;
    RecordPrototype.withMutations = MapPrototype.withMutations;
    RecordPrototype.asMutable = MapPrototype.asMutable;
    RecordPrototype.asImmutable = MapPrototype.asImmutable;

    function makeRecord(likeRecord, map, ownerID) {
      var record = Object.create(Object.getPrototypeOf(likeRecord));
      record._map = map;
      record.__ownerID = ownerID;
      return record;
    }

    function recordName(record) {
      return record._name || record.constructor.name || 'Record';
    }

    function setProps(prototype, names) {
      try {
        names.forEach(setProp.bind(undefined, prototype));
      } catch (error) {// Object.defineProperty failed. Probably IE8.
      }
    }

    function setProp(prototype, name) {
      Object.defineProperty(prototype, name, {
        get: function get() {
          return this.get(name);
        },
        set: function set(value) {
          invariant(this.__ownerID, 'Cannot set on an immutable record.');
          this.set(name, value);
        }
      });
    }

    createClass(Set, SetCollection); // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function (set) {
        var iter = SetIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function (v) {
          return set.add(v);
        });
      });
    }

    Set.of = function ()
    /*...values*/
    {
      return this(arguments);
    };

    Set.fromKeys = function (value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function () {
      return this.__toString('Set {', '}');
    }; // @pragma Access


    Set.prototype.has = function (value) {
      return this._map.has(value);
    }; // @pragma Modification


    Set.prototype.add = function (value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function (value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function () {
      return updateSet(this, this._map.clear());
    }; // @pragma Composition


    Set.prototype.union = function () {
      var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function (x) {
        return x.size !== 0;
      });

      if (iters.length === 0) {
        return this;
      }

      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }

      return this.withMutations(function (set) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function (value) {
            return set.add(value);
          });
        }
      });
    };

    Set.prototype.intersect = function () {
      var iters = SLICE$0.call(arguments, 0);

      if (iters.length === 0) {
        return this;
      }

      iters = iters.map(function (iter) {
        return SetIterable(iter);
      });
      var originalSet = this;
      return this.withMutations(function (set) {
        originalSet.forEach(function (value) {
          if (!iters.every(function (iter) {
            return iter.includes(value);
          })) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function () {
      var iters = SLICE$0.call(arguments, 0);

      if (iters.length === 0) {
        return this;
      }

      iters = iters.map(function (iter) {
        return SetIterable(iter);
      });
      var originalSet = this;
      return this.withMutations(function (set) {
        originalSet.forEach(function (value) {
          if (iters.some(function (iter) {
            return iter.includes(value);
          })) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function () {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function (merger) {
      var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function (comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function (mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function () {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function (fn, reverse) {
      var this$0 = this;
      return this._map.__iterate(function (_, k) {
        return fn(k, k, this$0);
      }, reverse);
    };

    Set.prototype.__iterator = function (type, reverse) {
      return this._map.map(function (_, k) {
        return k;
      }).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      var newMap = this._map.__ensureOwner(ownerID);

      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }

      return this.__make(newMap, ownerID);
    };

    function isSet(maybeSet) {
      return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
    }

    Set.isSet = isSet;
    var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
    var SetPrototype = Set.prototype;
    SetPrototype[IS_SET_SENTINEL] = true;
    SetPrototype[DELETE] = SetPrototype.remove;
    SetPrototype.mergeDeep = SetPrototype.merge;
    SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
    SetPrototype.withMutations = MapPrototype.withMutations;
    SetPrototype.asMutable = MapPrototype.asMutable;
    SetPrototype.asImmutable = MapPrototype.asImmutable;
    SetPrototype.__empty = emptySet;
    SetPrototype.__make = makeSet;

    function updateSet(set, newMap) {
      if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
      }

      return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
    }

    function makeSet(map, ownerID) {
      var set = Object.create(SetPrototype);
      set.size = map ? map.size : 0;
      set._map = map;
      set.__ownerID = ownerID;
      return set;
    }

    var EMPTY_SET;

    function emptySet() {
      return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
    }

    createClass(OrderedSet, Set); // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function (set) {
        var iter = SetIterable(value);
        assertNotInfinite(iter.size);
        iter.forEach(function (v) {
          return set.add(v);
        });
      });
    }

    OrderedSet.of = function ()
    /*...values*/
    {
      return this(arguments);
    };

    OrderedSet.fromKeys = function (value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function () {
      return this.__toString('OrderedSet {', '}');
    };

    function isOrderedSet(maybeOrderedSet) {
      return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
    }

    OrderedSet.isOrderedSet = isOrderedSet;
    var OrderedSetPrototype = OrderedSet.prototype;
    OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
    OrderedSetPrototype.__empty = emptyOrderedSet;
    OrderedSetPrototype.__make = makeOrderedSet;

    function makeOrderedSet(map, ownerID) {
      var set = Object.create(OrderedSetPrototype);
      set.size = map ? map.size : 0;
      set._map = map;
      set.__ownerID = ownerID;
      return set;
    }

    var EMPTY_ORDERED_SET;

    function emptyOrderedSet() {
      return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
    }

    createClass(Stack, IndexedCollection); // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
    }

    Stack.of = function ()
    /*...values*/
    {
      return this(arguments);
    };

    Stack.prototype.toString = function () {
      return this.__toString('Stack [', ']');
    }; // @pragma Access


    Stack.prototype.get = function (index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);

      while (head && index--) {
        head = head.next;
      }

      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function () {
      return this._head && this._head.value;
    }; // @pragma Modification


    Stack.prototype.push = function ()
    /*...values*/
    {
      if (arguments.length === 0) {
        return this;
      }

      var newSize = this.size + arguments.length;
      var head = this._head;

      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }

      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function (iter) {
      iter = IndexedIterable(iter);

      if (iter.size === 0) {
        return this;
      }

      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function (value) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });

      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function () {
      return this.slice(1);
    };

    Stack.prototype.unshift = function ()
    /*...values*/
    {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function (iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function () {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function () {
      if (this.size === 0) {
        return this;
      }

      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return emptyStack();
    };

    Stack.prototype.slice = function (begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }

      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);

      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }

      var newSize = this.size - resolvedBegin;
      var head = this._head;

      while (resolvedBegin--) {
        head = head.next;
      }

      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }

      return makeStack(newSize, head);
    }; // @pragma Mutability


    Stack.prototype.__ensureOwner = function (ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }

      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }

      return makeStack(this.size, this._head, ownerID, this.__hash);
    }; // @pragma Iteration


    Stack.prototype.__iterate = function (fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }

      var iterations = 0;
      var node = this._head;

      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }

        node = node.next;
      }

      return iterations;
    };

    Stack.prototype.__iterator = function (type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }

      var iterations = 0;
      var node = this._head;
      return new Iterator(function () {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }

        return iteratorDone();
      });
    };

    function isStack(maybeStack) {
      return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
    }

    Stack.isStack = isStack;
    var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
    var StackPrototype = Stack.prototype;
    StackPrototype[IS_STACK_SENTINEL] = true;
    StackPrototype.withMutations = MapPrototype.withMutations;
    StackPrototype.asMutable = MapPrototype.asMutable;
    StackPrototype.asImmutable = MapPrototype.asImmutable;
    StackPrototype.wasAltered = MapPrototype.wasAltered;

    function makeStack(size, head, ownerID, hash) {
      var map = Object.create(StackPrototype);
      map.size = size;
      map._head = head;
      map.__ownerID = ownerID;
      map.__hash = hash;
      map.__altered = false;
      return map;
    }

    var EMPTY_STACK;

    function emptyStack() {
      return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
    }
    /**
     * Contributes additional methods to a constructor
     */


    function mixin(ctor, methods) {
      var keyCopier = function keyCopier(key) {
        ctor.prototype[key] = methods[key];
      };

      Object.keys(methods).forEach(keyCopier);
      Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
      return ctor;
    }

    Iterable.Iterator = Iterator;
    mixin(Iterable, {
      // ### Conversion to other types
      toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);

        this.valueSeq().__iterate(function (v, i) {
          array[i] = v;
        });

        return array;
      },
      toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
      },
      toJS: function toJS() {
        return this.toSeq().map(function (value) {
          return value && typeof value.toJS === 'function' ? value.toJS() : value;
        }).__toJS();
      },
      toJSON: function toJSON() {
        return this.toSeq().map(function (value) {
          return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
        }).__toJS();
      },
      toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
      },
      toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
      },
      toObject: function toObject() {
        assertNotInfinite(this.size);
        var object = {};

        this.__iterate(function (v, k) {
          object[k] = v;
        });

        return object;
      },
      toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
      },
      toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
      },
      toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
      },
      toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
      },
      toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
      },
      toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
      },
      toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
      },
      // ### Common JavaScript methods and properties
      toString: function toString() {
        return '[Iterable]';
      },
      __toString: function __toString(head, tail) {
        if (this.size === 0) {
          return head + tail;
        }

        return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
      },
      // ### ES6 Collection methods (ES6 Array and Map)
      concat: function concat() {
        var values = SLICE$0.call(arguments, 0);
        return reify(this, concatFactory(this, values));
      },
      includes: function includes(searchValue) {
        return this.some(function (value) {
          return is(value, searchValue);
        });
      },
      entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
      },
      every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;

        this.__iterate(function (v, k, c) {
          if (!predicate.call(context, v, k, c)) {
            returnValue = false;
            return false;
          }
        });

        return returnValue;
      },
      filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
      },
      find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
      },
      forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
      },
      join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? '' + separator : ',';
        var joined = '';
        var isFirst = true;

        this.__iterate(function (v) {
          isFirst ? isFirst = false : joined += separator;
          joined += v !== null && v !== undefined ? v.toString() : '';
        });

        return joined;
      },
      keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
      },
      map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
      },
      reduce: function reduce(reducer, initialReduction, context) {
        assertNotInfinite(this.size);
        var reduction;
        var useFirst;

        if (arguments.length < 2) {
          useFirst = true;
        } else {
          reduction = initialReduction;
        }

        this.__iterate(function (v, k, c) {
          if (useFirst) {
            useFirst = false;
            reduction = v;
          } else {
            reduction = reducer.call(context, reduction, v, k, c);
          }
        });

        return reduction;
      },
      reduceRight: function reduceRight(reducer, initialReduction, context) {
        var reversed = this.toKeyedSeq().reverse();
        return reversed.reduce.apply(reversed, arguments);
      },
      reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
      },
      slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
      },
      some: function some(predicate, context) {
        return !this.every(not(predicate), context);
      },
      sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
      },
      values: function values() {
        return this.__iterator(ITERATE_VALUES);
      },
      // ### More sequential methods
      butLast: function butLast() {
        return this.slice(0, -1);
      },
      isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function () {
          return true;
        });
      },
      count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
      },
      countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
      },
      equals: function equals(other) {
        return deepEqual(this, other);
      },
      entrySeq: function entrySeq() {
        var iterable = this;

        if (iterable._cache) {
          // We cache as an entries array, so we can just return the cache!
          return new ArraySeq(iterable._cache);
        }

        var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();

        entriesSequence.fromEntrySeq = function () {
          return iterable.toSeq();
        };

        return entriesSequence;
      },
      filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
      },
      findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;

        this.__iterate(function (v, k, c) {
          if (predicate.call(context, v, k, c)) {
            found = [k, v];
            return false;
          }
        });

        return found;
      },
      findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
      },
      findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
      },
      findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
      },
      findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
      },
      first: function first() {
        return this.find(returnTrue);
      },
      flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
      },
      flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
      },
      fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
      },
      get: function get(searchKey, notSetValue) {
        return this.find(function (_, key) {
          return is(key, searchKey);
        }, undefined, notSetValue);
      },
      getIn: function getIn(searchKeyPath, notSetValue) {
        var nested = this; // Note: in an ES6 environment, we would prefer:
        // for (var key of searchKeyPath) {

        var iter = forceIterator(searchKeyPath);
        var step;

        while (!(step = iter.next()).done) {
          var key = step.value;
          nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;

          if (nested === NOT_SET) {
            return notSetValue;
          }
        }

        return nested;
      },
      groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
      },
      has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
      },
      hasIn: function hasIn(searchKeyPath) {
        return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
      },
      isSubset: function isSubset(iter) {
        iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
        return this.every(function (value) {
          return iter.includes(value);
        });
      },
      isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
        return iter.isSubset(this);
      },
      keyOf: function keyOf(searchValue) {
        return this.findKey(function (value) {
          return is(value, searchValue);
        });
      },
      keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
      },
      last: function last() {
        return this.toSeq().reverse().first();
      },
      lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
      },
      max: function max(comparator) {
        return maxFactory(this, comparator);
      },
      maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
      },
      min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
      },
      minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
      },
      rest: function rest() {
        return this.slice(1);
      },
      skip: function skip(amount) {
        return this.slice(Math.max(0, amount));
      },
      skipLast: function skipLast(amount) {
        return reify(this, this.toSeq().reverse().skip(amount).reverse());
      },
      skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
      },
      skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
      },
      sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
      },
      take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
      },
      takeLast: function takeLast(amount) {
        return reify(this, this.toSeq().reverse().take(amount).reverse());
      },
      takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
      },
      takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
      },
      valueSeq: function valueSeq() {
        return this.toIndexedSeq();
      },
      // ### Hashable Object
      hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashIterable(this));
      } // ### Internal
      // abstract __iterate(fn, reverse)
      // abstract __iterator(type, reverse)

    }); // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

    var IterablePrototype = Iterable.prototype;
    IterablePrototype[IS_ITERABLE_SENTINEL] = true;
    IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
    IterablePrototype.__toJS = IterablePrototype.toArray;
    IterablePrototype.__toStringMapper = quoteString;

    IterablePrototype.inspect = IterablePrototype.toSource = function () {
      return this.toString();
    };

    IterablePrototype.chain = IterablePrototype.flatMap;
    IterablePrototype.contains = IterablePrototype.includes;
    mixin(KeyedIterable, {
      // ### More sequential methods
      flip: function flip() {
        return reify(this, flipFactory(this));
      },
      mapEntries: function mapEntries(mapper, context) {
        var this$0 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function (v, k) {
          return mapper.call(context, [k, v], iterations++, this$0);
        }).fromEntrySeq());
      },
      mapKeys: function mapKeys(mapper, context) {
        var this$0 = this;
        return reify(this, this.toSeq().flip().map(function (k, v) {
          return mapper.call(context, k, v, this$0);
        }).flip());
      }
    });
    var KeyedIterablePrototype = KeyedIterable.prototype;
    KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
    KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
    KeyedIterablePrototype.__toJS = IterablePrototype.toObject;

    KeyedIterablePrototype.__toStringMapper = function (v, k) {
      return JSON.stringify(k) + ': ' + quoteString(v);
    };

    mixin(IndexedIterable, {
      // ### Conversion to other types
      toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
      },
      // ### ES6 Collection methods (ES6 Array and Map)
      filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
      },
      findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
      },
      indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
      },
      lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
      },
      reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
      },
      slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
      },
      splice: function splice(index, removeNum
      /*, ...values*/
      ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum | 0, 0);

        if (numArgs === 0 || numArgs === 2 && !removeNum) {
          return this;
        } // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.


        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
      },
      // ### More collection methods
      findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
      },
      first: function first() {
        return this.get(0);
      },
      flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
      },
      get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function (_, key) {
          return key === index;
        }, undefined, notSetValue);
      },
      has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
      },
      interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
      },
      interleave: function interleave()
      /*...iterables*/
      {
        var iterables = [this].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
        var interleaved = zipped.flatten(true);

        if (zipped.size) {
          interleaved.size = zipped.size * iterables.length;
        }

        return reify(this, interleaved);
      },
      keySeq: function keySeq() {
        return Range(0, this.size);
      },
      last: function last() {
        return this.get(-1);
      },
      skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
      },
      zip: function zip()
      /*, ...iterables */
      {
        var iterables = [this].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, iterables));
      },
      zipWith: function zipWith(zipper
      /*, ...iterables */
      ) {
        var iterables = arrCopy(arguments);
        iterables[0] = this;
        return reify(this, zipWithFactory(this, zipper, iterables));
      }
    });
    IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
    IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
    mixin(SetIterable, {
      // ### ES6 Collection methods (ES6 Array and Map)
      get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
      },
      includes: function includes(value) {
        return this.has(value);
      },
      // ### More sequential methods
      keySeq: function keySeq() {
        return this.valueSeq();
      }
    });
    SetIterable.prototype.has = IterablePrototype.includes;
    SetIterable.prototype.contains = SetIterable.prototype.includes; // Mixin subclasses

    mixin(KeyedSeq, KeyedIterable.prototype);
    mixin(IndexedSeq, IndexedIterable.prototype);
    mixin(SetSeq, SetIterable.prototype);
    mixin(KeyedCollection, KeyedIterable.prototype);
    mixin(IndexedCollection, IndexedIterable.prototype);
    mixin(SetCollection, SetIterable.prototype); // #pragma Helper functions

    function keyMapper(v, k) {
      return k;
    }

    function entryMapper(v, k) {
      return [k, v];
    }

    function not(predicate) {
      return function () {
        return !predicate.apply(this, arguments);
      };
    }

    function neg(predicate) {
      return function () {
        return -predicate.apply(this, arguments);
      };
    }

    function quoteString(value) {
      return typeof value === 'string' ? JSON.stringify(value) : String(value);
    }

    function defaultZipper() {
      return arrCopy(arguments);
    }

    function defaultNegComparator(a, b) {
      return a < b ? 1 : a > b ? -1 : 0;
    }

    function hashIterable(iterable) {
      if (iterable.size === Infinity) {
        return 0;
      }

      var ordered = isOrdered(iterable);
      var keyed = isKeyed(iterable);
      var h = ordered ? 1 : 0;

      var size = iterable.__iterate(keyed ? ordered ? function (v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
      } : function (v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
      } : ordered ? function (v) {
        h = 31 * h + hash(v) | 0;
      } : function (v) {
        h = h + hash(v) | 0;
      });

      return murmurHashOfSize(size, h);
    }

    function murmurHashOfSize(size, h) {
      h = imul(h, 0xCC9E2D51);
      h = imul(h << 15 | h >>> -15, 0x1B873593);
      h = imul(h << 13 | h >>> -13, 5);
      h = (h + 0xE6546B64 | 0) ^ size;
      h = imul(h ^ h >>> 16, 0x85EBCA6B);
      h = imul(h ^ h >>> 13, 0xC2B2AE35);
      h = smi(h ^ h >>> 16);
      return h;
    }

    function hashMerge(a, b) {
      return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
    }

    var Immutable = {
      Iterable: Iterable,
      Seq: Seq,
      Collection: Collection,
      Map: Map,
      OrderedMap: OrderedMap,
      List: List,
      Stack: Stack,
      Set: Set,
      OrderedSet: OrderedSet,
      Record: Record,
      Range: Range,
      Repeat: Repeat,
      is: is,
      fromJS: fromJS
    };
    return Immutable;
  });
});
/*!
 * calendar.js: inspired by the calendar module from Python
 * Copyright(c) 2011 Luciano Ramalho <luciano@ramalho.org>
 * MIT Licensed
 */

var version = '0.1.0';

var CalendarException = function CalendarException(message) {
  this.message = message;

  this.toString = function () {
    return this.constructor.name + ": " + this.message;
  };
};

var Calendar = function Calendar(firstWeekDay) {
  //properties
  this.firstWeekDay = firstWeekDay || 0; // 0 = Sunday
};

Calendar.prototype = {
  constructor: Calendar,
  weekStartDate: function weekStartDate(date) {
    var startDate = new Date(date.getTime());

    while (startDate.getDay() !== this.firstWeekDay) {
      startDate.setDate(startDate.getDate() - 1);
    }

    return startDate;
  },
  monthDates: function monthDates(year, month, dayFormatter, weekFormatter) {
    if (typeof year !== "number" || year < 1970) {
      throw new CalendarException('year must be a number >= 1970');
    }

    if (typeof month !== "number" || month < 0 || month > 11) {
      throw new CalendarException('month must be a number (Jan is 0)');
    }

    var weeks = [],
        week = [],
        i = 0,
        date = this.weekStartDate(new Date(year, month, 1));

    do {
      for (i = 0; i < 7; i++) {
        week.push(dayFormatter ? dayFormatter(date) : date);
        date = new Date(date.getTime());
        date.setDate(date.getDate() + 1);
      }

      weeks.push(weekFormatter ? weekFormatter(week) : week);
      week = [];
    } while (date.getMonth() <= month && date.getFullYear() === year);

    return weeks;
  },
  monthDays: function monthDays(year, month) {
    var getDayOrZero = function getDayOrZero(date) {
      return date.getMonth() === month ? date.getDate() : 0;
    };

    return this.monthDates(year, month, getDayOrZero);
  },
  monthText: function monthText(year, month) {
    if (typeof year === "undefined") {
      var now = new Date();
      year = now.getFullYear();
      month = now.getMonth();
    }

    var getDayOrBlank = function getDayOrBlank(date) {
      var s = date.getMonth() === month ? date.getDate().toString() : "  ";

      while (s.length < 2) {
        s = " " + s;
      }

      return s;
    };

    var weeks = this.monthDates(year, month, getDayOrBlank, function (week) {
      return week.join(" ");
    });
    return weeks.join("\n");
  }
};
var months = "JAN FEB MAR APR MAY JUN JUL AUG SEP OCT NOV DEC".split(" ");

for (var i = 0; i < months.length; i++) {
  Calendar[months[i]] = i;
}

var Calendar_1 = Calendar;
var calendar = {
  version: version,
  Calendar: Calendar_1
};
var bemCx_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  exports.default = bemCx;

  function bemCx() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var block = options.block,
        element = options.element,
        namespace = options.namespace,
        modifiers = options.modifiers,
        states = options.states;
    var bemClasses = [];
    var baseClassName = void 0;

    if (element) {
      if (namespace) {
        baseClassName = namespace + '-' + block + '__' + element;
      } else {
        baseClassName = block + '__' + element;
      }
    } else {
      if (namespace) {
        baseClassName = namespace + '-' + block;
      } else {
        baseClassName = block;
      }
    }

    bemClasses.push(baseClassName);

    if (states) {
      if ((typeof states === 'undefined' ? 'undefined' : _typeof(states)) === 'object') {
        states = Object.keys(states).filter(function (s) {
          return states[s];
        });
      }

      states.forEach(function (state) {
        bemClasses.push(baseClassName + '--is-' + state);
      });
    }

    if (modifiers) {
      if ((typeof modifiers === 'undefined' ? 'undefined' : _typeof(modifiers)) === 'object') {
        modifiers = Object.keys(modifiers).filter(function (m) {
          return modifiers[m];
        });
      }

      modifiers.forEach(function (modifier) {
        bemClasses.push(baseClassName + '--' + modifier);

        if (states) {
          states.forEach(function (state) {
            bemClasses.push(baseClassName + '--' + modifier + '--is-' + state);
          });
        }
      });
    }

    return bemClasses.join(' ');
  }
});
unwrapExports(bemCx_1);
var BemMixin_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _bemCx2 = _interopRequireDefault(bemCx_1);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var BemMixin = {
    propTypes: {
      bemNamespace: _propTypes2.default.string,
      bemBlock: _propTypes2.default.string
    },
    contextTypes: {
      bemNamespace: _propTypes2.default.string,
      bemBlock: _propTypes2.default.string
    },
    childContextTypes: {
      bemNamespace: _propTypes2.default.string,
      bemBlock: _propTypes2.default.string
    },
    getChildContext: function getChildContext() {
      return {
        bemNamespace: this.getBemNamespace(),
        bemBlock: this.getBemBlock()
      };
    },
    getBemNamespace: function getBemNamespace() {
      if (this.props.bemNamespace) {
        return this.props.bemNamespace;
      }

      if (this.context.bemNamespace) {
        return this.context.bemNamespace;
      }

      return null;
    },
    getBemBlock: function getBemBlock() {
      if (this.props.bemBlock) {
        return this.props.bemBlock;
      }

      if (this.context.bemBlock) {
        return this.context.bemBlock;
      }

      return null;
    },
    cx: function cx() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var opts = {
        namespace: this.getBemNamespace(),
        element: this.constructor.displayName,
        block: this.getBemBlock()
      };
      Object.assign(opts, options);
      return (0, _bemCx2.default)(opts);
    }
  };
  exports.default = BemMixin;
});
unwrapExports(BemMixin_1);
var isMomentRange_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isMomentRange;

  var _momentRange2 = _interopRequireDefault(momentRange$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function isMomentRange(val) {
    return val && val.start && val.end && _momentRange2.default.isMoment(val.start) && _momentRange2.default.isMoment(val.end);
  }
});
unwrapExports(isMomentRange_1);
var CustomPropTypes = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _momentRange2 = _interopRequireDefault(momentRange$1);

  var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = {
    momentOrMomentRange: function momentOrMomentRange(props, propName) {
      var val = props[propName];

      if (!val) {
        return null;
      } else if (_momentRange2.default.isMoment(val)) {
        return null;
      } else if ((0, _isMomentRange2.default)(val)) {
        return null;
      }

      return new Error('\'' + propName + '\' must be a moment or a moment range');
    },
    moment: function moment(props, propName) {
      var val = props[propName];

      if (!val) {
        return null;
      } else if (_momentRange2.default.isMoment(val)) {
        return null;
      }

      return new Error('\'' + propName + '\' must be a moment');
    },
    momentRange: function momentRange(props, propName) {
      var val = props[propName];

      if (!val) {
        return null;
      } else if ((0, _isMomentRange2.default)(val)) {
        return null;
      }

      return new Error('\'' + propName + '\' must be a moment range');
    }
  };
});
unwrapExports(CustomPropTypes);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */

function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */


function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  } // Test for A's keys different from B.


  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty$1.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

var shallowEqual_1 = shallowEqual;
var reactAddonsPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual_1(this.props, nextProps) || !shallowEqual_1(this.state, nextState);
  }
};
var Legend_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  var _createReactClass2 = _interopRequireDefault(createReactClass);

  var _BemMixin2 = _interopRequireDefault(BemMixin_1);

  var _reactAddonsPureRenderMixin2 = _interopRequireDefault(reactAddonsPureRenderMixin);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Legend = (0, _createReactClass2.default)({
    mixins: [_BemMixin2.default, _reactAddonsPureRenderMixin2.default],
    displayName: "Legend",
    propTypes: {
      selectedLabel: _propTypes2.default.string.isRequired,
      stateDefinitions: _propTypes2.default.object.isRequired
    },
    render: function render() {
      var _props = this.props,
          selectedLabel = _props.selectedLabel,
          stateDefinitions = _props.stateDefinitions;
      var items = [];
      var name = void 0;
      var def = void 0;
      var style = void 0;

      for (name in stateDefinitions) {
        def = stateDefinitions[name];

        if (def.label && def.color) {
          style = {
            backgroundColor: def.color
          };
          items.push(_react2.default.createElement('li', {
            className: this.cx({
              element: 'LegendItem'
            }),
            key: name
          }, _react2.default.createElement('span', {
            className: this.cx({
              element: 'LegendItemColor'
            }),
            style: style
          }), _react2.default.createElement('span', {
            className: this.cx({
              element: 'LegendItemLabel'
            })
          }, def.label)));
        }
      }

      return _react2.default.createElement('ul', {
        className: this.cx()
      }, _react2.default.createElement('li', {
        className: this.cx({
          element: 'LegendItem'
        })
      }, _react2.default.createElement('span', {
        className: this.cx({
          element: 'LegendItemColor',
          modifiers: {
            'selection': true
          }
        })
      }), _react2.default.createElement('span', {
        className: this.cx({
          element: 'LegendItemLabel'
        })
      }, selectedLabel)), items);
    }
  });
  exports.default = Legend;
});
unwrapExports(Legend_1);
var areMomentRangesEqual_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = areMomentRangesEqual;

  var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function areMomentRangesEqual(r1, r2) {
    if (!(0, _isMomentRange2.default)(r1) || !(0, _isMomentRange2.default)(r2)) {
      return false;
    }

    return r1.start.isSame(r2.start, 'day') && r1.end.isSame(r2.end, 'day');
  }
});
unwrapExports(areMomentRangesEqual_1);
var shallowEqual_1$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _momentRange2 = _interopRequireDefault(momentRange$1);

  var _areMomentRangesEqual2 = _interopRequireDefault(areMomentRangesEqual_1);

  var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function shallowEqual(objA, objB) {
    if (objA === objB) {
      return true;
    }

    var key; // Test for A's keys different from B.

    for (key in objA) {
      if (objA.hasOwnProperty(key)) {
        if (!objB.hasOwnProperty(key)) {
          return false;
        } else if (_momentRange2.default.isMoment(objA[key]) && _momentRange2.default.isMoment(objB[key])) {
          if (!objA[key].isSame(objB[key], 'day')) {
            return false;
          }
        } else if ((0, _isMomentRange2.default)(objA[key]) && (0, _isMomentRange2.default)(objB[key])) {
          if (!(0, _areMomentRangesEqual2.default)(objA[key], objB[key])) {
            return false;
          }
        } else if (objA[key] !== objB[key]) {
          return false;
        }
      }
    } // Test for B's keys missing from A.


    for (key in objB) {
      if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
        return false;
      }
    }

    return true;
  }

  exports.default = shallowEqual;
});
unwrapExports(shallowEqual_1$1);
var PureRenderMixin_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _shallowEqual2 = _interopRequireDefault(shallowEqual_1$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PureRenderMixin = {
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
    }
  };
  exports.default = PureRenderMixin;
});
unwrapExports(PureRenderMixin_1);
var CalendarMonth_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  var _createReactClass2 = _interopRequireDefault(createReactClass);

  var _momentRange2 = _interopRequireDefault(momentRange$1);

  var _calendar2 = _interopRequireDefault(calendar);

  var _immutable2 = _interopRequireDefault(immutable);

  var _BemMixin2 = _interopRequireDefault(BemMixin_1);

  var _CustomPropTypes2 = _interopRequireDefault(CustomPropTypes);

  var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);

  var _PureRenderMixin2 = _interopRequireDefault(PureRenderMixin_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var CalendarMonth = (0, _createReactClass2.default)({
    mixins: [_BemMixin2.default, _PureRenderMixin2.default],
    displayName: "CalendarMonth",
    propTypes: {
      dateComponent: _propTypes2.default.func,
      disableNavigation: _propTypes2.default.bool,
      enabledRange: _CustomPropTypes2.default.momentRange,
      firstOfMonth: _CustomPropTypes2.default.moment,
      firstOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
      hideSelection: _propTypes2.default.bool,
      highlightedDate: _propTypes2.default.object,
      highlightedRange: _propTypes2.default.object,
      onMonthChange: _propTypes2.default.func,
      onYearChange: _propTypes2.default.func,
      value: _CustomPropTypes2.default.momentOrMomentRange,
      locale: _propTypes2.default.string,
      focusedElement: _propTypes2.default.oneOf(['start', 'end'])
    },
    setLocale: function setLocale(locale) {
      _momentRange2.default.locale(locale);

      this.WEEKDAYS = _immutable2.default.List(_momentRange2.default.weekdays()).zip(_immutable2.default.List(_momentRange2.default.weekdaysShort()));
      this.MONTHS = _immutable2.default.List(_momentRange2.default.months());
    },
    componentWillMount: function componentWillMount() {
      var locale = this.props.locale;
      this.setLocale(locale);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var locale = nextProps.locale;

      if (locale !== this.props.locale) {
        this.setLocale(locale);
      }
    },
    renderDay: function renderDay(date, i) {
      var _props = this.props,
          CalendarDate = _props.dateComponent,
          value = _props.value,
          highlightedDate = _props.highlightedDate,
          highlightedRange = _props.highlightedRange,
          hideSelection = _props.hideSelection,
          enabledRange = _props.enabledRange,
          focusedElement = _props.focusedElement,
          props = _objectWithoutProperties(_props, ['dateComponent', 'value', 'highlightedDate', 'highlightedRange', 'hideSelection', 'enabledRange', 'focusedElement']);

      var d = (0, _momentRange2.default)(date).locale(this.props.locale);
      var isInSelectedRange = void 0;
      var isSelectedDate = void 0;
      var isSelectedRangeStart = void 0;
      var isSelectedRangeEnd = void 0;

      if (!hideSelection && value && _momentRange2.default.isMoment(value) && value.isSame(d, 'day')) {
        isSelectedDate = true;
      } else if (!hideSelection && value && (0, _isMomentRange2.default)(value) && value.contains(d)) {
        isInSelectedRange = true;
        isSelectedRangeStart = value.start.isSame(d, 'day');
        isSelectedRangeEnd = value.end.isSame(d, 'day');
      }

      return _react2.default.createElement(CalendarDate, _extends({
        key: i,
        isToday: d.isSame((0, _momentRange2.default)(), 'day'),
        isDisabled: !enabledRange.contains(d),
        isHighlightedDate: !!(highlightedDate && highlightedDate.isSame(d, 'day')),
        isHighlightedRangeStart: !!(highlightedRange && highlightedRange.start.isSame(d, 'day')),
        isHighlightedRangeEnd: !!(highlightedRange && highlightedRange.end.isSame(d, 'day')),
        isInHighlightedRange: !!(highlightedRange && highlightedRange.contains(d)),
        isSelectedDate: isSelectedDate,
        isSelectedRangeStart: isSelectedRangeStart,
        isSelectedRangeEnd: isSelectedRangeEnd,
        isInSelectedRange: isInSelectedRange,
        date: d,
        focusedElement: focusedElement
      }, props));
    },
    renderWeek: function renderWeek(dates, i) {
      var days = dates.map(this.renderDay);
      return _react2.default.createElement('tr', {
        className: this.cx({
          element: 'Week'
        }),
        key: i
      }, days.toJS());
    },
    renderDayHeaders: function renderDayHeaders() {
      var firstOfWeek = this.props.firstOfWeek;

      var indices = _immutable2.default.Range(firstOfWeek, 7).concat(_immutable2.default.Range(0, firstOfWeek));

      var headers = indices.map(function (index) {
        var weekday = this.WEEKDAYS.get(index);
        return _react2.default.createElement('th', {
          className: this.cx({
            element: 'WeekdayHeading'
          }),
          key: weekday,
          scope: 'col'
        }, _react2.default.createElement('abbr', {
          title: weekday[0]
        }, weekday[1]));
      }.bind(this));
      return _react2.default.createElement('tr', {
        className: this.cx({
          element: 'Weekdays'
        })
      }, headers.toJS());
    },
    handleYearChange: function handleYearChange(event) {
      this.props.onYearChange(parseInt(event.target.value, 10));
    },
    renderYearChoice: function renderYearChoice(year) {
      var enabledRange = this.props.enabledRange;

      if (year < enabledRange.start.year()) {
        return null;
      }

      if (year > enabledRange.end.year()) {
        return null;
      }

      return _react2.default.createElement('option', {
        key: year,
        value: year
      }, (0, _momentRange2.default)(year, 'YYYY').locale(this.props.locale).format('YYYY'));
    },
    renderHeaderYear: function renderHeaderYear() {
      var firstOfMonth = this.props.firstOfMonth;
      var y = firstOfMonth.year();

      var years = _immutable2.default.Range(y - 5, y).concat(_immutable2.default.Range(y, y + 10));

      var choices = years.map(this.renderYearChoice);
      var modifiers = {
        year: true
      };
      return _react2.default.createElement('span', {
        className: this.cx({
          element: 'MonthHeaderLabel',
          modifiers: modifiers
        })
      }, firstOfMonth.locale(this.props.locale).format('YYYY'), this.props.disableNavigation ? null : _react2.default.createElement('select', {
        className: this.cx({
          element: 'MonthHeaderSelect'
        }),
        value: y,
        onChange: this.handleYearChange
      }, choices.toJS()));
    },
    handleMonthChange: function handleMonthChange(event) {
      this.props.onMonthChange(parseInt(event.target.value, 10));
    },
    renderMonthChoice: function renderMonthChoice(month, i) {
      var _props2 = this.props,
          firstOfMonth = _props2.firstOfMonth,
          enabledRange = _props2.enabledRange;
      var disabled = false;
      var year = firstOfMonth.year();

      if ((0, _momentRange2.default)({
        years: year,
        months: i + 1,
        date: 1
      }).unix() < enabledRange.start.unix()) {
        disabled = true;
      }

      if ((0, _momentRange2.default)({
        years: year,
        months: i,
        date: 1
      }).unix() > enabledRange.end.unix()) {
        disabled = true;
      }

      return _react2.default.createElement('option', {
        key: month,
        value: i,
        disabled: disabled ? 'disabled' : null
      }, month);
    },
    renderHeaderMonth: function renderHeaderMonth() {
      var firstOfMonth = this.props.firstOfMonth;
      var choices = this.MONTHS.map(this.renderMonthChoice);
      var modifiers = {
        month: true
      };
      return _react2.default.createElement('span', {
        className: this.cx({
          element: 'MonthHeaderLabel',
          modifiers: modifiers
        })
      }, firstOfMonth.locale(this.props.locale).format('MMMM'), this.props.disableNavigation ? null : _react2.default.createElement('select', {
        className: this.cx({
          element: 'MonthHeaderSelect'
        }),
        value: firstOfMonth.month(),
        onChange: this.handleMonthChange
      }, choices.toJS()));
    },
    renderHeader: function renderHeader() {
      return _react2.default.createElement('div', {
        className: this.cx({
          element: 'MonthHeader'
        })
      }, this.renderHeaderMonth(), ' ', this.renderHeaderYear());
    },
    render: function render() {
      var _props3 = this.props,
          firstOfWeek = _props3.firstOfWeek,
          firstOfMonth = _props3.firstOfMonth;
      var cal = new _calendar2.default.Calendar(firstOfWeek);

      var monthDates = _immutable2.default.fromJS(cal.monthDates(firstOfMonth.year(), firstOfMonth.month()));

      var weeks = monthDates.map(this.renderWeek);
      return _react2.default.createElement('div', {
        className: this.cx({
          element: 'Month'
        })
      }, this.renderHeader(), _react2.default.createElement('table', {
        className: this.cx({
          element: 'MonthDates'
        })
      }, _react2.default.createElement('thead', null, this.renderDayHeaders()), _react2.default.createElement('tbody', null, weeks.toJS())));
    }
  });
  exports.default = CalendarMonth;
});
unwrapExports(CalendarMonth_1);
var lightenDarkenColor_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = lightenDarkenColor;

  function lightenDarkenColor(col, amt) {
    var usePound = false;
    var num = void 0;
    var r = void 0;
    var b = void 0;
    var g = void 0;

    if (col[0] === "#") {
      col = col.slice(1);
      usePound = true;
    }

    num = parseInt(col, 16);
    r = (num >> 16) + amt;

    if (r > 255) {
      r = 255;
    } else if (r < 0) {
      r = 0;
    }

    b = (num >> 8 & 0x00FF) + amt;

    if (b > 255) {
      b = 255;
    } else if (b < 0) {
      b = 0;
    }

    g = (num & 0x0000FF) + amt;

    if (g > 255) {
      g = 255;
    } else if (g < 0) {
      g = 0;
    }

    return (usePound ? "#" : "") + (g | b << 8 | r << 16).toString(16);
  }
});
unwrapExports(lightenDarkenColor_1);
var CalendarDatePeriod_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  var _createReactClass2 = _interopRequireDefault(createReactClass);

  var _BemMixin2 = _interopRequireDefault(BemMixin_1);

  var _PureRenderMixin2 = _interopRequireDefault(PureRenderMixin_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var CalendarDatePeriod = (0, _createReactClass2.default)({
    mixins: [_BemMixin2.default, _PureRenderMixin2.default],
    displayName: "CalendarDatePeriod",
    propTypes: {
      color: _propTypes2.default.string,
      period: _propTypes2.default.string
    },
    render: function render() {
      var _props = this.props,
          color = _props.color,
          period = _props.period;

      var modifiers = _defineProperty({}, period, true);

      var style = void 0;

      if (color) {
        style = {
          backgroundColor: color
        };
      }

      return _react2.default.createElement('div', {
        style: style,
        className: this.cx({
          modifiers: modifiers
        })
      });
    }
  });
  exports.default = CalendarDatePeriod;
});
unwrapExports(CalendarDatePeriod_1);
var CalendarHighlight_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  var _createReactClass2 = _interopRequireDefault(createReactClass);

  var _BemMixin2 = _interopRequireDefault(BemMixin_1);

  var _PureRenderMixin2 = _interopRequireDefault(PureRenderMixin_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var CalendarHighlight = (0, _createReactClass2.default)({
    mixins: [_BemMixin2.default, _PureRenderMixin2.default],
    displayName: "CalendarHighlight",
    propTypes: {
      modifier: _propTypes2.default.string
    },
    render: function render() {
      var modifier = this.props.modifier;

      var modifiers = _defineProperty({}, modifier, true);

      var states = {};
      return _react2.default.createElement('div', {
        className: this.cx({
          states: states,
          modifiers: modifiers
        })
      });
    }
  });
  exports.default = CalendarHighlight;
});
unwrapExports(CalendarHighlight_1);
var CalendarSelection_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  var _createReactClass2 = _interopRequireDefault(createReactClass);

  var _BemMixin2 = _interopRequireDefault(BemMixin_1);

  var _PureRenderMixin2 = _interopRequireDefault(PureRenderMixin_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var CalendarSelection = (0, _createReactClass2.default)({
    mixins: [_BemMixin2.default, _PureRenderMixin2.default],
    displayName: "CalendarSelection",
    propTypes: {
      modifier: _propTypes2.default.string,
      pending: _propTypes2.default.bool.isRequired,
      focused: _propTypes2.default.bool
    },
    render: function render() {
      var _props = this.props,
          modifier = _props.modifier,
          pending = _props.pending,
          focused = _props.focused;

      var modifiers = _defineProperty({}, modifier, true);

      modifiers.focused = focused;
      var states = {
        pending: pending
      };
      return _react2.default.createElement('div', {
        className: this.cx({
          states: states,
          modifiers: modifiers
        })
      });
    }
  });
  exports.default = CalendarSelection;
});
unwrapExports(CalendarSelection_1);
var CalendarDate_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  var _createReactClass2 = _interopRequireDefault(createReactClass);

  var _immutable2 = _interopRequireDefault(immutable);

  var _BemMixin2 = _interopRequireDefault(BemMixin_1);

  var _CustomPropTypes2 = _interopRequireDefault(CustomPropTypes);

  var _PureRenderMixin2 = _interopRequireDefault(PureRenderMixin_1);

  var _lightenDarkenColor2 = _interopRequireDefault(lightenDarkenColor_1);

  var _CalendarDatePeriod2 = _interopRequireDefault(CalendarDatePeriod_1);

  var _CalendarHighlight2 = _interopRequireDefault(CalendarHighlight_1);

  var _CalendarSelection2 = _interopRequireDefault(CalendarSelection_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CalendarDate = (0, _createReactClass2.default)({
    mixins: [_BemMixin2.default, _PureRenderMixin2.default],
    displayName: "CalendarDate",
    propTypes: {
      date: _CustomPropTypes2.default.moment,
      firstOfMonth: _propTypes2.default.object.isRequired,
      isSelectedDate: _propTypes2.default.bool,
      isSelectedRangeStart: _propTypes2.default.bool,
      isSelectedRangeEnd: _propTypes2.default.bool,
      isInSelectedRange: _propTypes2.default.bool,
      isHighlightedDate: _propTypes2.default.bool,
      isHighlightedRangeStart: _propTypes2.default.bool,
      isHighlightedRangeEnd: _propTypes2.default.bool,
      isInHighlightedRange: _propTypes2.default.bool,
      highlightedDate: _propTypes2.default.object,
      dateStates: _propTypes2.default.instanceOf(_immutable2.default.List),
      isDisabled: _propTypes2.default.bool,
      isToday: _propTypes2.default.bool,
      dateRangesForDate: _propTypes2.default.func,
      onHighlightDate: _propTypes2.default.func,
      onUnHighlightDate: _propTypes2.default.func,
      onSelectDate: _propTypes2.default.func,
      focusedElement: _propTypes2.default.oneOf(['start', 'end'])
    },
    getInitialState: function getInitialState() {
      return {
        mouseDown: false
      };
    },
    componentWillUnmount: function componentWillUnmount() {
      this.isUnmounted = true;
      document.removeEventListener('mouseup', this.mouseUp);
      document.removeEventListener('touchend', this.touchEnd);
    },
    mouseUp: function mouseUp() {
      this.props.onSelectDate(this.props.date);

      if (this.isUnmounted) {
        return;
      }

      if (this.state.mouseDown) {
        this.setState({
          mouseDown: false
        });
      }

      document.removeEventListener('mouseup', this.mouseUp);
    },
    mouseDown: function mouseDown() {
      this.setState({
        mouseDown: true
      });
      document.addEventListener('mouseup', this.mouseUp);
    },
    touchEnd: function touchEnd() {
      event.preventDefault();
      this.props.onHighlightDate(this.props.date);
      this.props.onSelectDate(this.props.date);

      if (this.isUnmounted) {
        return;
      }

      if (this.state.mouseDown) {
        this.setState({
          mouseDown: false
        });
      }

      document.removeEventListener('touchend', this.touchEnd);
    },
    touchStart: function touchStart(event) {
      event.preventDefault();
      this.setState({
        mouseDown: true
      });
      document.addEventListener('touchend', this.touchEnd);
    },
    mouseEnter: function mouseEnter() {
      this.props.onHighlightDate(this.props.date);
    },
    mouseLeave: function mouseLeave() {
      if (this.state.mouseDown) {
        this.props.onSelectDate(this.props.date);
        this.setState({
          mouseDown: false
        });
      }

      this.props.onUnHighlightDate(this.props.date);
    },
    getBemModifiers: function getBemModifiers() {
      var _props = this.props,
          date = _props.date,
          firstOfMonth = _props.firstOfMonth,
          today = _props.isToday;
      var otherMonth = false;
      var weekend = false;

      if (date.month() !== firstOfMonth.month()) {
        otherMonth = true;
      }

      if (date.day() === 0 || date.day() === 6) {
        weekend = true;
      }

      return {
        today: today,
        weekend: weekend,
        otherMonth: otherMonth
      };
    },
    getBemStates: function getBemStates() {
      var _props2 = this.props,
          isSelectedDate = _props2.isSelectedDate,
          isInSelectedRange = _props2.isInSelectedRange,
          isInHighlightedRange = _props2.isInHighlightedRange,
          highlighted = _props2.isHighlightedDate,
          disabled = _props2.isDisabled;
      var selected = isSelectedDate || isInSelectedRange || isInHighlightedRange;
      return {
        disabled: disabled,
        highlighted: highlighted,
        selected: selected
      };
    },
    render: function render() {
      var _props3 = this.props,
          date = _props3.date,
          dateRangesForDate = _props3.dateRangesForDate,
          isSelectedDate = _props3.isSelectedDate,
          isSelectedRangeStart = _props3.isSelectedRangeStart,
          isSelectedRangeEnd = _props3.isSelectedRangeEnd,
          isInSelectedRange = _props3.isInSelectedRange,
          isHighlightedDate = _props3.isHighlightedDate,
          isHighlightedRangeStart = _props3.isHighlightedRangeStart,
          isHighlightedRangeEnd = _props3.isHighlightedRangeEnd,
          isInHighlightedRange = _props3.isInHighlightedRange,
          focusedElement = _props3.focusedElement;
      var bemModifiers = this.getBemModifiers();
      var bemStates = this.getBemStates();
      var pending = isInHighlightedRange;
      var color = void 0;
      var amColor = void 0;
      var pmColor = void 0;
      var states = dateRangesForDate(date);
      var numStates = states.count();
      var cellStyle = {};
      var style = {};
      var highlightModifier = void 0;
      var selectionModifier = void 0;
      var focused = void 0;

      if (isSelectedDate || isSelectedRangeStart && isSelectedRangeEnd || isHighlightedRangeStart && isHighlightedRangeEnd) {
        selectionModifier = 'single';
      } else if (isSelectedRangeStart || isHighlightedRangeStart) {
        selectionModifier = 'start';
        focused = focusedElement === 'start';
      } else if (isSelectedRangeEnd || isHighlightedRangeEnd) {
        selectionModifier = 'end';
        focused = focusedElement === 'end';
      } else if (isInSelectedRange || isInHighlightedRange) {
        selectionModifier = 'segment';
      }

      if (isHighlightedDate) {
        highlightModifier = 'single';
      }

      if (numStates === 1) {
        // If there's only one state, it means we're not at a boundary
        color = states.getIn([0, 'color']);

        if (color) {
          style = {
            backgroundColor: color
          };
          cellStyle = {
            borderLeftColor: (0, _lightenDarkenColor2.default)(color, -10),
            borderRightColor: (0, _lightenDarkenColor2.default)(color, -10)
          };
        }
      } else {
        amColor = states.getIn([0, 'color']);
        pmColor = states.getIn([1, 'color']);

        if (amColor) {
          cellStyle.borderLeftColor = (0, _lightenDarkenColor2.default)(amColor, -10);
        }

        if (pmColor) {
          cellStyle.borderRightColor = (0, _lightenDarkenColor2.default)(pmColor, -10);
        }
      }

      return _react2.default.createElement('td', {
        className: this.cx({
          element: 'Date',
          modifiers: bemModifiers,
          states: bemStates
        }),
        style: cellStyle,
        onTouchStart: this.touchStart,
        onMouseEnter: this.mouseEnter,
        onMouseLeave: this.mouseLeave,
        onMouseDown: this.mouseDown
      }, numStates > 1 && _react2.default.createElement('div', {
        className: this.cx({
          element: "HalfDateStates"
        })
      }, _react2.default.createElement(_CalendarDatePeriod2.default, {
        period: 'am',
        color: amColor
      }), _react2.default.createElement(_CalendarDatePeriod2.default, {
        period: 'pm',
        color: pmColor
      })), numStates === 1 && _react2.default.createElement('div', {
        className: this.cx({
          element: "FullDateStates"
        }),
        style: style
      }), selectionModifier ? _react2.default.createElement(_CalendarSelection2.default, {
        modifier: selectionModifier,
        focused: focused,
        pending: pending
      }) : null, _react2.default.createElement('span', {
        className: this.cx({
          element: "DateLabel"
        })
      }, date.format('D')), highlightModifier ? _react2.default.createElement(_CalendarHighlight2.default, {
        modifier: highlightModifier
      }) : null);
    }
  });
  exports.default = CalendarDate;
});
unwrapExports(CalendarDate_1);
var PaginationArrow_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  var _createReactClass2 = _interopRequireDefault(createReactClass);

  var _BemMixin2 = _interopRequireDefault(BemMixin_1);

  var _reactAddonsPureRenderMixin2 = _interopRequireDefault(reactAddonsPureRenderMixin);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var PaginationArrow = (0, _createReactClass2.default)({
    mixins: [_BemMixin2.default, _reactAddonsPureRenderMixin2.default],
    displayName: "PaginationArrow",
    propTypes: {
      disabled: _propTypes2.default.bool,
      onTrigger: _propTypes2.default.func,
      direction: _propTypes2.default.oneOf(['next', 'previous'])
    },
    getDefaultProps: function getDefaultProps() {
      return {
        disabled: false
      };
    },
    render: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          direction = _props.direction,
          onTrigger = _props.onTrigger,
          props = _objectWithoutProperties(_props, ['disabled', 'direction', 'onTrigger']);

      var modifiers = _defineProperty({}, direction, true);

      var states = {
        disabled: disabled
      };
      var elementOpts = {
        modifiers: modifiers,
        states: states
      };
      var iconOpts = {
        element: 'PaginationArrowIcon',
        modifiers: modifiers,
        states: states
      };
      return _react2.default.createElement('div', _extends({
        className: this.cx(elementOpts)
      }, props, {
        onClick: onTrigger
      }), _react2.default.createElement('div', {
        className: this.cx(iconOpts)
      }));
    }
  });
  exports.default = PaginationArrow;
});
unwrapExports(PaginationArrow_1);
var areMomentValuesEqual = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  exports.default = function (previousValue, nextValue) {
    var areBothMoment = _momentRange2.default.isMoment(previousValue) && _momentRange2.default.isMoment(nextValue);

    if (!areBothMoment) {
      return false;
    }

    return previousValue.isSame(nextValue);
  };

  var _momentRange2 = _interopRequireDefault(momentRange$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
});
unwrapExports(areMomentValuesEqual);
var hasUpdatedValue = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  exports.default = function (previousProps, nextProps) {
    var previousValue = previousProps.value;
    var nextValue = nextProps.value;
    return !(previousValue === nextValue || (0, _areMomentValuesEqual2.default)(previousValue, nextValue) || (0, _areMomentRangesEqual2.default)(previousValue, nextValue));
  };

  var _areMomentRangesEqual2 = _interopRequireDefault(areMomentRangesEqual_1);

  var _areMomentValuesEqual2 = _interopRequireDefault(areMomentValuesEqual);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
});
unwrapExports(hasUpdatedValue);
var getYearMonth_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getYearMonthProps = undefined;
  exports.getYearMonth = getYearMonth;

  var _momentRange2 = _interopRequireDefault(momentRange$1);

  var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function getYearMonth(date) {
    if (!_momentRange2.default.isMoment(date)) {
      return undefined;
    }

    return {
      year: date.year(),
      month: date.month()
    };
  }

  var getYearMonthProps = exports.getYearMonthProps = function getYearMonthProps(props) {
    var selectionType = props.selectionType,
        value = props.value,
        initialYear = props.initialYear,
        initialMonth = props.initialMonth;

    if (!(_momentRange2.default.isMoment(value) || (0, _isMomentRange2.default)(value))) {
      return {
        year: initialYear,
        month: initialMonth
      };
    }

    if (selectionType === 'single') {
      return getYearMonth(value);
    }

    return getYearMonth(value.start);
  };
});
unwrapExports(getYearMonth_1);
var getYearMonth_2 = getYearMonth_1.getYearMonthProps;
var getYearMonth_3 = getYearMonth_1.getYearMonth;
var DateRangePicker_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  var _createReactClass2 = _interopRequireDefault(createReactClass);

  var _momentRange2 = _interopRequireDefault(momentRange$1);

  var _immutable2 = _interopRequireDefault(immutable);

  var _calendar2 = _interopRequireDefault(calendar);

  var _BemMixin2 = _interopRequireDefault(BemMixin_1);

  var _CustomPropTypes2 = _interopRequireDefault(CustomPropTypes);

  var _Legend2 = _interopRequireDefault(Legend_1);

  var _CalendarMonth2 = _interopRequireDefault(CalendarMonth_1);

  var _CalendarDate2 = _interopRequireDefault(CalendarDate_1);

  var _PaginationArrow2 = _interopRequireDefault(PaginationArrow_1);

  var _isMomentRange2 = _interopRequireDefault(isMomentRange_1);

  var _hasUpdatedValue2 = _interopRequireDefault(hasUpdatedValue);

  var _reactAddonsPureRenderMixin2 = _interopRequireDefault(reactAddonsPureRenderMixin);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var absoluteMinimum = (0, _momentRange2.default)(new Date(-8640000000000000 / 2)).startOf('day');
  var absoluteMaximum = (0, _momentRange2.default)(new Date(8640000000000000 / 2)).startOf('day');

  function noop() {}

  var DIRECTIONS = {
    next: 'next',
    previous: 'previous'
  };
  var DateRangePicker = (0, _createReactClass2.default)({
    mixins: [_BemMixin2.default, _reactAddonsPureRenderMixin2.default],
    displayName: "DateRangePicker",
    propTypes: {
      bemBlock: _propTypes2.default.string,
      bemNamespace: _propTypes2.default.string,
      className: _propTypes2.default.string,
      dateStates: _propTypes2.default.array,
      // an array of date ranges and their states
      defaultState: _propTypes2.default.string,
      disableNavigation: _propTypes2.default.bool,
      firstOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
      helpMessage: _propTypes2.default.string,
      initialDate: _propTypes2.default.instanceOf(Date),
      initialFromValue: _propTypes2.default.bool,
      initialMonth: _propTypes2.default.number,
      // Overrides values derived from initialDate/initialRange
      initialRange: _propTypes2.default.object,
      initialYear: _propTypes2.default.number,
      // Overrides values derived from initialDate/initialRange
      locale: _propTypes2.default.string,
      maximumDate: _propTypes2.default.instanceOf(Date),
      minimumDate: _propTypes2.default.instanceOf(Date),
      numberOfCalendars: _propTypes2.default.number,
      onHighlightDate: _propTypes2.default.func,
      // triggered when a date is highlighted (hovered)
      onHighlightRange: _propTypes2.default.func,
      // triggered when a range is highlighted (hovered)
      onSelect: _propTypes2.default.func,
      // triggered when a date or range is selectec
      onSelectStart: _propTypes2.default.func,
      // triggered when the first date in a range is selected
      paginationArrowComponent: _propTypes2.default.func,
      selectedLabel: _propTypes2.default.string,
      selectionType: _propTypes2.default.oneOf(['single', 'range']),
      singleDateRange: _propTypes2.default.bool,
      showLegend: _propTypes2.default.bool,
      stateDefinitions: _propTypes2.default.object,
      value: _CustomPropTypes2.default.momentOrMomentRange,
      animate: _propTypes2.default.bool,
      animationAxis: _propTypes2.default.oneOf(['X', 'Y']),
      duration: _propTypes2.default.number,
      focusedElement: _propTypes2.default.oneOf(['start', 'end'])
    },
    getDefaultProps: function getDefaultProps() {
      var date = new Date();
      var initialDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      return {
        bemNamespace: null,
        bemBlock: 'DateRangePicker',
        className: '',
        numberOfCalendars: 1,
        firstOfWeek: 0,
        disableNavigation: false,
        nextLabel: '',
        previousLabel: '',
        initialDate: initialDate,
        initialFromValue: true,
        locale: (0, _momentRange2.default)().locale(),
        selectionType: 'range',
        singleDateRange: false,
        stateDefinitions: {
          '__default': {
            color: null,
            selectable: true,
            label: null
          }
        },
        selectedLabel: "Your selected dates",
        defaultState: '__default',
        dateStates: [],
        showLegend: false,
        onSelect: noop,
        paginationArrowComponent: _PaginationArrow2.default,
        animate: true,
        animationAxis: 'X',
        duration: 500
      };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var _this = this;

      var _props = this.props,
          numberOfCalendars = _props.numberOfCalendars,
          maximumDate = _props.maximumDate;
      var maxDate = new Date(maximumDate);
      var nextDateStates = this.getDateStates(nextProps);
      var nextEnabledRange = this.getEnabledRange(nextProps);
      var value = nextProps.value;
      value = (0, _isMomentRange2.default)(value) ? value.start : value;
      var updatedState = {
        selectedStartDate: this.state.selectedStartDate,
        hideSelection: !!this.state.selectedStartDate,
        dateStates: this.state.dateStates && _immutable2.default.is(this.state.dateStates, nextDateStates) ? this.state.dateStates : nextDateStates,
        enabledRange: this.state.enabledRange && this.state.enabledRange.isSame(nextEnabledRange) ? this.state.enabledRange : nextEnabledRange,
        highlightedRange: !this.state.selectedStartDate
      };

      if ((0, _hasUpdatedValue2.default)(this.props, nextProps)) {
        if (this.state.selectedStartDate) {
          updatedState.hideSelection = false;
          updatedState.selectedStartDate = null;
          this.setState({
            highlightedRange: nextProps.value
          }, function () {
            return _this.completeSelection();
          });
        }

        if (!nextProps.value || !this.isStartOrEndVisible(nextProps)) {
          var yearMonth = (0, getYearMonth_1.getYearMonthProps)(nextProps);
          updatedState.year = yearMonth.year;
          updatedState.month = yearMonth.month;
        }

        if (numberOfCalendars > 1 && maxDate && maxDate.getFullYear() === +value.format('YYYY') && maxDate.getMonth() === +value.format('M') - 1) {
          var momentDate = (0, _momentRange2.default)(maxDate).subtract(numberOfCalendars, 'month');
          updatedState.year = +momentDate.format('YYYY');
          updatedState.month = +momentDate.format('M');
        }
      }

      this.setState(updatedState);
    },
    getInitialState: function getInitialState() {
      var now = new Date();
      var _props2 = this.props,
          initialYear = _props2.initialYear,
          initialMonth = _props2.initialMonth,
          initialFromValue = _props2.initialFromValue,
          value = _props2.value;
      var year = now.getFullYear();
      var month = now.getMonth();

      if (Number.isInteger(initialYear) && Number.isInteger(initialMonth)) {
        year = initialYear;
        month = initialMonth;
      }

      if (initialFromValue && (_momentRange2.default.isMoment(value) || (0, _isMomentRange2.default)(value))) {
        var yearMonth = (0, getYearMonth_1.getYearMonthProps)(this.props);
        month = yearMonth.month;
        year = yearMonth.year;
      }

      return {
        year: year,
        month: month,
        selectedStartDate: null,
        highlightedDate: null,
        highlightRange: null,
        hideSelection: false,
        enabledRange: this.getEnabledRange(this.props),
        dateStates: this.getDateStates(this.props),
        direction: ''
      };
    },
    getEnabledRange: function getEnabledRange(props) {
      var min = props.minimumDate ? (0, _momentRange2.default)(props.minimumDate).startOf('day') : absoluteMinimum;
      var max = props.maximumDate ? (0, _momentRange2.default)(props.maximumDate).startOf('day') : absoluteMaximum;
      return _momentRange2.default.range(min, max);
    },
    getDateStates: function getDateStates(props) {
      var dateStates = props.dateStates,
          defaultState = props.defaultState,
          stateDefinitions = props.stateDefinitions;
      var actualStates = [];
      var minDate = absoluteMinimum;
      var maxDate = absoluteMaximum;
      var dateCursor = (0, _momentRange2.default)(minDate).startOf('day');

      var defs = _immutable2.default.fromJS(stateDefinitions);

      dateStates.forEach(function (s) {
        var r = s.range;
        var start = r.start.startOf('day');
        var end = r.end.startOf('day');

        if (!dateCursor.isSame(start, 'day')) {
          actualStates.push({
            state: defaultState,
            range: _momentRange2.default.range(dateCursor, start)
          });
        }

        actualStates.push(s);
        dateCursor = end;
      });
      actualStates.push({
        state: defaultState,
        range: _momentRange2.default.range(dateCursor, maxDate)
      }); // sanitize date states

      return _immutable2.default.List(actualStates).map(function (s) {
        var def = defs.get(s.state);
        return _immutable2.default.Map({
          range: s.range,
          state: s.state,
          selectable: def.get('selectable', true),
          color: def.get('color')
        });
      });
    },
    isDateDisabled: function isDateDisabled(date) {
      return !this.state.enabledRange.contains(date);
    },
    isDateSelectable: function isDateSelectable(date) {
      return this.dateRangesForDate(date).some(function (r) {
        return r.get('selectable');
      });
    },
    nonSelectableStateRanges: function nonSelectableStateRanges() {
      return this.state.dateStates.filter(function (d) {
        return !d.get('selectable');
      });
    },
    dateRangesForDate: function dateRangesForDate(date) {
      return this.state.dateStates.filter(function (d) {
        return d.get('range').contains(date);
      });
    },
    sanitizeRange: function sanitizeRange(range, forwards) {
      /* Truncates the provided range at the first intersection
       * with a non-selectable state. Using forwards to determine
       * which direction to work
       */
      var blockedRanges = this.nonSelectableStateRanges().map(function (r) {
        return r.get('range');
      });
      var intersect = void 0;

      if (forwards) {
        intersect = blockedRanges.find(function (r) {
          return range.intersect(r);
        });

        if (intersect) {
          return _momentRange2.default.range(range.start, intersect.start);
        }
      } else {
        intersect = blockedRanges.findLast(function (r) {
          return range.intersect(r);
        });

        if (intersect) {
          return _momentRange2.default.range(intersect.end, range.end);
        }
      }

      if (range.start.isBefore(this.state.enabledRange.start)) {
        return _momentRange2.default.range(this.state.enabledRange.start, range.end);
      }

      if (range.end.isAfter(this.state.enabledRange.end)) {
        return _momentRange2.default.range(range.start, this.state.enabledRange.end);
      }

      return range;
    },
    highlightRange: function highlightRange(range) {
      this.setState({
        highlightedRange: range,
        highlightedDate: null
      });

      if (typeof this.props.onHighlightRange === 'function') {
        this.props.onHighlightRange(range, this.statesForRange(range));
      }
    },
    onUnHighlightDate: function onUnHighlightDate() {
      this.setState({
        highlightedDate: null
      });
    },
    onSelectDate: function onSelectDate(date) {
      var selectionType = this.props.selectionType;
      var selectedStartDate = this.state.selectedStartDate;

      if (selectionType === 'range') {
        if (selectedStartDate) {
          this.completeRangeSelection();
        } else if (date && !this.isDateDisabled(date) && this.isDateSelectable(date)) {
          this.startRangeSelection(date);

          if (this.props.singleDateRange) {
            this.highlightRange(_momentRange2.default.range(date, date));
          }
        }
      } else {
        if (!this.isDateDisabled(date) && this.isDateSelectable(date)) {
          this.completeSelection();
        }
      }
    },
    onHighlightDate: function onHighlightDate(date) {
      var selectionType = this.props.selectionType;
      var selectedStartDate = this.state.selectedStartDate;
      var datePair = void 0;
      var range = void 0;
      var forwards = void 0;

      if (selectionType === 'range') {
        if (selectedStartDate) {
          datePair = _immutable2.default.List.of(selectedStartDate, date).sortBy(function (d) {
            return d.unix();
          });
          range = _momentRange2.default.range(datePair.get(0), datePair.get(1));
          forwards = range.start.unix() === selectedStartDate.unix();
          range = this.sanitizeRange(range, forwards);
          this.highlightRange(range);
        } else if (!this.isDateDisabled(date) && this.isDateSelectable(date)) {
          this.highlightDate(date);
        }
      } else {
        if (!this.isDateDisabled(date) && this.isDateSelectable(date)) {
          this.highlightDate(date);
        }
      }
    },
    startRangeSelection: function startRangeSelection(date) {
      this.setState({
        hideSelection: true,
        selectedStartDate: date
      });

      if (typeof this.props.onSelectStart === 'function') {
        this.props.onSelectStart((0, _momentRange2.default)(date));
      }
    },
    statesForDate: function statesForDate(date) {
      return this.state.dateStates.filter(function (d) {
        return date.within(d.get('range'));
      }).map(function (d) {
        return d.get('state');
      });
    },
    statesForRange: function statesForRange(range) {
      if (range.start.isSame(range.end, 'day')) {
        return this.statesForDate(range.start);
      }

      return this.state.dateStates.filter(function (d) {
        return d.get('range').intersect(range);
      }).map(function (d) {
        return d.get('state');
      });
    },
    completeSelection: function completeSelection() {
      var highlightedDate = this.state.highlightedDate;

      if (highlightedDate) {
        this.setState({
          hideSelection: false,
          highlightedDate: null
        });
        this.props.onSelect(highlightedDate, this.statesForDate(highlightedDate));
      }
    },
    completeRangeSelection: function completeRangeSelection() {
      var range = this.state.highlightedRange;

      if (range && (!range.start.isSame(range.end, 'day') || this.props.singleDateRange)) {
        this.setState({
          selectedStartDate: null,
          highlightedRange: null,
          highlightedDate: null,
          hideSelection: false
        });
        this.props.onSelect(range, this.statesForRange(range));
      }
    },
    highlightDate: function highlightDate(date) {
      this.setState({
        highlightedDate: date
      });

      if (typeof this.props.onHighlightDate === 'function') {
        this.props.onHighlightDate(date, this.statesForDate(date));
      }
    },
    getMonthDate: function getMonthDate() {
      return (0, _momentRange2.default)(new Date(this.state.year, this.state.month, 1));
    },
    isStartOrEndVisible: function isStartOrEndVisible(props) {
      var _this2 = this;

      var value = props.value,
          selectionType = props.selectionType,
          numberOfCalendars = props.numberOfCalendars;

      var isVisible = function isVisible(date) {
        var yearMonth = (0, getYearMonth_1.getYearMonth)(date);
        var isSameYear = yearMonth.year === _this2.state.year;
        var isMonthVisible = yearMonth.month === _this2.state.month || numberOfCalendars === 2 && yearMonth.month - 1 === _this2.state.month;
        return isSameYear && isMonthVisible;
      };

      if (selectionType === 'single') {
        return isVisible(value);
      }

      return isVisible(value.start) || isVisible(value.end);
    },
    canMoveBack: function canMoveBack() {
      if (this.getMonthDate().subtract(1, 'days').isBefore(this.state.enabledRange.start)) {
        return false;
      }

      return true;
    },
    moveBack: function moveBack() {
      var monthDate = void 0;

      if (this.canMoveBack()) {
        monthDate = this.getMonthDate();
        monthDate.subtract(1, 'months');
        this.animate(DIRECTIONS.previous, monthDate);
      }
    },
    canMoveForward: function canMoveForward() {
      if (this.getMonthDate().add(this.props.numberOfCalendars, 'months').isAfter(this.state.enabledRange.end)) {
        return false;
      }

      return true;
    },
    moveForward: function moveForward() {
      var monthDate = void 0;

      if (this.canMoveForward()) {
        monthDate = this.getMonthDate();
        monthDate.add(1, 'months');
        this.animate(DIRECTIONS.next, monthDate);
      }
    },
    animate: function animate(direction, monthDate) {
      var _this3 = this;

      var _props3 = this.props,
          animate = _props3.animate,
          duration = _props3.duration;

      if (animate) {
        this.setState({
          direction: direction
        });
        setTimeout(function () {
          _this3.setState(_extends({}, (0, getYearMonth_1.getYearMonth)(monthDate), {
            direction: ''
          }));
        }, duration);
      } else {
        this.setState((0, getYearMonth_1.getYearMonth)(monthDate));
      }
    },
    changeYear: function changeYear(year) {
      var _state = this.state,
          enabledRange = _state.enabledRange,
          month = _state.month;

      if ((0, _momentRange2.default)({
        years: year,
        months: month,
        date: 1
      }).unix() < enabledRange.start.unix()) {
        month = enabledRange.start.month();
      }

      if ((0, _momentRange2.default)({
        years: year,
        months: month + 1,
        date: 1
      }).unix() > enabledRange.end.unix()) {
        month = enabledRange.end.month();
      }

      this.setState({
        year: year,
        month: month
      });
    },
    changeMonth: function changeMonth(date) {
      var _state2 = this.state,
          enabledRange = _state2.enabledRange,
          year = _state2.year;

      if ((0, _momentRange2.default)({
        years: year,
        months: date,
        date: 1
      }).unix() < enabledRange.start.unix()) {
        year += 1;
      }

      this.setState({
        month: date,
        year: year
      });
    },
    rangesOverlap: function rangesOverlap(rangeA, rangeB) {
      if (rangeA.overlaps(rangeB) || rangeA.contains(rangeB.start) || rangeA.contains(rangeB.end)) {
        return true;
      }

      return false;
    },
    renderCalendar: function renderCalendar(index) {
      var _props4 = this.props,
          bemBlock = _props4.bemBlock,
          bemNamespace = _props4.bemNamespace,
          firstOfWeek = _props4.firstOfWeek,
          numberOfCalendars = _props4.numberOfCalendars,
          selectionType = _props4.selectionType,
          value = _props4.value;
      var _state3 = this.state,
          dateStates = _state3.dateStates,
          enabledRange = _state3.enabledRange,
          hideSelection = _state3.hideSelection,
          highlightedDate = _state3.highlightedDate,
          highlightedRange = _state3.highlightedRange;
      var monthDate = this.getMonthDate();
      var year = monthDate.year();
      var month = monthDate.month();
      var key = index + '-' + year + '-' + month;
      var props = void 0;
      monthDate.add(index, 'months');
      var cal = new _calendar2.default.Calendar(firstOfWeek);

      var monthDates = _immutable2.default.fromJS(cal.monthDates(monthDate.year(), monthDate.month()));

      var monthStart = monthDates.first().first();
      var monthEnd = monthDates.last().last();

      var monthRange = _momentRange2.default.range(monthStart, monthEnd);

      if (_momentRange2.default.isMoment(value) && !monthRange.contains(value)) {
        value = null;
      } else if ((0, _isMomentRange2.default)(value) && !this.rangesOverlap(monthRange, value)) {
        value = null;
      }

      if (!_momentRange2.default.isMoment(highlightedDate) || !monthRange.contains(highlightedDate)) {
        highlightedDate = null;
      }

      if (!(0, _isMomentRange2.default)(highlightedRange) || !this.rangesOverlap(monthRange, highlightedRange)) {
        highlightedRange = null;
      }

      props = {
        bemBlock: bemBlock,
        bemNamespace: bemNamespace,
        dateStates: dateStates,
        enabledRange: enabledRange,
        firstOfWeek: firstOfWeek,
        hideSelection: hideSelection,
        highlightedDate: highlightedDate,
        highlightedRange: highlightedRange,
        index: index,
        key: key,
        selectionType: selectionType,
        value: value,
        maxIndex: numberOfCalendars - 1,
        firstOfMonth: monthDate,
        onMonthChange: this.changeMonth,
        onYearChange: this.changeYear,
        onSelectDate: this.onSelectDate,
        onHighlightDate: this.onHighlightDate,
        onUnHighlightDate: this.onUnHighlightDate,
        dateRangesForDate: this.dateRangesForDate,
        dateComponent: _CalendarDate2.default,
        locale: this.props.locale,
        focusedElement: this.props.focusedElement
      };
      return _react2.default.createElement(_CalendarMonth2.default, props);
    },
    getStyle: function getStyle() {
      var direction = this.state.direction;
      var animate = this.props.animate;

      if (!direction || !animate) {
        return null;
      }

      var _props5 = this.props,
          numberOfCalendars = _props5.numberOfCalendars,
          duration = _props5.duration,
          animationAxis = _props5.animationAxis;
      var style = void 0;

      switch (direction) {
        case DIRECTIONS.next:
          {
            style = {
              transition: 'transform ' + duration + 'ms',
              transform: 'translate' + animationAxis + '(-' + 100 / numberOfCalendars + '%)'
            };
            break;
          }

        case DIRECTIONS.previous:
          {
            style = {
              transition: 'transform ' + duration + 'ms',
              transform: 'translate' + animationAxis + '(' + 100 / numberOfCalendars + '%)'
            };
            break;
          }
      }

      return style;
    },
    render: function render() {
      var _props6 = this.props,
          PaginationArrowComponent = _props6.paginationArrowComponent,
          className = _props6.className,
          numberOfCalendars = _props6.numberOfCalendars,
          stateDefinitions = _props6.stateDefinitions,
          selectedLabel = _props6.selectedLabel,
          showLegend = _props6.showLegend,
          helpMessage = _props6.helpMessage;
      var wrapperStyle = this.getStyle();

      var calendars = _immutable2.default.Range(-1, numberOfCalendars + 1).map(this.renderCalendar);

      className = this.cx({
        element: null
      }) + ' ' + className;
      return _react2.default.createElement('div', {
        className: className.trim()
      }, _react2.default.createElement(PaginationArrowComponent, {
        direction: 'previous',
        onTrigger: this.moveBack,
        disabled: !this.canMoveBack()
      }), _react2.default.createElement('div', {
        className: this.cx({
          element: 'MonthWrapper'
        })
      }, _react2.default.createElement('div', {
        className: this.cx({
          element: 'MonthInnerWrapper'
        }),
        style: wrapperStyle
      }, calendars.toJS())), _react2.default.createElement(PaginationArrowComponent, {
        direction: 'next',
        onTrigger: this.moveForward,
        disabled: !this.canMoveForward()
      }), helpMessage ? _react2.default.createElement('span', {
        className: this.cx({
          element: 'HelpMessage'
        })
      }, helpMessage) : null, showLegend ? _react2.default.createElement(_Legend2.default, {
        stateDefinitions: stateDefinitions,
        selectedLabel: selectedLabel
      }) : null);
    }
  });
  exports.default = DateRangePicker;
});
var DateRangePicker = unwrapExports(DateRangePicker_1);

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var config = {
  disabled: false
};
var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.shape({
  enter: PropTypes__default.number,
  exit: PropTypes__default.number,
  appear: PropTypes__default.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.shape({
  enter: PropTypes__default.string,
  exit: PropTypes__default.string,
  active: PropTypes__default.string
}), PropTypes__default.shape({
  enter: PropTypes__default.string,
  enterDone: PropTypes__default.string,
  enterActive: PropTypes__default.string,
  exit: PropTypes__default.string,
  exitDone: PropTypes__default.string,
  exitActive: PropTypes__default.string
})]) : null;
var TransitionGroupContext = React.createContext(null);
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = ReactDOM.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      // allows for nested Transitions
      return React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, children(status, childProps));
    }

    var child = React.Children.only(children);
    return (// allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, React.cloneElement(child, childProps))
    );
  };

  return Transition;
}(React.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: oneOfType([func.isRequired, element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

function _extends$1k() {
  _extends$1k = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1k.apply(this, arguments);
}

var _ref$1k = /*#__PURE__*/React.createElement("path", {
  d: "M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5a2 2 0 01-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"
});

var SvgComponent$1k = function SvgComponent(props) {
  return React.createElement("svg", _extends$1k({
    viewBox: "0 0 24 24"
  }, props), _ref$1k);
};

function _extends$1l() {
  _extends$1l = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1l.apply(this, arguments);
}

var _ref$1l = /*#__PURE__*/React.createElement("path", {
  d: "M20 2h1a2 2 0 012 2v18a2 2 0 01-2 2H3a2 2 0 01-2-2V4a2 2 0 012-2h1V0h2v2h12V0h2v2zM3 4v18h18V4H3zm0 2h18v2H3V6zm8 4h2v2h-2v-2z"
});

var SvgComponent$1l = function SvgComponent(props) {
  return React.createElement("svg", _extends$1l({
    viewBox: "0 0 24 24"
  }, props), _ref$1l);
};

var css$7 = ".DateRangePicker {\n  display: inline-block;\n  margin-bottom: 10px;\n  padding: 0;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.DateRangePicker__Legend {\n  color: #52575e;\n  font-size: 14px;\n  line-height: 16px;\n  list-style-type: none;\n  margin: 20px 0;\n  padding: 0; }\n\n.DateRangePicker__LegendItem {\n  display: inline-block;\n  margin: 0 20px; }\n\n.DateRangePicker__LegendItemColor {\n  border-radius: 50%;\n  display: inline-block;\n  height: 14px;\n  margin-right: 6px;\n  vertical-align: text-bottom;\n  width: 14px;\n  border: 1px solid rgba(0, 0, 0, 0.25); }\n\n.DateRangePicker__LegendItemColor--selection {\n  background-color: #ed5434; }\n\n.DateRangePicker__PaginationArrow {\n  border: 0;\n  cursor: pointer;\n  display: block;\n  height: 35px;\n  outline: none;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  white-space: nowrap;\n  width: 35px;\n  z-index: 1; }\n\n.DateRangePicker__PaginationArrow--previous {\n  left: 20px; }\n\n.DateRangePicker__PaginationArrow--next {\n  right: 20px; }\n\n.DateRangePicker__PaginationArrow:hover {\n  background-color: #ccc; }\n\n.DateRangePicker__PaginationArrowIcon {\n  border-bottom: 8px solid transparent;\n  border-top: 8px solid transparent;\n  height: 0;\n  position: absolute;\n  top: 10px;\n  width: 0; }\n\n.DateRangePicker__PaginationArrowIcon--is-disabled {\n  opacity: .25; }\n\n.DateRangePicker__PaginationArrowIcon--previous {\n  border-left: 8px solid transparent;\n  border-right: 8px solid #aaa;\n  right: 11px; }\n\n.DateRangePicker__PaginationArrowIcon--next {\n  border-left: 8px solid #aaa;\n  border-right: 8px solid transparent;\n  left: 11px; }\n\n.DateRangePicker__Month {\n  color: #333;\n  display: inline-block;\n  margin: 0 20px;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 275px; }\n\n.DateRangePicker__MonthHeader {\n  color: #000;\n  font-size: 14px;\n  font-weight: bold;\n  height: 35px;\n  line-height: 35px;\n  position: relative;\n  text-align: center; }\n\n.DateRangePicker__MonthHeaderLabel {\n  display: inline-block;\n  position: relative; }\n\n.DateRangePicker__MonthHeaderSelect {\n  background: #e4e4e4;\n  border: 0;\n  cursor: pointer;\n  display: inline-block;\n  height: 100%;\n  left: 0;\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 5; }\n\n.DateRangePicker__MonthDates {\n  border-bottom: 1px solid #f4f5f6;\n  border-collapse: separate;\n  border-spacing: 0 1px;\n  margin: 0;\n  width: 100%; }\n\n.DateRangePicker__WeekdayHeading, .DateRangePicker__Date {\n  font-size: 12px;\n  line-height: 1;\n  padding: 10px 0;\n  text-align: center;\n  width: 14.285714285714286%; }\n\n.DateRangePicker__WeekdayHeading {\n  border-bottom: 1px solid #f4f5f6;\n  color: #000;\n  font-weight: bold; }\n\n.DateRangePicker__WeekdayHeading abbr[title] {\n  border-bottom-width: 0;\n  color: #000;\n  cursor: pointer;\n  font-size: inherit;\n  text-decoration: none; }\n\n.DateRangePicker__Date {\n  border: 0 solid #f4f5f6;\n  border-right-width: 1px;\n  cursor: pointer;\n  overflow: hidden;\n  position: relative; }\n\n.DateRangePicker__Date:first-child {\n  border-left-width: 1px; }\n\n.DateRangePicker__Date--weekend {\n  background-color: #f6f7f9; }\n\n.DateRangePicker__Date--otherMonth {\n  opacity: .25; }\n\n.DateRangePicker__Date--is-disabled {\n  color: #cdcdd1;\n  cursor: default; }\n\n.DateRangePicker__Date--is-selected {\n  color: #fff; }\n\n.DateRangePicker__Date--is-highlighted {\n  color: #333; }\n\n.DateRangePicker__CalendarDatePeriod {\n  bottom: 0;\n  position: absolute;\n  top: 0; }\n\n.DateRangePicker__CalendarDatePeriod--am {\n  left: 0;\n  right: 50%; }\n\n.DateRangePicker__CalendarDatePeriod--pm {\n  left: 50%;\n  right: 0; }\n\n.DateRangePicker__CalendarSelection {\n  background-color: #ed5434;\n  border: 1px solid #eb401d;\n  bottom: 5px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 5px; }\n\n.DateRangePicker__CalendarSelection--inOtherMonth {\n  opacity: .5; }\n\n.DateRangePicker__CalendarSelection--start {\n  border-bottom-left-radius: 5px;\n  border-right-width: 0;\n  border-top-left-radius: 5px;\n  left: 5px; }\n\n.DateRangePicker__CalendarSelection--end {\n  border-bottom-right-radius: 5px;\n  border-left-width: 0;\n  border-top-right-radius: 5px;\n  right: 5px; }\n\n.DateRangePicker__CalendarSelection--segment {\n  border-left-width: 0;\n  border-right-width: 0; }\n\n.DateRangePicker__CalendarSelection--single {\n  border-radius: 5px;\n  left: 5px;\n  right: 5px; }\n\n.DateRangePicker__CalendarSelection--is-pending {\n  background-color: rgba(237, 84, 52, 0.75);\n  border-width: 0; }\n\n.DateRangePicker__CalendarHighlight {\n  background-color: rgba(255, 255, 255, 0.25);\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  bottom: 5px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 5px; }\n\n.DateRangePicker__CalendarHighlight--inOtherMonth {\n  opacity: .5; }\n\n.DateRangePicker__CalendarHighlight--start {\n  border-bottom-left-radius: 5px;\n  border-right-width: 0;\n  border-top-left-radius: 5px;\n  left: 5px; }\n\n.DateRangePicker__CalendarHighlight--end {\n  border-bottom-right-radius: 5px;\n  border-left-width: 0;\n  border-top-right-radius: 5px;\n  right: 5px; }\n\n.DateRangePicker__CalendarHighlight--segment {\n  border-left-width: 0;\n  border-right-width: 0; }\n\n.DateRangePicker__CalendarHighlight--single {\n  background-color: #fff;\n  border: 1px solid #eb401d;\n  border-radius: 5px;\n  left: 5px;\n  right: 5px; }\n\n.DateRangePicker__HalfDateStates {\n  bottom: -50px;\n  left: -50px;\n  position: absolute;\n  right: -50px;\n  top: -50px;\n  transform: rotate(30deg); }\n\n.DateRangePicker__FullDateStates {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.DateRangePicker__DateLabel {\n  display: block;\n  position: relative;\n  text-align: center;\n  width: 100%;\n  z-index: 1; }\n\n/*----------------*/\n.date-picker {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  min-height: 2.25rem;\n  padding: 0.25rem 0.6875rem 0 0.625rem;\n  border-radius: .25rem;\n  border: 0.0625rem solid #dddddd;\n  background: white;\n  transition: box-shadow 200ms ease-in-out, border 200ms ease-in-out;\n  width: 14.375rem; }\n  .date-picker:hover, .date-picker:focus {\n    border-color: #6075ff;\n    box-shadow: 0 0 0.1875rem 0 rgba(5, 13, 66, 0.53); }\n    .date-picker:hover .date-picker__icon svg path, .date-picker:focus .date-picker__icon svg path {\n      fill: #6075ff; }\n    .date-picker:hover .date-picker__label, .date-picker:focus .date-picker__label {\n      color: #6075ff; }\n  .date-picker:after {\n    opacity: 0;\n    content: '';\n    position: absolute;\n    z-index: 2;\n    top: calc(100% + -6rem / 16);\n    left: 1rem;\n    width: 0.625rem;\n    height: 0.625rem;\n    border-left: 0.0625rem solid #6075ff;\n    border-top: 0.0625rem solid #6075ff;\n    transform: rotate(45deg) skew(12deg, 12deg);\n    background: #fff;\n    pointer-events: none;\n    transition: opacity .25s;\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1); }\n  .date-picker__icon {\n    margin-right: 0.5625rem;\n    width: 1.4375rem;\n    height: 1.5rem; }\n    .date-picker__icon svg {\n      width: 1.4375rem;\n      height: auto; }\n      .date-picker__icon svg path {\n        fill: #a2a2a2;\n        transition: fill 200ms ease-in-out; }\n    .date-picker__icon._single svg {\n      width: 19px;\n      position: relative;\n      top: 2px;\n      left: 2px; }\n  .date-picker._opened {\n    border-color: #6075ff;\n    box-shadow: 0 0 0.1875rem 0 rgba(5, 13, 66, 0.53); }\n    .date-picker._opened:after {\n      opacity: 1; }\n    .date-picker._opened .date-picker__icon svg path {\n      fill: #6075ff; }\n    .date-picker._opened .date-picker__label {\n      color: #6075ff; }\n  .date-picker__item {\n    position: relative; }\n    .date-picker__item-divider {\n      margin: 0 auto; }\n  .date-picker__item-label {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end; }\n    .date-picker__item-label span {\n      font-family: 'Lato Regular', sans-serif;\n      font-weight: 400;\n      font-size: 0.5rem;\n      line-height: 1.125em;\n      color: #a2a2a2;\n      text-transform: capitalize; }\n    .date-picker__item-label .form-control {\n      border-bottom: 1px solid #a2a2a2; }\n  .date-picker__wrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-grow: 1; }\n  .date-picker .form-control {\n    min-width: 4.5rem;\n    padding: 0;\n    border: none;\n    outline: none;\n    background: transparent;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.16667em;\n    color: #000;\n    letter-spacing: -.045em; }\n  .date-picker__label {\n    position: absolute;\n    top: -0.5rem;\n    left: 0.375rem;\n    padding: 0 0.125rem;\n    pointer-events: none;\n    background: linear-gradient(to right, rgba(255, 255, 255, 0.001) 0, #fff 0.125rem, #fff calc(100% - 2rem/16), rgba(255, 255, 255, 0.001));\n    transition: padding 200ms ease-in-out, background 200ms ease-in-out, transform 200ms ease-in-out, font-size 200ms ease-in-out, color 200ms ease-in-out;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: .75rem;\n    line-height: 1.21429em;\n    color: #a2a2a2; }\n\n.date-range-picker {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start; }\n  .date-range-picker__wrapper {\n    position: relative; }\n    .date-range-picker__wrapper-inner {\n      opacity: 0;\n      position: absolute !important;\n      z-index: 1;\n      top: calc(100% - 2rem/16);\n      right: 0;\n      padding: 11px 8px 5px;\n      border: 0.0625rem solid #6075ff;\n      border-radius: .25rem;\n      box-shadow: 0 0 0.75rem 0 rgba(140, 140, 140, 0.5);\n      background: #fff;\n      transition: opacity .25s, transform .25s;\n      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      transform-origin: 50% 0;\n      transform: scale(0.5, 0.5);\n      font-size: 0;\n      white-space: nowrap; }\n      .date-range-picker__wrapper-inner._entered {\n        opacity: 1;\n        transform: scale(1, 1); }\n  .date-range-picker__backdrop {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    z-index: 1;\n    top: 0;\n    left: 0; }\n  .date-range-picker__controls {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start; }\n    .date-range-picker__controls .date-range-picker__btns {\n      flex-wrap: wrap;\n      margin-bottom: -10px; }\n      .date-range-picker__controls .date-range-picker__btns > * {\n        margin: 0 10px 10px 0; }\n      .date-range-picker__controls .date-range-picker__btns + .date-range-picker__btn-done {\n        margin-left: 10px; }\n  .date-range-picker .DateRangePicker__Month {\n    margin: 0;\n    width: auto;\n    padding: 0 1.6875rem; }\n    .date-range-picker .DateRangePicker__Month:first-child {\n      position: absolute;\n      top: 0;\n      right: 100%; }\n    .date-range-picker .DateRangePicker__Month:last-child {\n      position: absolute;\n      top: 0;\n      left: 100%; }\n  .date-range-picker .DateRangePicker__MonthWrapper {\n    overflow: hidden; }\n  .date-range-picker .DateRangePicker__MonthInnerWrapper {\n    position: relative;\n    margin: 0 -1.6875rem; }\n  .date-range-picker .DateRangePicker__MonthHeader {\n    height: auto;\n    font-family: 'Lato Medium', sans-serif;\n    font-weight: 400;\n    font-size: 0.75rem;\n    line-height: 1.25em;\n    color: black;\n    text-transform: capitalize; }\n  .date-range-picker .DateRangePicker__MonthDates {\n    border-spacing: 0;\n    border: none; }\n  .date-range-picker .DateRangePicker__WeekdayHeading {\n    width: 1.9375rem; }\n  .date-range-picker .DateRangePicker__Date {\n    padding: 0 0 0.375rem;\n    border: none !important;\n    background: none;\n    text-align: center; }\n    .date-range-picker .DateRangePicker__Date--is-highlighted .DateRangePicker__DateLabel {\n      color: black !important; }\n    .date-range-picker .DateRangePicker__Date--is-disabled {\n      opacity: 0.25; }\n  .date-range-picker .DateRangePicker__DateLabel {\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    color: #000;\n    display: flex;\n    width: 37px;\n    height: 20px;\n    justify-content: center;\n    align-items: center;\n    font-size: 0.75rem;\n    text-align: center; }\n  .date-range-picker .DateRangePicker__CalendarHighlight {\n    top: 0;\n    left: 8.5px;\n    right: 8.5px;\n    bottom: 6px;\n    background: white;\n    color: black;\n    border: 0.09375rem solid #4d5ecc;\n    border-radius: 50%; }\n  .date-range-picker .DateRangePicker__CalendarSelection {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 6px;\n    border: none;\n    background: #dfe4ff; }\n    .date-range-picker .DateRangePicker__CalendarSelection--start, .date-range-picker .DateRangePicker__CalendarSelection--end, .date-range-picker .DateRangePicker__CalendarSelection--single {\n      left: 8.5px;\n      right: 8.5px;\n      background: #4d5ecc;\n      border-radius: 50% !important; }\n    .date-range-picker .DateRangePicker__CalendarSelection--end:before, .date-range-picker .DateRangePicker__CalendarSelection--start:before {\n      content: '';\n      display: block;\n      position: absolute;\n      background: #dfe4ff;\n      z-index: -1;\n      top: 0;\n      bottom: 0; }\n    .date-range-picker .DateRangePicker__CalendarSelection--end:before {\n      left: -8.5px;\n      right: 50%; }\n    .date-range-picker .DateRangePicker__CalendarSelection--end + .DateRangePicker__DateLabel {\n      color: white; }\n    .date-range-picker .DateRangePicker__CalendarSelection--start:before {\n      left: 50%;\n      right: -8.5px; }\n    .date-range-picker .DateRangePicker__CalendarSelection--start + .DateRangePicker__DateLabel {\n      color: white; }\n    .date-range-picker .DateRangePicker__CalendarSelection--single + .DateRangePicker__DateLabel {\n      color: white; }\n    .date-range-picker .DateRangePicker__CalendarSelection--focused {\n      border: 2px solid #3344b3; }\n      .date-range-picker .DateRangePicker__CalendarSelection--focused:before {\n        top: -2px;\n        bottom: -2px; }\n      .date-range-picker .DateRangePicker__CalendarSelection--focused.DateRangePicker__CalendarSelection--start:before {\n        left: 50%;\n        right: -10.5px; }\n      .date-range-picker .DateRangePicker__CalendarSelection--focused.DateRangePicker__CalendarSelection--end:before {\n        right: 50%;\n        left: -10.5px; }\n  .date-range-picker .DateRangePicker__WeekdayHeading {\n    padding: 7px 0 8px;\n    border: none; }\n    .date-range-picker .DateRangePicker__WeekdayHeading abbr {\n      font-family: 'Lato Regular', sans-serif;\n      font-weight: 400;\n      font-size: 0.75rem !important;\n      line-height: 1.25em;\n      color: black !important; }\n  .date-range-picker .DateRangePicker__PaginationArrow {\n    top: 0;\n    width: 0.75rem;\n    height: 0.75rem; }\n    .date-range-picker .DateRangePicker__PaginationArrow:hover {\n      background: none; }\n    .date-range-picker .DateRangePicker__PaginationArrow--previous {\n      left: 0.625rem; }\n    .date-range-picker .DateRangePicker__PaginationArrow--next {\n      right: 0.625rem; }\n    .date-range-picker .DateRangePicker__PaginationArrow--is-disabled {\n      border-color: #f4f4f4; }\n  .date-range-picker .DateRangePicker__PaginationArrowIcon {\n    border-color: #818181;\n    border-style: solid;\n    border-width: 0.125rem 0.125rem 0 0;\n    width: 0.5rem;\n    height: 0.5rem;\n    top: 50%;\n    left: 50%; }\n    .date-range-picker .DateRangePicker__PaginationArrowIcon--previous {\n      transform: translateY(-50%) translateX(-50%) rotate(-135deg); }\n    .date-range-picker .DateRangePicker__PaginationArrowIcon--next {\n      transform: translateY(-50%) translateX(-50%) rotate(45deg); }\n  .date-range-picker .DateRangePicker__MonthHeaderLabel {\n    position: relative; }\n    .date-range-picker .DateRangePicker__MonthHeaderLabel:after {\n      content: '';\n      position: absolute;\n      top: 100%;\n      left: 0;\n      right: 0;\n      height: 0.0625rem;\n      background-color: transparent;\n      background-image: linear-gradient(to right, #a2a2a2 0.0625rem, transparent 0.0625rem);\n      background-size: 0.125rem 0.0625rem;\n      background-repeat: repeat-x;\n      transition: all 0.3s; }\n    .date-range-picker .DateRangePicker__MonthHeaderLabel:hover:after {\n      background-image: linear-gradient(to right, #787878 0.0625rem, transparent 0.0625rem); }\n  .date-range-picker__wrapper-inner._animate-y-axis .DateRangePicker__Month {\n    display: block;\n    min-height: 12.5625rem; }\n    .date-range-picker__wrapper-inner._animate-y-axis .DateRangePicker__Month:first-child {\n      top: auto;\n      right: auto;\n      bottom: 100%;\n      left: 0; }\n    .date-range-picker__wrapper-inner._animate-y-axis .DateRangePicker__Month:last-child {\n      top: 100%;\n      left: 0; }\n  .date-range-picker__wrapper-inner._animate-y-axis .DateRangePicker__PaginationArrowIcon--previous {\n    transform: translateY(-50%) translateX(-50%) rotate(-45deg); }\n  .date-range-picker__wrapper-inner._animate-y-axis .DateRangePicker__PaginationArrowIcon--next {\n    transform: translateY(-50%) translateX(-50%) rotate(135deg); }\n  .date-range-picker__wrapper-inner._animate-y-axis .date-range-picker__controls {\n    flex-direction: column;\n    align-items: stretch; }\n    .date-range-picker__wrapper-inner._animate-y-axis .date-range-picker__controls .date-range-picker__btns {\n      margin-bottom: 0;\n      max-width: 259px; }\n      .date-range-picker__wrapper-inner._animate-y-axis .date-range-picker__controls .date-range-picker__btns + .date-range-picker__btn-done {\n        margin-left: auto; }\n  .date-range-picker__btns {\n    display: flex;\n    margin-bottom: 0.5rem; }\n  .date-range-picker__btn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 1.5625rem;\n    padding: 0 0.9375rem;\n    border-radius: 0.90625rem;\n    border: none;\n    outline: none;\n    background: #f4f4f4;\n    cursor: pointer;\n    transition: background .25s, color .25s;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.21429rem;\n    color: #787878;\n    text-transform: capitalize;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale; }\n    .date-range-picker__btn:focus {\n      outline: none; }\n    .date-range-picker__btn:not(:last-child) {\n      margin-right: 0.5rem; }\n    .date-range-picker__btn:hover, .date-range-picker__btn:focus {\n      background: #cbcbcb;\n      color: #fff; }\n    .date-range-picker__btn._active {\n      background: #4d5ecc;\n      color: #fff; }\n  .date-range-picker__btn-done {\n    margin-left: auto; }\n  .date-range-picker_with-time .form-control {\n    min-width: 8.4375rem; }\n";
styleInject(css$7);
var reactIs_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.memo") : 60115,
      r = b ? Symbol.for("react.lazy") : 60116;

  function t(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case r:
        case q:
        case d:
          return u;
      }
    }
  }

  function v(a) {
    return t(a) === m;
  }

  exports.typeOf = t;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = r;
  exports.Memo = q;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
  };

  exports.isAsyncMode = function (a) {
    return v(a) || t(a) === l;
  };

  exports.isConcurrentMode = v;

  exports.isContextConsumer = function (a) {
    return t(a) === k;
  };

  exports.isContextProvider = function (a) {
    return t(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return t(a) === n;
  };

  exports.isFragment = function (a) {
    return t(a) === e;
  };

  exports.isLazy = function (a) {
    return t(a) === r;
  };

  exports.isMemo = function (a) {
    return t(a) === q;
  };

  exports.isPortal = function (a) {
    return t(a) === d;
  };

  exports.isProfiler = function (a) {
    return t(a) === g;
  };

  exports.isStrictMode = function (a) {
    return t(a) === f;
  };

  exports.isSuspense = function (a) {
    return t(a) === p;
  };
});
unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      Object.defineProperty(exports, '__esModule', {
        value: true
      }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
      }
      /**
       * Forked from fbjs/warning:
       * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
       *
       * Only change is we use console.warn instead of console.error,
       * and do nothing when 'console' is not supported.
       * This really simplifies the code.
       * ---
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */


      var lowPriorityWarning = function lowPriorityWarning() {};

      {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.warn(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        lowPriorityWarning = function lowPriorityWarning(condition, format) {
          if (format === undefined) {
            throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (!condition) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }

            printWarning.apply(undefined, [format].concat(args));
          }
        };
      }
      var lowPriorityWarning$1 = lowPriorityWarning;

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_LAZY_TYPE:
            case REACT_MEMO_TYPE:
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.typeOf = typeOf;
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isValidElementType = isValidElementType;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
    })();
  }
});
unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf;
var reactIs_development_2 = reactIs_development.AsyncMode;
var reactIs_development_3 = reactIs_development.ConcurrentMode;
var reactIs_development_4 = reactIs_development.ContextConsumer;
var reactIs_development_5 = reactIs_development.ContextProvider;
var reactIs_development_6 = reactIs_development.Element;
var reactIs_development_7 = reactIs_development.ForwardRef;
var reactIs_development_8 = reactIs_development.Fragment;
var reactIs_development_9 = reactIs_development.Lazy;
var reactIs_development_10 = reactIs_development.Memo;
var reactIs_development_11 = reactIs_development.Portal;
var reactIs_development_12 = reactIs_development.Profiler;
var reactIs_development_13 = reactIs_development.StrictMode;
var reactIs_development_14 = reactIs_development.Suspense;
var reactIs_development_15 = reactIs_development.isValidElementType;
var reactIs_development_16 = reactIs_development.isAsyncMode;
var reactIs_development_17 = reactIs_development.isConcurrentMode;
var reactIs_development_18 = reactIs_development.isContextConsumer;
var reactIs_development_19 = reactIs_development.isContextProvider;
var reactIs_development_20 = reactIs_development.isElement;
var reactIs_development_21 = reactIs_development.isForwardRef;
var reactIs_development_22 = reactIs_development.isFragment;
var reactIs_development_23 = reactIs_development.isLazy;
var reactIs_development_24 = reactIs_development.isMemo;
var reactIs_development_25 = reactIs_development.isPortal;
var reactIs_development_26 = reactIs_development.isProfiler;
var reactIs_development_27 = reactIs_development.isStrictMode;
var reactIs_development_28 = reactIs_development.isSuspense;
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
var reactIs_1 = reactIs.isValidElementType;
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf$1(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function withClickOutside(WrappedComponent) {
  var EnhancedComponent = /*#__PURE__*/function (_React$Component) {
    inherits(EnhancedComponent, _React$Component);

    function EnhancedComponent(props) {
      var _this;

      classCallCheck(this, EnhancedComponent);
      _this = possibleConstructorReturn(this, getPrototypeOf(EnhancedComponent).call(this, props));
      defineProperty(assertThisInitialized(_this), "__domNode", void 0);
      defineProperty(assertThisInitialized(_this), "__wrappedInstance", void 0);
      defineProperty(assertThisInitialized(_this), "handleClickOutside", void 0);
      defineProperty(assertThisInitialized(_this), "handleClickOutside", function (e) {
        var domNode = _this.__domNode;

        if ((!domNode || !domNode.contains(e.target)) && _this.__wrappedInstance && typeof _this.__wrappedInstance.handleClickOutside === 'function') {
          _this.__wrappedInstance.handleClickOutside(e);
        }
      });
      _this.handleClickOutside = _this.handleClickOutside.bind(assertThisInitialized(_this));
      return _this;
    }

    createClass(EnhancedComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            wrappedRef = _this$props.wrappedRef,
            rest = objectWithoutProperties(_this$props, ["wrappedRef"]);
        return React.createElement(WrappedComponent, _extends_1({}, rest, {
          ref: function ref(c) {
            _this2.__wrappedInstance = c;
            _this2.__domNode = ReactDOM.findDOMNode(c);
            wrappedRef && wrappedRef(c);
          }
        }));
      }
    }]);
    return EnhancedComponent;
  }(React.Component);

  EnhancedComponent.displayName = "withClickOutside(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
  return hoistNonReactStatics_cjs(EnhancedComponent, WrappedComponent);
}

var css$8 = ".tabs__btn {\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: none; }\n  .tabs__btn:focus {\n    outline: none; }\n\n.tabs {\n  display: flex;\n  align-items: baseline; }\n  .tabs__btn {\n    position: relative;\n    padding: 0 0.125rem 0.3125rem;\n    cursor: pointer;\n    font-family: 'Lato Bold', sans-serif;\n    font-weight: 400;\n    font-size: 1.125rem;\n    line-height: 1.22222em;\n    color: #787878; }\n    .tabs__btn:not(:last-child) {\n      margin-right: 1.6875rem; }\n    .tabs__btn:before {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      height: 0.125rem;\n      border-radius: 0.125rem;\n      background: transparent; }\n    .tabs__btn:hover, .tabs__btn._active {\n      font-family: 'Lato Bold', sans-serif;\n      font-weight: 400;\n      border-color: #000000;\n      color: #000000; }\n    .tabs__btn._active:before {\n      background: #000; }\n    .tabs__btn:after {\n      content: attr(data-placeholder);\n      display: block;\n      visibility: hidden;\n      height: 0;\n      font-family: 'Lato Bold', sans-serif;\n      font-weight: 400; }\n  .tabs_small .tabs__btn {\n    font-size: 0.75rem; }\n  .tabs_capitalized .tabs__btn {\n    text-transform: capitalize; }\n";
styleInject(css$8);

var Tabs = /*#__PURE__*/function (_Component) {
  inherits(Tabs, _Component);

  function Tabs(props) {
    var _this;

    classCallCheck(this, Tabs);
    _this = possibleConstructorReturn(this, getPrototypeOf(Tabs).call(this, props));
    _this.state = {};
    return _this;
  }

  createClass(Tabs, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !isEqual(['className', 'value', 'items'], this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          value = _this$props.value,
          _this$props$items = _this$props.items,
          items = _this$props$items === void 0 ? [] : _this$props$items,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? function () {} : _this$props$onChange;
      return React.createElement("div", {
        className: "tabs ".concat(className)
      }, items.map(function (item, index) {
        var active = item.value === value;
        return React.createElement("button", {
          key: index,
          onClick: function onClick() {
            return onChange(item);
          },
          className: "tabs__btn ".concat(active ? '_active' : '')
        }, item.title);
      }));
    }
  }]);
  return Tabs;
}(Component);

Tabs.propTypes = {
  className: PropTypes__default.string,
  value: PropTypes__default.any,
  items: PropTypes__default.arrayOf(PropTypes__default.shape({
    title: PropTypes__default.string,
    value: PropTypes__default.any
  })),
  onChange: PropTypes__default.func
};

function momentOrDatePropCheck(props, propName) {
  var val = props[propName];

  if (!val) {
    return null;
  } else if (isMoment(val)) {
    return null;
  } else if (val instanceof Date) {
    return null;
  }

  return new Error("'".concat(propName, "' must be a moment or Date"));
}

var css$9 = ".TimePicker-module_container__1Szpk {\n  display: flex;\n  flex-direction: column;\n  position: relative; }\n  .TimePicker-module_container__1Szpk.TimePicker-module_withTabs__nHUlT {\n    font-size: 12px;\n    line-height: 18px; }\n    .TimePicker-module_container__1Szpk.TimePicker-module_withTabs__nHUlT .TimePicker-module_mode__32WtN {\n      left: auto;\n      right: 0; }\n    .TimePicker-module_container__1Szpk.TimePicker-module_withTabs__nHUlT .TimePicker-module_time__1Gy-1 {\n      left: 0;\n      right: auto; }\n\n.TimePicker-module_button__3OKj9 {\n  position: absolute;\n  top: 0;\n  color: #6075ff;\n  text-transform: capitalize;\n  cursor: pointer;\n  display: inline-block;\n  padding: 0;\n  z-index: 2;\n  user-select: none; }\n  .TimePicker-module_buttonMeridiem__3oT5x {\n    left: 0;\n    padding-left: 0;\n    text-transform: uppercase; }\n  .TimePicker-module_buttonView__3xTKu {\n    right: 0;\n    padding-right: 0; }\n\n.TimePicker-module_mode__32WtN {\n  position: absolute;\n  top: 0;\n  display: inline-block;\n  padding: 0;\n  z-index: 2; }\n\n.TimePicker-module_time__1Gy-1 {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0;\n  font-family: \"Lato Regular\", sans-serif;\n  font-weight: 400; }\n";
var styles$1 = {
  "container": "TimePicker-module_container__1Szpk",
  "withTabs": "TimePicker-module_withTabs__nHUlT",
  "mode": "TimePicker-module_mode__32WtN",
  "time": "TimePicker-module_time__1Gy-1",
  "button": "TimePicker-module_button__3OKj9",
  "buttonMeridiem": "TimePicker-module_buttonMeridiem__3oT5x",
  "buttonView": "TimePicker-module_buttonView__3xTKu"
};
styleInject(css$9);
var css$a = ".ClockNumber-module_clockNumber__2YJoK {\n  width: 32px;\n  height: 32px;\n  user-select: none;\n  position: absolute;\n  left: calc(50% - (32px / 2));\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%; }\n  .ClockNumber-module_clockNumberSelected__1k-Og {\n    color: #ffffff; }\n  .ClockNumber-module_clockNumber-sm__3SO73 {\n    font-size: 20px;\n    font-family: \"Lato Regular\", sans-serif;\n    font-weight: 400; }\n";
var styles$2 = {
  "clockNumber": "ClockNumber-module_clockNumber__2YJoK",
  "clockNumberSelected": "ClockNumber-module_clockNumberSelected__1k-Og",
  "clockNumber-sm": "ClockNumber-module_clockNumber-sm__3SO73"
};
styleInject(css$a);
var positions = {
  0: [0, 40],
  1: [55, 19.6],
  2: [94.4, 59.5],
  3: [109, 114],
  4: [94.4, 168.5],
  5: [54.5, 208.4],
  6: [0, 223],
  7: [-54.5, 208.4],
  8: [-94.4, 168.5],
  9: [-109, 114],
  10: [-94.4, 59.5],
  11: [-54.5, 19.6],
  12: [0, 5],
  13: [36.9, 49.9],
  14: [64, 77],
  15: [74, 114],
  16: [64, 151],
  17: [37, 178],
  18: [0, 188],
  19: [-37, 178],
  20: [-64, 151],
  21: [-74, 114],
  22: [-64, 77],
  23: [-37, 50]
};
var memoizeTransform = memoize(function (index) {
  var position = positions[index];
  return {
    transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
  };
});

var ClockNumber = function ClockNumber(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      index = _ref.index,
      size = _ref.size;
  var transformStyle = memoizeTransform(index);
  return React.createElement("span", {
    className: "".concat(styles$2.clockNumber, " ").concat(size ? styles$2["clockNumber-".concat(size)] : '', " ").concat(selected ? styles$2.clockNumberSelected : ''),
    style: transformStyle
  }, label);
};

ClockNumber.propTypes = {
  selected: PropTypes__default.bool,
  label: PropTypes__default.string,
  index: PropTypes__default.number,
  size: PropTypes__default.oneOf(['sm', ''])
};
var ClockTypes = {
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds'
};

function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(function (item) {
      return array.indexOf(item) !== -1;
    });
  }

  return array.indexOf(itemOrItems) !== -1;
}

var getMoment = function getMoment(date) {
  if (moment$1__default.isMoment(date)) {
    return date;
  }

  return moment$1__default(date);
};

var getHoursValue = function getHoursValue(d) {
  var date = getMoment(d);
  return date.hour();
};

var getMinutesValue = function getMinutesValue(d) {
  var date = getMoment(d);
  return date.minute();
};

var getSecondsValue = function getSecondsValue(d) {
  var date = getMoment(d);
  return date.second();
};

var setHoursValue = function setHoursValue(t, hours) {
  var time = getMoment(t);
  return time.set('h', hours);
};

var setMinutesValue = function setMinutesValue(t, minutes) {
  var time = getMoment(t);
  return time.set('m', minutes);
};

var setSecondsValue = function setSecondsValue(t, seconds) {
  var time = getMoment(t);
  return time.set('s', seconds);
};

var getHourNumbers = function getHourNumbers(_ref) {
  var ampm = _ref.ampm,
      date = _ref.date,
      size = _ref.size;
  var currentHours = getHoursValue(date);
  var hourNumbers = [];
  var startHour = ampm ? 1 : 0;
  var endHour = ampm ? 12 : 23;

  var isSelected = function isSelected(hour) {
    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }

      return currentHours === hour || currentHours - 12 === hour;
    }

    return currentHours === hour;
  };

  for (var hour = startHour; hour <= endHour; hour += 1) {
    var label = hour.toString();

    if (hour === 0) {
      label = '00';
    }

    var props = {
      index: hour,
      label: label,
      selected: isSelected(hour),
      size: size
    };
    hourNumbers.push(React.createElement(ClockNumber, _extends_1({
      key: hour
    }, props)));
  }

  return hourNumbers;
};

var getMinutesNumbers = function getMinutesNumbers(_ref2) {
  var value = _ref2.value,
      size = _ref2.size;
  return [React.createElement(ClockNumber, {
    size: size,
    label: '00',
    selected: value === 0,
    index: 12,
    key: 12
  }), React.createElement(ClockNumber, {
    size: size,
    label: '05',
    selected: value === 5,
    index: 1,
    key: 1
  }), React.createElement(ClockNumber, {
    size: size,
    label: '10',
    selected: value === 10,
    index: 2,
    key: 2
  }), React.createElement(ClockNumber, {
    size: size,
    label: '15',
    selected: value === 15,
    index: 3,
    key: 3
  }), React.createElement(ClockNumber, {
    size: size,
    label: '20',
    selected: value === 20,
    index: 4,
    key: 4
  }), React.createElement(ClockNumber, {
    size: size,
    label: '25',
    selected: value === 25,
    index: 5,
    key: 5
  }), React.createElement(ClockNumber, {
    size: size,
    label: '30',
    selected: value === 30,
    index: 6,
    key: 6
  }), React.createElement(ClockNumber, {
    size: size,
    label: '35',
    selected: value === 35,
    index: 7,
    key: 7
  }), React.createElement(ClockNumber, {
    size: size,
    label: '40',
    selected: value === 40,
    index: 8,
    key: 8
  }), React.createElement(ClockNumber, {
    size: size,
    label: '45',
    selected: value === 45,
    index: 9,
    key: 9
  }), React.createElement(ClockNumber, {
    size: size,
    label: '50',
    selected: value === 50,
    index: 10,
    key: 10
  }), React.createElement(ClockNumber, {
    size: size,
    label: '55',
    selected: value === 55,
    index: 11,
    key: 11
  })];
};

var center = {
  x: 260 / 2,
  y: 260 / 2
};
var basePoint = {
  x: center.x,
  y: 0
};
var cx = basePoint.x - center.x;
var cy = basePoint.y - center.y;

var rad2deg = function rad2deg(rad) {
  return rad * 57.29577951308232;
};

var getAngleValue = function getAngleValue(step, offsetX, offsetY) {
  var x = offsetX - center.x;
  var y = offsetY - center.y;
  var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
  var deg = rad2deg(atan);
  deg = Math.round(deg / step) * step;
  deg %= 360;
  var value = Math.floor(deg / step) || 0;
  var delta = Math.pow(x, 2) + Math.pow(y, 2);
  var distance = Math.sqrt(delta);
  return {
    value: value,
    distance: distance
  };
};

var getHours = function getHours(offsetX, offsetY, ampm) {
  var _getAngleValue = getAngleValue(30, offsetX, offsetY),
      value = _getAngleValue.value,
      distance = _getAngleValue.distance;

  value = value || 12;

  if (!ampm) {
    if (distance < 90) {
      value += 12;
      value %= 24;
    }
  } else {
    value %= 12;
  }

  return value;
};

var getMinutes = function getMinutes(offsetX, offsetY) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var angleStep = step * 6;

  var _getAngleValue2 = getAngleValue(angleStep, offsetX, offsetY),
      value = _getAngleValue2.value;

  value = value * step % 60;
  return value;
};

var getMeridiem = function getMeridiem(date) {
  return getHoursValue(date) >= 12 ? 'pm' : 'am';
};

var convertToMeridiem = function convertToMeridiem(time, meridiem, ampm) {
  if (ampm) {
    var currentMeridiem = getHoursValue(time) >= 12 ? 'pm' : 'am';

    if (currentMeridiem !== meridiem) {
      var hours = meridiem === 'am' ? getHoursValue(time) - 12 : getHoursValue(time) + 12;
      return setHoursValue(time, hours);
    }
  }

  return time;
};

var css$b = ".Clock-module_container__u9bjC {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  margin: 16px 0; }\n\n.Clock-module_clock__3pf-q {\n  background-color: rgba(0, 0, 0, 0.07);\n  border-radius: 50%;\n  height: 260px;\n  width: 260px;\n  position: relative;\n  pointer-events: none;\n  z-index: 1; }\n\n.Clock-module_squareMask__367fB {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  pointer-events: auto;\n  outline: none;\n  touch-action: none;\n  user-select: none; }\n  .Clock-module_squareMask__367fB:active {\n    cursor: move; }\n\n.Clock-module_pin__3GogJ {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: #4d5ecc;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n\n.Clock-module_containersm__37oAn {\n  height: 130px;\n  align-items: center; }\n\n.Clock-module_clocksm__3ocgE {\n  transform: scale(0.6); }\n";
var styles$3 = {
  "container": "Clock-module_container__u9bjC",
  "clock": "Clock-module_clock__3pf-q",
  "squareMask": "Clock-module_squareMask__367fB",
  "pin": "Clock-module_pin__3GogJ",
  "containersm": "Clock-module_containersm__37oAn",
  "clocksm": "Clock-module_clocksm__3ocgE"
};
styleInject(css$b);
var css$c = ".ClockPointer-module_pointer__28siQ {\n  width: 2px;\n  background-color: #4d5ecc;\n  position: absolute;\n  left: calc(50% - 1px);\n  bottom: 50%;\n  transform-origin: center bottom 0px; }\n\n.ClockPointer-module_animateTransform__2kcFs {\n  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms; }\n\n.ClockPointer-module_thumb__11aUL {\n  width: 4px;\n  height: 4px;\n  background-color: #ffffff;\n  border-radius: 100%;\n  position: absolute;\n  top: -21px;\n  left: -15px;\n  border: 14px solid #4d5ecc;\n  box-sizing: content-box; }\n\n.ClockPointer-module_noPoint__zRXBt {\n  background-color: #4d5ecc; }\n";
var classes = {
  "pointer": "ClockPointer-module_pointer__28siQ",
  "animateTransform": "ClockPointer-module_animateTransform__2kcFs",
  "thumb": "ClockPointer-module_thumb__11aUL",
  "noPoint": "ClockPointer-module_noPoint__zRXBt"
};
styleInject(css$c);

var ClockPointer = /*#__PURE__*/function (_React$Component) {
  inherits(ClockPointer, _React$Component);

  function ClockPointer() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, ClockPointer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(ClockPointer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      toAnimateTransform: false,
      previousType: undefined
    });
    defineProperty(assertThisInitialized(_this), "getAngleStyle", function () {
      var _this$props = _this.props,
          value = _this$props.value,
          type = _this$props.type,
          isInner = _this$props.isInner;
      var max = type === ClockTypes.HOURS ? 12 : 60;
      var angle = 360 / max * value;

      if (type === ClockTypes.HOURS && value > 12) {
        angle -= 360; // round up angle to max 360 degrees
      }

      return {
        height: isInner ? '26%' : '40%',
        transform: "rotateZ(".concat(angle, "deg)")
      };
    });
    return _this;
  }

  createClass(ClockPointer, [{
    key: "render",
    value: function render() {
      var hasSelected = this.props.hasSelected;
      var toAnimateTransform = this.state.toAnimateTransform;
      return React.createElement("div", {
        style: this.getAngleStyle(),
        className: "".concat(classes.pointer, " ").concat(toAnimateTransform ? classes.animateTransform : '')
      }, React.createElement("div", {
        className: "".concat(classes.thumb, " ").concat(hasSelected ? classes.noPoint : '')
      }));
    }
  }]);
  return ClockPointer;
}(React.Component);

defineProperty(ClockPointer, "propTypes", {
  value: PropTypes__default.number.isRequired,
  hasSelected: PropTypes__default.bool,
  type: PropTypes__default.oneOf(['hours', 'minutes', 'seconds']),
  isInner: PropTypes__default.bool
});
defineProperty(ClockPointer, "getDerivedStateFromProps", function (nextProps, state) {
  if (nextProps.type !== state.previousType) {
    return {
      toAnimateTransform: true,
      previousType: nextProps.type
    };
  }

  return {
    toAnimateTransform: false,
    previousType: nextProps.type
  };
});

var Clock = /*#__PURE__*/function (_React$Component) {
  inherits(Clock, _React$Component);

  function Clock() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Clock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Clock)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "isMoving", false);
    defineProperty(assertThisInitialized(_this), "handleTouchMove", function (e) {
      _this.isMoving = true;

      _this.setTime(e);
    });
    defineProperty(assertThisInitialized(_this), "handleTouchEnd", function (e) {
      if (_this.isMoving) {
        _this.setTime(e, true);

        _this.isMoving = false;
      }
    });
    defineProperty(assertThisInitialized(_this), "handleMove", function (e) {
      e.preventDefault();
      e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari

      var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;

      if (isButtonPressed) {
        _this.setTime(e.nativeEvent, false);
      }
    });
    defineProperty(assertThisInitialized(_this), "handleMouseUp", function (e) {
      if (_this.isMoving) {
        _this.isMoving = false;
      }

      _this.setTime(e.nativeEvent, true);
    });
    defineProperty(assertThisInitialized(_this), "hasSelected", function () {
      var _this$props = _this.props,
          type = _this$props.type,
          value = _this$props.value;

      if (type === ClockTypes.HOURS) {
        return true;
      }

      return value % 5 === 0;
    });
    return _this;
  }

  createClass(Clock, [{
    key: "setTime",
    value: function setTime(e) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var offsetX = e.offsetX,
          offsetY = e.offsetY;

      if (typeof offsetX === 'undefined') {
        var rect = e.target.getBoundingClientRect();
        offsetX = e.changedTouches[0].clientX - rect.left;
        offsetY = e.changedTouches[0].clientY - rect.top;
      }

      var value = this.props.type === ClockTypes.SECONDS || this.props.type === ClockTypes.MINUTES ? getMinutes(offsetX, offsetY, this.props.minutesStep) : getHours(offsetX, offsetY, Boolean(this.props.ampm));
      this.props.onChange(value, isFinish);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          children = _this$props2.children,
          type = _this$props2.type,
          ampm = _this$props2.ampm,
          size = _this$props2.size;
      var isPointerInner = !ampm && type === ClockTypes.HOURS && (value < 1 || value > 12);
      return React.createElement("div", {
        className: "".concat(styles$3.container, " ").concat(size ? styles$3["container".concat(size)] : '', " clock__container")
      }, React.createElement("div", {
        className: "".concat(styles$3.clock, " ").concat(size ? styles$3["clock".concat(size)] : '', " clock")
      }, React.createElement("div", {
        role: "menu",
        tabIndex: -1,
        className: styles$3.squareMask,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        onMouseUp: this.handleMouseUp,
        onMouseMove: this.handleMove
      }), React.createElement("div", {
        className: styles$3.pin
      }), React.createElement(ClockPointer, {
        value: value,
        type: type,
        hasSelected: this.hasSelected(),
        isInner: isPointerInner
      }), children));
    }
  }]);
  return Clock;
}(React.Component);

defineProperty(Clock, "propTypes", {
  type: PropTypes__default.oneOf(Object.keys(ClockTypes).map(function (key) {
    return ClockTypes[key];
  })).isRequired,
  value: PropTypes__default.number.isRequired,
  onChange: PropTypes__default.func.isRequired,
  children: PropTypes__default.arrayOf(PropTypes__default.node).isRequired,
  ampm: PropTypes__default.bool,
  minutesStep: PropTypes__default.number,
  size: PropTypes__default.oneOf(['sm', '']) // innerRef: PropTypes.any,

});
defineProperty(Clock, "defaultProps", {
  ampm: false,
  minutesStep: 1
});

var ClockView = /*#__PURE__*/function (_React$Component) {
  inherits(ClockView, _React$Component);

  function ClockView() {
    classCallCheck(this, ClockView);
    return possibleConstructorReturn(this, getPrototypeOf(ClockView).apply(this, arguments));
  }

  createClass(ClockView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          ampm = _this$props.ampm,
          date = _this$props.date,
          onHourChange = _this$props.onHourChange,
          onMinutesChange = _this$props.onMinutesChange,
          onSecondsChange = _this$props.onSecondsChange,
          minutesStep = _this$props.minutesStep,
          size = _this$props.size;
      var viewProps = memoize(function () {
        switch (type) {
          case ClockTypes.HOURS:
            {
              return {
                value: getHoursValue(date),
                children: getHourNumbers({
                  ampm: ampm,
                  date: date,
                  size: size
                }),
                onChange: function onChange(value, isFinish) {
                  var currentMeridiem = getMeridiem(date);
                  var updatedTimeWithMeridiem = convertToMeridiem(setHoursValue(date, value), currentMeridiem, Boolean(ampm));
                  onHourChange(updatedTimeWithMeridiem, isFinish);
                }
              };
            }

          case ClockTypes.MINUTES:
            {
              var minutesValue = getMinutesValue(date);
              return {
                value: minutesValue,
                children: getMinutesNumbers({
                  value: minutesValue,
                  size: size
                }),
                onChange: function onChange(value, isFinish) {
                  var updatedTime = setMinutesValue(date, value);
                  onMinutesChange(updatedTime, isFinish);
                }
              };
            }

          case ClockTypes.SECONDS:
            {
              var secondsValue = getSecondsValue(date);
              return {
                value: secondsValue,
                children: getMinutesNumbers({
                  value: secondsValue,
                  size: size
                }),
                onChange: function onChange(value, isFinish) {
                  var updatedTime = setSecondsValue(date, value);
                  onSecondsChange(updatedTime, isFinish);
                }
              };
            }

          default:
            {
              throw new Error("You must provide the type for TimePicker: ".concat(Object.values(ClockTypes).join(', ')));
            }
        }
      }, function () {
        return [ampm, date, onHourChange, onMinutesChange, onSecondsChange, type];
      });
      return React.createElement(Clock, _extends_1({
        type: type,
        ampm: ampm,
        minutesStep: minutesStep,
        size: size
      }, viewProps()));
    }
  }]);
  return ClockView;
}(React.Component);

defineProperty(ClockView, "propTypes", {
  type: PropTypes__default.oneOf(['hours', 'minutes', 'seconds']).isRequired,
  date: PropTypes__default.number.isRequired,
  ampm: PropTypes__default.bool,
  onHourChange: PropTypes__default.func,
  onMinutesChange: PropTypes__default.func,
  onSecondsChange: PropTypes__default.func,
  minutesStep: PropTypes__default.number,
  size: PropTypes__default.oneOf(['sm', ''])
});

var TimePicker = /*#__PURE__*/function (_React$Component) {
  inherits(TimePicker, _React$Component);

  function TimePicker(props) {
    var _this;

    classCallCheck(this, TimePicker);
    _this = possibleConstructorReturn(this, getPrototypeOf(TimePicker).call(this, props));
    defineProperty(assertThisInitialized(_this), "handleChange", function (value, isFinish) {
      var _this$props = _this.props,
          views = _this$props.views,
          onChange = _this$props.onChange;
      var openTo = _this.state.openTo;
      var nextViewToOpen = views[views.indexOf(openTo) + 1];

      _this.setState({
        time: value
      });

      if (isFinish && nextViewToOpen) {
        // do not close picker if needs to show next view
        onChange(value, false);

        _this.setState({
          openTo: nextViewToOpen
        });

        return;
      }

      onChange(value, Boolean(isFinish));
    });
    defineProperty(assertThisInitialized(_this), "handleMeridiemChange", function () {
      var oldMode = _this.state.mode;
      var mode = oldMode === 'am' ? 'pm' : 'am';
      var _this$props2 = _this.props,
          value = _this$props2.value,
          ampm = _this$props2.ampm;

      _this.setState({
        mode: mode
      });

      var timeWithMeridiem = convertToMeridiem(value, mode, Boolean(ampm));

      _this.handleChange(timeWithMeridiem, false);
    });
    defineProperty(assertThisInitialized(_this), "handleChangeTimeView", function (view) {
      var views = _this.props.views;
      var openTo = _this.state.openTo;
      var nextViewToOpen = views[views.indexOf(openTo) + 1] || views[0];

      _this.setState({
        openTo: nextViewToOpen
      });
    });
    _this.state = {
      openTo: props.openTo && arrayIncludes(props.views, props.openTo) ? props.openTo : props.views[0],
      mode: getMeridiem(props.value),
      time: moment$1__default(props.value)
    };
    return _this;
  }

  createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          ampm = _this$props3.ampm,
          minutesStep = _this$props3.minutesStep,
          size = _this$props3.size,
          useViewsAsTabs = _this$props3.useViewsAsTabs;
      var _this$state = this.state,
          mode = _this$state.mode,
          time = _this$state.time;
      var modeValue = !!(mode === 'pm');
      return React.createElement("div", {
        className: "".concat(styles$1.container, " ").concat(useViewsAsTabs ? styles$1.withTabs : '', " timepicker")
      }, React.createElement("div", {
        className: styles$1.mode
      }, React.createElement(Switch, {
        size: useViewsAsTabs ? 'sm' : '',
        list: ['AM', 'PM'],
        name: "time-mode-swithcer",
        onChange: this.handleMeridiemChange,
        value: modeValue
      })), !useViewsAsTabs ? React.createElement("div", {
        className: "".concat(styles$1.button, " ").concat(styles$1.buttonView),
        onClick: this.handleChangeTimeView
      }, React.createElement("span", null, this.openTo)) : React.createElement("div", {
        className: "".concat(styles$1.time),
        onClick: this.handleChangeTimeView
      }, React.createElement("span", null, time.format('hh:mm A'))), React.createElement(ClockView, {
        type: this.openTo,
        date: value,
        ampm: ampm,
        minutesStep: minutesStep,
        onHourChange: this.handleChange,
        onMinutesChange: this.handleChange,
        onSecondsChange: this.handleChange,
        size: size
      }));
    }
  }, {
    key: "timeOptions",
    get: function get() {
      return this.props.views.map(function (v) {
        return {
          title: v,
          value: v
        };
      });
    }
  }, {
    key: "openTo",
    get: function get() {
      return this.props.openTo || this.state.openTo;
    }
  }]);
  return TimePicker;
}(React.Component);

defineProperty(TimePicker, "propTypes", {
  value: PropTypes__default.number.isRequired,
  ampm: PropTypes__default.bool,
  minutesStep: PropTypes__default.number,
  openTo: PropTypes__default.oneOf(Object.values(ClockTypes)),
  views: PropTypes__default.arrayOf(PropTypes__default.oneOf(Object.values(ClockTypes))),
  onChange: PropTypes__default.func.isRequired,
  size: PropTypes__default.oneOf(['sm', '']),
  useViewsAsTabs: PropTypes__default.bool
});
defineProperty(TimePicker, "defaultProps", {
  ampm: true,
  views: ['hours', 'minutes'],
  size: '',
  useViewsAsTabs: false
});
var css$d = ".DatesPickerWithTimePicker-module_tabs__2JVyl {\n  margin-bottom: 1rem; }\n\n.DatesPickerWithTimePicker-module_pickerWrapper__3YuUW {\n  font-size: 16px; }\n";
var styles$4 = {
  "tabs": "DatesPickerWithTimePicker-module_tabs__2JVyl",
  "pickerWrapper": "DatesPickerWithTimePicker-module_pickerWrapper__3YuUW"
};
styleInject(css$d);
var tabs = [{
  title: 'Date',
  value: 'date'
}];

var DatesPickerWithTimePicker = /*#__PURE__*/function (_React$Component) {
  inherits(DatesPickerWithTimePicker, _React$Component);

  function DatesPickerWithTimePicker() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, DatesPickerWithTimePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(DatesPickerWithTimePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      tab: 'date'
    });
    defineProperty(assertThisInitialized(_this), "tabs", tabs.concat(['hours', 'minutes'].map(function (view) {
      return {
        title: view,
        value: view
      };
    })));
    defineProperty(assertThisInitialized(_this), "handleChangeTab", function (tab) {
      _this.setState({
        tab: tab.value
      });

      _this.props.clearAfterSelection();
    });
    defineProperty(assertThisInitialized(_this), "handleChange", function (value) {
      _this.props.onChange(value);
    });
    defineProperty(assertThisInitialized(_this), "renderTimePicker", function () {
      var value = _this.props.value;
      var tab = _this.state.tab;
      var time = value ? value.valueOf() : moment$1__default().startOf('day').valueOf();
      return React.createElement("div", {
        className: styles$4.pickerWrapper
      }, React.createElement(TimePicker, {
        openTo: tab,
        value: time,
        onChange: _this.handleChange,
        size: 'sm',
        useViewsAsTabs: true
      }));
    });
    defineProperty(assertThisInitialized(_this), "renderBar", function () {
      var tab = _this.state.tab;
      var children = _this.props.children;
      return React.createElement(React.Fragment, null, React.createElement(Tabs, {
        items: _this.tabs,
        className: "tabs_small tabs_capitalized ".concat(styles$4.tabs),
        value: tab,
        onChange: _this.handleChangeTab
      }), tab === 'date' ? children : _this.renderTimePicker());
    });
    return _this;
  }

  createClass(DatesPickerWithTimePicker, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps, prevState) {
      if (this.props.toggleToTime && !prevProps.toggleToTime && this.state.tab === 'date') {
        return true;
      }

      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (snapshot) {
        this.handleChangeTab(this.tabs[1]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          withTimePicker = _this$props.withTimePicker,
          children = _this$props.children;
      return React.createElement(React.Fragment, null, withTimePicker ? this.renderBar() : children);
    }
  }]);
  return DatesPickerWithTimePicker;
}(React.Component);

defineProperty(DatesPickerWithTimePicker, "propTypes", {
  value: PropTypes__default.oneOfType([PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck]), PropTypes__default.shape({
    start: PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck]),
    end: PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck])
  })]),
  withTimePicker: PropTypes__default.bool.isRequired,
  onChange: PropTypes__default.func.isRequired,
  clearAfterSelection: PropTypes__default.func,
  toggleToTime: PropTypes__default.bool
});

var DatesPickerOnDoneWrapperComponent = /*#__PURE__*/function (_React$PureComponent) {
  inherits(DatesPickerOnDoneWrapperComponent, _React$PureComponent);

  function DatesPickerOnDoneWrapperComponent() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, DatesPickerOnDoneWrapperComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(DatesPickerOnDoneWrapperComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      value: null
    });
    defineProperty(assertThisInitialized(_this), "findPreselectedRangeId", function (dateRange) {
      var preselectedRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var start = moment$1__default(dateRange.start);
      var end = moment$1__default(dateRange.end);

      for (var ii = 0; ii < preselectedRange.length; ii++) {
        var current = preselectedRange[ii];
        var rangeStart = moment$1__default(current.start);
        var rangeEnd = moment$1__default(current.end);

        if (start.isSame(rangeStart, 'day') && end.isSame(rangeEnd, 'day')) {
          return current.key;
        }
      }

      return null;
    });
    defineProperty(assertThisInitialized(_this), "onSelect", function (value, states, preselectedRangeKey) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          preselectedRangeValues = _this$props.preselectedRangeValues,
          updateByDone = _this$props.updateByDone,
          resetInputValue = _this$props.resetInputValue;

      var formatedPreselectedKey = preselectedRangeKey || _this.findPreselectedRangeId(value, preselectedRangeValues);

      _this.setState({
        value: value,
        states: states,
        preselectedRange: formatedPreselectedKey
      });

      resetInputValue();

      if (!updateByDone) {
        onSelect(value, states, formatedPreselectedKey);
      }
    });
    defineProperty(assertThisInitialized(_this), "handleClickOutside", function () {
      return _this.props.resetInputValue();
    });
    return _this;
  }

  createClass(DatesPickerOnDoneWrapperComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        value: this.props.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          updateByDone = _this$props2.updateByDone,
          onSelect = _this$props2.onSelect;
      var _this$state = this.state,
          value = _this$state.value,
          preselectedRange = _this$state.preselectedRange;
      return this.props.children(value, updateByDone ? this.onSelect : onSelect, preselectedRange);
    }
  }]);
  return DatesPickerOnDoneWrapperComponent;
}(React.PureComponent);

defineProperty(DatesPickerOnDoneWrapperComponent, "propTypes", {
  onSelect: PropTypes__default.func,
  value: PropTypes__default.any,
  resetInputValue: PropTypes__default.func,
  updateByDone: PropTypes__default.bool,
  preselectedRangeValues: PropTypes__default.array
});
var DatesPickerOnDoneWrapper = withClickOutside(DatesPickerOnDoneWrapperComponent);
var css$e = ".tooltip {\n  position: relative; }\n  .tooltip__label {\n    pointer-events: none;\n    position: absolute;\n    z-index: 100;\n    display: block;\n    padding: 5px 10px;\n    border-radius: 5px;\n    background-color: #787878;\n    box-shadow: 0 3px 16px rgba(0, 0, 0, 0.15);\n    transform-origin: 0 0 0;\n    font-family: 'Lato Medium', sans-serif;\n    font-weight: 400;\n    font-size: 1rem;\n    line-height: 1.15;\n    color: #ffffff;\n    white-space: normal; }\n    .tooltip__label-outer {\n      display: block; }\n    .tooltip__label-inner {\n      display: inline; }\n  .tooltip_visible .tooltip__label {\n    opacity: 1;\n    visibility: visible;\n    transition: transform 200ms ease, opacity 200ms, visibility 200ms 0s; }\n  .tooltip_hidden .tooltip__label {\n    opacity: 0;\n    visibility: hidden;\n    transition: transform 200ms ease, opacity 200ms, visibility 200ms 200ms; }\n  .tooltip.tooltip_top .tooltip__label {\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    margin-bottom: 5px; }\n  .tooltip.tooltip_top.tooltip_visible .tooltip__label {\n    transform: translateY(0) translateX(-50%); }\n  .tooltip.tooltip_top.tooltip_hidden .tooltip__label {\n    transform: translateY(-10px) translateX(-50%); }\n  .tooltip.tooltip_bottom .tooltip__label {\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    margin-top: 5px; }\n  .tooltip.tooltip_bottom.tooltip_visible .tooltip__label {\n    transform: translateY(0) translateX(-50%); }\n  .tooltip.tooltip_bottom.tooltip_hidden .tooltip__label {\n    transform: translateY(10px) translateX(-50%); }\n  .tooltip.tooltip_bottom-left .tooltip__label {\n    top: 100%;\n    left: 0;\n    margin-top: 5px; }\n  .tooltip.tooltip_bottom-left.tooltip_visible .tooltip__label {\n    transform: translateY(0); }\n  .tooltip.tooltip_bottom-left.tooltip_hidden .tooltip__label {\n    transform: translateY(10px); }\n  .tooltip.tooltip_bottom-right .tooltip__label {\n    top: 100%;\n    right: 0;\n    margin-top: 5px; }\n  .tooltip.tooltip_bottom-right.tooltip_visible .tooltip__label {\n    transform: translateY(0); }\n  .tooltip.tooltip_bottom-right.tooltip_hidden .tooltip__label {\n    transform: translateY(10px); }\n  .tooltip.tooltip_right .tooltip__label {\n    top: 50%;\n    left: 100%;\n    transform: translateY(-50%);\n    margin-left: 5px; }\n  .tooltip.tooltip_right.tooltip_visible .tooltip__label {\n    transform: translateY(-50%) translateX(0); }\n  .tooltip.tooltip_right.tooltip_hidden .tooltip__label {\n    transform: translateY(-50%) translateX(10px); }\n  .tooltip.tooltip_left .tooltip__label {\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    margin-right: 5px; }\n  .tooltip.tooltip_left.tooltip_visible .tooltip__label {\n    transform: translateY(-50%) translateX(calc(-100% - 5px)); }\n  .tooltip.tooltip_left.tooltip_hidden .tooltip__label {\n    transform: translateY(-50%) translateX(calc(-100% - 15px)); }\n";
styleInject(css$e);
var Positions = {
  LEFT: 'tooltip_left',
  TOP: 'tooltip_top',
  RIGHT: 'tooltip_right',
  BOTTOM: 'tooltip_bottom',
  'BOTTOM-LEFT': 'tooltip_bottom-left',
  'BOTTOM-RIGHT': 'tooltip_bottom-right'
};

var Tooltip = /*#__PURE__*/function (_PureComponent) {
  inherits(Tooltip, _PureComponent);

  function Tooltip(props) {
    var _this;

    classCallCheck(this, Tooltip);
    _this = possibleConstructorReturn(this, getPrototypeOf(Tooltip).call(this, props));
    defineProperty(assertThisInitialized(_this), "tooltipLabel", createRef());
    defineProperty(assertThisInitialized(_this), "onFontLoaded", function () {
      var font = new fontfaceobserver_standalone('Lato Medium');
      font.load().then(function () {
        _this.setStyleToInitial();
      });
    });
    defineProperty(assertThisInitialized(_this), "setStyleToInitial", function () {
      _this.setState({
        labelInnerMaxWidth: _this.labelInnerWidth,
        isLabelMaxWidthSet: false
      });
    });
    defineProperty(assertThisInitialized(_this), "setLabelMaxWidth", function () {
      if (_this.tooltipLabelInner) {
        var contentWidth = Math.ceil(_this.tooltipLabelInner.getBoundingClientRect().width);
        contentWidth = contentWidth <= _this.labelInnerWidth ? contentWidth : _this.labelInnerWidth;

        _this.setState({
          labelInnerMaxWidth: contentWidth,
          isLabelMaxWidthSet: true
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "handleMouseEnter", function () {
      _this.setStyleToInitial();

      var position = _this.getPosition();

      _this.timer = setTimeout(function () {
        _this.setState({
          isVisible: true,
          isShowing: true,
          position: position
        });
      }, _this.props.delayTime);
    });
    defineProperty(assertThisInitialized(_this), "handleMouseLeave", function () {
      clearTimeout(_this.timer);

      _this.setState({
        isVisible: false
      }, function () {
        _this.process = setTimeout(function () {
          _this.setState({
            position: _this.props.auto ? Positions.TOP : Positions[_this.props.position.toUpperCase()],
            isShowing: false
          });
        }, 200); // Animation duration
      });
    });
    _this.labelInnerWidth = props.labelMaxWidth ? props.labelMaxWidth - 20 : 480; // 2x 10px horizontal paddings

    _this.state = {
      isVisible: false,
      isShowing: false,
      // visible with animation duration
      position: Positions[props.position.toUpperCase()],
      labelInnerMaxWidth: _this.labelInnerWidth
    };
    _this.timer = null;
    return _this;
  }

  createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onFontLoaded();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.state.isLabelMaxWidthSet) {
        this.setLabelMaxWidth();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      if (this.props.auto) {
        clearTimeout(this.process);
        var _this$state = this.state,
            isShowing = _this$state.isShowing,
            current = _this$state.position;

        if (isShowing) {
          return current;
        }

        var position = Positions.TOP;
        var coord = this.tooltipLabel.current.getBoundingClientRect();
        var x = coord.x,
            y = coord.y,
            right = coord.right;

        if (y < 0) {
          position = Positions.BOTTOM;
        }

        if (x < 0) {
          position = Positions.RIGHT;
        }

        if (right > window.innerWidth) {
          position = Positions.LEFT;
        }

        return position;
      } else {
        return this.state.position;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          style = _this$props.style,
          handleClick = _this$props.handleClick;
      var _this$state2 = this.state,
          isVisible = _this$state2.isVisible,
          position = _this$state2.position,
          labelInnerMaxWidth = _this$state2.labelInnerMaxWidth;
      var visible = isVisible ? 'tooltip_visible' : 'tooltip_hidden';
      var tooltipClassName = "tooltip ".concat(position, " ").concat(visible, " ").concat(className);
      return React.createElement("div", {
        className: tooltipClassName,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        style: style,
        onClick: handleClick
      }, React.createElement("span", {
        ref: this.tooltipLabel,
        className: "tooltip__label"
      }, React.createElement("span", {
        className: "tooltip__label-outer",
        style: {
          width: "".concat(this.labelInnerWidth, "px"),
          maxWidth: "".concat(labelInnerMaxWidth, "px")
        }
      }, React.createElement("span", {
        ref: function ref(el) {
          _this2.tooltipLabelInner = el;
        },
        className: "tooltip__label-inner"
      }, this.props.label))), this.props.children);
    }
  }]);
  return Tooltip;
}(PureComponent);

Tooltip.defaultProps = {
  delayTime: 500,
  position: 'top',
  auto: true
};
Tooltip.propTypes = {
  label: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]).isRequired,
  delayTime: PropTypes__default.number,
  position: PropTypes__default.oneOf(['top', 'right', 'bottom', 'bottom-left', 'bottom-right', 'left']),
  auto: PropTypes__default.bool,
  labelMaxWidth: PropTypes__default.number,
  className: PropTypes__default.string,
  style: PropTypes__default.object
};

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var moment = range.extendMoment(moment$1__default);

var noop$1 = function noop() {
  console.log('noop');
};

var DATE_FORMAT = 'MM/DD/YYYY';

var DEFAULT_PRESELECTED_VALUES = function () {
  var end = moment().endOf('day');
  return [{
    key: 'week',
    title: 'Week',
    start: moment().add(-1, 'week').startOf('day'),
    end: end
  }, {
    key: 'month',
    title: 'Month',
    start: moment().add(-1, 'month').startOf('day'),
    end: end
  }, {
    key: '3months',
    title: '3 Months',
    start: moment().add(-3, 'month').startOf('day'),
    end: end
  }];
}();

var getMomentDate = function getMomentDate(date) {
  if (date instanceof moment) {
    return date;
  }

  return moment(date, DATE_FORMAT);
};

var DatesPickerWrapper = function DatesPickerWrapper(_ref) {
  var children = _ref.children,
      tooltipParams = _ref.tooltipParams;
  return tooltipParams ? React.createElement(Tooltip, tooltipParams, children) : children;
};

var DatesPickerComponent = /*#__PURE__*/function (_Component) {
  inherits(DatesPickerComponent, _Component);

  function DatesPickerComponent(props) {
    var _this;

    classCallCheck(this, DatesPickerComponent);
    _this = possibleConstructorReturn(this, getPrototypeOf(DatesPickerComponent).call(this, props));
    defineProperty(assertThisInitialized(_this), "startInputRef", null);
    defineProperty(assertThisInitialized(_this), "onSelect", function (value, states, preselectedRange) {
      var _this$props = _this.props,
          singleDateMode = _this$props.singleDateMode,
          updateDateRange = _this$props.updateDateRange;

      if (!value) {
        return;
      }

      var start = value.start,
          end = value.end;

      if (end) {
        end = moment(end).endOf('day');
      }

      _this.setState({
        value: value,
        states: states,
        preselectedRange: preselectedRange,
        inputValue: null,
        afterSelection: true,
        isButtonDisabled: false
      });

      singleDateMode ? updateDateRange(value, preselectedRange) : updateDateRange(start, end, preselectedRange);
    });
    defineProperty(assertThisInitialized(_this), "revertAfterSelection", function () {
      _this.setState({
        afterSelection: false
      });
    });
    defineProperty(assertThisInitialized(_this), "onToggle", function () {
      if (_this.props.disableNavigation) return;

      _this.setState({
        isOpen: !_this.state.isOpen
      });
    });
    defineProperty(assertThisInitialized(_this), "onOpen", function () {
      _this.setState({
        isOpen: true
      });
    });
    defineProperty(assertThisInitialized(_this), "onClose", function () {
      _this.setState({
        isOpen: false
      });
    });
    defineProperty(assertThisInitialized(_this), "onInputFocus", function (e, field) {
      var target = e.target;
      var value = target.value;
      !_this.state.isOpen && target.blur();
      target.setSelectionRange(0, value.length);

      _this.setState({
        focusedElement: field === 'singleDate' ? null : field
      });
    });
    defineProperty(assertThisInitialized(_this), "onInputBlur", function (e, field) {
      var isOpen = _this.state.isOpen;

      _this.setState({
        focusedElement: null
      });

      isOpen && _this.onInputEntered(e, field);
    });
    defineProperty(assertThisInitialized(_this), "onInputKeyEnter", function (e, field) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        _this.onInputEntered(e, field, true);

        e.target.blur();

        _this.onClose();
      }
    });
    defineProperty(assertThisInitialized(_this), "onInputEntered", function (e, field, fromEnterKey) {
      var _this$props2 = _this.props,
          dateRange = _this$props2.dateRange,
          singleDate = _this$props2.singleDate,
          singleDateMode = _this$props2.singleDateMode,
          dateFormat = _this$props2.dateFormat;
      var target = e.target;
      var momentValue = moment$1__default(target.value, dateFormat);
      var prevValue = singleDateMode ? singleDate : dateRange; // Checking if value is valid and could be selected

      if (!momentValue.isValid() || _this.pickerComponent && _this.pickerComponent.isDateDisabled(momentValue) && !_this.pickerComponent.isDateSelectable(momentValue)) {
        var value = singleDateMode ? prevValue : _objectSpread$1({}, prevValue);
        return _this.onSelect(value);
      }

      var newValue;

      switch (field) {
        case 'start':
          {
            if (momentValue.isAfter(moment$1__default(prevValue.end))) {
              newValue = prevValue.start;
            } else {
              newValue = momentValue.startOf('day').toDate();
            }

            break;
          }

        case 'end':
          {
            if (momentValue.isBefore(moment$1__default(prevValue.start))) {
              newValue = prevValue.end;
            } else {
              newValue = momentValue.endOf('day').toDate();
            }

            break;
          }

        case 'singleDate':
          {
            newValue = _this.props.withTimePicker ? momentValue.toDate() : momentValue.endOf('day').toDate();
            break;
          }

        default:
          {
            newValue = prevValue[field];
          }
      }

      field === 'singleDate' ? _this.setState({
        inputValue: newValue
      }, function () {
        return fromEnterKey && _this.onSelect(newValue);
      }) : _this.setState({
        inputValue: _objectSpread$1({}, prevValue, defineProperty({}, field, newValue))
      }, function () {
        return fromEnterKey && _this.onSelect(_objectSpread$1({}, prevValue, defineProperty({}, field, newValue)));
      });
    });
    defineProperty(assertThisInitialized(_this), "renderSelectionValue", function () {
      var _this$props3 = _this.props,
          singleDateProps = _this$props3.singleDate,
          dateRange = _this$props3.dateRange,
          singleDateMode = _this$props3.singleDateMode,
          dateFormat = _this$props3.dateFormat,
          label = _this$props3.label,
          singleDatePlaceholder = _this$props3.singleDatePlaceholder,
          tooltipParams = _this$props3.tooltipParams,
          _this$props3$classNam = _this$props3.className,
          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam;

      var _ref2 = dateRange || {},
          start = _ref2.start,
          end = _ref2.end;

      var singleDate = singleDateMode && singleDateProps;
      var inputValue = _this.state.inputValue;

      if (start) {
        start = moment(inputValue ? inputValue.start : start).format(dateFormat);
      }

      if (end) {
        end = moment(inputValue ? inputValue.end : end).format(dateFormat);
      }

      if (singleDate) {
        singleDate = moment(inputValue || singleDate).format(dateFormat);
      }

      return React.createElement(DatesPickerWrapper, {
        tooltipParams: tooltipParams
      }, React.createElement("div", {
        className: "date-picker ".concat(_this.state.isOpen ? '_opened' : '', " ").concat(className),
        onClick: _this.onOpen
      }, React.createElement("div", {
        className: "date-picker__label"
      }, label || "Date ".concat(singleDateMode ? '' : 'Range')), React.createElement("i", {
        className: "icon date-picker__icon ".concat(singleDateMode ? '_single' : '')
      }, singleDateMode ? React.createElement(SvgComponent$1l, null) : React.createElement(SvgComponent$1k, null)), React.createElement("div", {
        className: "date-picker__wrapper"
      }, React.createElement("div", {
        className: "date-picker__item ".concat(singleDateMode ? '_single' : '')
      }, React.createElement("label", {
        className: "date-picker__item-label",
        onClick: function onClick(e) {
          return !_this.state.isOpen && e.preventDefault();
        }
      }, React.createElement("input", {
        ref: function ref(el) {
          if (el) {
            el.value = singleDateMode ? singleDate : start;
            _this.startInputRef = el;
          }
        },
        onFocus: function onFocus(e) {
          return _this.onInputFocus(e, singleDateMode ? 'singleDate' : 'start');
        },
        onBlur: function onBlur(e) {
          return _this.onInputBlur(e, singleDateMode ? 'singleDate' : 'start');
        },
        type: "text",
        size: "5",
        placeholder: singleDatePlaceholder,
        className: "form-control",
        onKeyDown: function onKeyDown(e) {
          return _this.onInputKeyEnter(e, singleDateMode ? 'singleDate' : 'start');
        },
        tabIndex: 0
      }))), !singleDateMode && React.createElement(React.Fragment, null, React.createElement("div", {
        className: "date-picker__item-divider"
      }, " \u2013 "), React.createElement("div", {
        className: "date-picker__item"
      }, React.createElement("label", {
        className: "date-picker__item-label"
      }, React.createElement("input", {
        type: "text",
        size: "5",
        className: "form-control",
        ref: function ref(el) {
          if (el) {
            el.value = end;
          }
        },
        onFocus: function onFocus(e) {
          return _this.onInputFocus(e, 'end');
        },
        onBlur: function onBlur(e) {
          return _this.onInputBlur(e, 'end');
        },
        onKeyDown: function onKeyDown(e) {
          return _this.onInputKeyEnter(e, 'end');
        },
        tabIndex: 0
      })))))));
    });
    defineProperty(assertThisInitialized(_this), "selectPreselectedRange", function (onSelectCallback) {
      return function (event) {
        var rangeID = event.target.getAttribute('data-range-id');
        if (!rangeID) return;

        var range = _this.state.preselectedRangeValues.reduce(function (acc, item) {
          acc[item.key] = item;
          return acc;
        }, {});

        var _range$rangeID = range[rangeID],
            start = _range$rangeID.start,
            end = _range$rangeID.end;
        var r = moment.range(start, end);

        _this.setState({
          isButtonDisabled: false
        });

        if (onSelectCallback) {
          onSelectCallback(r, null, rangeID);
        } else {
          _this.onSelect(moment.range(start, end), null, rangeID);
        }
      };
    });
    defineProperty(assertThisInitialized(_this), "handleClickOutside", function (event) {
      if (_this.state.isOpen) {
        event.stopPropagation();
      }

      _this.onClose();
    });
    defineProperty(assertThisInitialized(_this), "innerWrapperHandler", function (el) {
      if (el) {
        try {
          var elLeft = Number.parseFloat(window.getComputedStyle(el).left);
          var parentLeft = el.parentElement.getBoundingClientRect().left;
          var diff = Math.abs(parentLeft) - Math.abs(elLeft);

          if (diff < 0) {
            el.style.right = "".concat(-(Math.abs(diff) + 10), "px");
          }
        } catch (e) {
          el.style.right = 0;
        }
      }
    });
    _this.state = {
      isOpen: false,
      preselectedRange: false,
      // props.dateRange && props.dateRange.range,
      preselectedRangeValues: _this.getPreselectedList(),
      focusedElement: null,
      inputValue: null,
      afterSelection: false,
      isButtonDisabled: false
    };
    return _this;
  }

  createClass(DatesPickerComponent, [{
    key: "getPreselectedList",
    value: function getPreselectedList() {
      var preselected = this.props.preselected;
      var preselectedRangeValues;

      if (preselected) {
        if (preselected === true) {
          preselectedRangeValues = DEFAULT_PRESELECTED_VALUES;
        } else if (preselected instanceof Array) {
          preselectedRangeValues = preselected;
        } else {
          throw Error('The preselected property must be a boolean or an Array types');
        }
      }

      return preselectedRangeValues;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.singleDateMode && this.props.preselected && this.props.dateRange) {
        this.checkPreselectedValues(this.props.dateRange, this.state.preselectedRangeValues);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var preselectedRangeValues;

      if (this.props.preselected !== prevProps.preselected) {
        preselectedRangeValues = this.getPreselectedList();
        this.setState(function () {
          return {
            preselectedRangeValues: preselectedRangeValues
          };
        });
      }

      if (!this.props.singleDateMode && this.props.preselected && prevProps.dateRange !== this.props.dateRange) {
        this.checkPreselectedValues(this.props.dateRange, preselectedRangeValues || this.state.preselectedRangeValues);
      }

      if (this.startInputRef && this.state.isOpen && prevState.isOpen !== this.state.isOpen) {
        this.startInputRef.select();
      }
    }
  }, {
    key: "checkPreselectedValues",
    value: function checkPreselectedValues(dateRange, preselectedRange) {
      var start = getMomentDate(dateRange.start);
      var end = getMomentDate(dateRange.end);

      for (var ii = 0; ii < preselectedRange.length; ii++) {
        var current = preselectedRange[ii];
        var rangeStart = getMomentDate(current.start);
        var rangeEnd = getMomentDate(current.end);

        if (start.isSame(rangeStart, 'day') && end.isSame(rangeEnd, 'day')) {
          this.setState({
            preselectedRange: current.key
          });
          return;
        }
      }

      if (this.state.preselectedRange) {
        this.setState({
          preselectedRange: null
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(newProps, newState) {
      if (this.state.isOpen !== newState.isOpen || this.state.focusedElement !== newState.focusedElement) {
        return true;
      }

      return !(newProps.dateRange === this.props.dateRange && newState.preselectedRange === this.state.preselectedRange && newState.preselectedRangeValues === this.state.preselectedRangeValues && newProps.singleDate === this.props.singleDate && newProps.preselected === this.props.preselected && newProps.afterSelection === this.state.afterSelection);
    }
  }, {
    key: "renderPreselectedRange",
    value: function renderPreselectedRange(onSelectCallback, selectedRangeId) {
      var _this2 = this;

      if (!this.props.preselected) {
        return null;
      }

      var preselectedRangeValues = this.state.preselectedRangeValues;
      return React.createElement("div", {
        "data-active-range": this.state.preselectedRange,
        className: "date-range-picker__btns",
        onClick: this.selectPreselectedRange(onSelectCallback)
      }, preselectedRangeValues.map(function (item, index) {
        return React.createElement("button", {
          key: index,
          className: "date-range-picker__btn ".concat((selectedRangeId === undefined ? _this2.state.preselectedRange === item.key : selectedRangeId === item.key) ? '_active' : ''),
          "data-range-id": item.key
        }, item.title);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          singleDate = _this$props4.singleDate,
          singleDateMode = _this$props4.singleDateMode,
          insidePreselectors = _this$props4.insidePreselectors;
      var datePickerProps = this.props.datePickerProps;
      var _this$state = this.state,
          isButtonDisabled = _this$state.isButtonDisabled,
          isOpen = _this$state.isOpen;

      var _ref3 = this.props.dateRange || {},
          start = _ref3.start,
          end = _ref3.end;

      var value1 = null;

      if (start && end) {
        value1 = moment.range(moment(start).startOf('day'), moment(end));
      } else if (singleDateMode) {
        value1 = singleDate ? moment(singleDate) : null;
      }

      var animateYAxisClassName = this.props.datePickerProps.animationAxis === 'Y' ? '_animate-y-axis' : '';
      return React.createElement("div", {
        className: "date-range-picker ".concat(isOpen ? '_opened' : '', " ").concat(this.withTimePicker ? 'date-range-picker_with-time' : '')
      }, !singleDateMode && !insidePreselectors && this.renderPreselectedRange(), React.createElement("div", {
        className: "date-range-picker__wrapper"
      }, this.renderSelectionValue(), React.createElement(Transition, {
        "in": this.state.isOpen,
        timeout: {
          enter: 1,
          exit: 250
        },
        unmountOnExit: true
      }, function (state) {
        return React.createElement(DatesPickerOnDoneWrapper, {
          value: value1,
          inputValue: _this3.state.inputValue || value1,
          resetInputValue: function resetInputValue() {
            return _this3.setState({
              inputValue: null
            });
          },
          onSelect: _this3.onSelect,
          updateByDone: _this3.props.updateByDone,
          preselectedRangeValues: _this3.getPreselectedList()
        }, function (value, _onSelect, preselectedRangeKey) {
          return React.createElement("div", {
            className: "date-range-picker__wrapper-inner _".concat(state, " ").concat(animateYAxisClassName),
            ref: _this3.innerWrapperHandler
          }, React.createElement(DatesPickerWithTimePicker, {
            toggleToTime: _this3.state.afterSelection,
            clearAfterSelection: _this3.revertAfterSelection,
            value: value,
            withTimePicker: _this3.withTimePicker,
            onChange: _onSelect
          }, React.createElement(DateRangePicker, _extends_1({
            ref: function ref(comp) {
              _this3.pickerComponent = comp;
            },
            value: value,
            onSelect: function onSelect(v) {
              _onSelect(v);

              _this3.setState({
                afterSelection: true,
                isButtonDisabled: false
              });
            },
            focusedElement: _this3.state.focusedElement,
            selectionType: singleDateMode ? 'single' : 'range',
            onSelectStart: function onSelectStart() {
              return _this3.setState({
                isButtonDisabled: true
              });
            }
          }, datePickerProps))), React.createElement("div", {
            className: "date-range-picker__controls"
          }, _this3.props.insidePreselectors && _this3.renderPreselectedRange(_onSelect, preselectedRangeKey), React.createElement(Button, {
            className: "btn-square _conflower-blue _xs date-range-picker__btn-done _filled",
            onClick: function onClick(event) {
              _this3.onSelect(_this3.state.inputValue || value);

              _this3.handleClickOutside(event);
            },
            disabled: isButtonDisabled
          }, "Apply")));
        });
      })));
    }
  }, {
    key: "withTimePicker",
    get: function get() {
      var _this$props5 = this.props,
          singleDateMode = _this$props5.singleDateMode,
          withTimePicker = _this$props5.withTimePicker;
      return singleDateMode && withTimePicker;
    }
  }]);
  return DatesPickerComponent;
}(Component);

defineProperty(DatesPickerComponent, "defaultProps", {
  updateDateRange: noop$1,
  dateRange: {
    start: '',
    end: ''
  },
  preselected: false,
  insidePreselectors: false,
  singleDate: '',
  singleDateMode: false,
  labels: [],
  dateFormat: DATE_FORMAT,
  withTimePicker: false,
  updateByDone: true,
  label: ''
});
DatesPickerWrapper.propTypes = {
  tooltipParams: PropTypes__default.object
};
var propTypes = {
  datePickerProps: PropTypes__default.object,
  dateRange: PropTypes__default.shape({
    start: PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck]),
    end: PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck])
  }),
  singleDate: PropTypes__default.oneOfType([PropTypes__default.number, momentOrDatePropCheck]),
  preselected: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.arrayOf(PropTypes__default.shape({
    start: momentOrDatePropCheck,
    end: momentOrDatePropCheck,
    title: PropTypes__default.string,
    key: PropTypes__default.string
  }))]),
  insidePreselectors: PropTypes__default.bool,
  updateDateRange: PropTypes__default.func,
  dateFormat: PropTypes__default.string,
  singleDateMode: PropTypes__default.bool,
  labels: PropTypes__default.arrayOf(PropTypes__default.string),
  withTimePicker: PropTypes__default.bool,
  updateByDone: PropTypes__default.bool,
  label: PropTypes__default.string,
  singleDatePlaceholder: PropTypes__default.string,
  tooltipParams: PropTypes__default.object,
  className: PropTypes__default.string
};
DatesPickerComponent.propTypes = propTypes;
var DatesPicker = withClickOutside(DatesPickerComponent);
DatesPicker.propTypes = propTypes;

var Tumbler$1 = function Tumbler(_ref) {
  var isActive = _ref.isActive,
      label = _ref.label,
      onClick = _ref.onClick;
  return React.createElement("div", {
    onClick: onClick,
    className: "select__tumbler ".concat(isActive ? '_active' : '')
  }, React.createElement("div", {
    className: "select__tumbler-slide"
  }, React.createElement("div", {
    className: "select__tumbler-btn"
  })), React.createElement("div", {
    className: "select__tumbler-label"
  }, label || 'Shows Groups'));
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var isIncludeSubstr = function isIncludeSubstr(a, b) {
  return a.toLowerCase().includes(b.toLowerCase());
};

var itemIsSelected = function itemIsSelected(item, selectedValue) {
  if (selectedValue === null || selectedValue === undefined || Array.isArray(selectedValue) && !selectedValue.length) {
    return false;
  }

  if (Array.isArray(selectedValue)) {
    return selectedValue.some(function (v) {
      return v.value === item.value;
    });
  }

  return item.value === selectedValue.value;
};

var moveItem = function moveItem(a, from, to) {
  if (from === to || to === null) return a;
  var clone = toConsumableArray(a);
  clone.splice(to, 0, clone.splice(from, 1)[0]);
  return clone;
};

var filterItems = function filterItems(list, search, searchByValue) {
  var recurse = function recurse(arr) {
    return arr.map(function (item) {
      if (Array.isArray(item.options)) {
        var options = recurse(item.options);

        if (options && options.filter(function (o) {
          return o;
        }).length) {
          return _objectSpread$2({}, item, {
            options: options
          });
        }
      }

      return isIncludeSubstr(item.label, search) || searchByValue && item.value.toString().includes(search) ? item : null;
    }).filter(function (o) {
      return o;
    });
  };

  return recurse(list);
};

var getItemClasses = function getItemClasses(item, _ref) {
  var isActive = _ref.isActive,
      indexItem = _ref.indexItem,
      startDragIndex = _ref.startDragIndex,
      targetDropIndex = _ref.targetDropIndex;
  var className = 'select__option';
  if (isActive) className += ' _active';
  if (item.isGroupHeader) className += ' _header';
  if (item.alwaysEnabled) className += ' _enabled';
  if (item.lastFirstGroup) className += ' _last-enabled';

  if (indexItem !== undefined) {
    if (targetDropIndex === indexItem) className += ' _separator';
    if (startDragIndex === indexItem) className += ' _hide';
    className += startDragIndex < targetDropIndex ? ' _bottom' : ' _top';
  }

  return className;
};

var updateStateOfOptions = function updateStateOfOptions(state, item, isMulti) {
  var traverseMulti = function traverseMulti(list, parentSelected) {
    if (!list) return;
    list.forEach(function (node) {
      var isActive;

      if (node.value === item.value) {
        isActive = !node.isActive;
      } else if (parentSelected !== undefined) {
        isActive = parentSelected;
      }

      if (isActive !== undefined) node.isActive = isActive;
      if (!(node.options && node.options.length)) return;
      traverseMulti(node.options, isActive);
      node.isActive = node.options.every(function (o) {
        return o.isActive;
      });
    });
  };

  var traverseSingle = function traverseSingle(list) {
    if (!list) return;
    list.forEach(function (node) {
      node.isActive = item.value === node.value;
      traverseSingle(node.options);
    });
  };

  var traverse = function traverse(list) {
    if (!list) return;
    isMulti ? traverseMulti(list) : traverseSingle(list);
  };

  var cloneState = cloneDeep(state);
  traverse(cloneState);
  return cloneState;
};

var FIRST_GROUP_ID = 1;

var makeStateOfOptions = function makeStateOfOptions(options, selectedValue) {
  var dnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var recurse = function recurse(list) {
    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return list.map(function (item) {
      var res = _objectSpread$2({}, item, {
        deep: deep,
        isActive: item.alwaysEnabled || itemIsSelected(item, selectedValue)
      });

      if (item.options && item.options.length) {
        res.options = recurse(item.options, deep + 1);
      }

      if (item.alwaysEnabled) {
        res.alwaysEnabled = item.alwaysEnabled;
      }

      return res;
    });
  };

  var state = recurse(options);

  if (dnd) {
    var selected = Array.isArray(selectedValue) ? selectedValue : [];
    var selectedValuesOrder = selected.reduce(function (acc, v) {
      if (options.some(function (o) {
        return o.value === v.value;
      })) {
        var item = state.find(function (s) {
          return s.value === v.value;
        });
        if (item) acc = [].concat(toConsumableArray(acc), [item]);
      }

      return acc;
    }, []);
    var fixedOptions = state.filter(function (o) {
      return o.alwaysEnabled;
    });
    var res = [].concat(toConsumableArray(fixedOptions.filter(function (o) {
      return !selectedValuesOrder.some(function (s) {
        return o.value === s.value;
      });
    })), toConsumableArray(selectedValuesOrder));
    var numberOfFirstGroup = res.filter(function (v) {
      return v.draggableGroup === 1;
    }).length;
    res = res.filter(function (v) {
      return v.draggableGroup === FIRST_GROUP_ID;
    }).concat(res.filter(function (v) {
      return v.draggableGroup !== FIRST_GROUP_ID;
    }));

    if (numberOfFirstGroup) {
      res[numberOfFirstGroup - 1] = _objectSpread$2({}, res[numberOfFirstGroup - 1], {
        lastFirstGroup: true
      });
    }

    state = [].concat(toConsumableArray(res), toConsumableArray(state.filter(function (v) {
      return !v.isActive;
    })));
  }

  return state;
};

var traverseState = function traverseState(list, cb) {
  list.forEach(function (item) {
    cb(item);
    if (item.options && item.options.length) traverseState(item.options, cb);
  });
};

var normalizeValue = function normalizeValue(value) {
  if (!value) return value;

  var getProps = function getProps(_ref2) {
    var deep = _ref2.deep,
        options = _ref2.options,
        isActive = _ref2.isActive,
        rest = objectWithoutProperties(_ref2, ["deep", "options", "isActive"]);
    return rest;
  };

  if (!Array.isArray(value)) {
    return getProps(value);
  } else {
    var list = value.map(function (v) {
      return getProps(v);
    });
    return list;
  }
};

function _extends$1m() {
  _extends$1m = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1m.apply(this, arguments);
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$1(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _typeof2(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof2 = function _typeof2(obj) {
      return typeof obj;
    };
  } else {
    _typeof2 = function _typeof2(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof2(obj);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */


var NODE_ENV = process.env.NODE_ENV;

var invariant$1 = function invariant$1(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
};

var invariant_1$1 = invariant$1;

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray$1(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
}

var Manager = function () {
  function Manager() {
    _classCallCheck$1(this, Manager);

    _defineProperty$1(this, "refs", {});
  }

  _createClass$1(Manager, [{
    key: "add",
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: "remove",
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var _this = this;

      return this.refs[this.active.collection].find(function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: "getOrderedRefs",
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
      return this.refs[collection].sort(sortByIndex);
    }
  }]);

  return Manager;
}();

function sortByIndex(_ref2, _ref3) {
  var index1 = _ref2.node.sortableInfo.index;
  var index2 = _ref3.node.sortableInfo.index;
  return index1 - index2;
}

function omit(obj, keysToOmit) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

var events = {
  end: ['touchend', 'touchcancel', 'mouseup'],
  move: ['touchmove', 'mousemove'],
  start: ['touchstart', 'mousedown']
};

var vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return '';
  }

  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';

    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function setInlineStyles(node, styles) {
  Object.keys(styles).forEach(function (key) {
    node.style[key] = styles[key];
  });
}

function setTranslate3d(node, translate) {
  node.style["".concat(vendorPrefix, "Transform")] = translate == null ? '' : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
}

function setTransitionDuration(node, duration) {
  node.style["".concat(vendorPrefix, "TransitionDuration")] = duration == null ? '' : "".concat(duration, "ms");
}

function closest(el, fn) {
  while (el) {
    if (fn(el)) {
      return el;
    }

    el = el.parentNode;
  }

  return null;
}

function limit(min, max, value) {
  return Math.max(min, Math.min(value, max));
}

function getPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }

  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);
  return {
    bottom: getPixelValue(style.marginBottom),
    left: getPixelValue(style.marginLeft),
    right: getPixelValue(style.marginRight),
    top: getPixelValue(style.marginTop)
  };
}

function provideDisplayName(prefix, Component$$1) {
  var componentName = Component$$1.displayName || Component$$1.name;
  return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
}

function getScrollAdjustedBoundingClientRect(node, scrollDelta) {
  var boundingClientRect = node.getBoundingClientRect();
  return {
    top: boundingClientRect.top + scrollDelta.top,
    left: boundingClientRect.left + scrollDelta.left
  };
}

function getPosition(event) {
  if (event.touches && event.touches.length) {
    return {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  } else if (event.changedTouches && event.changedTouches.length) {
    return {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
  } else {
    return {
      x: event.pageX,
      y: event.pageY
    };
  }
}

function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}

function getEdgeOffset(node, parent) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    left: 0,
    top: 0
  };

  if (!node) {
    return undefined;
  }

  var nodeOffset = {
    left: offset.left + node.offsetLeft,
    top: offset.top + node.offsetTop
  };

  if (node.parentNode === parent) {
    return nodeOffset;
  }

  return getEdgeOffset(node.parentNode, parent, nodeOffset);
}

function getTargetIndex(newIndex, prevIndex, oldIndex) {
  if (newIndex < oldIndex && newIndex > prevIndex) {
    return newIndex - 1;
  } else if (newIndex > oldIndex && newIndex < prevIndex) {
    return newIndex + 1;
  } else {
    return newIndex;
  }
}

function getLockPixelOffset(_ref) {
  var lockOffset = _ref.lockOffset,
      width = _ref.width,
      height = _ref.height;
  var offsetX = lockOffset;
  var offsetY = lockOffset;
  var unit = 'px';

  if (typeof lockOffset === 'string') {
    var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
    invariant_1$1(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);
    offsetX = parseFloat(lockOffset);
    offsetY = parseFloat(lockOffset);
    unit = match[1];
  }

  invariant_1$1(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

  if (unit === '%') {
    offsetX = offsetX * width / 100;
    offsetY = offsetY * height / 100;
  }

  return {
    x: offsetX,
    y: offsetY
  };
}

function getLockPixelOffsets(_ref2) {
  var height = _ref2.height,
      width = _ref2.width,
      lockOffset = _ref2.lockOffset;
  var offsets = Array.isArray(lockOffset) ? lockOffset : [lockOffset, lockOffset];
  invariant_1$1(offsets.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

  var _offsets = _slicedToArray$1(offsets, 2),
      minLockOffset = _offsets[0],
      maxLockOffset = _offsets[1];

  return [getLockPixelOffset({
    height: height,
    lockOffset: minLockOffset,
    width: width
  }), getLockPixelOffset({
    height: height,
    lockOffset: maxLockOffset,
    width: width
  })];
}

function isScrollable(el) {
  var computedStyle = window.getComputedStyle(el);
  var overflowRegex = /(auto|scroll)/;
  var properties = ['overflow', 'overflowX', 'overflowY'];
  return properties.find(function (property) {
    return overflowRegex.test(computedStyle[property]);
  });
}

function getScrollingParent(el) {
  if (!(el instanceof HTMLElement)) {
    return null;
  } else if (isScrollable(el)) {
    return el;
  } else {
    return getScrollingParent(el.parentNode);
  }
}

var KEYCODE = {
  TAB: 9,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
var NodeType = {
  Anchor: 'A',
  Button: 'BUTTON',
  Canvas: 'CANVAS',
  Input: 'INPUT',
  Option: 'OPTION',
  Textarea: 'TEXTAREA',
  Select: 'SELECT'
};

function cloneNode(node) {
  var selector = 'input, textarea, select, canvas, [contenteditable]';
  var fields = node.querySelectorAll(selector);
  var clonedNode = node.cloneNode(true);

  var clonedFields = _toConsumableArray$1(clonedNode.querySelectorAll(selector));

  clonedFields.forEach(function (field, i) {
    if (field.type !== 'file') {
      field.value = fields[i].value;
    }

    if (field.type === 'radio' && field.name) {
      field.name = "__sortableClone__".concat(field.name);
    }

    if (field.tagName === NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
      var destCtx = field.getContext('2d');
      destCtx.drawImage(fields[i], 0, 0);
    }
  });
  return clonedNode;
}

function isSortableHandle(node) {
  return node.sortableHandle != null;
}

var AutoScroller = function () {
  function AutoScroller(container, onScrollCallback) {
    _classCallCheck$1(this, AutoScroller);

    this.container = container;
    this.onScrollCallback = onScrollCallback;
  }

  _createClass$1(AutoScroller, [{
    key: "clear",
    value: function clear() {
      clearInterval(this.interval);
      this.interval = null;
    }
  }, {
    key: "update",
    value: function update(_ref) {
      var _this = this;

      var translate = _ref.translate,
          minTranslate = _ref.minTranslate,
          maxTranslate = _ref.maxTranslate,
          width = _ref.width,
          height = _ref.height;
      var direction = {
        x: 0,
        y: 0
      };
      var speed = {
        x: 1,
        y: 1
      };
      var acceleration = {
        x: 10,
        y: 10
      };
      var _this$container = this.container,
          scrollTop = _this$container.scrollTop,
          scrollLeft = _this$container.scrollLeft,
          scrollHeight = _this$container.scrollHeight,
          scrollWidth = _this$container.scrollWidth,
          clientHeight = _this$container.clientHeight,
          clientWidth = _this$container.clientWidth;
      var isTop = scrollTop === 0;
      var isBottom = scrollHeight - scrollTop - clientHeight === 0;
      var isLeft = scrollLeft === 0;
      var isRight = scrollWidth - scrollLeft - clientWidth === 0;

      if (translate.y >= maxTranslate.y - height / 2 && !isBottom) {
        direction.y = 1;
        speed.y = acceleration.y * Math.abs((maxTranslate.y - height / 2 - translate.y) / height);
      } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
        direction.x = 1;
        speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
      } else if (translate.y <= minTranslate.y + height / 2 && !isTop) {
        direction.y = -1;
        speed.y = acceleration.y * Math.abs((translate.y - height / 2 - minTranslate.y) / height);
      } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
        direction.x = -1;
        speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
      }

      if (this.interval) {
        this.clear();
        this.isAutoScrolling = false;
      }

      if (direction.x !== 0 || direction.y !== 0) {
        this.interval = setInterval(function () {
          _this.isAutoScrolling = true;
          var offset = {
            left: speed.x * direction.x,
            top: speed.y * direction.y
          };
          _this.container.scrollTop += offset.top;
          _this.container.scrollLeft += offset.left;

          _this.onScrollCallback(offset);
        }, 5);
      }
    }
  }]);

  return AutoScroller;
}();

function defaultGetHelperDimensions(_ref) {
  var node = _ref.node;
  return {
    height: node.offsetHeight,
    width: node.offsetWidth
  };
}

function defaultShouldCancelStart(event) {
  var interactiveElements = [NodeType.Input, NodeType.Textarea, NodeType.Select, NodeType.Option, NodeType.Button];

  if (interactiveElements.indexOf(event.target.tagName) !== -1) {
    return true;
  }

  if (closest(event.target, function (el) {
    return el.contentEditable === 'true';
  })) {
    return true;
  }

  return false;
}

var propTypes$1 = {
  axis: PropTypes__default.oneOf(['x', 'y', 'xy']),
  contentWindow: PropTypes__default.any,
  disableAutoscroll: PropTypes__default.bool,
  distance: PropTypes__default.number,
  getContainer: PropTypes__default.func,
  getHelperDimensions: PropTypes__default.func,
  helperClass: PropTypes__default.string,
  helperContainer: PropTypes__default.oneOfType([PropTypes__default.func, typeof HTMLElement === 'undefined' ? PropTypes__default.any : PropTypes__default.instanceOf(HTMLElement)]),
  hideSortableGhost: PropTypes__default.bool,
  keyboardSortingTransitionDuration: PropTypes__default.number,
  lockAxis: PropTypes__default.string,
  lockOffset: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string, PropTypes__default.arrayOf(PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]))]),
  lockToContainerEdges: PropTypes__default.bool,
  onSortEnd: PropTypes__default.func,
  onSortMove: PropTypes__default.func,
  onSortOver: PropTypes__default.func,
  onSortStart: PropTypes__default.func,
  pressDelay: PropTypes__default.number,
  pressThreshold: PropTypes__default.number,
  keyCodes: PropTypes__default.shape({
    lift: PropTypes__default.arrayOf(PropTypes__default.number),
    drop: PropTypes__default.arrayOf(PropTypes__default.number),
    cancel: PropTypes__default.arrayOf(PropTypes__default.number),
    up: PropTypes__default.arrayOf(PropTypes__default.number),
    down: PropTypes__default.arrayOf(PropTypes__default.number)
  }),
  shouldCancelStart: PropTypes__default.func,
  transitionDuration: PropTypes__default.number,
  updateBeforeSortStart: PropTypes__default.func,
  useDragHandle: PropTypes__default.bool,
  useWindowAsScrollContainer: PropTypes__default.bool
};
var defaultKeyCodes = {
  lift: [KEYCODE.SPACE],
  drop: [KEYCODE.SPACE],
  cancel: [KEYCODE.ESC],
  up: [KEYCODE.UP, KEYCODE.LEFT],
  down: [KEYCODE.DOWN, KEYCODE.RIGHT]
};
var defaultProps = {
  axis: 'y',
  disableAutoscroll: false,
  distance: 0,
  getHelperDimensions: defaultGetHelperDimensions,
  hideSortableGhost: true,
  lockOffset: '50%',
  lockToContainerEdges: false,
  pressDelay: 0,
  pressThreshold: 5,
  keyCodes: defaultKeyCodes,
  shouldCancelStart: defaultShouldCancelStart,
  transitionDuration: 300,
  useWindowAsScrollContainer: false
};
var omittedProps = Object.keys(propTypes$1);

function validateProps(props) {
  invariant_1$1(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
}

function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, value);
}

function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function (_React$Component) {
    _inherits$1(WithSortableContainer, _React$Component);

    function WithSortableContainer(props) {
      var _this;

      _classCallCheck$1(this, WithSortableContainer);

      _this = _possibleConstructorReturn$1(this, _getPrototypeOf(WithSortableContainer).call(this, props));

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "state", {});

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleStart", function (event) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;

        if (event.button === 2 || shouldCancelStart(event)) {
          return;
        }

        _this.touched = true;
        _this.position = getPosition(event);
        var node = closest(event.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection,
              disabled = _node$sortableInfo.disabled;

          if (disabled) {
            return;
          }

          if (useDragHandle && !closest(event.target, isSortableHandle)) {
            return;
          }

          _this.manager.active = {
            collection: collection,
            index: index
          };

          if (!isTouchEvent(event) && event.target.tagName === NodeType.Anchor) {
            event.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(event);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(event);
              }, _this.props.pressDelay);
            }
          }
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "nodeIsChild", function (node) {
        return node.sortableInfo.manager === _this.manager;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleMove", function (event) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;

        if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
          var position = getPosition(event);
          var delta = {
            x: _this.position.x - position.x,
            y: _this.position.y - position.y
          };
          var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
          _this.delta = delta;

          if (!distance && (!pressThreshold || combinedDelta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && combinedDelta >= distance && _this.manager.isActive()) {
            _this.handlePress(event);
          }
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleEnd", function () {
        _this.touched = false;

        _this.cancel();
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "cancel", function () {
        var distance = _this.props.distance;
        var sorting = _this.state.sorting;

        if (!sorting) {
          if (!distance) {
            clearTimeout(_this.pressTimer);
          }

          _this.manager.active = null;
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handlePress", function (event) {
        try {
          var active = _this.manager.getActive();

          var _temp6 = function () {
            if (active) {
              var _temp7 = function _temp7() {
                var index = _node.sortableInfo.index;
                var margin = getElementMargin(_node);

                var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();

                var dimensions = _getHelperDimensions({
                  collection: _collection,
                  index: index,
                  node: _node
                });

                _this.node = _node;
                _this.margin = margin;
                _this.width = dimensions.width;
                _this.height = dimensions.height;
                _this.marginOffset = {
                  x: _this.margin.left + _this.margin.right,
                  y: Math.max(_this.margin.top, _this.margin.bottom)
                };
                _this.boundingClientRect = _node.getBoundingClientRect();
                _this.containerBoundingRect = containerBoundingRect;
                _this.index = index;
                _this.newIndex = index;
                _this.axis = {
                  x: _axis.indexOf('x') >= 0,
                  y: _axis.indexOf('y') >= 0
                };
                _this.offsetEdge = getEdgeOffset(_node, _this.container);

                if (_isKeySorting) {
                  _this.initialOffset = getPosition(_objectSpread$3({}, event, {
                    pageX: _this.boundingClientRect.left,
                    pageY: _this.boundingClientRect.top
                  }));
                } else {
                  _this.initialOffset = getPosition(event);
                }

                _this.initialScroll = {
                  left: _this.scrollContainer.scrollLeft,
                  top: _this.scrollContainer.scrollTop
                };
                _this.initialWindowScroll = {
                  left: window.pageXOffset,
                  top: window.pageYOffset
                };
                _this.helper = _this.helperContainer.appendChild(cloneNode(_node));
                setInlineStyles(_this.helper, {
                  boxSizing: 'border-box',
                  height: "".concat(_this.height, "px"),
                  left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                  pointerEvents: 'none',
                  position: 'fixed',
                  top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                  width: "".concat(_this.width, "px")
                });

                if (_isKeySorting) {
                  _this.helper.focus();
                }

                if (_hideSortableGhost) {
                  _this.sortableGhost = _node;
                  setInlineStyles(_node, {
                    opacity: 0,
                    visibility: 'hidden'
                  });
                }

                _this.minTranslate = {};
                _this.maxTranslate = {};

                if (_isKeySorting) {
                  var _ref = _useWindowAsScrollContainer ? {
                    top: 0,
                    left: 0,
                    width: _this.contentWindow.innerWidth,
                    height: _this.contentWindow.innerHeight
                  } : _this.containerBoundingRect,
                      containerTop = _ref.top,
                      containerLeft = _ref.left,
                      containerWidth = _ref.width,
                      containerHeight = _ref.height;

                  var containerBottom = containerTop + containerHeight;
                  var containerRight = containerLeft + containerWidth;

                  if (_this.axis.x) {
                    _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                    _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                  }

                  if (_this.axis.y) {
                    _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                    _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                  }
                } else {
                  if (_this.axis.x) {
                    _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                    _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                  }

                  if (_this.axis.y) {
                    _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                    _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                  }
                }

                if (_helperClass) {
                  _helperClass.split(' ').forEach(function (className) {
                    return _this.helper.classList.add(className);
                  });
                }

                _this.listenerNode = event.touches ? _node : _this.contentWindow;

                if (_isKeySorting) {
                  _this.listenerNode.addEventListener('wheel', _this.handleKeyEnd, true);

                  _this.listenerNode.addEventListener('mousedown', _this.handleKeyEnd, true);

                  _this.listenerNode.addEventListener('keydown', _this.handleKeyDown);
                } else {
                  events.move.forEach(function (eventName) {
                    return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                  });
                  events.end.forEach(function (eventName) {
                    return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                  });
                }

                _this.setState({
                  sorting: true,
                  sortingIndex: index
                });

                if (_onSortStart) {
                  _onSortStart({
                    node: _node,
                    index: index,
                    collection: _collection,
                    isKeySorting: _isKeySorting
                  }, event);
                }

                if (_isKeySorting) {
                  _this.keyMove(0);
                }
              };

              var _this$props3 = _this.props,
                  _axis = _this$props3.axis,
                  _getHelperDimensions = _this$props3.getHelperDimensions,
                  _helperClass = _this$props3.helperClass,
                  _hideSortableGhost = _this$props3.hideSortableGhost,
                  updateBeforeSortStart = _this$props3.updateBeforeSortStart,
                  _onSortStart = _this$props3.onSortStart,
                  _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
              var _node = active.node,
                  _collection = active.collection;
              var _isKeySorting = _this.manager.isKeySorting;

              var _temp8 = function () {
                if (typeof updateBeforeSortStart === 'function') {
                  _this._awaitingUpdateBeforeSortStart = true;

                  var _temp9 = _finallyRethrows(function () {
                    var index = _node.sortableInfo.index;
                    return Promise.resolve(updateBeforeSortStart({
                      collection: _collection,
                      index: index,
                      node: _node,
                      isKeySorting: _isKeySorting
                    }, event)).then(function () {});
                  }, function (_wasThrown, _result) {
                    _this._awaitingUpdateBeforeSortStart = false;
                    if (_wasThrown) throw _result;
                    return _result;
                  });

                  if (_temp9 && _temp9.then) return _temp9.then(function () {});
                }
              }();

              return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
            }
          }();

          return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleSortMove", function (event) {
        var onSortMove = _this.props.onSortMove;

        if (typeof event.preventDefault === 'function') {
          event.preventDefault();
        }

        _this.updateHelperPosition(event);

        _this.animateNodes();

        _this.autoscroll();

        if (onSortMove) {
          onSortMove(event);
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleSortEnd", function (event) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var _this$manager = _this.manager,
            collection = _this$manager.active.collection,
            isKeySorting = _this$manager.isKeySorting;
        var nodes = _this.manager.refs[collection];

        if (_this.listenerNode) {
          if (isKeySorting) {
            _this.listenerNode.removeEventListener('wheel', _this.handleKeyEnd, true);

            _this.listenerNode.removeEventListener('mousedown', _this.handleKeyEnd, true);

            _this.listenerNode.removeEventListener('keydown', _this.handleKeyDown);
          } else {
            events.move.forEach(function (eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
            });
            events.end.forEach(function (eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
            });
          }
        }

        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          setInlineStyles(_this.sortableGhost, {
            opacity: '',
            visibility: ''
          });
        }

        for (var i = 0, len = nodes.length; i < len; i++) {
          var _node2 = nodes[i];
          var el = _node2.node;
          _node2.edgeOffset = null;
          _node2.boundingClientRect = null;
          setTranslate3d(el, null);
          setTransitionDuration(el, null);
          _node2.translate = null;
        }

        _this.autoScroller.clear();

        _this.manager.active = null;
        _this.manager.isKeySorting = false;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            collection: collection,
            newIndex: _this.newIndex,
            oldIndex: _this.index,
            isKeySorting: isKeySorting
          }, event);
        }

        _this.touched = false;
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "autoscroll", function () {
        var disableAutoscroll = _this.props.disableAutoscroll;
        var isKeySorting = _this.manager.isKeySorting;

        if (disableAutoscroll) {
          return;
        }

        if (isKeySorting) {
          var translate = _objectSpread$3({}, _this.translate);

          var scrollX = 0;
          var scrollY = 0;

          if (_this.axis.x) {
            translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
            scrollX = _this.translate.x - translate.x;
          }

          if (_this.axis.y) {
            translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
            scrollY = _this.translate.y - translate.y;
          }

          _this.translate = translate;
          setTranslate3d(_this.helper, _this.translate);
          _this.scrollContainer.scrollLeft += scrollX;
          _this.scrollContainer.scrollTop += scrollY;
          return;
        }

        _this.autoScroller.update({
          height: _this.height,
          maxTranslate: _this.maxTranslate,
          minTranslate: _this.minTranslate,
          translate: _this.translate,
          width: _this.width
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "onAutoScroll", function (offset) {
        _this.translate.x += offset.left;
        _this.translate.y += offset.top;

        _this.animateNodes();
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleKeyDown", function (event) {
        var keyCode = event.keyCode;
        var _this$props5 = _this.props,
            shouldCancelStart = _this$props5.shouldCancelStart,
            _this$props5$keyCodes = _this$props5.keyCodes,
            customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;

        var keyCodes = _objectSpread$3({}, defaultKeyCodes, customKeyCodes);

        if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) {
          return;
        }

        event.stopPropagation();
        event.preventDefault();

        if (keyCodes.lift.includes(keyCode) && !_this.manager.active) {
          _this.keyLift(event);
        } else if (keyCodes.drop.includes(keyCode) && _this.manager.active) {
          _this.keyDrop(event);
        } else if (keyCodes.cancel.includes(keyCode)) {
          _this.newIndex = _this.manager.active.index;

          _this.keyDrop(event);
        } else if (keyCodes.up.includes(keyCode)) {
          _this.keyMove(-1);
        } else if (keyCodes.down.includes(keyCode)) {
          _this.keyMove(1);
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "keyLift", function (event) {
        var target = event.target;
        var node = closest(target, function (el) {
          return el.sortableInfo != null;
        });
        var _node$sortableInfo2 = node.sortableInfo,
            index = _node$sortableInfo2.index,
            collection = _node$sortableInfo2.collection;
        _this.initialFocusedNode = target;
        _this.manager.isKeySorting = true;
        _this.manager.active = {
          index: index,
          collection: collection
        };

        _this.handlePress(event);
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "keyMove", function (shift) {
        var nodes = _this.manager.getOrderedRefs();

        var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
        var newIndex = _this.newIndex + shift;
        var prevIndex = _this.newIndex;

        if (newIndex < 0 || newIndex > lastIndex) {
          return;
        }

        _this.prevIndex = prevIndex;
        _this.newIndex = newIndex;
        var targetIndex = getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
        var target = nodes.find(function (_ref2) {
          var node = _ref2.node;
          return node.sortableInfo.index === targetIndex;
        });
        var targetNode = target.node;
        var scrollDelta = _this.containerScrollDelta;
        var targetBoundingClientRect = target.boundingClientRect || getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
        var targetTranslate = target.translate || {
          x: 0,
          y: 0
        };
        var targetPosition = {
          top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
          left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
        };
        var shouldAdjustForSize = prevIndex < newIndex;
        var sizeAdjustment = {
          x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
          y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
        };

        _this.handleSortMove({
          pageX: targetPosition.left + sizeAdjustment.x,
          pageY: targetPosition.top + sizeAdjustment.y,
          ignoreTransition: shift === 0
        });
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "keyDrop", function (event) {
        _this.handleSortEnd(event);

        if (_this.initialFocusedNode) {
          _this.initialFocusedNode.focus();
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "handleKeyEnd", function (event) {
        if (_this.manager.active) {
          _this.keyDrop(event);
        }
      });

      _defineProperty$1(_assertThisInitialized$1(_assertThisInitialized$1(_this)), "isValidSortingTarget", function (event) {
        var useDragHandle = _this.props.useDragHandle;
        var target = event.target;
        var node = closest(target, function (el) {
          return el.sortableInfo != null;
        });
        return node && node.sortableInfo && !node.sortableInfo.disabled && (useDragHandle ? isSortableHandle(target) : target.sortableInfo);
      });

      validateProps(props);
      _this.manager = new Manager();
      _this.events = {
        end: _this.handleEnd,
        move: _this.handleMove,
        start: _this.handleStart
      };
      return _this;
    }

    _createClass$1(WithSortableContainer, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
        var container = this.getContainer();
        Promise.resolve(container).then(function (containerNode) {
          _this2.container = containerNode;
          _this2.document = _this2.container.ownerDocument || document;
          var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
          _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
          _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : getScrollingParent(_this2.container) || _this2.container;
          _this2.autoScroller = new AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
          Object.keys(_this2.events).forEach(function (key) {
            return events[key].forEach(function (eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          });

          _this2.container.addEventListener('keydown', _this2.handleKeyDown);
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this3 = this;

        if (this.helper && this.helper.parentNode) {
          this.helper.parentNode.removeChild(this.helper);
        }

        if (!this.container) {
          return;
        }

        Object.keys(this.events).forEach(function (key) {
          return events[key].forEach(function (eventName) {
            return _this3.container.removeEventListener(eventName, _this3.events[key]);
          });
        });
        this.container.removeEventListener('keydown', this.handleKeyDown);
      }
    }, {
      key: "updateHelperPosition",
      value: function updateHelperPosition(event) {
        var _this$props6 = this.props,
            lockAxis = _this$props6.lockAxis,
            lockOffset = _this$props6.lockOffset,
            lockToContainerEdges = _this$props6.lockToContainerEdges,
            transitionDuration = _this$props6.transitionDuration,
            _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration,
            keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
        var isKeySorting = this.manager.isKeySorting;
        var ignoreTransition = event.ignoreTransition;
        var offset = getPosition(event);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;
        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = getLockPixelOffsets({
            height: this.height,
            lockOffset: lockOffset,
            width: this.width
          }),
              _getLockPixelOffsets2 = _slicedToArray$1(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };
          translate.x = limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) {
          setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
        }

        setTranslate3d(this.helper, translate);
      }
    }, {
      key: "animateNodes",
      value: function animateNodes() {
        var _this$props7 = this.props,
            transitionDuration = _this$props7.transitionDuration,
            hideSortableGhost = _this$props7.hideSortableGhost,
            onSortOver = _this$props7.onSortOver;
        var containerScrollDelta = this.containerScrollDelta,
            windowScrollDelta = this.windowScrollDelta;
        var nodes = this.manager.getOrderedRefs();
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
          top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
        };
        var isKeySorting = this.manager.isKeySorting;
        var prevIndex = this.newIndex;
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var _node3 = nodes[i].node;
          var index = _node3.sortableInfo.index;
          var width = _node3.offsetWidth;
          var height = _node3.offsetHeight;
          var offset = {
            height: this.height > height ? height / 2 : this.height / 2,
            width: this.width > width ? width / 2 : this.width / 2
          };
          var mustShiftBackward = isKeySorting && index > this.index && index <= prevIndex;
          var mustShiftForward = isKeySorting && index < this.index && index >= prevIndex;
          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          if (!edgeOffset) {
            edgeOffset = getEdgeOffset(_node3, this.container);
            nodes[i].edgeOffset = edgeOffset;

            if (isKeySorting) {
              nodes[i].boundingClientRect = getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
            }
          }

          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = getEdgeOffset(nextNode.node, this.container);

            if (isKeySorting) {
              nextNode.boundingClientRect = getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
            }
          }

          if (index === this.index) {
            if (hideSortableGhost) {
              this.sortableGhost = _node3;
              setInlineStyles(_node3, {
                opacity: 0,
                visibility: 'hidden'
              });
            }

            continue;
          }

          if (transitionDuration) {
            setTransitionDuration(_node3, transitionDuration);
          }

          if (this.axis.x) {
            if (this.axis.y) {
              if (mustShiftForward || index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                translate.x = this.width + this.marginOffset.x;

                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  if (nextNode) {
                    translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                    translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                  }
                }

                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (mustShiftBackward || index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                translate.x = -(this.width + this.marginOffset.x);

                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  if (prevNode) {
                    translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                    translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                  }
                }

                this.newIndex = index;
              }
            } else {
              if (mustShiftBackward || index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (mustShiftForward || index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;

                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (mustShiftBackward || index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (mustShiftForward || index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;

              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }

          setTranslate3d(_node3, translate);
          nodes[i].translate = translate;
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }

        if (isKeySorting) {
          this.newIndex = prevIndex;
        }

        var oldIndex = isKeySorting ? this.prevIndex : prevIndex;

        if (onSortOver && this.newIndex !== oldIndex) {
          onSortOver({
            collection: this.manager.active.collection,
            index: this.index,
            newIndex: this.newIndex,
            oldIndex: oldIndex,
            isKeySorting: isKeySorting
          });
        }
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant_1$1(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: "getContainer",
      value: function getContainer() {
        var getContainer = this.props.getContainer;

        if (typeof getContainer !== 'function') {
          return findDOMNode(this);
        }

        return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
      }
    }, {
      key: "render",
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;
        return createElement(WrappedComponent, _extends$1m({
          ref: ref
        }, omit(this.props, omittedProps)));
      }
    }, {
      key: "helperContainer",
      get: function get() {
        var helperContainer = this.props.helperContainer;

        if (typeof helperContainer === 'function') {
          return helperContainer();
        }

        return this.props.helperContainer || this.document.body;
      }
    }, {
      key: "containerScrollDelta",
      get: function get() {
        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;

        if (useWindowAsScrollContainer) {
          return {
            left: 0,
            top: 0
          };
        }

        return {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
      }
    }, {
      key: "windowScrollDelta",
      get: function get() {
        return {
          left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
          top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
        };
      }
    }]);

    return WithSortableContainer;
  }(Component), _defineProperty$1(_class, "displayName", provideDisplayName('sortableList', WrappedComponent)), _defineProperty$1(_class, "defaultProps", defaultProps), _defineProperty$1(_class, "propTypes", propTypes$1), _defineProperty$1(_class, "childContextTypes", {
    manager: PropTypes__default.object.isRequired
  }), _temp;
}

var propTypes$1$1 = {
  index: PropTypes__default.number.isRequired,
  collection: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  disabled: PropTypes__default.bool
};
var omittedProps$1 = Object.keys(propTypes$1$1);

function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function (_React$Component) {
    _inherits$1(WithSortableElement, _React$Component);

    function WithSortableElement() {
      _classCallCheck$1(this, WithSortableElement);

      return _possibleConstructorReturn$1(this, _getPrototypeOf(WithSortableElement).apply(this, arguments));
    }

    _createClass$1(WithSortableElement, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.register();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.node) {
          if (prevProps.index !== this.props.index) {
            this.node.sortableInfo.index = this.props.index;
          }

          if (prevProps.disabled !== this.props.disabled) {
            this.node.sortableInfo.disabled = this.props.disabled;
          }
        }

        if (prevProps.collection !== this.props.collection) {
          this.unregister(prevProps.collection);
          this.register();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unregister();
      }
    }, {
      key: "register",
      value: function register() {
        var _this$props = this.props,
            collection = _this$props.collection,
            disabled = _this$props.disabled,
            index = _this$props.index;
        var node = findDOMNode(this);
        node.sortableInfo = {
          collection: collection,
          disabled: disabled,
          index: index,
          manager: this.context.manager
        };
        this.node = node;
        this.ref = {
          node: node
        };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: "unregister",
      value: function unregister() {
        var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.collection;
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant_1$1(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: "render",
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;
        return createElement(WrappedComponent, _extends$1m({
          ref: ref
        }, omit(this.props, omittedProps$1)));
      }
    }]);

    return WithSortableElement;
  }(Component), _defineProperty$1(_class, "displayName", provideDisplayName('sortableElement', WrappedComponent)), _defineProperty$1(_class, "contextTypes", {
    manager: PropTypes__default.object.isRequired
  }), _defineProperty$1(_class, "propTypes", propTypes$1$1), _defineProperty$1(_class, "defaultProps", {
    collection: 0
  }), _temp;
}

var SortableContainer = sortableContainer(function (_ref) {
  var children = _ref.children,
      onAttachedRef = _ref.onAttachedRef;
  return React.createElement("div", {
    className: "select__list",
    ref: function ref(el) {
      onAttachedRef(el);
    }
  }, children);
});
var SortableItem = sortableElement(function (_ref) {
  var item = _ref.item,
      className = _ref.className,
      moveCb = _ref.moveCb,
      isActive = _ref.isActive,
      additionalProps = objectWithoutProperties(_ref, ["item", "className", "moveCb", "isActive"]);
  return React.createElement("div", _extends_1({
    className: className
  }, additionalProps), React.createElement("div", {
    className: "select__option-label"
  }, item.reactElement || item.label), isActive && React.createElement(React.Fragment, null, React.createElement("i", {
    className: "select__option-icon _dnd"
  }, React.createElement(Icon, {
    name: "DragIndicator"
  }))));
});

var WithErrorPlaceholderImage = /*#__PURE__*/function (_React$Component) {
  inherits(WithErrorPlaceholderImage, _React$Component);

  function WithErrorPlaceholderImage() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, WithErrorPlaceholderImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(WithErrorPlaceholderImage)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      hasLoadingError: false
    });
    defineProperty(assertThisInitialized(_this), "onError", function () {
      return _this.setState({
        hasLoadingError: true
      });
    });
    return _this;
  }

  createClass(WithErrorPlaceholderImage, [{
    key: "render",
    value: function render() {
      if (this.state.hasLoadingError) {
        return React.createElement(Icon, {
          name: "NoData"
        });
      }

      return React.createElement("img", {
        src: this.props.src,
        onError: this.onError
      });
    }
  }]);
  return WithErrorPlaceholderImage;
}(React.Component);

WithErrorPlaceholderImage.propTypes = {
  src: PropTypes__default.string
};
var css$f = ".select__list-input {\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.21429em; }\n\n.title-main {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 3rem;\n  text-transform: capitalize;\n  color: #787878; }\n\n.title-main-subtitle {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 2.25rem;\n  text-transform: uppercase;\n  color: #ff5859; }\n\n.title-form {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 1.25rem;\n  text-transform: uppercase;\n  color: #3fd4ad; }\n\n.title-form-subtitle {\n  font-family: 'Lato Light', sans-serif;\n  font-weight: 400;\n  font-size: 2rem;\n  color: #000000; }\n\n.title-card {\n  font-family: 'Lato Medium', sans-serif;\n  font-weight: 400;\n  font-size: 1.5rem;\n  line-height: 1.375em;\n  color: #000000; }\n\n.title-card-subtitle {\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  color: #787878; }\n\n.paragraph {\n  margin-bottom: 1.5rem;\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.78947em;\n  color: #787878; }\n  .paragraph_large {\n    font-size: 1.5rem; }\n\n.select {\n  position: relative;\n  z-index: 1;\n  width: 15.625rem; }\n  .select:hover {\n    z-index: 2; }\n  .select._opened {\n    z-index: 3; }\n  .select__label {\n    position: absolute;\n    padding: 0;\n    max-width: calc(100% - 31rem/16);\n    background: transparent;\n    overflow: hidden;\n    transition: padding .25s, transform .25s, font-size .25s, color .25s;\n    font-family: 'Lato Light Italic', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.21429em;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n    .select__label._up {\n      transform: translate(-0.375rem, -1.125rem);\n      padding: 0 0.125rem;\n      font-family: 'Lato Regular', sans-serif;\n      font-weight: 400;\n      font-size: .75rem;\n      color: #a2a2a2; }\n      .select__label._up:before {\n        content: '';\n        position: absolute;\n        z-index: -1;\n        top: 0.3125rem;\n        left: 0.125rem;\n        right: 0.125rem;\n        height: 0.125rem;\n        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.001) 0, #fff 100%); }\n      .select__label._up:after {\n        content: '';\n        position: absolute;\n        z-index: -1;\n        top: 0.4375rem;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: linear-gradient(to right, rgba(255, 255, 255, 0.001) 0, #fff 0.125rem, #fff calc(100% - 2rem/16), rgba(255, 255, 255, 0.001)); }\n  .select__value {\n    margin-right: auto;\n    overflow: hidden;\n    font-family: 'Lato Light', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.21429em;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n    .select__value:not(._selected) {\n      font-family: 'Lato Light Italic', sans-serif;\n      font-weight: 400; }\n    .select__value._selected {\n      font-family: 'Lato Regular', sans-serif;\n      font-weight: 400;\n      color: black; }\n  .select._opened .select__value, .select._opened .select__label:not(._up) {\n    font-family: 'Lato Bold', sans-serif;\n    font-weight: 400; }\n    .select._opened .select__value:not(._selected), .select._opened .select__label:not(._up):not(._selected) {\n      font-family: 'Lato Bold Italic', sans-serif;\n      font-weight: 400; }\n  .select._opened .select__label._up {\n    color: #6075ff; }\n  .select__outer-wrapper {\n    position: relative;\n    height: 2.25rem; }\n  .select__wrapper {\n    position: absolute;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    width: 100%;\n    border-radius: .25rem;\n    transition: box-shadow .25s; }\n  .select:hover .select__btn {\n    border-color: #6075ff; }\n  .select:hover .select__label._up {\n    color: #6075ff; }\n  .select:hover .select__indicator {\n    border-top-color: #505050; }\n  .select:hover .select__wrapper {\n    box-shadow: 0 0 0.1875rem 0 rgba(5, 13, 66, 0.53); }\n  .select__btn {\n    display: flex;\n    position: relative;\n    font-family: 'Lato Light', sans-serif;\n    font-weight: 400;\n    border: 0.0625rem solid #e0e0e0;\n    border-radius: .25rem;\n    height: 2.25rem;\n    padding: 0 1.125rem 0 0.8125rem;\n    align-items: center;\n    cursor: pointer;\n    width: 100%;\n    background-color: white;\n    white-space: nowrap; }\n    .select__btn-secondary {\n      margin-right: .5rem;\n      padding-left: .5rem;\n      font-family: 'Lato Bold', sans-serif;\n      font-weight: 400;\n      font-size: 0.875rem;\n      color: #8293ff; }\n      .select__btn-secondary:hover {\n        color: #4f67ff; }\n  .select__clear {\n    margin-right: .5rem; }\n    .select__clear svg {\n      width: 12px;\n      height: 12px; }\n    .select__clear:hover svg {\n      fill: black; }\n  .select__indicator {\n    position: absolute;\n    top: 50%;\n    right: 0.625rem;\n    transform: translateY(-50%);\n    border-style: solid;\n    border-width: 0.3125rem 0.25rem 0 0.25rem;\n    border-color: #787878 transparent transparent transparent;\n    cursor: pointer;\n    width: 0;\n    height: 0;\n    transition: border .25s; }\n  .select__list-wrapper {\n    display: none;\n    position: relative;\n    z-index: 1;\n    padding: 0 0.4375rem;\n    border-top: 0.0625rem solid #d8d8d8;\n    border-radius: 0 0 0.1875rem 0.1875rem;\n    width: 100%;\n    background-color: white;\n    overflow: hidden; }\n  .select__list-input-wrapper {\n    position: relative;\n    margin: 0.25rem 0;\n    width: 100%; }\n    .select__list-input-wrapper svg {\n      position: absolute;\n      width: 1.125rem;\n      height: auto;\n      top: 50%;\n      transform: translateY(-50%);\n      left: 0.5625rem; }\n  .select__list {\n    margin: 0 -0.4375rem;\n    max-height: 15.625rem;\n    overflow-y: auto; }\n  .select__option {\n    position: relative; }\n    .select__option:not(._header):hover {\n      background-color: #f2f5ff; }\n      .select__option:not(._header):hover .select__option-icon._dnd {\n        opacity: 1; }\n    .select__option:not(._header)._active {\n      background-color: #dfe4ff; }\n    .select__option-label {\n      display: flex;\n      align-items: center;\n      padding: 0.3125rem 0.8125rem;\n      font-family: 'Lato Light', sans-serif;\n      font-weight: 400;\n      font-size: 0.875rem;\n      line-height: 1.125rem;\n      cursor: pointer; }\n    .select__option._header .select__option-label {\n      font-family: 'Lato Bold', sans-serif;\n      font-weight: 400;\n      cursor: initial; }\n    .select__option-icon {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      pointer-events: none;\n      line-height: 0; }\n      .select__option-icon._dnd {\n        right: 0.6875rem;\n        width: 1rem;\n        height: auto;\n        cursor: pointer;\n        opacity: 0; }\n        .select__option-icon._dnd svg {\n          width: auto;\n          height: auto; }\n    .select__option._active {\n      position: relative; }\n      .select__option._active:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        width: .25rem;\n        background: #6075ff; }\n    .select__option-image {\n      flex: 0 0 auto;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-right: .5rem; }\n      .select__option-image img {\n        max-width: 8.4375rem;\n        max-height: 5rem; }\n  .select._dnd .select__option:not(._active) {\n    background-color: white; }\n  .select._dnd .select__option:hover {\n    background-color: #f2f5ff; }\n  .select._dnd .select__option-label {\n    padding-right: 1.875rem; }\n  .select._dnd .select__option._active svg {\n    fill: #798eff; }\n  .select._dnd .select__option._active:hover {\n    background: #f2f5ff; }\n  .select._dnd .select__option._enabled {\n    background-color: #dfe4ff; }\n    .select._dnd .select__option._enabled svg {\n      fill: #798eff; }\n  .select._dnd .select__option._last-enabled {\n    position: relative; }\n    .select._dnd .select__option._last-enabled ~ ._separator {\n      display: block;\n      opacity: 1;\n      height: 1px;\n      width: 100%;\n      background-color: #6075ff; }\n  .select._dnd .select__option._hide {\n    opacity: .3; }\n  .select._dnd .select__option._separator:before {\n    content: '';\n    position: absolute;\n    left: -0.5rem;\n    right: -0.5rem;\n    height: 2px;\n    background-color: #798eff; }\n  .select._dnd .select__option._separator._top:before {\n    top: 0; }\n  .select._dnd .select__option._separator._bottom:before {\n    bottom: 0; }\n  .select._dnd .select__list {\n    margin: 0; }\n    .select._dnd .select__list-wrapper {\n      padding: 0; }\n  .select._sorting .select__list {\n    cursor: pointer; }\n  .select._sorting .select__option:hover {\n    background-color: white; }\n    .select._sorting .select__option:hover .select__option-icon._dnd {\n      opacity: 0; }\n  .select._sorting .select__option._active:hover {\n    background-color: #dfe4ff; }\n  .select._sorting .select__option._active:not(._enabled):hover {\n    background-color: #dfe4ff; }\n  .select._with-groups .select__option-label {\n    align-items: center;\n    min-height: 1.75rem;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400; }\n  .select._with-groups .select__option._header .select__option-label {\n    font-family: 'Lato Bold', sans-serif;\n    font-weight: 400; }\n  .select__list-input {\n    padding: 0 0.625rem 0 1.9375rem;\n    width: 100%;\n    height: 2.25rem;\n    border-radius: .25rem;\n    border: 0.0625rem solid #dddddd;\n    outline: 0;\n    color: #000; }\n    .select__list-input::-moz-placeholder {\n      color: #a2a2a2;\n      opacity: 1;\n      font-family: inherit; }\n    .select__list-input:-ms-input-placeholder {\n      color: #a2a2a2;\n      opacity: 1;\n      font-family: inherit; }\n    .select__list-input::-webkit-input-placeholder {\n      color: #a2a2a2;\n      opacity: 1;\n      font-family: inherit; }\n  .select._opened .select__value._bold {\n    font-family: 'Lato Bold', sans-serif;\n    font-weight: 400; }\n  .select._opened .select__wrapper {\n    border: 1px solid #6075ff;\n    box-shadow: 0 0 0.1875rem 0 rgba(5, 13, 66, 0.53); }\n  .select._opened .select__btn {\n    height: 2.125rem;\n    border: none;\n    border-radius: .25rem .25rem 0 0; }\n  .select._opened .select__list-wrapper {\n    display: block; }\n  .select._opened .select__indicator {\n    transform: rotateX(180deg) translateY(60%); }\n  .select__tumbler {\n    display: flex;\n    margin: 10px 0;\n    align-items: center;\n    cursor: pointer; }\n    .select__tumbler-slide {\n      position: relative;\n      width: 1.625rem;\n      height: 0.6875rem;\n      background-color: #707070;\n      border-radius: 100px;\n      opacity: 0.5; }\n    .select__tumbler-btn {\n      position: absolute;\n      background: #6075ff;\n      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);\n      height: 0.8125rem;\n      width: 0.8125rem;\n      border-radius: 100%;\n      top: 50%;\n      transform: translateY(-50%) translateX(0);\n      transition: transform .3s; }\n    .select__tumbler-label {\n      margin-left: 0.625rem;\n      color: #a2a2a2; }\n    .select__tumbler._active .select__tumbler-slide {\n      opacity: 1; }\n    .select__tumbler._active .select__tumbler-btn {\n      transform: translateY(-50%) translateX(100%); }\n  .select__dragged {\n    z-index: 10000;\n    box-shadow: 0 0 0.25em 0.0625rem rgba(162, 162, 162, 0.5); }\n    .select__dragged .select__option-icon .svg-icon {\n      fill: #798eff; }\n    .select__dragged .select__option-icon._dnd {\n      opacity: 1; }\n    .select__dragged .select__option-label {\n      padding-left: 2.1875rem;\n      padding-right: 1.875rem; }\n  .select._opened .tooltip__label {\n    opacity: 0; }\n";
styleInject(css$f);
var PADDING_STEP = 20;

var BtnWrapper = function BtnWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      tooltipParams = _ref.tooltipParams,
      handleClick = _ref.handleClick;
  return tooltipParams ? React.createElement(Tooltip, _extends_1({
    className: className,
    handleClick: handleClick
  }, tooltipParams), children) : React.createElement("div", {
    className: className,
    onClick: handleClick
  }, children);
};

var Select = /*#__PURE__*/function (_Component) {
  inherits(Select, _Component);

  function Select(props) {
    var _this;

    classCallCheck(this, Select);
    _this = possibleConstructorReturn(this, getPrototypeOf(Select).call(this, props));
    defineProperty(assertThisInitialized(_this), "_selectList", null);
    defineProperty(assertThisInitialized(_this), "setOpenStateThroughProp", function (prevProps) {
      // if isOpen prop is set and not equal to isOpen state
      if (typeof _this.props.isOpen === 'boolean' && _this.props.isOpen !== _this.state.isOpen) {
        _this.setState({
          isOpen: _this.props.isOpen
        }); // prevents closing through windowClickHandler when clicking on external el that changes isOpen prop


        _this.ignoredCloseClickElement = _this.props.ignoredCloseClickElement;
      }
    });
    defineProperty(assertThisInitialized(_this), "windowClickHandler", function (_ref2) {
      var target = _ref2.target;

      if (!_this.state.isOpen || target.closest('.js-select') === _this.select || // prevent closing if el added as ignored
      _this.ignoredCloseClickElement && target === _this.ignoredCloseClickElement) {
        return;
      }

      _this.setState({
        isOpen: false
      }); // changes isOpen prop when isOpen state is changed


      _this.props.toggleOpenProp && _this.props.toggleOpenProp(false);
    });
    defineProperty(assertThisInitialized(_this), "toggleSelect", function () {
      _this.setState({
        isOpen: !_this.state.isOpen
      }); // changes isOpen prop when isOpen state is changed


      _this.props.toggleOpenProp && _this.props.toggleOpenProp(!_this.state.isOpen);
    });
    defineProperty(assertThisInitialized(_this), "handleChangeSearch", function (_ref3) {
      var target = _ref3.target;

      _this.setState({
        search: target.value
      });
    });
    defineProperty(assertThisInitialized(_this), "toggleTumbler", function () {
      _this.props.onTumblerChange();
    });
    defineProperty(assertThisInitialized(_this), "handleSelectedOption", function (item) {
      return function (e) {
        var isMulti = _this.props.isMulti;
        var stateOfOptions = _this.state.stateOfOptions;
        var newState = updateStateOfOptions(stateOfOptions, item, isMulti);

        _this.setStateOptions(newState, item);

        if (!isMulti) {
          _this.toggleSelect();
        }
      };
    });
    defineProperty(assertThisInitialized(_this), "allSelected", function () {
      var _this$props = _this.props,
          totalRecords = _this$props.totalRecords,
          searchByValue = _this$props.searchByValue;
      var _this$state = _this.state,
          stateOfOptions = _this$state.stateOfOptions,
          search = _this$state.search;

      if (!stateOfOptions.length) {
        return false;
      }

      var allSelected = true;

      var callback = function callback(item) {
        if (!item.isActive) allSelected = false;
      };

      traverseState(filterItems(stateOfOptions, search, searchByValue), callback);
      return totalRecords ? allSelected && stateOfOptions.length === totalRecords : allSelected;
    });
    defineProperty(assertThisInitialized(_this), "deselectAll", function () {
      var stateOfOptions = _this.state.stateOfOptions;
      var cloneState = cloneDeep$1(stateOfOptions);

      var callback = function callback(item) {
        if (!item.alwaysEnabled) {
          item.isActive = false;
        }
      };

      traverseState(cloneState, callback);

      _this.setStateOptions(cloneState, null, true);
    });
    defineProperty(assertThisInitialized(_this), "selectAll", function () {
      var _this$state2 = _this.state,
          stateOfOptions = _this$state2.stateOfOptions,
          search = _this$state2.search;
      var _this$props2 = _this.props,
          searchByValue = _this$props2.searchByValue,
          onSelectAll = _this$props2.onSelectAll;
      var cloneState = filterItems(cloneDeep$1(stateOfOptions), search, searchByValue);

      var callback = function callback(item) {
        item.isActive = true;
      };

      traverseState(cloneState, callback);

      _this.setStateOptions(cloneState);

      if (onSelectAll) {
        onSelectAll();
      }
    });
    defineProperty(assertThisInitialized(_this), "onSortStart", function () {
      _this.setState({
        isSorting: true
      });
    });
    defineProperty(assertThisInitialized(_this), "onSortEnd", function (_ref4) {
      var oldIndex = _ref4.oldIndex,
          newIndex = _ref4.newIndex;
      var newValues = moveItem(_this.state.stateOfOptions, oldIndex, newIndex);

      _this.setStateOptions(newValues);

      _this.setState({
        targetDropIndex: null,
        startDragIndex: null,
        isSorting: false
      });
    });
    defineProperty(assertThisInitialized(_this), "handleClearValue", function (e) {
      e.stopPropagation();

      _this.deselectAll();
    });
    defineProperty(assertThisInitialized(_this), "renderItem", function (item, i) {
      var _this$props3 = _this.props,
          isMulti = _this$props3.isMulti,
          levelPadding = _this$props3.levelPadding,
          dnd = _this$props3.dnd;
      var _this$state3 = _this.state,
          targetDropIndex = _this$state3.targetDropIndex,
          startDragIndex = _this$state3.startDragIndex;
      var additionalProps = {
        style: {}
      };
      var padd = (item.deep || 0) * (levelPadding || PADDING_STEP);

      if (padd !== 0) {
        additionalProps.style.paddingLeft = padd;
      }

      if (!item.isGroupHeader && !item.alwaysEnabled) {
        additionalProps.onClick = _this.handleSelectedOption(item);
      }

      var isActive = item.isActive,
          draggableGroup = item.draggableGroup,
          lastFirstGroup = item.lastFirstGroup;
      var className = getItemClasses(item, {
        isActive: isActive
      });

      if (dnd && isActive && isMulti) {
        var indexItem = i;
        className = getItemClasses(item, {
          isActive: isActive,
          indexItem: indexItem,
          startDragIndex: startDragIndex,
          targetDropIndex: targetDropIndex
        });
      }

      var separator = lastFirstGroup ? React.createElement("div", {
        className: "_separator"
      }) : null;
      return dnd ? React.createElement(React.Fragment, {
        key: item.label ? item.label : i
      }, React.createElement(SortableItem, _extends_1({
        item: item,
        isActive: isActive,
        disabled: !isActive,
        collection: draggableGroup ? "".concat(draggableGroup) : isActive ? 'active' : 'disabled',
        className: className
      }, additionalProps)), separator) : React.createElement("div", _extends_1({
        key: item.value !== undefined ? item.value : i,
        className: className
      }, additionalProps), React.createElement("div", {
        className: "select__option-label"
      }, item.labelImageSrc && React.createElement("div", {
        className: "select__option-image"
      }, React.createElement(WithErrorPlaceholderImage, {
        src: item.labelImageSrc
      })), item.reactLabel || item.label));
    });
    defineProperty(assertThisInitialized(_this), "renderList", function () {
      var _this$props4 = _this.props,
          isSearchable = _this$props4.isSearchable,
          searchByValue = _this$props4.searchByValue,
          dnd = _this$props4.dnd;
      var _this$state4 = _this.state,
          search = _this$state4.search,
          stateOfOptions = _this$state4.stateOfOptions;

      if (!stateOfOptions) {
        return null;
      }

      var resultOptions = stateOfOptions;

      if (isSearchable) {
        resultOptions = filterItems(stateOfOptions, search, searchByValue);
      }

      var res = [];

      var cb = function cb(item) {
        return res.push(item);
      };

      traverseState(resultOptions, cb);
      return dnd ? React.createElement(SortableContainer, {
        helperClass: "select__dragged _active",
        distance: 5,
        onSortStart: _this.onSortStart,
        onSortEnd: _this.onSortEnd,
        onAttachedRef: function onAttachedRef(el) {
          _this._selectList = el;
        },
        items: res
      }, res.map(function (item, i) {
        return _this.renderItem(item, i);
      })) : React.createElement("div", {
        className: "select__list",
        ref: function ref(el) {
          _this._selectList = el;
        }
      }, res.map(function (item, i) {
        return _this.renderItem(item, i);
      }));
    });
    defineProperty(assertThisInitialized(_this), "renderButton", function () {
      var buttonProps = _this.props.buttonProps;

      if (buttonProps) {
        return React.createElement("div", {
          className: "w-100 d-flex justify-content-center"
        }, React.createElement(Button, {
          className: buttonProps.className || 'btn-round _conflower-blue mt-3 mb-3',
          onClick: buttonProps.onClick
        }, !!buttonProps.symbolBeforeLabel && React.createElement("span", {
          className: "btn-round__prefix"
        }, buttonProps.symbolBeforeLabel), buttonProps.label || 'New'));
      }

      return null;
    });
    defineProperty(assertThisInitialized(_this), "renderSelectedValue", function () {
      var _this$props5 = _this.props,
          isMulti = _this$props5.isMulti,
          multiPlaceholder = _this$props5.multiPlaceholder,
          allSelectedText = _this$props5.allSelectedText,
          v = _this$props5.value;
      var isOpen = _this.state.isOpen;

      if (isMulti) {
        if (!isOpen && _this.allSelected()) {
          return allSelectedText || 'All Selected';
        }

        return v && !!v.length && (multiPlaceholder ? multiPlaceholder(v.length) : "".concat(v.length, " Selected"));
      } else {
        return v && (v.reactLabel || v.label);
      }
    });
    _this.state = {
      isOpen: false,
      search: '',
      tumblerIsActive: props.tumblerIsActive,
      withGroups: props.options.some(function (item) {
        return item.isGroupHeader;
      }),
      stateOfOptions: makeStateOfOptions(props.options, props.value, props.dnd),
      isSorting: false
    };
    return _this;
  }

  createClass(Select, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual(['value', 'options', 'isMulti', 'multiPlaceholder', 'allSelectable', 'isSearchable', 'hideValueOnFocus', 'onChange', 'showControlLabel', 'tumbler', 'dnd', 'onTumblerChange', 'label', 'labelImageSrc', 'reactLabel', 'placeholder', 'className', 'isOpen', // sets isOpen state through prop
      'toggleOpenProp', // changes isOpen prop value
      'ignoredCloseClickElement' // prevents select from closing when clicking on outer element that changes isOpen prop
      ], this.props, nextProps) && isEqual(['isOpen', 'search', 'stateOfOptions', 'tumblerIsActive', 'targetDropIndex', 'startDragIndex', 'isSorting'], this.state, nextState));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.windowClickHandler);
      this.setOpenStateThroughProp();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!isEqual(['value', 'options', 'isMulti', 'dnd'], this.props, prevProps) || !isEqual(['isSorting'], this.state, prevState)) {
        this.setState({
          withGroups: this.props.options.some(function (item) {
            return item.isGroupHeader;
          }),
          stateOfOptions: makeStateOfOptions(this.props.options, this.props.value, this.props.dnd)
        });
      }

      if (prevProps.tumblerIsActive !== this.props.tumblerIsActive) {
        this.setState({
          tumblerIsActive: this.props.tumblerIsActive
        });
      }

      if (this.state.isOpen && this.state.isOpen !== prevState.isOpen) {
        if (this._selectList) {
          this._selectList.classList.add(this.props.scrollableClassName || '_scrollable');
        }

        this.searchInput && this.searchInput.focus(); // has isOpen state changed to true, then focus search input
      } // If state.isOpen was changed, then props.isOpen is not yet updated here.
      // This function should be fired by props.isOpen change.


      if (prevState.isOpen === this.state.isOpen) {
        this.setOpenStateThroughProp(prevProps);
      } // clear filter after drop-down was closed


      if (!this.state.isOpen && prevState.isOpen) {
        this.setState({
          search: ''
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.windowClickHandler);
    } // opens/closes select clicking on external element

  }, {
    key: "setStateOptions",
    value: function setStateOptions(state, item, fromDeselectedAll) {
      if (this.props.onChange) {
        var values = [];

        var callback = function callback(item) {
          if (item.isActive) values.push(item);
        };

        traverseState(state, callback);

        if (!this.props.isMulti) {
          values = values.length ? values[0] : null;
        } // add fromDeselectedAll for lazyLoad select


        this.props.onChange(normalizeValue(values), item, fromDeselectedAll);
      }

      this.setState({
        stateOfOptions: state
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          className = _this$props6.className,
          label = _this$props6.label,
          reactLabel = _this$props6.reactLabel,
          allSelectable = _this$props6.allSelectable,
          isMulti = _this$props6.isMulti,
          isClearable = _this$props6.isClearable,
          hideCrossIfClosed = _this$props6.hideCrossIfClosed,
          hideValueOnFocus = _this$props6.hideValueOnFocus,
          selectAllLabel = _this$props6.selectAllLabel,
          tumbler = _this$props6.tumbler,
          tumblerLabel = _this$props6.tumblerLabel,
          dnd = _this$props6.dnd,
          value = _this$props6.value,
          isSearchable = _this$props6.isSearchable,
          changeSearchHandler = _this$props6.changeSearchHandler,
          _this$props6$placehol = _this$props6.placeholder,
          placeholder = _this$props6$placehol === void 0 ? 'Select...' : _this$props6$placehol,
          tooltipParams = _this$props6.tooltipParams;
      var _this$state5 = this.state,
          isOpen = _this$state5.isOpen,
          search = _this$state5.search,
          tumblerIsActive = _this$state5.tumblerIsActive,
          withGroups = _this$state5.withGroups,
          isSorting = _this$state5.isSorting;
      var isSelected = value && (value.reactLabel || value.label || value.length);
      var labelClassName = 'select__label';

      if (hideValueOnFocus) {
        if (!isOpen) {
          if (isSelected) {
            labelClassName += ' _up';
          }
        }
      } else {
        if (isSelected) {
          labelClassName += ' _up';
        }
      }

      var showLabel = true;

      if (!reactLabel && !label) {
        if (!(hideValueOnFocus && isOpen) && isSelected) {
          showLabel = false;
        }
      }

      return React.createElement("div", {
        className: "select js-select ".concat(isSorting ? '_sorting' : '', " ").concat(isOpen ? '_opened' : '', " ").concat(withGroups ? '_with-groups' : '', " ").concat(className || '', " ").concat(dnd ? '_dnd' : ''),
        ref: function ref(el) {
          _this2.select = el;
        }
      }, React.createElement("div", {
        className: "select__outer-wrapper"
      }, React.createElement("div", {
        className: "select__wrapper"
      }, React.createElement(BtnWrapper, {
        className: "select__btn",
        handleClick: this.toggleSelect,
        tooltipParams: tooltipParams
      }, showLabel && React.createElement("div", {
        className: labelClassName
      }, hideValueOnFocus && isOpen ? reactLabel || label || placeholder : isSelected ? reactLabel || label : placeholder), React.createElement("div", {
        className: "select__value ".concat(hideValueOnFocus ? '_bold' : '', " ").concat(isSelected ? '_selected' : '')
      }, (!hideValueOnFocus || !isOpen) && this.renderSelectedValue()), isMulti && isOpen && allSelectable && !this.allSelected() && React.createElement("div", {
        className: "select__btn-secondary",
        onClick: function onClick(e) {
          e.stopPropagation();

          _this2.selectAll();
        }
      }, selectAllLabel || 'Select All'), (isClearable || allSelectable) && (!hideCrossIfClosed || isOpen) && value && (!Array.isArray(value) || !!value.length) && React.createElement("div", {
        className: "select__clear",
        onClick: this.handleClearValue
      }, React.createElement(Icon, {
        name: "Close"
      })), React.createElement("div", {
        className: "select__indicator"
      })), isOpen && React.createElement("div", {
        className: "select__list-wrapper"
      }, isSearchable && React.createElement("div", {
        className: "select__list-input-wrapper"
      }, React.createElement(Icon, {
        name: "Search"
      }), React.createElement("input", {
        ref: function ref(el) {
          _this2.searchInput = el;
        },
        placeholder: "Search",
        className: "select__list-input",
        value: changeSearchHandler ? undefined : search,
        onChange: changeSearchHandler || this.handleChangeSearch
      })), this.renderButton(), tumbler && React.createElement(Tumbler$1, {
        onClick: this.toggleTumbler,
        isActive: tumblerIsActive,
        label: tumblerLabel
      }), this.renderList()))));
    }
  }]);
  return Select;
}(Component);

BtnWrapper.propTypes = {
  className: PropTypes__default.string,
  tooltipParams: PropTypes__default.object,
  handleClick: PropTypes__default.func
};
Select.propTypes = {
  options: PropTypes__default.array,
  value: PropTypes__default.any,
  onChange: PropTypes__default.func,
  isMulti: PropTypes__default.bool,
  tumblerIsActive: PropTypes__default.bool,
  multiPlaceholder: PropTypes__default.func,
  allSelectable: PropTypes__default.bool,
  isClearable: PropTypes__default.bool,
  hideCrossIfClosed: PropTypes__default.bool,
  hideValueOnFocus: PropTypes__default.bool,
  tumbler: PropTypes__default.bool,
  dnd: PropTypes__default.bool,
  onTumblerChange: PropTypes__default.func,
  label: PropTypes__default.string,
  reactLabel: PropTypes__default.elementType,
  labelImageSrc: PropTypes__default.string,
  placeholder: PropTypes__default.string,
  selectAllLabel: PropTypes__default.string,
  tumblerLabel: PropTypes__default.string,
  isSearchable: PropTypes__default.bool,
  searchByValue: PropTypes__default.bool,
  className: PropTypes__default.string,
  levelPadding: PropTypes__default.number,
  totalRecords: PropTypes__default.number,
  changeSearchHandler: PropTypes__default.func,
  allSelectedText: PropTypes__default.string,
  scrollableClassName: PropTypes__default.string,
  tooltipParams: PropTypes__default.object,
  isOpen: PropTypes__default.bool,
  toggleOpenProp: PropTypes__default.func,
  ignoredCloseClickElement: PropTypes__default.object,
  buttonProps: PropTypes__default.exact({
    label: PropTypes__default.string,
    className: PropTypes__default.string,
    onClick: PropTypes__default.func,
    symbolBeforeLabel: PropTypes__default.string
  }),
  onSelectAll: PropTypes__default.func
};
var css$g = ".text-field._error .text-field__help-text {\n  color: #ff5859; }\n\n.text-field:not(._with-border) {\n  width: 100%;\n  margin: 0;\n  border: 0;\n  display: inline-flex;\n  padding: 0;\n  position: relative;\n  min-width: 0;\n  flex-direction: column;\n  vertical-align: top; }\n  .text-field:not(._with-border)._error .text-field__label,\n  .text-field:not(._with-border)._error .text-field__help-text {\n    color: #ff5859; }\n  .text-field:not(._with-border)._error .text-field__base:after,\n  .text-field:not(._with-border)._error .text-field__base:before {\n    border-bottom-color: #ff5859; }\n  .text-field:not(._with-border)._disabled {\n    opacity: 0.5;\n    cursor: default;\n    pointer-events: none; }\n\n.text-field._with-border {\n  position: relative; }\n\n.text-field__label:not(._with-border) {\n  color: #a2a2a2;\n  font-size: 0.875rem;\n  font-family: \"Lato Regular\", sans-serif;\n  line-height: 1.21429em;\n  transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, font-size 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  top: 0;\n  left: 0;\n  position: absolute;\n  transform: translate(0, 21px);\n  transform-origin: top left;\n  padding: 0; }\n  .text-field__label:not(._with-border)._focused, .text-field__label:not(._with-border)._filled {\n    transform: translate(0, 0);\n    transform-origin: top left; }\n  .text-field__label:not(._with-border):not(._filled):not(._focused) {\n    font-family: 'Lato Italic', sans-serif;\n    font-weight: 400; }\n\n.text-field__label._with-border {\n  pointer-events: none;\n  position: absolute;\n  z-index: 1;\n  top: .5rem;\n  left: 0.6875rem;\n  padding: 0;\n  max-width: calc(100% - 31rem/16);\n  background: transparent;\n  overflow: hidden;\n  transition: padding .25s, top .25s, left .25s, font-size .25s, color .25s;\n  font-family: 'Lato Medium Italic', sans-serif;\n  font-weight: 400;\n  font-size: 0.875rem;\n  line-height: 1.21429em;\n  color: #a2a2a2;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n  .text-field__label._with-border._focused {\n    color: #6075ff; }\n  .text-field__label._with-border._focused, .text-field__label._with-border._filled {\n    top: -0.4375rem;\n    left: .5rem;\n    padding: 0 0.125rem;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: .75rem; }\n    .text-field__label._with-border._focused:before, .text-field__label._with-border._filled:before {\n      content: '';\n      position: absolute;\n      z-index: -1;\n      top: 0.3125rem;\n      left: 0.125rem;\n      right: 0.125rem;\n      height: 0.125rem;\n      background: linear-gradient(to bottom, rgba(255, 255, 255, 0.001) 0, #fff 100%); }\n    .text-field__label._with-border._focused:after, .text-field__label._with-border._filled:after {\n      content: '';\n      position: absolute;\n      z-index: -1;\n      top: 0.4375rem;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: linear-gradient(to right, rgba(255, 255, 255, 0.001) 0, #fff 0.125rem, #fff calc(100% - 2rem/16), rgba(255, 255, 255, 0.001)); }\n  .text-field__label._with-border._icon:not(._filled):not(._focused) {\n    left: 1.875rem; }\n  .text-field__label._with-border._error {\n    color: #ff5859; }\n\n.text-field._with-border:hover .text-field__label:not(._error)._filled {\n  color: #6075ff; }\n\n.text-field__base:not(._with-border) {\n  color: rgba(0, 0, 0, 0.87);\n  cursor: text;\n  display: inline-flex;\n  font-size: 1rem;\n  font-family: \"Lato Light\", sans-serif;\n  line-height: 1.1875em;\n  align-items: center;\n  margin-top: 21px;\n  position: relative; }\n  .text-field__base:not(._with-border):before {\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \"\\00a0\";\n    position: absolute;\n    transition: border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    border-bottom: 1px solid #d1d1d1;\n    pointer-events: none; }\n  .text-field__base:not(._with-border):after {\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \"\";\n    position: absolute;\n    transform: scaleX(0);\n    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    border-bottom: 2px solid #6075ff;\n    pointer-events: none; }\n  .text-field__base:not(._with-border):hover:not(._disabled):not(._error):after {\n    transform: scaleX(1); }\n\n.text-field__base._with-border {\n  position: relative;\n  z-index: 0;\n  display: flex;\n  align-items: flex-start;\n  min-height: 2.25rem;\n  padding: 0 0 0 0.625rem;\n  background-color: white;\n  border: 0.0625rem solid #dddddd;\n  box-shadow: none;\n  border-radius: .25rem;\n  transition: box-shadow 200ms ease-in-out, border-color 200ms ease-in-out; }\n  .text-field__base._with-border:hover, .text-field__base._with-border._focused {\n    border-color: #6075ff;\n    box-shadow: 0 0 0.1875rem 0 rgba(5, 13, 66, 0.53); }\n  .text-field__base._with-border._reset-icon {\n    padding-right: 1.5rem; }\n  .text-field__base._with-border._icon {\n    padding-left: .5rem; }\n  .text-field__base._with-border._error {\n    border-color: #ff5859; }\n\n.text-field__input {\n  resize: none; }\n  .text-field__input:not(._with-border) {\n    box-sizing: border-box;\n    font: inherit;\n    width: 100%;\n    height: 1.375rem;\n    border: 0;\n    margin: 0;\n    padding: 0 0 5px;\n    display: block;\n    min-width: 0;\n    background: none;\n    color: black;\n    font-size: 0.875rem;\n    font-family: \"Lato Regular\", sans-serif;\n    line-height: 1.21429em;\n    -webkit-tap-highlight-color: transparent; }\n    .text-field__input:not(._with-border):focus {\n      outline: 0; }\n  .text-field__input._with-border {\n    flex: 1 1 auto;\n    align-self: flex-start;\n    padding: 0.53125rem 0.625rem 0.53125rem 0;\n    height: 2.125rem;\n    min-height: 2.125rem;\n    border-radius: 0 .25rem .25rem 0;\n    border: none;\n    box-shadow: none;\n    font-family: 'Lato Medium', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.21429em;\n    color: #000;\n    width: 100%; }\n    .text-field__input._with-border:focus, .text-field__input._with-border:hover {\n      outline: none; }\n\n.text-field._with-border .text-field__icon {\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: .5rem .25rem 0 0;\n  width: 1.125rem;\n  overflow: hidden;\n  line-height: 0;\n  font-style: normal; }\n  .text-field._with-border .text-field__icon svg {\n    width: 100%;\n    height: auto;\n    fill: #a2a2a2; }\n  .text-field._with-border .text-field__icon path {\n    transition: fill 200ms ease-in-out; }\n\n.text-field._with-border:hover .text-field__icon path,\n.text-field._with-border._focused .text-field__icon path {\n  fill: #6075ff; }\n\n.text-field._with-border .text-field__reset {\n  position: absolute;\n  top: 0.6875rem;\n  right: .5rem;\n  width: 0.75rem;\n  cursor: pointer;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: none;\n  line-height: 0; }\n  .text-field._with-border .text-field__reset:focus {\n    outline: none; }\n  .text-field._with-border .text-field__reset svg {\n    width: 100%;\n    height: auto; }\n\n.text-field__help-text {\n  color: rgba(0, 0, 0, 0.54);\n  margin: 0;\n  font-size: 0.82353rem;\n  text-align: left;\n  margin-top: 5px;\n  min-height: 1em;\n  font-family: \"Lato Medium\", sans-serif;\n  line-height: 1.21429em; }\n\n.text-field__asterisk {\n  color: inherit; }\n\n.text-field-icon {\n  position: relative;\n  display: flex;\n  align-items: center; }\n  .text-field-icon__field {\n    height: 2.25rem;\n    padding: 0 0.625rem;\n    background-color: white;\n    border: 0.0625rem solid #dddddd;\n    box-shadow: none;\n    border-radius: .25rem;\n    font-family: 'Lato Medium', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.21429em;\n    color: #000;\n    width: 100%;\n    transition: box-shadow 200ms ease-in-out, border-color 200ms ease-in-out; }\n    .text-field-icon__field:focus, .text-field-icon__field:hover {\n      outline: none; }\n  .text-field-icon:hover .text-field-icon__field,\n  .text-field-icon._focused .text-field-icon__field {\n    border-color: #6075ff;\n    box-shadow: 0 0 0.1875rem 0 rgba(5, 13, 66, 0.53); }\n  .text-field-icon._reset-icon .text-field-icon__field {\n    padding-right: 1.5rem; }\n  .text-field-icon._icon .text-field-icon__field {\n    padding-left: 1.875rem; }\n  .text-field-icon__icon {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0.5625rem;\n    overflow: hidden;\n    line-height: 0;\n    font-style: normal;\n    width: 1.125rem;\n    display: flex;\n    justify-content: center;\n    align-items: center; }\n    .text-field-icon__icon svg {\n      width: 100%;\n      height: auto;\n      fill: #a2a2a2; }\n    .text-field-icon__icon path {\n      transition: fill 200ms ease-in-out; }\n  .text-field-icon:hover .text-field-icon__icon path,\n  .text-field-icon._focused .text-field-icon__icon path {\n    fill: #6075ff; }\n  .text-field-icon__reset {\n    position: absolute;\n    top: 50%;\n    right: 0.5625rem;\n    transform: translateY(-50%);\n    width: 0.75rem;\n    cursor: pointer;\n    padding: 0;\n    border: none;\n    border-radius: 0;\n    background: none;\n    line-height: 0; }\n    .text-field-icon__reset:focus {\n      outline: none; }\n    .text-field-icon__reset svg {\n      width: 100%;\n      height: auto; }\n  .text-field-icon__label {\n    pointer-events: none;\n    position: absolute;\n    padding: 0;\n    max-width: calc(100% - 31rem/16);\n    background: transparent;\n    overflow: hidden;\n    transform: translate(0.625rem, -0.0625rem);\n    transition: padding .25s, transform .25s, font-size .25s, color .25s;\n    font-family: 'Lato Medium Italic', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.21429em;\n    color: #a2a2a2;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n    .text-field-icon__label._focused {\n      color: #6075ff; }\n    .text-field-icon__label._up {\n      transform: translate(0.5rem, -1.125rem);\n      padding: 0 0.125rem;\n      font-family: 'Lato Regular', sans-serif;\n      font-weight: 400;\n      font-size: .75rem; }\n      .text-field-icon__label._up:before {\n        content: '';\n        position: absolute;\n        z-index: -1;\n        top: 0.3125rem;\n        left: 0.125rem;\n        right: 0.125rem;\n        height: 0.125rem;\n        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.001) 0, #fff 100%); }\n      .text-field-icon__label._up:after {\n        content: '';\n        position: absolute;\n        z-index: -1;\n        top: 0.4375rem;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: linear-gradient(to right, rgba(255, 255, 255, 0.001) 0, #fff 0.125rem, #fff calc(100% - 2rem/16), rgba(255, 255, 255, 0.001)); }\n  .text-field-icon._icon .text-field-icon__label:not(._up):not(._focused) {\n    transform: translate(1.875rem, 0); }\n  .text-field-icon:hover .text-field-icon__label._up {\n    color: #6075ff; }\n";
styleInject(css$g);

var TextField = /*#__PURE__*/function (_Component) {
  inherits(TextField, _Component);

  function TextField(props) {
    var _this;

    classCallCheck(this, TextField);
    _this = possibleConstructorReturn(this, getPrototypeOf(TextField).call(this));
    defineProperty(assertThisInitialized(_this), "handleFocus", function (event) {
      _this.setState({
        focused: true
      });

      _this.inputRef.select();

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    });
    defineProperty(assertThisInitialized(_this), "handleBlur", function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    });
    defineProperty(assertThisInitialized(_this), "handleKeyUp", function (event) {
      if (_this.props.onSubmitted && event.key === 'Enter') {
        _this.props.onSubmitted(_this.props.value);
      }
    });
    defineProperty(assertThisInitialized(_this), "pushClassName", function (arrays) {
      return function (className) {
        arrays.forEach(function (array) {
          return array.push(className);
        });
      };
    });
    defineProperty(assertThisInitialized(_this), "handleResetClick", function () {
      _this.props.onChange('');

      _this.setState({
        isFilled: false
      });
    });
    _this.state = {
      isValid: true,
      error: null,
      isFilled: !!props.value
    };
    _this.isControlled = props.value !== undefined;
    return _this;
  }

  createClass(TextField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.isControlled) {
        this.checkDirty(this.inputRef);
      }

      if (this.props.validateOnInit) {
        this.validateControl();
      }

      this.props.inputRef && this.props.inputRef(this.inputRef);
    }
  }, {
    key: "validateControl",
    value: function validateControl() {
      var target = this.inputRef;
      return this.validate(target.value, target);
    }
  }, {
    key: "checkDirty",
    value: function checkDirty(_ref) {
      var value = _ref.value;

      if (!!value) {
        this.setState({
          isFilled: true
        });
      } else {
        this.setState({
          isFilled: false
        });
      }
    }
  }, {
    key: "handleValueChange",
    value: function handleValueChange(value, target) {
      var _this$props = this.props,
          type = _this$props.type,
          onChange = _this$props.onChange,
          validationRules = _this$props.validationRules;

      if (type === 'amount') {
        var i = 0;
        value = value.replace(/[^0-9.]+/g, '').replace(/\./g, function (match) {
          i += 1;
          return i === 2 ? '' : match;
        });
      }

      if (onChange) {
        var errors;

        if (validationRules && validationRules.length) {
          errors = validationRules.reduce(function (errors, rule) {
            if (!rule.func(value, target, rule)) {
              if (!errors) {
                errors = [];
              }

              errors.push({
                name: target.name,
                message: rule.error(target.name, rule)
              });
            }

            return errors;
          }, null);
        }

        onChange(value, errors);
      }

      if (!this.isControlled) {
        this.checkDirty({
          value: value
        });
      }

      this.validate(value, target);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (this.props.value !== oldProps.value || !isEqual$1(this.props.validationKeys, oldProps.validationKeys)) {
        if (this.isControlled) {
          this.checkDirty({
            value: this.props.value
          });
        }

        this.validate(this.props.value, this.inputRef);
      }
    }
  }, {
    key: "validate",
    value: function validate(value, target) {
      var _this$props$validatio = this.props.validationRules,
          validationRules = _this$props$validatio === void 0 ? [] : _this$props$validatio;
      var rules = validationRules.slice();
      var rule = rules.pop();

      while (rule) {
        var isValid = rule.func(value, target, rule);

        if (!isValid) {
          this.setValidationState(false, rule, target.name);
          return false;
        }

        rule = rules.pop();
      }

      this.setValidationState(true);
      return true;
    }
  }, {
    key: "setValidationState",
    value: function setValidationState(isValid, rule, name) {
      if (isValid) {
        this.setState({
          isValid: true,
          error: null
        });
        this.props.onValidate(true);
      } else {
        this.setState({
          isValid: false,
          error: rule.error(name, rule)
        });
        this.props.onValidate(false);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual$1(['label', 'type', 'name', 'value', 'helperText', 'placeholder', 'disabled', 'validationKeys', 'isTextarea', 'withBorder', 'iconName', 'svgParams'], this.props, nextProps) && isEqual$1(['focused', 'isValid', 'error', 'isFilled'], this.state, nextState));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          label = _this$props2.label,
          type = _this$props2.type,
          name = _this$props2.name,
          value = _this$props2.value,
          helperText = _this$props2.helperText,
          placeholder = _this$props2.placeholder,
          disabled = _this$props2.disabled,
          isTextarea = _this$props2.isTextarea,
          withBorder = _this$props2.withBorder,
          iconName = _this$props2.iconName,
          svgParams = _this$props2.svgParams;
      var _this$state = this.state,
          focused = _this$state.focused,
          isValid = _this$state.isValid,
          error = _this$state.error,
          isFilled = _this$state.isFilled;
      var textFieldClassName = ['text-field', className];
      var labelClassName = ['text-field__label'];
      var baseClassName = ['text-field__base'];
      var inputClassName = ['text-field__input'];
      var pushClassName = this.pushClassName([textFieldClassName, labelClassName, baseClassName, inputClassName]);

      if (focused) {
        pushClassName('_focused');
      }

      if (isFilled) {
        pushClassName('_filled');
      }

      if (withBorder) {
        pushClassName('_with-border');

        if (iconName) {
          pushClassName('_icon');
        }
      }

      if (!isValid) {
        pushClassName('_error');
      }

      if (disabled) {
        pushClassName('_disabled');
      }

      var placeholderContainer = !isFilled && focused ? placeholder : '';
      var reset = iconName === 'Search';
      return React.createElement("div", {
        className: textFieldClassName.join(' ')
      }, React.createElement("label", {
        className: labelClassName.join(' ')
      }, label), React.createElement("div", {
        className: baseClassName.join(' ')
      }, withBorder && iconName && React.createElement("i", {
        className: "text-field__icon"
      }, React.createElement(Icon, _extends_1({
        name: iconName
      }, svgParams))), React.createElement(!isTextarea ? 'input' : 'textarea', {
        ref: function ref(el) {
          _this2.inputRef = el;
        },
        className: inputClassName.join(' '),
        type: type,
        name: name,
        value: value,
        placeholder: placeholderContainer,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: function onChange(e) {
          return _this2.handleValueChange(e.target.value, e.target);
        },
        onKeyUp: this.handleKeyUp
      }), withBorder && reset && value && React.createElement("button", {
        className: "text-field__reset",
        onClick: this.handleResetClick
      }, React.createElement(Icon, {
        name: "Close"
      }))), (error || helperText) && React.createElement("p", {
        className: "text-field__help-text"
      }, error || helperText));
    }
  }]);
  return TextField;
}(Component);

defineProperty(TextField, "defaultProps", {
  type: 'text',
  onValidate: function onValidate() {},
  validateOnInit: false,
  svgParams: {}
});
TextField.propTypes = {
  className: PropTypes__default.string,
  label: PropTypes__default.string,
  type: PropTypes__default.string,
  name: PropTypes__default.string,
  value: PropTypes__default.string,
  helperText: PropTypes__default.string,
  validationRules: PropTypes__default.array,
  validateOnInit: PropTypes__default.bool,
  validationKeys: PropTypes__default.array,
  placeholder: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  inputRef: PropTypes__default.func,
  onSubmitted: PropTypes__default.func,
  onFocus: PropTypes__default.func,
  onBlur: PropTypes__default.func,
  onChange: PropTypes__default.func,
  onValidate: PropTypes__default.func,
  isTextarea: PropTypes__default.bool,
  withBorder: PropTypes__default.bool,
  iconName: PropTypes__default.string,
  svgParams: PropTypes__default.object
};

function createTextField(container, options) {
  var TextField = /*#__PURE__*/function () {
    function TextField(container) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      classCallCheck(this, TextField);
      defineProperty(this, "container", void 0);
      defineProperty(this, "wrapper", void 0);
      defineProperty(this, "label", void 0);
      defineProperty(this, "base", void 0);
      defineProperty(this, "input", void 0);
      defineProperty(this, "helper", void 0);
      this.container = container;
      this.options = options;
      this.handleFocus = this.handleFocus.bind(this);
      this.handleBlur = this.handleBlur.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.init();
      container.appendChild(this.wrapper);
      return this;
    }

    createClass(TextField, [{
      key: "init",
      value: function init() {
        this.createMarkup();
        this.addListeners();
      }
    }, {
      key: "createMarkup",
      value: function createMarkup() {
        this.wrapper = document.createElement('div');
        this.wrapper.classList.add('text-field');
        this.label = document.createElement('label');
        this.label.classList.add('text-field__label');
        this.label.innerText = this.options.label || '';
        this.base = document.createElement('div');
        this.base.classList.add('text-field__base');
        this.input = document.createElement('input');
        this.input.classList.add('text-field__input');
        this.input.type = this.options.type || 'text';
        this.input.name = this.options.name || '';
        this.base.appendChild(this.input);
        this.wrapper.appendChild(this.label);
        this.wrapper.appendChild(this.base);
        this.updateHelperElement(this.options.helperText);
      }
    }, {
      key: "addListeners",
      value: function addListeners() {
        this.input.addEventListener('focus', this.handleFocus);
        this.input.addEventListener('blur', this.handleBlur);
        this.input.addEventListener('keyup', this.handleChange);
      }
    }, {
      key: "updateHelperElement",
      value: function updateHelperElement(errorText) {
        if (this.options.helperText || errorText) {
          if (!this.helper) {
            this.helper = document.createElement('p');
            this.helper.classList.add('text-field__help-text');
            this.wrapper.appendChild(this.helper);
          }

          this.helper.innerText = errorText || this.options.helperText;
        }
      }
    }, {
      key: "handleFocus",
      value: function handleFocus() {
        this.base.classList.add('_focused');
        this.label.classList.add('_focused');
      }
    }, {
      key: "handleBlur",
      value: function handleBlur() {
        this.base.classList.remove('_focused');
        this.label.classList.remove('_focused');
      }
    }, {
      key: "handleChange",
      value: function handleChange(e) {
        var value = e.target.value;

        if (value) {
          this.label.classList.add('_filled');
        } else {
          this.label.classList.remove('_filled');
        }

        this.validate(value, e.target);
      }
    }, {
      key: "validate",
      value: function validate(value, target) {
        var _this$options$validat = this.options.validationRules,
            validationRules = _this$options$validat === void 0 ? [] : _this$options$validat;
        var rules = validationRules.slice();
        var rule = rules.pop();

        while (rule) {
          var isValid = rule.func(value, target, rule);

          if (!isValid) {
            this.setValidationState(false, rule, target.name);
            return;
          }

          rule = rules.pop();
        }

        this.setValidationState(true);
      }
    }, {
      key: "setValidationState",
      value: function setValidationState(isValid, rule, name) {
        if (isValid) {
          this.wrapper.classList.remove('_error');
          this.base.classList.remove('_error');
          this.updateHelperElement();
        } else {
          this.wrapper.classList.add('_error');
          this.base.classList.add('_error');
          this.updateHelperElement(rule.error(name, rule));
        }
      }
    }]);
    return TextField;
  }();

  return new TextField(container, options);
}

var TextFieldWithIcon = /*#__PURE__*/function (_Component) {
  inherits(TextFieldWithIcon, _Component);

  function TextFieldWithIcon() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, TextFieldWithIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(TextFieldWithIcon)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      focused: false,
      isFilled: !!_this.props.value
    });
    defineProperty(assertThisInitialized(_this), "inputRef", null);
    defineProperty(assertThisInitialized(_this), "handleChange", function (e) {
      var onChange = _this.props.onChange;
      onChange(e);

      _this.checkDirty(e.target);
    });
    defineProperty(assertThisInitialized(_this), "handleFocus", function (event) {
      _this.inputRef && _this.inputRef.select();

      _this.setState({
        focused: true
      });
    });
    defineProperty(assertThisInitialized(_this), "handleBlur", function (event) {
      _this.setState({
        focused: false
      });
    });
    return _this;
  }

  createClass(TextFieldWithIcon, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual(['name', 'placeholder', 'type', 'iconName', 'value', 'svgParams', 'reset'], this.props, nextProps) && isEqual(['focused', 'isFilled'], this.state, nextState));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.inputRef && this.props.inputRef(this.inputRef);
    }
  }, {
    key: "checkDirty",
    value: function checkDirty(_ref) {
      var value = _ref.value;
      var isFilled = this.state.isFilled;
      isFilled !== !!value && this.setState({
        isFilled: !!value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          placeholder = _this$props.placeholder,
          type = _this$props.type,
          iconName = _this$props.iconName,
          onChange = _this$props.onChange,
          value = _this$props.value,
          svgParams = _this$props.svgParams,
          rest = objectWithoutProperties(_this$props, ["name", "placeholder", "type", "iconName", "onChange", "value", "svgParams"]);
      var _this$state = this.state,
          focused = _this$state.focused,
          isFilled = _this$state.isFilled;
      var reset = iconName === 'Search';
      var containerClassName = ['text-field-icon'];

      if (focused) {
        containerClassName.push('_focused');
      }

      if (reset) {
        containerClassName.push('_reset-icon');
      }

      if (iconName) {
        containerClassName.push('_icon');
      }

      var labelClassName = ['text-field-icon__label'];

      if (focused || isFilled) {
        labelClassName.push('_up');
      }

      if (focused) {
        labelClassName.push('_focused');
      }

      return React.createElement("div", {
        className: containerClassName.join(' ')
      }, iconName && React.createElement("i", {
        className: "text-field-icon__icon"
      }, React.createElement(Icon, _extends_1({
        name: iconName
      }, svgParams))), React.createElement("div", {
        className: labelClassName.join(' ')
      }, placeholder), React.createElement("input", _extends_1({
        type: type,
        name: name,
        value: value,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        className: "text-field-icon__field",
        ref: function ref(el) {
          _this2.inputRef = el;
        }
      }, rest)), reset && value && React.createElement("button", {
        className: "text-field-icon__reset",
        onClick: function onClick() {
          return onChange({
            target: {
              value: ''
            }
          });
        }
      }, React.createElement(Icon, {
        name: "Close"
      })));
    }
  }]);
  return TextFieldWithIcon;
}(Component);

TextFieldWithIcon.defaultProps = {
  type: 'text',
  onChange: function onChange() {},
  svgParams: {}
};
TextFieldWithIcon.propTypes = {
  iconName: PropTypes__default.string,
  value: PropTypes__default.string.isRequired,
  name: PropTypes__default.string,
  placeholder: PropTypes__default.string,
  type: PropTypes__default.string,
  onChange: PropTypes__default.func,
  svgParams: PropTypes__default.object,
  reset: PropTypes__default.bool,
  focused: PropTypes__default.bool
};
var css$h = ".checkbox {\n  display: flex;\n  align-items: center;\n  position: relative; }\n  .checkbox .checkbox-svg-checked,\n  .checkbox .checkbox-svg-blank {\n    display: none;\n    pointer-events: none;\n    width: 20px;\n    height: 20px;\n    margin-right: 10px; }\n    .checkbox .checkbox-svg-checked svg,\n    .checkbox .checkbox-svg-blank svg {\n      fill: #a2a2a2;\n      width: 20px;\n      height: 20px; }\n  .checkbox .checkbox-svg-blank {\n    display: inline; }\n  .checkbox__input {\n    cursor: pointer;\n    position: absolute;\n    left: 0;\n    top: 0;\n    opacity: 0; }\n    .checkbox__input:checked ~ .checkbox-svg-checked {\n      display: inline; }\n    .checkbox__input:checked ~ .checkbox-svg-blank {\n      display: none; }\n  .checkbox_disabled .checkbox__input {\n    cursor: default; }\n  .checkbox__label {\n    position: relative;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    transition: color .25s;\n    font-family: 'Lato Medium', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 1.15;\n    color: #787878;\n    font-weight: normal;\n    letter-spacing: 0.07px; }\n    .checkbox__label > svg {\n      pointer-events: none;\n      width: 20px;\n      height: 20px;\n      fill: #a2a2a2;\n      transition: fill .25s; }\n      .checkbox__label > svg:not(:last-child) {\n        margin-right: 10px; }\n  .checkbox_disabled .checkbox__label {\n    cursor: default; }\n  .checkbox:not(.checkbox_disabled) .checkbox__label:hover {\n    color: #000; }\n    .checkbox:not(.checkbox_disabled) .checkbox__label:hover svg {\n      fill: #6075ff; }\n  .checkbox.checkbox_disabled .checkbox__label {\n    color: #a2a2a2; }\n    .checkbox.checkbox_disabled .checkbox__label > svg {\n      fill: #a2a2a2; }\n  .checkbox_checked .checkbox__label {\n    color: #000000; }\n    .checkbox_checked .checkbox__label svg {\n      fill: #000000; }\n";
styleInject(css$h);

function _extends$1n() {
  _extends$1n = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1n.apply(this, arguments);
}

var _ref$1m = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var _ref2$g = /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z"
});

var SvgComponent$1m = function SvgComponent(props) {
  return React.createElement("svg", _extends$1n({
    viewBox: "0 0 24 24"
  }, props), _ref$1m, _ref2$g);
};

function _extends$1o() {
  _extends$1o = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1o.apply(this, arguments);
}

var _ref$1n = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var _ref2$h = /*#__PURE__*/React.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
});

var SvgComponent$1n = function SvgComponent(props) {
  return React.createElement("svg", _extends$1o({
    viewBox: "0 0 24 24"
  }, props), _ref$1n, _ref2$h);
};

var Checkbox = /*#__PURE__*/function (_Component) {
  inherits(Checkbox, _Component);

  function Checkbox() {
    classCallCheck(this, Checkbox);
    return possibleConstructorReturn(this, getPrototypeOf(Checkbox).apply(this, arguments));
  }

  createClass(Checkbox, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !isEqual(['label', 'checked', 'disabled', 'className'], this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          label = _this$props.label,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          _onChange = _this$props.onChange,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className;
      var cb = checked ? React.createElement(SvgComponent$1m, null) : React.createElement(SvgComponent$1n, null);
      return React.createElement("div", {
        className: "checkbox ".concat(disabled ? 'checkbox_disabled' : '', " ").concat(checked ? 'checkbox_checked' : '', " ").concat(className)
      }, React.createElement("label", {
        className: "checkbox__label",
        htmlFor: name
      }, React.createElement("input", {
        type: "checkbox",
        id: name,
        name: name,
        disabled: disabled,
        checked: checked,
        onChange: function onChange(e) {
          return _onChange(e.target.checked);
        },
        className: "checkbox__input"
      }), cb, label && React.createElement("span", {
        className: "checkbox__title"
      }, label)));
    }
  }]);
  return Checkbox;
}(Component);

defineProperty(Checkbox, "defaultProps", {
  onChange: function onChange() {},
  checked: false,
  disabled: false
});
Checkbox.propTypes = {
  name: PropTypes__default.string,
  label: PropTypes__default.string,
  checked: PropTypes__default.bool,
  disabled: PropTypes__default.bool,
  onChange: PropTypes__default.func,
  className: PropTypes__default.string
};
var css$i = ".btn-group {\n  display: flex;\n  align-items: stretch; }\n  .btn-group__item {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    padding: 0 0.375rem;\n    height: 1.5rem;\n    border: 0.0625rem solid #6075ff;\n    outline: none;\n    background: transparent;\n    cursor: pointer;\n    transition: border .25s, background .25s, box-shadow .25s, color .25s;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.57143em;\n    color: #6075ff; }\n    .btn-group__item:not(:last-child) {\n      border-right: none; }\n    .btn-group__item:first-child {\n      border-radius: .25rem 0 0 .25rem; }\n    .btn-group__item:last-child {\n      border-radius: 0 .25rem .25rem 0; }\n    .btn-group__item._active {\n      border-color: #323c82;\n      background: #6075ff;\n      box-shadow: 0 0 0.25rem 0 #a2a2a2;\n      color: #fff; }\n      .btn-group__item._active:hover {\n        position: relative;\n        background: #4d5ecc; }\n    .btn-group__item:not(._active):hover {\n      position: relative;\n      border-color: #4d5ecc;\n      box-shadow: 0 0 0.25em 0 rgba(162, 162, 162, 0.5); }\n  .btn-group._sm .btn-group__item {\n    padding: 0 0.5625rem;\n    height: 1.875rem; }\n  .btn-group._md .btn-group__item {\n    padding: 0 0.875rem;\n    height: 2.5rem; }\n";
styleInject(css$i);

var ButtonsGroup = /*#__PURE__*/function (_Component) {
  inherits(ButtonsGroup, _Component);

  function ButtonsGroup() {
    classCallCheck(this, ButtonsGroup);
    return possibleConstructorReturn(this, getPrototypeOf(ButtonsGroup).apply(this, arguments));
  }

  createClass(ButtonsGroup, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !isEqual(['items', 'value', 'className', 'size'], this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          value = _this$props.value,
          onChange = _this$props.onChange,
          className = _this$props.className,
          size = _this$props.size;
      var isCheckboxes = Array.isArray(value);
      return React.createElement("div", {
        className: "btn-group ".concat(size ? "_".concat(size) : '', " ").concat(className)
      }, items.map(function (item, index) {
        var active = undefined;

        if (isCheckboxes) {
          active = value.indexOf(item.value) !== -1 ? '_active' : '';
        } else {
          active = item.value === value ? '_active' : '';
        }

        return React.createElement("button", {
          onClick: function onClick() {
            return onChange(item.value);
          },
          key: index,
          className: "btn-group__item ".concat(active)
        }, item.title);
      }));
    }
  }]);
  return ButtonsGroup;
}(Component);

defineProperty(ButtonsGroup, "defaultProps", {
  onChange: function onChange() {},
  className: ''
});
ButtonsGroup.propTypes = {
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array]),
  items: PropTypes__default.array.isRequired,
  onChange: PropTypes__default.func,
  className: PropTypes__default.string
};
var css$j = ".card {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  border-radius: .25rem;\n  background: #fff;\n  box-shadow: 0rem 0rem 0.5rem 0.125rem rgba(0, 0, 0, 0.16);\n  overflow: hidden;\n  transition: box-shadow .3s, transform .3s;\n  cursor: pointer; }\n  .card__header {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    padding: 1.3125rem 1rem 0.5rem 1.3125rem;\n    background: #ffffff;\n    border-bottom: 1px solid #f4f4f4; }\n  .card__title {\n    width: 100%;\n    font-family: 'Lato Medium', sans-serif;\n    font-weight: 400;\n    font-size: 1.5rem;\n    line-height: 1.15;\n    color: #000;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin-bottom: 0.5rem; }\n    .card__title_subtitle {\n      flex: 1 1 auto;\n      display: flex;\n      align-items: center;\n      font-family: 'Lato Medium', sans-serif;\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.15;\n      color: #787878; }\n  .card__content {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    padding: 1.625rem 1.3125rem 1rem;\n    position: relative; }\n  .card__overlay {\n    opacity: 0;\n    visibility: hidden;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.8);\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    transition: opacity .3s, visibility .3s; }\n  .card:hover, .card_hovered {\n    box-shadow: 0rem 0rem 0.625rem 0.25rem rgba(0, 0, 0, 0.16);\n    transform: translate(0px, -5px); }\n    .card:hover .card__overlay, .card_hovered .card__overlay {\n      opacity: 1;\n      visibility: visible; }\n  .card__subtitle {\n    animation: subtitle-animation 0.2s ease-in-out; }\n    .card__subtitle_hovered {\n      animation: subtitle-animation 0.2s ease-in-out; }\n\n@keyframes subtitle-animation {\n  0% {\n    opacity: 0;\n    transform: translateY(-12px); }\n  100% {\n    opacity: 0.5;\n    transform: translateY(0); } }\n";
styleInject(css$j);

var isFunction = function isFunction(element) {
  return typeof element === 'function';
};

var CardHoveredContent = function CardHoveredContent(_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    className: "card__overlay"
  }, children);
};

var CardHoveredSubtitle = function CardHoveredSubtitle(_ref2) {
  var children = _ref2.children;
  return React.createElement("div", {
    className: "card__subtitle_hovered"
  }, children);
};

var CardSubtitle = function CardSubtitle(_ref3) {
  var children = _ref3.children;
  return React.createElement("div", {
    className: "card__subtitle"
  }, children);
};

var Card = /*#__PURE__*/function (_Component) {
  inherits(Card, _Component);

  function Card(props) {
    var _this;

    classCallCheck(this, Card);
    _this = possibleConstructorReturn(this, getPrototypeOf(Card).call(this, props));
    defineProperty(assertThisInitialized(_this), "onMouseOver", function () {
      _this.setState({
        hovered: true
      });
    });
    defineProperty(assertThisInitialized(_this), "onMouseOut", function () {
      _this.setState({
        hovered: false
      });
    });
    _this.state = {
      hovered: false
    };
    return _this;
  }

  createClass(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          children = _this$props.children;
      var state = this.state;
      var hovered = state.hovered;
      return React.createElement("div", {
        className: "card ".concat(hovered ? 'card_hovered' : ''),
        onMouseEnter: this.onMouseOver,
        onMouseLeave: this.onMouseOut
      }, React.createElement("header", {
        className: "card__header"
      }, React.createElement("div", {
        className: "card__title"
      }, title), React.createElement("div", {
        className: "card__title card__title_subtitle"
      }, isFunction(subtitle) ? subtitle(state) : subtitle)), React.createElement("main", {
        className: "card__content"
      }, isFunction(children) ? children(state) : children));
    }
  }]);
  return Card;
}(Component);

Card.propTypes = {
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  subtitle: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element, PropTypes__default.func]),
  children: PropTypes__default.oneOfType([PropTypes__default.arrayOf(PropTypes__default.element), PropTypes__default.element, PropTypes__default.func])
};
var css$k = ".snackbar {\n  position: fixed;\n  display: flex;\n  min-width: 21.5rem;\n  border-radius: 0.25rem;\n  background-color: #787878;\n  padding: 1rem;\n  color: white;\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  transition: opacity .3s, visibility .3s;\n  opacity: 1;\n  visibility: visible;\n  justify-content: space-between;\n  z-index: 100;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 2rem; }\n  .snackbar__action {\n    align-items: center;\n    display: flex;\n    margin-left: 20px; }\n  .snackbar_shamrock {\n    background-color: #3fd4ad;\n    color: #ffffff; }\n    .snackbar_shamrock .snackbar__action svg {\n      fill: #ffffff; }\n  .snackbar_orange {\n    background-color: #ffa300;\n    color: #ffffff; }\n    .snackbar_orange .snackbar__action svg {\n      fill: #ffffff; }\n  .snackbar_persimmon {\n    background-color: #ff5859;\n    color: #ffffff; }\n    .snackbar_persimmon .snackbar__action svg {\n      fill: #ffffff; }\n";
styleInject(css$k);

var Snackbar = /*#__PURE__*/function (_Component) {
  inherits(Snackbar, _Component);

  function Snackbar() {
    classCallCheck(this, Snackbar);
    return possibleConstructorReturn(this, getPrototypeOf(Snackbar).apply(this, arguments));
  }

  createClass(Snackbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.setAutoHideTimer();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        if (this.props.open) {
          this.setAutoHideTimer();
        } else {
          clearTimeout(this.timerAutoHide);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timerAutoHide) {
        clearTimeout(this.timerAutoHide);
      }
    }
  }, {
    key: "setAutoHideTimer",
    value: function setAutoHideTimer(autoHideDuration) {
      var _this = this;

      var autoHideDurationBefore = autoHideDuration != null ? autoHideDuration : this.props.autoHideDuration;

      if (!this.props.onClose || autoHideDurationBefore == null) {
        return;
      }

      clearTimeout(this.timerAutoHide);
      this.timerAutoHide = setTimeout(function () {
        var autoHideDurationAfter = autoHideDuration != null ? autoHideDuration : _this.props.autoHideDuration;

        if (!_this.props.onClose || autoHideDurationAfter == null) {
          return;
        }

        _this.props.onClose(null, 'timeout');
      }, autoHideDurationBefore);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          message = _this$props.message,
          action = _this$props.action,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className;

      if (!open) {
        return null;
      }

      var classes = ['snackbar', className];
      return React.createElement("div", {
        className: classes.join(' ')
      }, React.createElement("div", {
        className: "snackbar__message"
      }, message), action && React.createElement("div", {
        className: "snackbar__action"
      }, action));
    }
  }]);
  return Snackbar;
}(Component);

defineProperty(Snackbar, "defaultProps", {
  autoHideDuration: 10000
});
Snackbar.propTypes = {
  open: PropTypes__default.bool,
  onClose: PropTypes__default.func,
  autoHideDuration: PropTypes__default.number,
  message: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.node]),
  action: PropTypes__default.node,
  className: PropTypes__default.string
};
var css$l = ".dialog {\n  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12); }\n\n.dialog {\n  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: box-shadow; }\n\n.modal__overflow {\n  overflow: hidden; }\n\n.modal__overlay {\n  z-index: 50;\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.dialog {\n  min-width: 400px;\n  min-height: 120px;\n  max-width: 700px;\n  border: 0.0625rem solid #6075ff;\n  border-radius: .25rem;\n  background: #ffffff; }\n  .dialog__buttons {\n    display: flex;\n    align-items: center;\n    align-self: flex-end; }\n    .dialog__buttons:not(:first-child) {\n      margin-left: 1rem; }\n    .dialog__buttons > button:not(:last-child) {\n      margin-right: .5rem; }\n  .dialog__header, .dialog__footer, .dialog__content {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    padding: 18px; }\n  .dialog__content-scrollable {\n    max-height: 220px;\n    min-height: 100px;\n    overflow: auto; }\n  .dialog__button {\n    display: inline-block;\n    font-family: \"Lato Medium\", sans-serif;\n    font-weight: 400;\n    font-size: 1.1875rem;\n    color: #818181;\n    text-transform: uppercase;\n    cursor: pointer;\n    -webkit-transition: color .25s;\n    transition: color .25s;\n    background-color: transparent;\n    border: 0;\n    padding: 0 0.625rem;\n    outline: none; }\n    .dialog__button:hover {\n      color: #000000; }\n  .dialog__header {\n    padding-bottom: 0; }\n  .dialog__footer {\n    padding-top: 18px; }\n  .dialog__content .title-card {\n    font-size: 1.375rem; }\n";
styleInject(css$l);
var css$m = ".modal__overflow {\n  overflow: hidden; }\n\n.modal__overlay {\n  z-index: 50;\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n";
styleInject(css$m);
var BODY_CLASS = 'modal__overflow';

var Modal = /*#__PURE__*/function (_Component) {
  inherits(Modal, _Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "overlayElement", React.createRef());
    defineProperty(assertThisInitialized(_this), "handleClickOutside", function (e) {
      if (e.target === _this.overlayElement.current) {
        _this.onClickOutside(e);
      }
    });
    defineProperty(assertThisInitialized(_this), "onClickOutside", function (e) {
      _this.props.onClickOutside && _this.props.onClickOutside(e);
    });
    defineProperty(assertThisInitialized(_this), "handleKeyEvent", function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        _this.onClickOutside(e);
      }
    });
    return _this;
  }

  createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.classList.add(BODY_CLASS);
      document.addEventListener('keydown', this.handleKeyEvent);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove(BODY_CLASS);
      document.removeEventListener('keydown', this.handleKeyEvent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          children = _this$props.children,
          modalProps = _this$props.modalProps;

      if (!open) {
        return null;
      }

      return React.createElement("div", _extends_1({
        className: "modal"
      }, modalProps), React.createElement("div", {
        className: "modal__overlay",
        ref: this.overlayElement,
        onClick: this.handleClickOutside
      }, children));
    }
  }]);
  return Modal;
}(Component);

Modal.propTypes = {
  onClickOutside: PropTypes__default.func
};

var Dialog = /*#__PURE__*/function (_Component) {
  inherits(Dialog, _Component);

  function Dialog() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Dialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Dialog)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "handleEnterKeyEvent", function (e) {
      if (!_this.props.open || !(e.key === 'Enter')) {
        return;
      }

      _this.props.handleEnterKeyEvent();
    });
    return _this;
  }

  createClass(Dialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.handleEnterKeyEvent) {
        window.addEventListener('keydown', this.handleEnterKeyEvent);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.handleEnterKeyEvent) {
        window.removeEventListener('keydown', this.handleEnterKeyEvent);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          className = _this$props.className,
          children = _this$props.children,
          onClickOutside = _this$props.onClickOutside,
          modalProps = _this$props.modalProps;

      if (!open) {
        return null;
      }

      return React.createElement(Modal, {
        open: open,
        onClickOutside: onClickOutside,
        modalProps: modalProps
      }, React.createElement("div", {
        className: "dialog ".concat(className ? className : '')
      }, children));
    }
  }]);
  return Dialog;
}(Component);

var DialogContent = function DialogContent(_ref) {
  var children = _ref.children;
  return React.createElement("main", {
    className: "dialog__content"
  }, children);
};

var DialogScrollableContent = function DialogScrollableContent(_ref2) {
  var children = _ref2.children;
  return React.createElement("div", {
    className: "dialog__content-scrollable"
  }, React.createElement(DialogContent, null, children));
};

var DialogHeader = function DialogHeader(_ref3) {
  var children = _ref3.children;
  return React.createElement("header", {
    className: "dialog__header"
  }, children);
};

var DialogFooter = function DialogFooter(_ref4) {
  var children = _ref4.children;
  return React.createElement("footer", {
    className: "dialog__footer"
  }, children);
};

var DialogButtons = function DialogButtons(_ref5) {
  var _ref5$buttons = _ref5.buttons,
      buttons = _ref5$buttons === void 0 ? [] : _ref5$buttons;
  return React.createElement("div", {
    className: "dialog__buttons"
  }, buttons.map(function (btn, i) {
    return React.createElement(Button, {
      key: i,
      onClick: btn.handler,
      className: "btn-square _conflower-blue ".concat(btn.className || "")
    }, btn.title);
  }));
};

Dialog.propTypes = {
  open: PropTypes__default.bool.isRequired,
  handleEnterKeyEvent: PropTypes__default.func
};
var css$n = ".nav-bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4.375rem;\n  background-color: #ffffff;\n  z-index: 50;\n  border-bottom: 0.0625rem solid #f4f4f4;\n  padding: 0 2rem; }\n  .nav-bar__wrapper {\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    padding-left: 0.6875rem; }\n    .nav-bar__wrapper-right {\n      display: flex;\n      align-items: center;\n      margin-left: auto; }\n  .nav-bar__title {\n    position: relative;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: 1.4375rem;\n    line-height: 1.21739em;\n    color: #787878 !important; }\n    .nav-bar__title a {\n      color: inherit;\n      text-decoration: none; }\n  .nav-bar__beta {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 .5rem;\n    min-width: 2.75rem;\n    height: 0.9375rem;\n    border-radius: .25rem;\n    background: #d8d8d8;\n    font-family: 'Lato Bold', sans-serif;\n    font-weight: 400;\n    font-size: 0.625rem;\n    line-height: 1.15;\n    color: #000;\n    text-transform: uppercase; }\n  .nav-bar__container {\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    height: 100%; }\n    .nav-bar__container .btn-circle {\n      margin: 0 2px; }\n  .nav-bar__content {\n    display: flex;\n    align-items: center;\n    flex-grow: 1; }\n  .nav-bar__profile {\n    width: 8.5625rem;\n    margin-left: 0.625rem;\n    border: 1px solid #f4f4f4;\n    border-radius: 0.5rem;\n    position: relative; }\n    .nav-bar__profile._focus {\n      box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15); }\n    .nav-bar__profile svg {\n      width: 3.75rem;\n      height: 1.5625rem; }\n    .nav-bar__profile-avatar {\n      width: 2.1875rem;\n      min-width: 2.1875rem;\n      height: 2.1875rem;\n      border-radius: 50%;\n      background-position: 50%;\n      background-size: 2.1875rem;\n      background-repeat: no-repeat;\n      background-color: initial; }\n    .nav-bar__profile-container {\n      display: flex;\n      align-items: center;\n      padding: 0.4375rem 0.8125rem;\n      cursor: pointer; }\n    .nav-bar__profile-logo {\n      margin-right: 0.875rem;\n      line-height: 0; }\n      .nav-bar__profile-logo img {\n        max-width: 100%; }\n  .nav-bar__circle-icon {\n    width: 2.1875rem;\n    height: 2.1875rem;\n    position: relative;\n    border-radius: 50%;\n    margin-right: 1rem; }\n    .nav-bar__circle-icon span {\n      display: block;\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      border-radius: 50%;\n      border-width: 0.3125rem;\n      border-style: solid;\n      border-color: transparent; }\n      .nav-bar__circle-icon span:nth-child(1) {\n        border-top-color: #ffa300; }\n      .nav-bar__circle-icon span:nth-child(2) {\n        border-top-color: #ff5859;\n        transform: rotate(90deg); }\n      .nav-bar__circle-icon span:nth-child(3) {\n        border-top-color: #3fd4ad;\n        transform: rotate(180deg); }\n      .nav-bar__circle-icon span:nth-child(4) {\n        border-top-color: #ffa300;\n        transform: rotate(270deg); }\n  .nav-bar__popup {\n    position: absolute;\n    right: 0;\n    display: flex;\n    transform: scale(0);\n    transition: transform 0.3s, opacity 0.3s;\n    opacity: 0;\n    top: 100%;\n    margin-top: 0.3125rem;\n    width: 22rem;\n    padding: 0;\n    background: transparent;\n    box-shadow: none; }\n    .nav-bar__popup._show {\n      transform: scale(1);\n      opacity: 1; }\n  .nav-bar__select {\n    width: 10.625rem; }\n    .nav-bar__select:not(:last-child) {\n      margin-right: 0.625rem; }\n  .nav-bar__search {\n    margin-right: 0.625rem;\n    width: 10.625rem; }\n  .nav-bar__create-report {\n    margin-left: auto; }\n    .nav-bar__create-report .icon {\n      margin-left: -0.25rem;\n      margin-right: 0.8125rem;\n      width: 1.25rem; }\n      .nav-bar__create-report .icon path:nth-child(1) {\n        fill: #fff; }\n";
styleInject(css$n);

var DefaultLogo = function DefaultLogo() {
  return React.createElement("div", {
    className: "nav-bar__circle-icon"
  }, React.createElement("span", null), React.createElement("span", null), React.createElement("span", null), React.createElement("span", null));
};

var DefaultBack = function DefaultBack(_ref) {
  var rest = _extends_1({}, _ref);

  return React.createElement(ButtonCircle, _extends_1({}, rest, {
    outline: true,
    iconName: "ArrowLeft"
  }));
};

var NavigationBar = /*#__PURE__*/function (_Component) {
  inherits(NavigationBar, _Component);

  function NavigationBar(props) {
    var _this;

    classCallCheck(this, NavigationBar);
    _this = possibleConstructorReturn(this, getPrototypeOf(NavigationBar).call(this, props));
    defineProperty(assertThisInitialized(_this), "preventOutsideClick", false);
    defineProperty(assertThisInitialized(_this), "handleClickOutsideProfile", function (e) {
      if (_this.profile && !_this.profile.contains(e.target) && _this.state.open && !_this.preventOutsideClick) {
        _this.togglePopup();
      }

      _this.preventOutsideClick = false;
    });
    defineProperty(assertThisInitialized(_this), "togglePopup", function () {
      var preventOutside = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var open = _this.state.open;

      _this.setState({
        open: !open
      });

      _this.preventOutsideClick = preventOutside;
    });
    _this.state = {
      open: false
    };
    return _this;
  }

  createClass(NavigationBar, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual(['backButton', 'className', 'title', 'leftActions', 'rightActions', 'leftLogo', 'profileLogo', 'profileAvatar'], this.props, nextProps) && isEqual(['open'], this.state, nextState));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutsideProfile);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutsideProfile);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          backButton = _this$props.backButton,
          backHandler = _this$props.backHandler,
          title = _this$props.title,
          leftLogo = _this$props.leftLogo,
          profileLogo = _this$props.profileLogo,
          profileAvatar = _this$props.profileAvatar,
          popupContent = _this$props.popupContent,
          isBeta = _this$props.isBeta,
          children = _this$props.children;
      var backComponent = null;

      if (backButton) {
        if (React.isValidElement(backButton)) {
          backComponent = backButton;
        } else {
          backComponent = React.createElement(DefaultBack, {
            onClick: backHandler
          });
        }
      }

      var open = this.state.open;
      return React.createElement("div", {
        className: "nav-bar ".concat(className)
      }, React.createElement("div", {
        className: "nav-bar__container"
      }, backComponent, leftLogo, React.createElement("h5", {
        className: "nav-bar__title"
      }, title, isBeta && React.createElement("span", {
        className: "nav-bar__beta"
      }, "beta")), React.createElement("div", {
        className: "nav-bar__content"
      }, children), React.createElement("div", {
        className: "nav-bar__right"
      }, React.createElement("div", {
        ref: function ref(el) {
          return _this2.profile = el;
        },
        className: "nav-bar__profile ".concat(open ? '_focus' : '')
      }, React.createElement(Tooltip, {
        label: "Account Info",
        position: "bottom",
        auto: false
      }, React.createElement("div", {
        className: "nav-bar__profile-container",
        onClick: this.togglePopup
      }, profileLogo, profileAvatar)), React.createElement("div", {
        className: "nav-bar__popup ".concat(open ? '_show' : '')
      }, popupContent)))));
    }
  }]);
  return NavigationBar;
}(Component);

NavigationBar.defaultProps = {
  backButton: true,
  backHandler: function backHandler() {},
  className: '',
  leftLogo: React.createElement(DefaultLogo, null),
  profileLogo: React.createElement(Logo, {
    animate: false,
    className: "nav-bar__profile-logo"
  }),
  profileAvatar: React.createElement("div", {
    className: "nav-bar__profile-avatar"
  }),
  popupContent: null,
  isBeta: false
};
NavigationBar.propTypes = {
  className: PropTypes__default.string,
  backButton: PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.element]),
  backHandler: PropTypes__default.func,
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]).isRequired,
  leftLogo: PropTypes__default.element,
  profileLogo: PropTypes__default.element,
  profileAvatar: PropTypes__default.element,
  popupContent: PropTypes__default.element,
  isBeta: PropTypes__default.bool
};
var css$o = ".pagination__list {\n  list-style: none;\n  display: flex; }\n\n.pagination__item {\n  margin-left: -1px;\n  user-select: none;\n  color: #787878;\n  background: #f4f4f4; }\n  .pagination__item_active {\n    background-color: #ffffff;\n    z-index: 1; }\n    .pagination__item_active .pagination__link {\n      color: #000000; }\n  .pagination__item_disabled .pagination__link {\n    cursor: not-allowed; }\n    .pagination__item_disabled .pagination__link_control:hover svg {\n      fill: #787878; }\n  .pagination__item:first-of-type .pagination__link {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px; }\n  .pagination__item:last-of-type .pagination__link {\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px; }\n\n.pagination__link {\n  padding: 6px 12px;\n  text-decoration: none;\n  color: #787878;\n  font-family: 'Lato Light', sans-serif;\n  font-weight: 400;\n  height: 100%;\n  min-width: 46px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #a2a2a2; }\n  .pagination__link_control {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #ffffff; }\n    .pagination__link_control svg {\n      fill: #787878;\n      width: 24px;\n      height: 24px; }\n    .pagination__link_control:hover svg {\n      fill: #000000; }\n  .pagination__link:hover {\n    color: #000000; }\n\n.pagination:hover .pagination__item_active .pagination__link {\n  border-right: 0.0625rem solid #3fd4ad;\n  border-color: #3fd4ad; }\n\n.pagination:hover .pagination__item .pagination__link {\n  border-top-color: #3fd4ad;\n  border-bottom-color: #3fd4ad; }\n\n.pagination:hover .pagination__item:first-of-type .pagination__link {\n  border-left-color: #3fd4ad; }\n\n.pagination:hover .pagination__item:last-of-type .pagination__link {\n  border-right-color: #3fd4ad; }\n\n.pagination:hover .pagination__item:not(.pagination__item_disabled) .pagination__link_control svg {\n  fill: #3fd4ad; }\n";
styleInject(css$o);

var Pagination = /*#__PURE__*/function (_PureComponent) {
  inherits(Pagination, _PureComponent);

  function Pagination() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(Pagination)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "handleOnChange", function (e, pageNumber) {
      e.preventDefault();
      var onChange = _this.props.onChange;
      onChange && onChange(pageNumber);
    });
    defineProperty(assertThisInitialized(_this), "handlePrev", function (e) {
      e.preventDefault();
      _this.hasPrev && _this.handleOnChange(e, 1);
    });
    defineProperty(assertThisInitialized(_this), "handleNext", function (e) {
      e.preventDefault();
      _this.hasNext && _this.handleOnChange(e, _this.pagesLength);
    });
    return _this;
  }

  createClass(Pagination, [{
    key: "getRange",
    value: function getRange() {
      var _this$props = this.props,
          pageRangeDisplayed = _this$props.pageRangeDisplayed,
          activePage = _this$props.activePage;
      var pagesLength = this.pagesLength;
      var middlePages = Math.floor(pageRangeDisplayed / 2);
      var startShift = 0;
      var endShift = 0;
      var start;
      var end;

      if (pagesLength <= pageRangeDisplayed) {
        start = 1;
        end = pagesLength;
      } else {
        start = Math.max(activePage - middlePages, 1);

        if (activePage - middlePages < 1) {
          endShift += Math.abs(activePage - middlePages) + 1;
        }

        end = Math.min(activePage + middlePages, pagesLength);

        if (activePage + middlePages > pagesLength) {
          startShift -= Math.abs(activePage + middlePages - pagesLength);
        }
      }

      var pages = [];

      for (var ii = start + startShift; ii <= end + endShift; ii++) {
        pages.push(ii);
      }

      return pages;
    }
  }, {
    key: "renderPages",
    value: function renderPages() {
      var _this2 = this;

      var activePage = this.props.activePage;
      var pages = this.getRange();
      return pages.map(function (number) {
        var active = number === activePage;
        return React.createElement("li", {
          key: number,
          className: "pagination__item ".concat(active ? 'pagination__item_active' : '')
        }, active ? React.createElement("span", {
          className: "pagination__link"
        }, number) : React.createElement("a", {
          href: "/",
          onClick: function onClick(e) {
            return _this2.handleOnChange(e, number);
          },
          className: "pagination__link"
        }, number));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "pagination"
      }, React.createElement("ul", {
        className: "pagination__list"
      }, React.createElement("li", {
        className: "pagination__item ".concat(!this.hasPrev ? 'pagination__item_disabled' : '')
      }, React.createElement("a", {
        className: "pagination__link pagination__link_control",
        href: "/",
        onClick: this.handlePrev
      }, React.createElement(Icon, {
        name: "Left"
      }))), this.renderPages(), React.createElement("li", {
        className: "pagination__item ".concat(!this.hasNext ? 'pagination__item_disabled' : '')
      }, React.createElement("a", {
        className: "pagination__link pagination__link_control",
        href: "/",
        onClick: this.handleNext
      }, React.createElement(Icon, {
        name: "Right"
      })))));
    }
  }, {
    key: "pagesLength",
    get: function get() {
      var _this$props2 = this.props,
          itemsCountPerPage = _this$props2.itemsCountPerPage,
          totalItemsCount = _this$props2.totalItemsCount;
      return Math.ceil(totalItemsCount / itemsCountPerPage);
    }
  }, {
    key: "hasPrev",
    get: function get() {
      var activePage = this.props.activePage;
      return activePage > 1;
    }
  }, {
    key: "hasNext",
    get: function get() {
      var activePage = this.props.activePage;
      return activePage < this.pagesLength;
    }
  }]);
  return Pagination;
}(PureComponent);

Pagination.defaultProps = {
  itemsCountPerPage: 10,
  activePage: 1,
  pageRangeDisplayed: 5
};
Pagination.propTypes = {
  activePage: PropTypes__default.number.isRequired,
  totalItemsCount: PropTypes__default.number.isRequired,
  itemsCountPerPage: PropTypes__default.number.isRequired,
  onChange: PropTypes__default.func.isRequired,
  pageRangeDisplayed: PropTypes__default.number
};
var InfiniteScroll_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function');
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
      throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var InfiniteScroll = function (_Component) {
    _inherits(InfiniteScroll, _Component);

    function InfiniteScroll(props) {
      _classCallCheck(this, InfiniteScroll);

      var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

      _this.scrollListener = _this.scrollListener.bind(_this);
      _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
      _this.mousewheelListener = _this.mousewheelListener.bind(_this);
      return _this;
    }

    _createClass(InfiniteScroll, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.pageLoaded = this.props.pageStart;
        this.options = this.eventListenerOptions();
        this.attachScrollListener();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        if (this.props.isReverse && this.loadMore) {
          var parentElement = this.getParentElement(this.scrollComponent);
          parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
          this.loadMore = false;
        }

        this.attachScrollListener();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.detachScrollListener();
        this.detachMousewheelListener();
      }
    }, {
      key: 'isPassiveSupported',
      value: function isPassiveSupported() {
        var passive = false;
        var testOptions = {
          get passive() {
            passive = true;
          }

        };

        try {
          document.addEventListener('test', null, testOptions);
          document.removeEventListener('test', null, testOptions);
        } catch (e) {// ignore
        }

        return passive;
      }
    }, {
      key: 'eventListenerOptions',
      value: function eventListenerOptions() {
        var options = this.props.useCapture;

        if (this.isPassiveSupported()) {
          options = {
            useCapture: this.props.useCapture,
            passive: true
          };
        }

        return options;
      } // Set a defaut loader for all your `InfiniteScroll` components

    }, {
      key: 'setDefaultLoader',
      value: function setDefaultLoader(loader) {
        this.defaultLoader = loader;
      }
    }, {
      key: 'detachMousewheelListener',
      value: function detachMousewheelListener() {
        var scrollEl = window;

        if (this.props.useWindow === false) {
          scrollEl = this.scrollComponent.parentNode;
        }

        scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
      }
    }, {
      key: 'detachScrollListener',
      value: function detachScrollListener() {
        var scrollEl = window;

        if (this.props.useWindow === false) {
          scrollEl = this.getParentElement(this.scrollComponent);
        }

        scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
        scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
      }
    }, {
      key: 'getParentElement',
      value: function getParentElement(el) {
        var scrollParent = this.props.getScrollParent && this.props.getScrollParent(el);

        if (scrollParent != null) {
          return scrollParent;
        }

        return el && el.parentNode;
      }
    }, {
      key: 'filterProps',
      value: function filterProps(props) {
        return props;
      }
    }, {
      key: 'attachScrollListener',
      value: function attachScrollListener() {
        var parentElement = this.getParentElement(this.scrollComponent);

        if (!this.props.hasMore || !parentElement) {
          return;
        }

        var scrollEl = window;

        if (this.props.useWindow === false) {
          scrollEl = parentElement;
        }

        scrollEl.addEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
        scrollEl.addEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
        scrollEl.addEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);

        if (this.props.initialLoad) {
          this.scrollListener();
        }
      }
    }, {
      key: 'mousewheelListener',
      value: function mousewheelListener(e) {
        // Prevents Chrome hangups
        // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
        if (e.deltaY === 1 && !this.isPassiveSupported()) {
          e.preventDefault();
        }
      }
    }, {
      key: 'scrollListener',
      value: function scrollListener() {
        var el = this.scrollComponent;
        var scrollEl = window;
        var parentNode = this.getParentElement(el);
        var offset = void 0;

        if (this.props.useWindow) {
          var doc = document.documentElement || document.body.parentNode || document.body;
          var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;

          if (this.props.isReverse) {
            offset = scrollTop;
          } else {
            offset = this.calculateOffset(el, scrollTop);
          }
        } else if (this.props.isReverse) {
          offset = parentNode.scrollTop;
        } else {
          offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
        } // Here we make sure the element is visible as well as checking the offset


        if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
          this.detachScrollListener();
          this.beforeScrollHeight = parentNode.scrollHeight;
          this.beforeScrollTop = parentNode.scrollTop; // Call loadMore after detachScrollListener to allow for non-async loadMore functions

          if (typeof this.props.loadMore === 'function') {
            this.props.loadMore(this.pageLoaded += 1);
            this.loadMore = true;
          }
        }
      }
    }, {
      key: 'calculateOffset',
      value: function calculateOffset(el, scrollTop) {
        if (!el) {
          return 0;
        }

        return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
      }
    }, {
      key: 'calculateTopPosition',
      value: function calculateTopPosition(el) {
        if (!el) {
          return 0;
        }

        return el.offsetTop + this.calculateTopPosition(el.offsetParent);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var renderProps = this.filterProps(this.props);

        var children = renderProps.children,
            element = renderProps.element,
            hasMore = renderProps.hasMore,
            initialLoad = renderProps.initialLoad,
            isReverse = renderProps.isReverse,
            loader = renderProps.loader,
            loadMore = renderProps.loadMore,
            pageStart = renderProps.pageStart,
            ref = renderProps.ref,
            threshold = renderProps.threshold,
            useCapture = renderProps.useCapture,
            useWindow = renderProps.useWindow,
            getScrollParent = renderProps.getScrollParent,
            props = _objectWithoutProperties(renderProps, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'ref', 'threshold', 'useCapture', 'useWindow', 'getScrollParent']);

        props.ref = function (node) {
          _this2.scrollComponent = node;

          if (ref) {
            ref(node);
          }
        };

        var childrenArray = [children];

        if (hasMore) {
          if (loader) {
            isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
          } else if (this.defaultLoader) {
            isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
          }
        }

        return _react2.default.createElement(element, props, childrenArray);
      }
    }]);

    return InfiniteScroll;
  }(React.Component);

  InfiniteScroll.propTypes = {
    children: _propTypes2.default.node.isRequired,
    element: _propTypes2.default.node,
    hasMore: _propTypes2.default.bool,
    initialLoad: _propTypes2.default.bool,
    isReverse: _propTypes2.default.bool,
    loader: _propTypes2.default.node,
    loadMore: _propTypes2.default.func.isRequired,
    pageStart: _propTypes2.default.number,
    ref: _propTypes2.default.func,
    getScrollParent: _propTypes2.default.func,
    threshold: _propTypes2.default.number,
    useCapture: _propTypes2.default.bool,
    useWindow: _propTypes2.default.bool
  };
  InfiniteScroll.defaultProps = {
    element: 'div',
    hasMore: false,
    initialLoad: true,
    pageStart: 0,
    ref: null,
    threshold: 250,
    useWindow: true,
    isReverse: false,
    useCapture: false,
    loader: null,
    getScrollParent: null
  };
  exports.default = InfiniteScroll;
  module.exports = exports['default'];
});
unwrapExports(InfiniteScroll_1);
var reactInfiniteScroller = InfiniteScroll_1;
var css$p = ".title-main {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 3rem;\n  text-transform: capitalize;\n  color: #787878; }\n\n.title-main-subtitle {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 2.25rem;\n  text-transform: uppercase;\n  color: #ff5859; }\n\n.title-form {\n  font-family: 'Lato Black', sans-serif;\n  font-weight: 400;\n  font-size: 1.25rem;\n  text-transform: uppercase;\n  color: #3fd4ad; }\n\n.title-form-subtitle {\n  font-family: 'Lato Light', sans-serif;\n  font-weight: 400;\n  font-size: 2rem;\n  color: #000000; }\n\n.title-card {\n  font-family: 'Lato Medium', sans-serif;\n  font-weight: 400;\n  font-size: 1.5rem;\n  line-height: 1.375em;\n  color: #000000; }\n\n.title-card-subtitle {\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  color: #787878; }\n\n.paragraph {\n  margin-bottom: 1.5rem;\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.78947em;\n  color: #787878; }\n  .paragraph_large {\n    font-size: 1.5rem; }\n\n.table {\n  position: relative;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch; }\n  .table__header_fixed {\n    position: -webkit-sticky;\n    /* Safari */\n    position: sticky;\n    background-color: white;\n    z-index: 15; }\n  .table__top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.75rem 0;\n    padding-left: 1.25rem;\n    min-height: 44px; }\n  .table__paging {\n    display: flex;\n    align-items: center;\n    padding-bottom: 5px; }\n    .table__paging .pagination__list {\n      margin: 0;\n      padding: 0; }\n    .table__paging .select {\n      width: 80px;\n      margin-left: 10px; }\n    .table__paging .select__control__control {\n      max-height: 38px;\n      min-height: 38px;\n      padding: 0 10px 0 10px; }\n    .table__paging .select__control__menu {\n      z-index: 100; }\n    .table__paging .select__control__option {\n      padding: 0 10px 0 10px; }\n    .table__paging .select__control__dropdown-indicator {\n      right: 5px; }\n";
styleInject(css$p);
var css$q = ".context-menu__button {\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: none; }\n  .context-menu__button:focus {\n    outline: none; }\n\n.context-menu {\n  position: fixed;\n  z-index: 500;\n  min-width: 200px;\n  background: #f4f4f4;\n  box-shadow: 0 0 17px 1px rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n  padding: 0;\n  overflow: hidden;\n  border: 1px solid #6075fe; }\n  .context-menu__list {\n    margin: 0;\n    padding: 0;\n    list-style: none; }\n    .context-menu__list-item:not(._with-btn) {\n      padding: 5px 12px; }\n    .context-menu__list-item:not(._title) {\n      font-size: 14px;\n      line-height: 16px;\n      cursor: pointer; }\n      .context-menu__list-item:not(._title):hover {\n        background-color: #cbcbcb; }\n    .context-menu__list-item._title {\n      border: none;\n      border-bottom: 1px solid #cbcbcb;\n      background-color: #f4f4f4; }\n  .context-menu__list-divider {\n    margin: 4px 0;\n    border-top: 1px solid #cbcbcb; }\n  .context-menu__title {\n    font-family: 'Lato Medium', sans-serif;\n    font-weight: 400;\n    color: #000000;\n    border-top-right-radius: 8px;\n    border-top-left-radius: 8px; }\n  .context-menu__button {\n    padding: 5px 12px;\n    width: 100%;\n    cursor: pointer;\n    font-family: 'Lato Light', sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    color: black;\n    text-align: left; }\n";
styleInject(css$q);

var ContextMenuComponent = /*#__PURE__*/function (_PureComponent) {
  inherits(ContextMenuComponent, _PureComponent);

  function ContextMenuComponent(props) {
    var _this;

    classCallCheck(this, ContextMenuComponent);
    _this = possibleConstructorReturn(this, getPrototypeOf(ContextMenuComponent).call(this, props));
    defineProperty(assertThisInitialized(_this), "calcPosition", function () {
      var _this$props = _this.props,
          clientX = _this$props.clientX,
          clientY = _this$props.clientY;

      var menuCoord = _this.menu.getBoundingClientRect();

      var clientWidth = window.innerWidth;
      var clientHeight = window.innerHeight;
      var diffX = clientWidth - (menuCoord.width + clientX);
      var diffY = clientHeight - (menuCoord.height + clientY);

      _this.setState({
        position: {
          left: "".concat(diffX < 0 ? clientX + diffX : clientX, "px"),
          top: "".concat(diffY < 0 ? clientY + diffY : clientY, "px")
        }
      });
    });
    _this.state = {
      position: {
        left: 0,
        top: 0
      }
    };
    return _this;
  }

  createClass(ContextMenuComponent, [{
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.props.onClose();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calcPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.clientX !== this.props.clientX || prevProps.clientY !== this.props.clientY) {
        this.calcPosition();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          children = _this$props2.children;
      return React.createElement("div", {
        className: "context-menu ".concat(className),
        ref: function ref(el) {
          return _this2.menu = el;
        },
        style: this.state.position
      }, children);
    }
  }]);
  return ContextMenuComponent;
}(PureComponent);

var ContextMenu = withClickOutside(ContextMenuComponent);
ContextMenuComponent.propTypes = {
  clientX: PropTypes__default.number.isRequired,
  clientY: PropTypes__default.number.isRequired,
  onClose: PropTypes__default.func.isRequired,
  className: PropTypes__default.string
};
ContextMenu.propTypes = {
  clientX: PropTypes__default.number.isRequired,
  clientY: PropTypes__default.number.isRequired,
  onClose: PropTypes__default.func.isRequired,
  className: PropTypes__default.string
};

var ContextMenuList = function ContextMenuList(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      rest = objectWithoutProperties(_ref, ["className", "children"]);
  return React.createElement("ul", _extends_1({
    className: "context-menu__list ".concat(className)
  }, rest), children);
};

ContextMenuList.propTypes = {
  className: PropTypes__default.string
};

var ContextMenuListDivider = function ContextMenuListDivider(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      rest = objectWithoutProperties(_ref, ["children", "className"]);
  return React.createElement("li", _extends_1({
    className: "context-menu__list-divider ".concat(className)
  }, rest), children);
};

var ContextMenuListItem = function ContextMenuListItem(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? false : _ref$title,
      rest = objectWithoutProperties(_ref, ["className", "children", "title"]);
  var content;

  if (title) {
    content = React.createElement("div", {
      className: "context-menu__title"
    }, children);
  } else {
    content = children;
  }

  return React.createElement("li", _extends_1({
    className: "context-menu__list-item ".concat(title ? '_title' : '', " ").concat(className)
  }, rest), content);
};

ContextMenuListItem.propTypes = {
  title: PropTypes__default.bool,
  className: PropTypes__default.string
};

var TableContextMenuComponent = /*#__PURE__*/function (_PureComponent) {
  inherits(TableContextMenuComponent, _PureComponent);

  function TableContextMenuComponent() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, TableContextMenuComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(TableContextMenuComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "handleFreezeRows", function (number) {
      var row = _this.props.row;

      _this.props.onFreezeRow(row, number);
    });
    defineProperty(assertThisInitialized(_this), "handleFreezeColumns", function (number) {
      var column = _this.props.column;

      _this.props.onFreezeColumn(column, number);
    });
    return _this;
  }

  createClass(TableContextMenuComponent, [{
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.props.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          rowNumber = _this$props.rowNumber,
          colNumber = _this$props.colNumber,
          _this$props$unsortedD = _this$props.unsortedDataLength,
          unsortedDataLength = _this$props$unsortedD === void 0 ? 0 : _this$props$unsortedD,
          _this$props$hasTableC = _this$props.hasTableCheckboxColumn,
          hasTableCheckboxColumn = _this$props$hasTableC === void 0 ? false : _this$props$hasTableC;
      var rowNumberDisplay = rowNumber + 1; // starts from 0

      var colNumberDisplay = colNumber + 1; // starts from 0
      // correction of freeze columns real number

      var freezeColumnsCorrection = hasTableCheckboxColumn ? 1 : 0;
      return React.createElement(ContextMenu, {
        clientX: this.props.clientX,
        clientY: this.props.clientY,
        onClose: this.props.onClose
      }, React.createElement(ContextMenuList, null, React.createElement(ContextMenuListItem, {
        title: true
      }, "Freeze"), React.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, React.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeRows(0);
        }
      }, "No rows")), React.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, React.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeRows(1 + unsortedDataLength);
        }
      }, "1 Row")), React.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, React.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeRows(2 + unsortedDataLength);
        }
      }, "2 Rows")), React.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, React.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeRows(rowNumberDisplay <= unsortedDataLength ? unsortedDataLength + 1 : rowNumberDisplay);
        }
      }, "Up to Current Row (", rowNumberDisplay - unsortedDataLength > 0 ? rowNumberDisplay - unsortedDataLength : 1, ")")), React.createElement(ContextMenuListDivider, null), React.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, React.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeColumns(0);
        }
      }, "No Columns")), React.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, React.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeColumns(1 + freezeColumnsCorrection);
        }
      }, "1 Column")), React.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, React.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeColumns(2 + freezeColumnsCorrection);
        }
      }, "2 Columns")), colNumberDisplay - freezeColumnsCorrection > 0 && React.createElement(ContextMenuListItem, {
        className: "_with-btn"
      }, React.createElement("button", {
        className: "context-menu__button",
        onClick: function onClick() {
          return _this2.handleFreezeColumns(colNumberDisplay);
        }
      }, "Up to Current Column (", colNumberDisplay - freezeColumnsCorrection, ")"))));
    }
  }]);
  return TableContextMenuComponent;
}(PureComponent);

var TableContextMenu = withClickOutside(TableContextMenuComponent);
TableContextMenuComponent.propTypes = {
  row: PropTypes__default.object,
  rowNumber: PropTypes__default.number,
  colNumber: PropTypes__default.number,
  clientX: PropTypes__default.number,
  clientY: PropTypes__default.number,
  onClose: PropTypes__default.func,
  onFreezeRow: PropTypes__default.func,
  onFreezeColumn: PropTypes__default.func,
  unsortedDataLength: PropTypes__default.number,
  hasTableCheckboxColumn: PropTypes__default.bool
};
var tablePropTypes = {
  paging: PropTypes__default.shape({
    activePage: PropTypes__default.number.isRequired,
    totalItemsCount: PropTypes__default.number.isRequired,
    itemsCountPerPage: PropTypes__default.oneOf([10, 25, 50, 100]).isRequired,
    pageRangeDisplayed: PropTypes__default.number
  }),
  body: PropTypes__default.arrayOf(PropTypes__default.shape({
    key: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.func, PropTypes__default.number]),
    hover: PropTypes__default.func,
    className: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.func]),
    classNameHover: PropTypes__default.string
  })),
  header: PropTypes__default.arrayOf(PropTypes__default.shape({
    label: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.elementType]),
    className: PropTypes__default.string,
    sortingKey: PropTypes__default.string,
    compareFunc: PropTypes__default.func,
    draggableGroup: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number])
  })),
  freeze: PropTypes__default.shape({
    rows: PropTypes__default.number,
    columns: PropTypes__default.number
  }),
  sorting: PropTypes__default.shape({
    field: PropTypes__default.string,
    direction: PropTypes__default.oneOf(['asc', 'desc']),
    compareFunc: PropTypes__default.func
  })
};

var TablePaging = /*#__PURE__*/function (_Component) {
  inherits(TablePaging, _Component);

  function TablePaging() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, TablePaging);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(TablePaging)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "perPageValues", [10, 25, 50, 100].map(function (v) {
      return {
        label: v,
        value: v
      };
    }));
    defineProperty(assertThisInitialized(_this), "perPageMap", {
      10: _this.perPageValues[0],
      25: _this.perPageValues[1],
      50: _this.perPageValues[2],
      100: _this.perPageValues[3]
    });
    defineProperty(assertThisInitialized(_this), "handlePaginationChange", function (page) {
      _this.props.onPaginationChanged(page);
    });
    defineProperty(assertThisInitialized(_this), "handlePerPageChange", function (data) {
      _this.props.onPerPageChanged(data);
    });
    return _this;
  }

  createClass(TablePaging, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !(nextProps.paging === this.props.paging);
    }
  }, {
    key: "render",
    value: function render() {
      var paging = this.props.paging;
      var itemsCountPerPage = paging.itemsCountPerPage,
          totalItemsCount = paging.totalItemsCount;
      var showPagination = itemsCountPerPage < totalItemsCount;
      return React.createElement("div", {
        className: "table__paging"
      }, showPagination && React.createElement(Pagination, _extends_1({}, paging, {
        onChange: this.handlePaginationChange
      })), React.createElement(Select, {
        options: this.perPageValues,
        value: this.perPageMap[paging.itemsCountPerPage],
        onChange: this.handlePerPageChange
      }));
    }
  }]);
  return TablePaging;
}(Component);

TablePaging.propTypes = {
  paging: tablePropTypes.paging,
  onPaginationChanged: PropTypes__default.func.isRequired,
  onPerPageChanged: PropTypes__default.func.isRequired
};

var TableHeader = /*#__PURE__*/function (_Component) {
  inherits(TableHeader, _Component);

  function TableHeader() {
    classCallCheck(this, TableHeader);
    return possibleConstructorReturn(this, getPrototypeOf(TableHeader).apply(this, arguments));
  }

  createClass(TableHeader, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !(nextProps.title === this.props.title && nextProps.fixedHeader === this.props.fixedHeader && nextProps.paging === this.props.paging);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          _this$props$fixedHead = _this$props.fixedHeader,
          fixedHeader = _this$props$fixedHead === void 0 ? '' : _this$props$fixedHead,
          innerRef = _this$props.innerRef,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          paging = _this$props.paging,
          onPaginationChanged = _this$props.onPaginationChanged,
          onPerPageChanged = _this$props.onPerPageChanged;
      var classNames = ['table__header', fixedHeader ? 'table__header_fixed' : ''];
      return React.createElement("div", {
        className: classNames.join(' ').trim(),
        ref: innerRef,
        style: style
      }, React.createElement("div", {
        className: "table__top"
      }, React.createElement("div", {
        className: "table__title title-card"
      }, title), paging && React.createElement(TablePaging, {
        paging: paging,
        onPaginationChanged: onPaginationChanged,
        onPerPageChanged: onPerPageChanged
      })));
    }
  }]);
  return TableHeader;
}(Component);

TableHeader.propTypes = {
  title: PropTypes__default.string,
  fixedHeader: PropTypes__default.bool,
  innerRef: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.shape({
    current: PropTypes__default.instanceOf(window.Element)
  })]),
  style: PropTypes__default.object,
  paging: tablePropTypes.paging,
  onPaginationChanged: PropTypes__default.func.isRequired,
  onPerPageChanged: PropTypes__default.func.isRequired
};

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var TdInner = function TdInner(_ref) {
  var children = _ref.children,
      tooltip = _ref.tooltip,
      isUnsorted = _ref.isUnsorted,
      tbodyRowHeight = _ref.tbodyRowHeight;
  var tdContentProps = {
    style: {
      height: "".concat(tbodyRowHeight, "px")
    },
    className: 'td-content'
  };
  return tooltip && !isUnsorted ? React.createElement(Tooltip, _extends_1({}, tdContentProps, {
    label: tooltip
  }), children) : React.createElement("div", tdContentProps, children);
};

var TableCell = /*#__PURE__*/function (_Component) {
  inherits(TableCell, _Component);

  function TableCell() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, TableCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(TableCell)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "state", {
      isTdClicked: false,
      hasTitle: undefined
    });
    defineProperty(assertThisInitialized(_this), "handleTdClick", function () {
      if (_this.props.field.click && !_this.state.isTdClicked) {
        _this.setState({
          isTdClicked: true
        }, function () {
          window.addEventListener('click', _this.handleWindowClick);
          window.addEventListener('keydown', _this.handleKeyDown);
          _this.innerClickElement && _this.innerClickElement.focus();
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "handleWindowClick", function (_ref2) {
      var target = _ref2.target;

      if (!(target === _this.td || _this.td.contains(target))) {
        _this.deactivateCell();
      }
    });
    defineProperty(assertThisInitialized(_this), "deactivateCell", function () {
      window.removeEventListener('click', _this.handleWindowClick);
      window.removeEventListener('keydown', _this.handleKeyDown);

      _this.setState({
        isTdClicked: false
      });
    });
    defineProperty(assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (e.key === 'Escape' || e.key === 'Enter') {
        _this.deactivateCell();
      }
    });
    defineProperty(assertThisInitialized(_this), "handleMouseEnter", function () {
      _this.setTitle();
    });
    defineProperty(assertThisInitialized(_this), "setTitle", function () {
      if (_this.tdElement && _this.tdElement.offsetWidth < _this.tdElement.scrollWidth) {
        !_this.state.hasTitle && _this.setState({
          hasTitle: true
        });
      } else {
        _this.state.hasTitle && _this.setState({
          hasTitle: false
        });
      }
    });
    return _this;
  }

  createClass(TableCell, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var isTotalCheckboxEqual = true;

      if (this.props.data.total) {
        isTotalCheckboxEqual = isEqual(['isAllSelected', 'isSomeSelected'], this.props, nextProps);
      }

      return !(isEqual(['field', 'data', 'colIndex', 'onContextMenu', 'rowIndex', 'freezeColumns', 'tdOnMouseOver', 'tdOnMouseLeave', 'isSkeleton', 'tbodyRowHeight'], this.props, nextProps) && isEqual(['isTdClicked', 'hasTitle'], this.state, nextState) && isTotalCheckboxEqual);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          field = _this$props.field,
          data = _this$props.data,
          colIndex = _this$props.colIndex,
          _onContextMenu = _this$props.onContextMenu,
          rowIndex = _this$props.rowIndex,
          freezeColumns = _this$props.freezeColumns,
          tdOnMouseOver = _this$props.tdOnMouseOver,
          tdOnMouseLeave = _this$props.tdOnMouseLeave,
          isSkeleton = _this$props.isSkeleton,
          tbodyRowHeight = _this$props.tbodyRowHeight;
      var _this$state = this.state,
          isTdClicked = _this$state.isTdClicked,
          hasTitle = _this$state.hasTitle;
      var classNames = [];

      if (field.className) {
        classNames.push(typeof field.className === 'function' ? field.className(data, field) : field.className);
      }

      if (isTdClicked) {
        classNames.push('_clicked');
      }

      var isUnsorted = data.rowClassName && data.rowClassName.indexOf('tr-unsorted') !== -1;
      var childrenProps = {};
      var clickElement;

      if (field.click) {
        clickElement = field.click(data, field);

        if (clickElement && field.isFocusOnClick) {
          var refName = field.clickFocusRefPropName || 'ref';
          childrenProps = defineProperty({}, refName, function (el) {
            _this2.innerClickElement = el;
          });
        }
      }

      var tdContent;

      if (!isSkeleton) {
        tdContent = typeof field.key === 'function' ? field.key(data, field) : data[field.key];
      }

      var tdProps = {
        className: classNames.join(' '),
        style: {
          height: "".concat(tbodyRowHeight, "px")
        }
      };

      if (!isSkeleton) {
        tdProps = _objectSpread$4({}, tdProps, {
          ref: function ref(el) {
            _this2.td = el;
          },
          key: colIndex,
          onContextMenu: function onContextMenu(e) {
            _onContextMenu(e, data, rowIndex, colIndex + freezeColumns);
          },
          onMouseOver: function onMouseOver(_ref3) {
            var target = _ref3.target;
            var el = target.closest('td'); // to overcome bug when EditableText Dialog is created through Portal

            if (el) {
              tdOnMouseOver(colIndex + freezeColumns);
            }
          },
          onMouseLeave: function onMouseLeave() {
            return tdOnMouseLeave();
          },
          onClick: this.handleTdClick,
          onMouseEnter: this.handleMouseEnter,
          title: hasTitle ? typeof tdContent === 'string' ? tdContent : undefined : undefined
        });
      }

      var tdContentProps = {
        style: {
          height: "".concat(tbodyRowHeight, "px")
        }
      };
      return React.createElement("td", tdProps, !isSkeleton ? React.createElement(React.Fragment, null, field.hover && React.createElement("div", _extends_1({}, tdContentProps, {
        className: "td-content _hover"
      }), React.createElement("div", {
        className: "td-content-inner"
      }, field.hover(data, field))), React.isValidElement(clickElement) && React.createElement("div", _extends_1({}, tdContentProps, {
        className: "td-content _click"
      }), React.createElement("div", {
        className: "td-content-inner"
      }, React.cloneElement(clickElement, childrenProps))), React.createElement(TdInner, {
        tooltip: field.tooltip,
        isUnsorted: isUnsorted,
        tbodyRowHeight: tbodyRowHeight
      }, React.createElement("div", {
        className: "td-content-inner",
        ref: function ref(el) {
          _this2.tdElement = el;
        }
      }, tdContent))) : React.createElement(TdInner, {
        tbodyRowHeight: tbodyRowHeight
      }, React.createElement("div", {
        className: "td-content-inner",
        style: {
          width: '100%'
        }
      }, React.createElement("div", {
        className: "skeleton-block",
        style: {
          width: '100%',
          height: "".concat(17 / 16, "rem")
        }
      }))));
    }
  }]);
  return TableCell;
}(Component);

TdInner.propTypes = {
  tooltip: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  isUnsorted: PropTypes__default.bool
};
TableCell.propTypes = {
  rowIndex: PropTypes__default.number,
  data: PropTypes__default.any,
  onContextMenu: PropTypes__default.func,
  colIndex: PropTypes__default.number,
  freezeColumns: PropTypes__default.number,
  tdOnMouseOver: PropTypes__default.func,
  tdOnMouseLeave: PropTypes__default.func,
  field: PropTypes__default.object,
  isSkeleton: PropTypes__default.bool,
  tbodyRowHeight: PropTypes__default.number
};

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var TableRow = /*#__PURE__*/function (_Component) {
  inherits(TableRow, _Component);

  function TableRow() {
    classCallCheck(this, TableRow);
    return possibleConstructorReturn(this, getPrototypeOf(TableRow).apply(this, arguments));
  }

  createClass(TableRow, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var isEqualRowIndex = true;

      if (this.props.rowIndex === this.props.hoveredRowIndex) {
        if (this.props.rowIndex !== nextProps.hoveredRowIndex) {
          isEqualRowIndex = false;
        }
      } else if (this.props.rowIndex === nextProps.hoveredRowIndex) {
        isEqualRowIndex = false;
      }

      return !(isEqual(['rowIndex', 'freezeColumns', 'onContextMenu', 'rowClickHandler', 'isAllSelected', 'isSomeSelected', 'isSkeleton'], this.props, nextProps) && isEqual$1(nextProps.data, this.props.data) && isEqual$1(nextProps.body, this.props.body) && isEqualRowIndex);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rowIndex = _this$props.rowIndex,
          data = _this$props.data,
          body = _this$props.body,
          _this$props$freezeCol = _this$props.freezeColumns,
          freezeColumns = _this$props$freezeCol === void 0 ? 0 : _this$props$freezeCol,
          onContextMenu = _this$props.onContextMenu,
          rowClickHandler = _this$props.rowClickHandler,
          hoveredRowIndex = _this$props.hoveredRowIndex,
          trOnMouseEnter = _this$props.trOnMouseEnter,
          trOnMouseLeave = _this$props.trOnMouseLeave,
          tdOnMouseOver = _this$props.tdOnMouseOver,
          tdOnMouseLeave = _this$props.tdOnMouseLeave,
          isSkeleton = _this$props.isSkeleton,
          tbodyRowHeight = _this$props.tbodyRowHeight,
          isAllSelected = _this$props.isAllSelected,
          isSomeSelected = _this$props.isSomeSelected;
      var trProps;

      if (!isSkeleton) {
        trProps = {
          onClick: function onClick(e) {
            return rowClickHandler(e, data, rowIndex);
          },
          className: "".concat(hoveredRowIndex === rowIndex ? 'tr-hover' : '', " ").concat(data.rowClassName || ''),
          onMouseEnter: trOnMouseEnter,
          onMouseLeave: trOnMouseLeave
        };
      } else {
        trProps = {
          className: "loader"
        };
      }

      return React.createElement("tr", trProps, body.map(function (field, colIndex) {
        var tdProps = {
          field: field,
          data: data,
          tbodyRowHeight: tbodyRowHeight
        };

        if (!isSkeleton) {
          tdProps = _objectSpread$5({}, tdProps, {
            colIndex: colIndex,
            onContextMenu: onContextMenu,
            rowIndex: rowIndex,
            freezeColumns: freezeColumns,
            tdOnMouseOver: tdOnMouseOver,
            tdOnMouseLeave: tdOnMouseLeave,
            isAllSelected: isAllSelected,
            isSomeSelected: isSomeSelected
          });
        } else {
          tdProps = _objectSpread$5({}, tdProps, {
            isSkeleton: true
          });
        }

        return React.createElement(TableCell, _extends_1({}, tdProps, {
          key: colIndex
        }));
      }));
    }
  }]);
  return TableRow;
}(Component);

TableRow.propTypes = {
  body: tablePropTypes.body,
  freeze: tablePropTypes.freeze,
  rowIndex: PropTypes__default.number,
  data: PropTypes__default.any,
  onContextMenu: PropTypes__default.func,
  rowClickHandler: PropTypes__default.func,
  freezeColumns: PropTypes__default.number,
  hoveredRowIndex: PropTypes__default.number,
  trOnMouseEnter: PropTypes__default.func,
  trOnMouseLeave: PropTypes__default.func,
  tdOnMouseOver: PropTypes__default.func,
  tdOnMouseLeave: PropTypes__default.func,
  isSkeleton: PropTypes__default.bool,
  tbodyRowHeight: PropTypes__default.number
};
var SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc'
};

var TableHeaderRow = /*#__PURE__*/function (_Component) {
  inherits(TableHeaderRow, _Component);

  function TableHeaderRow(props) {
    var _this;

    classCallCheck(this, TableHeaderRow);
    _this = possibleConstructorReturn(this, getPrototypeOf(TableHeaderRow).call(this, props));
    defineProperty(assertThisInitialized(_this), "_startDragIndex", null);
    defineProperty(assertThisInitialized(_this), "_endDragIndex", null);
    defineProperty(assertThisInitialized(_this), "_dragItem", null);
    defineProperty(assertThisInitialized(_this), "handleDragStart", function (item, index) {
      return function (e) {
        _this._startDragIndex = index;
        _this._dragItem = item;

        _this.setState({
          startDragIndex: index,
          draggableGroup: item.draggableGroup
        });
      };
    });
    defineProperty(assertThisInitialized(_this), "handleDragOver", function (item, index) {
      return function (e) {
        if (_this._endDragIndex === index) {
          return;
        }

        if (_this._dragItem && _this._dragItem.draggableGroup) {
          if (_this._startDragIndex !== index && _this._dragItem.draggableGroup === item.draggableGroup) {
            _this._endDragIndex = index;

            _this.setState({
              endDragIndex: index
            });
          }
        } else if (_this._startDragIndex !== index && _this._dragItem && !item.draggableGroup) {
          _this._endDragIndex = index;

          _this.setState({
            endDragIndex: index
          });
        }
      };
    });
    defineProperty(assertThisInitialized(_this), "handleDragEnd", function () {
      _this.props.onDragEnd(_this._dragItem, {
        start: _this._startDragIndex,
        end: _this._endDragIndex
      });

      _this._startDragIndex = null;
      _this._endDragIndex = null;
      _this._dragItem = null;

      _this.setState({
        startDragIndex: null,
        endDragIndex: null,
        draggableGroup: null
      });
    });
    _this.state = {
      startDragIndex: null,
      endDragIndex: null
    };
    return _this;
  }

  createClass(TableHeaderRow, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(isEqual$1(nextProps.header, this.props.header) && nextProps.sorting === this.props.sorting && nextProps.hoveredColIndex === this.props.hoveredColIndex && isEqual(['startDragIndex', 'endDragIndex'], this.state, nextState));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          header = _this$props.header,
          sorting = _this$props.sorting,
          onSortingChanged = _this$props.onSortingChanged,
          draggable = _this$props.draggable,
          hoveredColIndex = _this$props.hoveredColIndex,
          theadRowHeight = _this$props.theadRowHeight,
          handleTheadOnMouseEnterLeave = _this$props.handleTheadOnMouseEnterLeave,
          freezeColumns = _this$props.freezeColumns;
      var _this$state = this.state,
          startDragIndex = _this$state.startDragIndex,
          endDragIndex = _this$state.endDragIndex,
          draggableGroup = _this$state.draggableGroup;

      if (!header || !header.length) {
        return null;
      }

      return React.createElement("tr", null, header.map(function (h, i) {
        var className = h.className,
            label = h.label,
            tooltip = h.tooltip;
        var hasSort = sorting && h.sorting !== false && h.sortingKey;
        var sortIcon;
        var attrs = {};

        if (hasSort) {
          attrs.onClick = function () {
            return onSortingChanged(h);
          };

          if (h.sortingKey !== sorting.field) {
            sortIcon = React.createElement(Icon, {
              className: "sort-icon_default",
              name: "UnfoldMore"
            });
          } else if (sorting.direction === SORT_DIRECTION.ASC) {
            sortIcon = React.createElement(Icon, {
              className: "sort-icon_default",
              name: "ArrowUp"
            });
          } else {
            sortIcon = React.createElement(Icon, {
              className: "sort-icon_default",
              name: "ArrowDown"
            });
          }
        }

        var classNames = [className || ''];

        if (hasSort) {
          classNames.push('_sorting');
        }

        if (draggable && h.draggable !== false) {
          attrs.draggable = true;
          attrs.onDragStart = _this2.handleDragStart(h, i);
          attrs.onDragOver = _this2.handleDragOver(h, i);
          attrs.onDragEnd = _this2.handleDragEnd;

          if (endDragIndex === i) {
            classNames.push('_separator');
          }

          if (startDragIndex === i) {
            classNames.push('_hide');
          }

          if (draggableGroup && h.draggableGroup !== draggableGroup || _this2._dragItem && !draggableGroup && h.draggableGroup) {
            classNames.push('_hide');
          }

          classNames.push(startDragIndex < endDragIndex ? '_right' : '_left');
        }

        if (hoveredColIndex === i) {
          classNames.push('_th-hover');
        }

        var sortingClassName = h.sortingKey !== sorting.field ? '' : sorting.direction === SORT_DIRECTION.ASC ? '_up' : '_down';
        return React.createElement("td", _extends_1({
          className: classNames.join(' ')
        }, attrs, {
          style: {
            height: "".concat(theadRowHeight, "px")
          },
          key: i,
          onMouseEnter: tooltip ? handleTheadOnMouseEnterLeave({
            i: i + freezeColumns,
            text: tooltip
          }) : null,
          onMouseLeave: tooltip ? handleTheadOnMouseEnterLeave() : null
        }), React.createElement("div", {
          className: "td-content",
          style: {
            height: "".concat(theadRowHeight, "px")
          }
        }, label, sortIcon && React.createElement("div", {
          className: "td-sorting ".concat(sortingClassName)
        }, sortIcon)));
      }));
    }
  }]);
  return TableHeaderRow;
}(Component);

TableHeaderRow.propTypes = {
  header: tablePropTypes.header,
  freeze: tablePropTypes.freeze,
  sorting: tablePropTypes.sorting,
  onSortingChanged: PropTypes__default.func,
  draggable: PropTypes__default.bool,
  onDragEnd: PropTypes__default.func,
  theadRowHeight: PropTypes__default.number,
  hoveredColIndex: PropTypes__default.number,
  handleTheadOnMouseEnterLeave: PropTypes__default.func,
  freezeColumns: PropTypes__default.number
};
var css$r = ".tableHeaderTooltip-module_tooltip__1jEpb {\n  pointer-events: none;\n  position: absolute;\n  z-index: 4;\n  transform: translateX(-50%); }\n  .tableHeaderTooltip-module_tooltip__1jEpb.tableHeaderTooltip-module__left__1T9wi {\n    transform: translate(-100%, -50%); }\n  .tableHeaderTooltip-module_tooltip__1jEpb.tableHeaderTooltip-module__right__SopMJ {\n    transform: translateY(-50%); }\n";
var styles$5 = {
  "tooltip": "tableHeaderTooltip-module_tooltip__1jEpb",
  "_left": "tableHeaderTooltip-module__left__1T9wi",
  "_right": "tableHeaderTooltip-module__right__SopMJ"
};
styleInject(css$r);

var TableHeaderTooltip = /*#__PURE__*/function (_Component) {
  inherits(TableHeaderTooltip, _Component);

  function TableHeaderTooltip(props) {
    var _this;

    classCallCheck(this, TableHeaderTooltip);
    _this = possibleConstructorReturn(this, getPrototypeOf(TableHeaderTooltip).call(this));
    defineProperty(assertThisInitialized(_this), "onFontLoaded", function () {
      var font = new fontfaceobserver_standalone('Lato Medium');
      font.load().then(function () {
        return _this.setLabelMaxWidth();
      }).then(function () {
        return _this.getPosition();
      });
    });
    defineProperty(assertThisInitialized(_this), "setLabelMaxWidth", function (isTooltipChanged) {
      if (isTooltipChanged === undefined || isTooltipChanged === true) {
        var contentWidth = Math.ceil(_this.tooltipLabelInner.getBoundingClientRect().width);
        contentWidth = contentWidth <= _this.labelInnerWidth ? contentWidth : _this.labelInnerWidth;

        _this.setState({
          labelInnerMaxWidth: contentWidth,
          position: 'bottom'
        });
      }
    });
    _this.labelInnerWidth = props.labelMaxWidth ? props.labelMaxWidth - 20 : 480; // 2x 10px horizontal paddings

    _this.state = {
      position: 'bottom',
      labelInnerMaxWidth: _this.labelInnerWidth
    };
    return _this;
  }

  createClass(TableHeaderTooltip, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      this.isTooltipChanged = !isEqual$1(nextProps.tooltip, this.props.tooltip);

      if (this.isTooltipChanged) {
        this.isTooltipWidthSet = false;
      } else if (!isEqual$1(nextState.labelInnerMaxWidth, this.state.labelInnerMaxWidth)) {
        this.isTooltipWidthSet = true;
      }

      this.isScrollLeftChanged = !isEqual$1(nextProps.scrollLeft, this.props.scrollLeft);
      return !(isEqual$1(nextProps.tooltip, this.props.tooltip) && isEqual$1(nextProps.cellsWidths, this.props.cellsWidths) && isEqual$1(nextProps.scrollLeft, this.props.scrollLeft) && isEqual$1(nextProps.freezeColumns, this.props.freezeColumns) && isEqual$1(nextState.position, this.state.position) && isEqual$1(nextState.labelInnerMaxWidth, this.state.labelInnerMaxWidth));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onFontLoaded();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setLabelMaxWidth(this.isTooltipChanged);

      if (this.isTooltipWidthSet) {
        this.getPosition(this.isScrollLeftChanged);
      }
    }
  }, {
    key: "getPosition",
    value: function getPosition(isScrollLeftChanged) {
      var position = isScrollLeftChanged ? 'bottom' : this.state.position;
      var coord = this.tooltipLabel.getBoundingClientRect();
      var x = coord.x,
          right = coord.right;

      if (x < 0) {
        position = 'right';
      }

      if (right > window.innerWidth) {
        position = 'left';
      }

      if (position !== this.state.position) {
        this.setState({
          position: position
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          tooltip = _this$props.tooltip,
          _this$props$cellsWidt = _this$props.cellsWidths,
          cellsWidths = _this$props$cellsWidt === void 0 ? [] : _this$props$cellsWidt,
          _this$props$scrollLef = _this$props.scrollLeft,
          scrollLeft = _this$props$scrollLef === void 0 ? 0 : _this$props$scrollLef,
          _this$props$freezeCol = _this$props.freezeColumns,
          freezeColumns = _this$props$freezeCol === void 0 ? 0 : _this$props$freezeCol,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className;
      var top = this.props.top;
      var _this$state = this.state,
          position = _this$state.position,
          labelInnerMaxWidth = _this$state.labelInnerMaxWidth;
      var left = '';
      var right = 'auto';
      var positionClassName = ''; // sum of cells widths before active one

      var sumOfCellsWidthsBeforeActive = cellsWidths.slice(0, tooltip.i).reduce(function (a, b) {
        return a + b;
      }, 0); // scroll correction, assuming frozen columns

      var scrollCorrection = tooltip.i >= freezeColumns ? scrollLeft : 0;

      switch (position) {
        case 'bottom':
          left = (tooltip.i ? sumOfCellsWidthsBeforeActive : 0) + cellsWidths[tooltip.i] / 2 - // half a width of active cell
          scrollCorrection + 'px';
          break;

        case 'left':
          top = top / 2;
          left = sumOfCellsWidthsBeforeActive - scrollCorrection + 'px';
          positionClassName = styles$5._left;
          break;

        case 'right':
          top = top / 2;
          left = (tooltip.i ? sumOfCellsWidthsBeforeActive : 0) + cellsWidths[tooltip.i] - scrollCorrection + 'px';
          positionClassName = styles$5._right;
          break;
      }

      var style = {
        top: "".concat(top, "px"),
        left: left,
        right: right
      };
      return React.createElement("div", {
        ref: function ref(el) {
          _this2.tooltipLabel = el;
        },
        className: "".concat(styles$5.tooltip, " td-tooltip ").concat(className, " ").concat(positionClassName, " tooltip__label"),
        style: style
      }, React.createElement("span", {
        className: "tooltip__label-outer",
        style: {
          width: "".concat(this.labelInnerWidth, "px"),
          maxWidth: "".concat(this.isTooltipChanged ? this.labelInnerWidth : labelInnerMaxWidth, "px")
        }
      }, React.createElement("span", {
        ref: function ref(el) {
          _this2.tooltipLabelInner = el;
        },
        className: "tooltip__label-inner"
      }, tooltip.text)));
    }
  }]);
  return TableHeaderTooltip;
}(Component);

TableHeaderTooltip.propTypes = {
  tooltip: PropTypes__default.shape({
    i: PropTypes__default.number,
    text: PropTypes__default.string
  }),
  cellsWidths: PropTypes__default.arrayOf(PropTypes__default.number),
  top: PropTypes__default.number,
  scrollLeft: PropTypes__default.number,
  freezeColumns: PropTypes__default.number,
  className: PropTypes__default.string,
  labelMaxWidth: PropTypes__default.number
};
var css$s = ".table-module_container__1ZPhr .table-module_containerUp__2Qe14 .table-module_containerLeft__2m5Kg thead td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerUp__2Qe14 .table-module_containerLeft__2m5Kg thead th:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerUp__2Qe14 .table-module_containerLeft__2m5Kg thead td._checkbox:first-child + td .td-content,\n.table-module_container__1ZPhr .table-module_containerUp__2Qe14 .table-module_containerLeft__2m5Kg thead th._checkbox:first-child + th .td-content,\n.table-module_container__1ZPhr .table-module_containerUp__2Qe14 .table-module_containerRight__2tD1U:first-child thead td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerUp__2Qe14 .table-module_containerRight__2tD1U:first-child thead th:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerUp__2Qe14 .table-module_containerRight__2tD1U:first-child thead td._checkbox:first-child + td .td-content,\n.table-module_container__1ZPhr .table-module_containerUp__2Qe14 .table-module_containerRight__2tD1U:first-child thead th._checkbox:first-child + th .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr:first-child .table-module_containerLeft__2m5Kg thead td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr:first-child .table-module_containerLeft__2m5Kg thead th:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr:first-child .table-module_containerLeft__2m5Kg thead td._checkbox:first-child + td .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr:first-child .table-module_containerLeft__2m5Kg thead th._checkbox:first-child + th .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr:first-child .table-module_containerRight__2tD1U:first-child thead td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr:first-child .table-module_containerRight__2tD1U:first-child thead th:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr:first-child .table-module_containerRight__2tD1U:first-child thead td._checkbox:first-child + td .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr:first-child .table-module_containerRight__2tD1U:first-child thead th._checkbox:first-child + th .td-content {\n  border-radius: .25rem 0 0 0; }\n\n.table-module_container__1ZPhr .containerUp .containerRight thead td:last-child .td-content, .table-module_container__1ZPhr .table-module_containerUp__2Qe14 .table-module_containerRight__2tD1U thead td:last-child .td-content,\n.table-module_container__1ZPhr .containerUp .containerRight thead th:last-child .td-content, .table-module_container__1ZPhr .table-module_containerUp__2Qe14 .table-module_containerRight__2tD1U thead th:last-child .td-content,\n.table-module_container__1ZPhr .containerDown:first-child .containerRight thead td:last-child .td-content, .table-module_container__1ZPhr .table-module_containerDown__3fMpr:first-child .table-module_containerRight__2tD1U thead td:last-child .td-content,\n.table-module_container__1ZPhr .containerDown:first-child .containerRight thead th:last-child .td-content, .table-module_container__1ZPhr .table-module_containerDown__3fMpr:first-child .table-module_containerRight__2tD1U thead th:last-child .td-content {\n  border-radius: 0 .25rem 0 0; }\n\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr .table-module_containerLeft__2m5Kg tbody tr:last-child td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr .table-module_containerLeft__2m5Kg tbody tr:last-child td._checkbox:first-child + td .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr .table-module_containerLeft__2m5Kg tbody tr:last-child td._checkbox:first-child + td .td-content:before,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr .table-module_containerRight__2tD1U:first-child tbody tr:last-child td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr .table-module_containerRight__2tD1U:first-child tbody tr:last-child td._checkbox:first-child + td .td-content,\n.table-module_container__1ZPhr .table-module_containerDown__3fMpr .table-module_containerRight__2tD1U:first-child tbody tr:last-child td._checkbox:first-child + td .td-content:before {\n  border-radius: 0 0 0 .25rem; }\n\n.table-module_container__1ZPhr .containerDown .containerRight tbody tr:last-child td:last-child .td-content, .table-module_container__1ZPhr .table-module_containerDown__3fMpr .table-module_containerRight__2tD1U tbody tr:last-child td:last-child .td-content {\n  border-radius: 0 0 .25rem 0; }\n\n.table-module_container__1ZPhr table {\n  table-layout: fixed;\n  border-collapse: collapse;\n  padding: 0;\n  border: none; }\n\n.table-module_container__1ZPhr thead .td-content {\n  border-bottom: 1px solid #d8d8d8;\n  background: #f4f4f4; }\n\n.table-module_container__1ZPhr thead td:hover .td-content, .table-module_container__1ZPhr thead td._th-hover .td-content, .table-module_container__1ZPhr thead th:hover .td-content, .table-module_container__1ZPhr thead th._th-hover .td-content {\n  background: #f2f5ff; }\n\n.table-module_container__1ZPhr thead td:not(._hide):hover .td-content .td-tooltip,\n.table-module_container__1ZPhr thead td:not(._hide):hover .td-content .th-tooltip, .table-module_container__1ZPhr thead th:not(._hide):hover .td-content .td-tooltip,\n.table-module_container__1ZPhr thead th:not(._hide):hover .td-content .th-tooltip {\n  display: block; }\n\n.table-module_container__1ZPhr tbody tr:hover .td-content._hover, .table-module_container__1ZPhr tbody tr.tr-hover .td-content._hover {\n  display: flex; }\n  .table-module_container__1ZPhr tbody tr:hover .td-content._hover + .td-content, .table-module_container__1ZPhr tbody tr.tr-hover .td-content._hover + .td-content {\n    display: none; }\n\n.table-module_container__1ZPhr tbody tr:nth-child(even) .td-content {\n  background: #f2f2f2; }\n  .table-module_container__1ZPhr tbody tr:nth-child(even) .td-content .skeleton-block {\n    background-image: linear-gradient(90deg, #dddddd 0px, #E9E8E8 2rem, #dddddd 4rem); }\n\n.table-module_container__1ZPhr tbody tr:first-child .td-content {\n  border-top-width: 0; }\n\n.table-module_container__1ZPhr tbody tr.tr-unsorted .td-content {\n  border-color: #cbcbcb;\n  background: #cbcbcb;\n  font-family: \"Lato Bold\", sans-serif;\n  font-size: 0.8125rem; }\n\n.table-module_container__1ZPhr tbody tr:not(.tr-unsorted):last-child .td-content {\n  border-bottom: 1px solid #d8d8d8; }\n\n.table-module_container__1ZPhr tbody tr:not(.tr-unsorted):hover .td-content, .table-module_container__1ZPhr tbody tr:not(.tr-unsorted).tr-hover .td-content {\n  border-left-color: #f4f4f4;\n  background-color: #f2f5ff; }\n\n.table-module_container__1ZPhr tbody tr:not(.tr-unsorted):hover td:first-child .td-content, .table-module_container__1ZPhr tbody tr:not(.tr-unsorted).tr-hover td:first-child .td-content {\n  border-left-color: #d8d8d8; }\n\n.table-module_container__1ZPhr tbody tr:not(.tr-unsorted):hover td:first-child._checkbox + td .td-content, .table-module_container__1ZPhr tbody tr:not(.tr-unsorted).tr-hover td:first-child._checkbox + td .td-content {\n  border-left-color: #d8d8d8; }\n\n.table-module_container__1ZPhr tbody tr._selected td:not(._checkbox) .td-content, .table-module_container__1ZPhr tbody tr._selected:hover td:not(._checkbox) .td-content, .table-module_container__1ZPhr tbody tr._selected.tr-hover td:not(._checkbox) .td-content {\n  border-color: #bac3ff !important;\n  background: #ebeeff !important; }\n\n.table-module_container__1ZPhr tbody tr._selected td._checkbox:first-child + td .td-content, .table-module_container__1ZPhr tbody tr._selected:hover td._checkbox:first-child + td .td-content, .table-module_container__1ZPhr tbody tr._selected.tr-hover td._checkbox:first-child + td .td-content {\n  position: relative; }\n  .table-module_container__1ZPhr tbody tr._selected td._checkbox:first-child + td .td-content:before, .table-module_container__1ZPhr tbody tr._selected:hover td._checkbox:first-child + td .td-content:before, .table-module_container__1ZPhr tbody tr._selected.tr-hover td._checkbox:first-child + td .td-content:before {\n    content: '';\n    position: absolute;\n    z-index: 2;\n    top: -0.0625rem;\n    left: -0.0625rem;\n    bottom: -0.0625rem;\n    width: .25rem;\n    background: #6075ff; }\n\n.table-module_container__1ZPhr tbody tr._selected:not(:last-child) td:not(._checkbox) .td-content, .table-module_container__1ZPhr tbody tr._selected:hover:not(:last-child) td:not(._checkbox) .td-content, .table-module_container__1ZPhr tbody tr._selected.tr-hover:not(:last-child) td:not(._checkbox) .td-content {\n  position: relative; }\n  .table-module_container__1ZPhr tbody tr._selected:not(:last-child) td:not(._checkbox) .td-content:after, .table-module_container__1ZPhr tbody tr._selected:hover:not(:last-child) td:not(._checkbox) .td-content:after, .table-module_container__1ZPhr tbody tr._selected.tr-hover:not(:last-child) td:not(._checkbox) .td-content:after {\n    content: '';\n    position: absolute;\n    z-index: 1;\n    top: 100%;\n    left: -0.0625rem;\n    right: -0.0625rem;\n    height: 0.0625rem;\n    background: #bac3ff; }\n\n.table-module_container__1ZPhr td, .table-module_container__1ZPhr th {\n  padding: 0;\n  min-width: 100px;\n  width: 300px;\n  max-width: 300px;\n  border: none; }\n  .table-module_container__1ZPhr td:last-child .td-content, .table-module_container__1ZPhr th:last-child .td-content {\n    border-right: 1px solid #d8d8d8; }\n  .table-module_container__1ZPhr td._sorting .td-content, .table-module_container__1ZPhr th._sorting .td-content {\n    cursor: pointer; }\n  .table-module_container__1ZPhr td._checkbox, .table-module_container__1ZPhr th._checkbox {\n    min-width: 44px;\n    width: 44px;\n    max-width: 44px; }\n    .table-module_container__1ZPhr td._checkbox .td-content, .table-module_container__1ZPhr th._checkbox .td-content {\n      border-width: 0 !important;\n      background: transparent !important; }\n  .table-module_container__1ZPhr td._clicked .td-content._click, .table-module_container__1ZPhr th._clicked .td-content._click {\n    display: flex; }\n    .table-module_container__1ZPhr td._clicked .td-content._click + .td-content, .table-module_container__1ZPhr th._clicked .td-content._click + .td-content {\n      display: none; }\n\n.table-module_container__1ZPhr .td-content {\n  display: flex;\n  align-items: center;\n  padding: 6px 8px;\n  height: 100%;\n  border-top: 1px solid #d8d8d8;\n  border-left: 1px solid #d8d8d8;\n  background: #fff;\n  font-family: 'Lato Regular', sans-serif;\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 1.21429em;\n  color: #2b2b2b;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n  .table-module_container__1ZPhr .td-content._hover {\n    display: none; }\n  .table-module_container__1ZPhr .td-content._click {\n    display: none; }\n    .table-module_container__1ZPhr .td-content._click + .td-content {\n      cursor: pointer; }\n  .table-module_container__1ZPhr .td-content .td-sorting {\n    position: relative;\n    margin-left: auto;\n    width: 0.5rem;\n    line-height: 0; }\n    .table-module_container__1ZPhr .td-content .td-sorting._up, .table-module_container__1ZPhr .td-content .td-sorting._down {\n      width: 0.75rem; }\n    .table-module_container__1ZPhr .td-content .td-sorting:not(._up):not(._down) {\n      visibility: hidden; }\n    .table-module_container__1ZPhr .td-content .td-sorting .sort-icon_default {\n      margin-left: auto;\n      width: 100%;\n      height: auto;\n      fill: #787878; }\n  .table-module_container__1ZPhr .td-content:hover .td-sorting:not(._up):not(._down) {\n    visibility: visible; }\n\n.table-module_container__1ZPhr .td-content-inner {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.table-module_container__1ZPhr .td-tooltip._css,\n.table-module_container__1ZPhr .th-tooltip._css {\n  display: none; }\n\n.table-module_container__1ZPhr .table-module_containerLeft__2m5Kg td:last-child .td-content,\n.table-module_container__1ZPhr .table-module_containerLeft__2m5Kg th:last-child .td-content {\n  border-right: 2px solid #a2a2a2; }\n\n.table-module_container__1ZPhr .table-module_containerLeft__2m5Kg + .table-module_containerRight__2tD1U td:first-child .td-content,\n.table-module_container__1ZPhr .table-module_containerLeft__2m5Kg + .table-module_containerRight__2tD1U th:first-child .td-content {\n  border-left-width: 0; }\n\n.table-module_container__1ZPhr .table-module_containerUp__2Qe14 tbody tr:not(.tr-unsorted):last-child .td-content {\n  border-bottom: 2px solid #a2a2a2; }\n\n.table-module_containerTable__EaneQ._odd-stripes tbody tr:not(.tr-unsorted):not(.tr-hover):not(:hover):nth-child(even) .td-content {\n  background: #fff; }\n\n.table-module_containerTable__EaneQ._odd-stripes tbody tr:not(.tr-unsorted):not(.tr-hover):not(:hover):nth-child(odd) .td-content {\n  background: #f2f2f2; }\n  .table-module_containerTable__EaneQ._odd-stripes tbody tr:not(.tr-unsorted):not(.tr-hover):not(:hover):nth-child(odd) .td-content .skeleton-block {\n    background-image: linear-gradient(90deg, #dddddd 0px, #E9E8E8 2rem, #dddddd 4rem); }\n\n.table-module_containerTable__EaneQ {\n  position: relative; }\n  .table-module_containerTableProgress__1ltyG {\n    pointer-events: none;\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    right: 0;\n    transition: background-image .25s; }\n\n.table-module_containerUp__2Qe14 {\n  position: -webkit-sticky;\n  /* Safari */\n  position: sticky;\n  z-index: 3;\n  top: 0;\n  display: flex;\n  align-items: flex-start;\n  background: #fff; }\n  .table-module_containerUp__2Qe14 .table-module_containerLeft__2m5Kg table {\n    overflow: hidden; }\n\n.table-module_containerDown__3fMpr {\n  position: relative;\n  top: 0;\n  overflow: auto;\n  display: flex;\n  align-items: flex-start; }\n\n.table-module_containerLeft__2m5Kg {\n  flex: 0 1 auto; }\n\n.table-module_containerRight__2tD1U {\n  flex: 1 1 auto;\n  overflow: hidden; }\n  .table-module_containerRightScroller__g3_OG {\n    overflow: auto; }\n\n.table-module_container__1ZPhr._dnd .td-content {\n  position: relative; }\n\n.table-module_container__1ZPhr._dnd td._hide .td-content, .table-module_container__1ZPhr._dnd th._hide .td-content {\n  opacity: 0.3; }\n\n.table-module_container__1ZPhr._dnd td._separator .td-content:before, .table-module_container__1ZPhr._dnd th._separator .td-content:before {\n  content: '';\n  position: absolute;\n  width: 4px;\n  height: 100%;\n  background-color: #798eff; }\n\n.table-module_container__1ZPhr._dnd td._separator._left .td-content:before, .table-module_container__1ZPhr._dnd th._separator._left .td-content:before {\n  left: 0; }\n\n.table-module_container__1ZPhr._dnd td._separator._right .td-content:before, .table-module_container__1ZPhr._dnd th._separator._right .td-content:before {\n  right: 0; }\n\n.table-module_scroller__HSsUm {\n  position: absolute;\n  z-index: 3;\n  bottom: 0;\n  right: 0;\n  height: 20px;\n  transform: translateY(100%);\n  overflow: auto;\n  opacity: .5;\n  transition: opacity .25s; }\n  .table-module_scroller__HSsUm:hover {\n    opacity: 1; }\n  .table-module_scroller__HSsUm._fixed {\n    position: fixed;\n    bottom: 40px;\n    right: auto; }\n  .table-module_scroller__HSsUm::-webkit-scrollbar {\n    -webkit-appearance: none;\n    height: 10px; }\n  .table-module_scroller__HSsUm::-webkit-scrollbar-thumb {\n    height: 10px;\n    border-radius: 5px;\n    background-color: rgba(0, 0, 0, 0.5); }\n  .table-module_scrollerPlaceholder__1PQ0_ {\n    height: 1px; }\n\n.table-module_iframe__2_uWF {\n  display: block;\n  margin: 0;\n  width: 100%;\n  height: 0;\n  border: 0; }\n\n.table-module_tooltipWrapper__2rDL_ {\n  position: -webkit-sticky;\n  /* Safari */\n  position: sticky;\n  z-index: 25; }\n";
var styles$6 = {
  "container": "table-module_container__1ZPhr",
  "containerUp": "table-module_containerUp__2Qe14",
  "containerLeft": "table-module_containerLeft__2m5Kg",
  "containerRight": "table-module_containerRight__2tD1U",
  "containerDown": "table-module_containerDown__3fMpr",
  "containerTable": "table-module_containerTable__EaneQ",
  "containerTableProgress": "table-module_containerTableProgress__1ltyG",
  "containerRightScroller": "table-module_containerRightScroller__g3_OG",
  "scroller": "table-module_scroller__HSsUm",
  "scrollerPlaceholder": "table-module_scrollerPlaceholder__1PQ0_",
  "iframe": "table-module_iframe__2_uWF",
  "tooltipWrapper": "table-module_tooltipWrapper__2rDL_"
};
styleInject(css$s);

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Table = /*#__PURE__*/function (_Component) {
  inherits(Table, _Component);

  function Table(props) {
    var _this;

    classCallCheck(this, Table);
    _this = possibleConstructorReturn(this, getPrototypeOf(Table).call(this, props));
    defineProperty(assertThisInitialized(_this), "onFontLoaded", function () {
      var font = new fontfaceobserver_standalone('Lato Regular');
      font.load().then(function () {
        _this.syncWidths();
      });
    });
    defineProperty(assertThisInitialized(_this), "tableHeaderElement", React.createRef());
    defineProperty(assertThisInitialized(_this), "onTableChanged", function () {
      if (_this.props.onChange) {
        var _this$state = _this.state,
            sorting = _this$state.sorting,
            paging = _this$state.paging;

        _this.props.onChange({
          sorting: sorting,
          paging: paging
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "handleContextMenu", function (event, row, rowNumber, colNumber) {
      event.preventDefault();

      _this.setState({
        contextMenu: {
          row: row,
          rowNumber: rowNumber,
          colNumber: colNumber,
          clientX: event.clientX,
          clientY: event.clientY
        }
      });
    });
    defineProperty(assertThisInitialized(_this), "renderBodyRow", function (data, rowIndex, body, freezeColumns) {
      var _this$props = _this.props,
          tbodyRowHeight = _this$props.tbodyRowHeight,
          rowKeyExtractor = _this$props.rowKeyExtractor,
          rowClickHandler = _this$props.rowClickHandler;
      var _this$state2 = _this.state,
          hoveredRowIndex = _this$state2.hoveredRowIndex,
          freeze = _this$state2.freeze;
      return React.createElement(TableRow, {
        data: data,
        body: body,
        rowIndex: rowIndex,
        key: rowKeyExtractor(data, rowIndex),
        onContextMenu: _this.handleContextMenu,
        rowClickHandler: rowClickHandler,
        freezeColumns: freezeColumns,
        hoveredRowIndex: hoveredRowIndex,
        trOnMouseEnter: freeze.columns > 0 ? _this.setHoveredRowIndex(rowIndex) : null,
        trOnMouseLeave: freeze.columns > 0 ? _this.setHoveredRowIndex(null) : null,
        tdOnMouseOver: _this.setHoveredColIndex,
        tdOnMouseLeave: _this.setHoveredColIndex,
        tbodyRowHeight: tbodyRowHeight,
        isAllSelected: _this.isAllSelected,
        isSomeSelected: _this.isSomeSelected
      });
    });
    defineProperty(assertThisInitialized(_this), "setHoveredRowIndex", function (hoveredRowIndex) {
      return function () {
        return _this.setState({
          hoveredRowIndex: hoveredRowIndex
        });
      };
    });
    defineProperty(assertThisInitialized(_this), "setHoveredColIndex", function (hoveredColIndex) {
      return _this.setState({
        hoveredColIndex: hoveredColIndex
      });
    });
    defineProperty(assertThisInitialized(_this), "handlePerPageChange", function (v) {
      var paging = _this.state.paging;

      _this.setState({
        paging: _objectSpread$6({}, paging, {
          itemsCountPerPage: v.value,
          activePage: 1
        })
      }, function () {
        _this.onTableChanged();
      });
    });
    defineProperty(assertThisInitialized(_this), "handlePageChange", function (page) {
      var paging = _this.state.paging;

      _this.setState({
        paging: _objectSpread$6({}, paging, {
          activePage: page
        })
      }, function () {
        _this.onTableChanged();
      });
    });
    defineProperty(assertThisInitialized(_this), "handleFreezeRow", function (row, index) {
      var freezeUpdateHandler = _this.props.freezeUpdateHandler;

      _this.setState({
        contextMenu: null,
        freeze: _objectSpread$6({}, _this.state.freeze, {
          rows: index
        })
      }, function () {
        return freezeUpdateHandler && freezeUpdateHandler(_this.state.freeze);
      });
    });
    defineProperty(assertThisInitialized(_this), "handleFreezeColumn", function (column, index) {
      var freezeUpdateHandler = _this.props.freezeUpdateHandler;

      _this.setState({
        contextMenu: null,
        freeze: _objectSpread$6({}, _this.state.freeze, {
          columns: index
        })
      }, function () {
        return freezeUpdateHandler && freezeUpdateHandler(_this.state.freeze);
      });
    });
    defineProperty(assertThisInitialized(_this), "syncWidths", function () {
      // get lower table full row cells
      var downCells = [].concat(toConsumableArray(_this.tableDowns[0] ? _this.tableDowns[0].querySelectorAll('tbody tr:first-child td') : []), toConsumableArray(_this.tableDowns[1] ? _this.tableDowns[1].querySelectorAll('tbody tr:first-child td') : []));
      var cellsWidths = []; // check if table component has upper table and if yes get all its cells

      var upCells;

      if (_this.tableUps.length) {
        upCells = [].concat(toConsumableArray(_this.tableUps[0] ? _this.tableUps[0].querySelectorAll('thead td') : []), toConsumableArray(_this.tableUps[1] ? _this.tableUps[1].querySelectorAll('thead td') : []));
      }

      [].forEach.call(downCells, function (i, k) {
        if (!i.offsetWidth) return; // @todo does this really needed?

        if (upCells) {
          upCells[k].style.minWidth = "".concat(i.offsetWidth, "px");
          upCells[k].style.maxWidth = "".concat(i.offsetWidth, "px");
        }

        cellsWidths.push(i.offsetWidth);
      }); // to use widths out of current function

      _this.cellsWidths = cellsWidths;
    });
    defineProperty(assertThisInitialized(_this), "addTableUps", function (el, index) {
      if (!el || _this.tableUps.indexOf(el) !== -1) {
        return;
      }

      _this.tableUps[index] = el;
    });
    defineProperty(assertThisInitialized(_this), "addTableDowns", function (el, index) {
      if (!el || _this.tableDowns.indexOf(el) !== -1) {
        return;
      }

      _this.tableDowns[index] = el;
    });
    defineProperty(assertThisInitialized(_this), "addSyncedElement", function (el) {
      if (!el || _this.syncedElements.indexOf(el) !== -1) {
        return;
      }

      _this.syncedElements.push(el);
    });
    defineProperty(assertThisInitialized(_this), "syncScroll", function (e) {
      // if nothing to sync with or if scroll event fired on element that is not under mouse now
      if (_this.syncedElements.length < 2 || _this.scrollTarget !== e.target) {
        return;
      } // set scroll position for all table parts...


      _this.syncedElements.forEach(function (i) {
        // ...except the part where the event was initiated (since this part has already actual scroll)
        if (i !== e.target) {
          i.scrollLeft = e.target.scrollLeft;
        }
      });

      _this.setState({
        tableHorizontalScroll: e.target.scrollLeft
      }); // setState to update table header tooltip position

    });
    defineProperty(assertThisInitialized(_this), "handleTableMouseMoveOrWheelEvent", function (e) {
      _this.setCurrentScrollTarget(e.target);
    });
    defineProperty(assertThisInitialized(_this), "setCurrentScrollTarget", function (target) {
      var scrollTarget = _this.syncedElements.find(function (i) {
        return i.contains(target) || i === target;
      });

      if (_this.scrollTarget !== scrollTarget) {
        _this.scrollTarget = scrollTarget;
      }
    });
    defineProperty(assertThisInitialized(_this), "setScrollerDimensions", function () {
      var fixedXScroller = _this.props.fixedXScroller;
      var fixScrollerAtBottom = _this.state.fixScrollerAtBottom;

      var widthsContainer = _this.table.querySelectorAll('.js-columns-widths-down');

      var scroller = _this.scroller;
      var scrollerPlaceholder = scroller.querySelector('.js-scroller-placeholder'); // necessary for scroller position calculating

      var isScrollerAbsolute = !fixedXScroller || fixScrollerAtBottom; // if scroller is absolute or fixed positioned

      var containerBoundingClientRect = _this.table.getBoundingClientRect();

      var fixedLeft = containerBoundingClientRect.left;
      var tableWidth = containerBoundingClientRect.width; // common values for table with freezed columns and without

      var cellsCols1 = widthsContainer[0].querySelectorAll('tbody tr:first-child td');
      var widthFirst = [].reduce.call(cellsCols1, function (acc, current) {
        return acc + current.offsetWidth;
      }, 0); // width of the whole table or its left part if it has freezed columns
      // if freeze.columns > 1

      if (widthsContainer.length === 2) {
        var cellsCol2 = widthsContainer[1].querySelectorAll('tbody tr:first-child td');
        var widthLast = [].reduce.call(cellsCol2, function (acc, current) {
          return acc + current.offsetWidth;
        }, 0); // width of right part of the table (exists only when table has freezed columns)
        // Place x scrollbar right under the table. Otherwise fix it at the bottom of viewport.

        if (isScrollerAbsolute) {
          scroller.style.left = "".concat(widthFirst, "px"); // move absolute scroller right on freezed columns width
        } else {
          scroller.style.left = "".concat(fixedLeft + widthFirst, "px"); // move fixed scroller right on table left position and freezed columns width

          scroller.style.width = "".concat(tableWidth - widthFirst, "px"); // set fixed scroller width to table width without freezed columns width
        }

        scrollerPlaceholder.style.width = "".concat(widthLast, "px");
      } else {
        // Place x scrollbar right under the table. Otherwise fix it at the bottom of viewport.
        if (isScrollerAbsolute) {
          scroller.style.left = 0; // place absolute scroller to the left of table
        } else {
          scroller.style.left = "".concat(fixedLeft, "px"); // place fixed scroller to the left of table

          scroller.style.width = "".concat(tableWidth, "px"); // set fixed scroller width to table width
        }

        scrollerPlaceholder.style.width = "".concat(widthFirst, "px");
      }
    });
    defineProperty(assertThisInitialized(_this), "stickFixedScrollerToTable", function () {
      if (!_this.containerTable) {
        return;
      }

      var containerBoundingClientRect = _this.containerTable.getBoundingClientRect();

      var tableTop = containerBoundingClientRect.top;
      var tableHeight = containerBoundingClientRect.height;
      _this.scrollerBottom = _this.scrollerBottom || parseInt(window.getComputedStyle(_this.scroller).bottom, 10);
      var viewportHeight = window.innerHeight; // if table is scrolled up/down

      var isScrolledUp = viewportHeight - tableTop - tableHeight > _this.scrollerBottom;
      var isScrolledDown = tableTop > viewportHeight;

      if (isScrolledUp || isScrolledDown) {
        !_this.state.fixScrollerAtBottom && _this.setState({
          fixScrollerAtBottom: true
        });
      } else {
        _this.state.fixScrollerAtBottom && _this.setState({
          fixScrollerAtBottom: false
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "getTableHeight", function (rows) {
      var skeletonsNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var addition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return "".concat(_this.props.theadRowHeight + (rows + skeletonsNumber) * _this.props.tbodyRowHeight + addition, "px");
    });
    defineProperty(assertThisInitialized(_this), "getLoader", function (data, body) {
      var _this$props2 = _this.props,
          skeletonRowsNumber = _this$props2.skeletonRowsNumber,
          tbodyRowHeight = _this$props2.tbodyRowHeight;
      return data ? toConsumableArray(new Array(skeletonRowsNumber)).map(function (i, k) {
        return React.createElement(TableRow, {
          isSkeleton: true,
          data: data,
          body: body,
          tbodyRowHeight: tbodyRowHeight,
          key: k
        });
      }) : null;
    });
    defineProperty(assertThisInitialized(_this), "handleTheadOnMouseEnterLeave", function (tooltip) {
      return function () {
        return _this.setState({
          tooltip: tooltip
        });
      };
    });
    defineProperty(assertThisInitialized(_this), "renderTableHeaderRow", function (header, hoveredColIndex, fixedHeader) {
      var freezeColumns = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var _this$props3 = _this.props,
          draggable = _this$props3.draggable,
          onDragEnd = _this$props3.onDragEnd,
          theadRowHeight = _this$props3.theadRowHeight;
      var sorting = _this.state.sorting;
      return React.createElement("thead", null, React.createElement(TableHeaderRow, {
        header: header,
        sorting: sorting,
        onSortingChanged: _this.handleChangeSorting,
        draggable: draggable,
        onDragEnd: onDragEnd,
        hoveredColIndex: hoveredColIndex,
        theadRowHeight: theadRowHeight,
        handleTheadOnMouseEnterLeave: _this.handleTheadOnMouseEnterLeave,
        freezeColumns: freezeColumns,
        fixedHeader: fixedHeader
      }));
    });
    defineProperty(assertThisInitialized(_this), "setScrollProgress", function () {
      // if needed ref is not exist
      if (!_this.containerUp) {
        return;
      }

      var _this$props4 = _this.props,
          offsetTop = _this$props4.offsetTop,
          infiniteScroll = _this$props4.infiniteScroll,
          unsortedData = _this$props4.unsortedData,
          tbodyRowHeight = _this$props4.tbodyRowHeight;
      var totalItemsCount = _this.props.totalItemsCount;
      var freeze = _this.state.freeze;

      var containerUpTop = _this.containerUp.getBoundingClientRect().top;

      var containerDownTop = _this.containerDown.getBoundingClientRect().top; // part of table scrolled by means of window scroll
      // relative to sticky table element


      var scrolledUpPixels = containerUpTop - containerDownTop;
      var innerTableScroll = 0; // exists only with infiniteScroll

      if (infiniteScroll) {
        // infinite content is scrolled inside containerDown
        var infiniteContentTop = _this.containerDownRight.getBoundingClientRect().top;

        innerTableScroll = containerDownTop - infiniteContentTop;
      } // sum of 'window scrolled' and 'infinite scrolled' pixels


      var totalScrolledPixels = scrolledUpPixels + innerTableScroll; // count pixels that cannot be scrolled up (under sticky element),
      // due to not enough space under table

      var pixelsAfterTable = document.body.scrollHeight - (window.pageYOffset + _this.containerDown.getBoundingClientRect().bottom);

      var remainedUnScrolled = window.innerHeight - (offsetTop + _this.containerUp.offsetHeight + pixelsAfterTable);

      if (remainedUnScrolled < 0) {
        remainedUnScrolled = 0;
      }

      totalItemsCount = totalItemsCount || _this.props.data.length;
      var percent = totalScrolledPixels / ((totalItemsCount - (freeze.rows ? freeze.rows - unsortedData.length : 0)) * tbodyRowHeight - remainedUnScrolled) * 100;

      _this.setState({
        tableScrollProgress: percent
      });
    });
    _this.tableUps = [];
    _this.tableDowns = [];
    _this.syncedElements = [];
    _this.state = {
      paging: props.paging ? props.paging : null,
      sorting: props.sorting,
      contextMenu: null,
      fixScrollerAtBottom: true,
      freeze: {
        rows: props.freezeRows,
        columns: props.freezeColumns
      }
    };

    if (!props.server) {
      _this.state.data = props.data || [];
    }

    _this.handleChangeSorting = _this.handleChangeSorting.bind(assertThisInitialized(_this));
    return _this;
  }

  createClass(Table, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var props = this.props;

      if (!props.server && (prevProps.data.length !== props.data.length || prevProps.data !== props.data)) {
        this.setState({
          data: props.data,
          paging: this.paging
        });
      } else if (props.sorting !== prevProps.sorting) {
        this.setState({
          sorting: props.sorting
        });
      } // update freeze if freezeColumns or freezeRows props have changed


      var isFreezeColsUpdatedThroughProps = this.props.freezeColumns !== prevProps.freezeColumns && this.props.freezeColumns !== this.state.freeze.columns;
      var isFreezeRowsUpdatedThroughProps = this.props.freezeRows !== prevProps.freezeRows && this.props.freezeRows !== this.state.freeze.rows;

      if (isFreezeColsUpdatedThroughProps || isFreezeRowsUpdatedThroughProps) {
        this.setState({
          freeze: {
            columns: isFreezeColsUpdatedThroughProps ? this.props.freezeColumns : this.state.freeze.columns,
            rows: isFreezeRowsUpdatedThroughProps ? this.props.freezeRows : this.state.freeze.rows
          }
        });
      }

      this.syncWidths();

      if (props.infiniteScroll) {
        this.setScrollerDimensions();

        if (this.props.fixedXScroller) {
          this.stickFixedScrollerToTable();
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onTableChanged();
      this.syncWidths();
      this.onFontLoaded();

      if (this.props.infiniteScroll) {
        this.setScrollerDimensions();

        if (this.props.fixedXScroller) {
          this.stickFixedScrollerToTable();
          window.addEventListener('scroll', this.stickFixedScrollerToTable);
        }
      }

      window.addEventListener('resize', this.syncWidths);

      if (this.props.windowFreeResizeEvent) {
        this.iframe.contentWindow.addEventListener('resize', this.syncWidths);
      }

      this.setScrollProgress();
      window.addEventListener('scroll', this.setScrollProgress);

      if (this.props.infiniteScroll) {
        this.containerDown.addEventListener('scroll', this.setScrollProgress);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.syncWidths);

      if (this.props.windowFreeResizeEvent) {
        this.iframe.contentWindow.removeEventListener('resize', this.syncWidths);
      }

      if (this.props.infiniteScroll && this.props.fixedXScroller) {
        window.removeEventListener('scroll', this.stickFixedScrollerToTable);
      }

      window.removeEventListener('scroll', this.setScrollProgress);
    }
  }, {
    key: "handleChangeSorting",
    value: function handleChangeSorting(data) {
      var _this2 = this;

      var sorting = this.state.sorting;
      this.setState({
        sorting: _objectSpread$6({}, sorting, {
          field: data.sortingKey,
          compareFunc: data.compareFunc ? data.compareFunc : null,
          direction: sorting.field === data.sortingKey ? sorting.direction === SORT_DIRECTION.ASC ? SORT_DIRECTION.DESC : SORT_DIRECTION.ASC : SORT_DIRECTION.ASC
        }),
        paging: this.paging
      }, function () {
        return _this2.onTableChanged();
      });
    }
  }, {
    key: "getData",
    value: function getData() {
      var data = [];
      var sorting = this.state.sorting;
      var paging = this.paging;

      if (this.props.server) {
        return toConsumableArray(this.props.data);
      } else {
        data = this.state.data.slice(); // copy array
      }

      if (sorting) {
        if (sorting.compareFunc) {
          data.sort(sorting.compareFunc.bind(null, sorting.direction));
        } else {
          if (sorting.direction === SORT_DIRECTION.ASC) {
            data.sort(function (a, b) {
              return a[sorting.field] > b[sorting.field] ? 1 : -1;
            });
          } else {
            data.sort(function (a, b) {
              return a[sorting.field] < b[sorting.field] ? 1 : -1;
            });
          }
        }
      }

      if (!paging) {
        return data;
      }

      var activePage = paging.activePage,
          itemsCountPerPage = paging.itemsCountPerPage;
      return data.slice((activePage - 1) * itemsCountPerPage, itemsCountPerPage * activePage);
    }
  }, {
    key: "renderBody",
    value: function renderBody(data, body, freezeColumns) {
      var _this3 = this;

      if (!body || !body.length) {
        return null;
      }

      if (!this.props.infiniteScroll && this.props.loading) {
        return React.createElement("tr", {
          className: "table__loading"
        }, React.createElement("td", null, "Loading..."));
      }

      return data.map(function (i, k) {
        return _this3.renderBodyRow(i, k, body, freezeColumns);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props5 = this.props,
          className = _this$props5.className,
          title = _this$props5.title,
          header = _this$props5.header,
          body = _this$props5.body,
          enableContextMenu = _this$props5.enableContextMenu,
          unsortedData = _this$props5.unsortedData,
          infiniteScroll = _this$props5.infiniteScroll,
          draggable = _this$props5.draggable,
          windowFreeResizeEvent = _this$props5.windowFreeResizeEvent,
          fixedXScroller = _this$props5.fixedXScroller,
          InfiniteScrollComponent = _this$props5.InfiniteScrollComponent,
          skeletonRowsNumber = _this$props5.skeletonRowsNumber,
          theadRowHeight = _this$props5.theadRowHeight;
      var offsetTop = this.props.offsetTop;
      var _this$state3 = this.state,
          contextMenu = _this$state3.contextMenu,
          fixScrollerAtBottom = _this$state3.fixScrollerAtBottom,
          hoveredColIndex = _this$state3.hoveredColIndex,
          freeze = _this$state3.freeze,
          tooltip = _this$state3.tooltip,
          tableHorizontalScroll = _this$state3.tableHorizontalScroll,
          tableScrollProgress = _this$state3.tableScrollProgress;
      var freezeRows = freeze.rows;
      var freezeColumns = freeze.columns;
      if (!offsetTop && freezeRows > 0) offsetTop = 0;
      var data = this.getData();
      var unsortedDataLength = unsortedData && unsortedData.length || 0;

      if (unsortedDataLength) {
        unsortedData.forEach(function (i) {
          i.rowClassName = 'tr-unsorted';
        });
        data = [].concat(toConsumableArray(unsortedData), toConsumableArray(data));
        freezeRows = freeze.rows ? freeze.rows : unsortedDataLength;
      }

      var tableHeaderStyle = {};
      var tableContentHeaderStyle = {}; // if offsetTop is number

      var fixedHeader = !!(freezeRows || !isNaN(parseFloat(offsetTop)) && isFinite(offsetTop));

      if (fixedHeader) {
        tableHeaderStyle.top = "".concat(offsetTop, "px");

        if (this.tableHeaderElement.current) {
          tableContentHeaderStyle.top = "".concat(offsetTop + this.tableHeaderElement.current.getBoundingClientRect().height, "px");
        } else {
          tableContentHeaderStyle.top = "".concat(offsetTop, "px");
        }
      }

      var paging = this.paging; // when infinite-scroll table exists - check if it was ended up

      var skeletonsNumber = skeletonRowsNumber;

      if (InfiniteScrollComponent && !InfiniteScrollComponent.hasMore) {
        skeletonsNumber = 0;
      } // check if table has checkbox column @todo take in account case when className is set with function


      var hasTableCheckboxColumn = !!body.filter(function (i) {
        return typeof i.className === 'string' && i.className.indexOf('_checkbox') !== -1;
      }).length; // to update total checkbox when all or something checked/unchecked

      this.isAllSelected = data.length - unsortedDataLength === data.filter(function (i) {
        return i.rowClassName === '_selected';
      }).length;
      this.isSomeSelected = data.filter(function (i) {
        return i.rowClassName === '_selected';
      }).length > 0;
      return React.createElement("div", {
        className: "".concat(styles$6.container, " ").concat(className || '', " ").concat(draggable ? '_dnd' : '', " table"),
        ref: function ref(el) {
          _this4.table = el;
        }
      }, React.createElement(TableHeader, {
        title: title,
        fixedHeader: fixedHeader,
        innerRef: this.tableHeaderElement,
        style: tableHeaderStyle,
        paging: paging,
        onPerPageChanged: this.handlePerPageChange,
        onPaginationChanged: this.handlePageChange
      }), React.createElement("div", {
        className: "".concat(styles$6.containerTable, " ").concat(unsortedDataLength % 2 === 0 ? '' : '_odd-stripes'),
        ref: function ref(el) {
          _this4.containerTable = el;
        },
        onMouseMove: this.handleTableMouseMoveOrWheelEvent,
        onWheel: this.handleTableMouseMoveOrWheelEvent
      }, tooltip && React.createElement("div", {
        className: styles$6.tooltipWrapper,
        style: _objectSpread$6({}, tableContentHeaderStyle)
      }, React.createElement(TableHeaderTooltip, {
        tooltip: tooltip,
        cellsWidths: this.cellsWidths,
        top: theadRowHeight,
        scrollLeft: tableHorizontalScroll,
        freezeColumns: freezeColumns
      })), fixedHeader && React.createElement("div", {
        ref: function ref(el) {
          _this4.containerUp = el;
        },
        className: "".concat(styles$6.containerUp),
        style: _objectSpread$6({}, tableContentHeaderStyle, {
          overflowY: infiniteScroll ? 'scroll' : ''
        })
      }, !!freezeColumns && React.createElement("div", {
        className: "".concat(styles$6.containerLeft),
        style: {
          height: this.getTableHeight(freezeRows)
        },
        ref: function ref(el) {
          _this4.addTableUps(el, 0);
        }
      }, React.createElement("table", null, this.renderTableHeaderRow(header.slice(0, freezeColumns), hoveredColIndex < freezeColumns ? hoveredColIndex : undefined, fixedHeader), React.createElement("tbody", null, this.renderBody(data.slice(0, freezeRows), body.slice(0, freezeColumns))))), React.createElement("div", {
        className: "".concat(styles$6.containerRight),
        style: {
          height: this.getTableHeight(freezeRows)
        }
      }, React.createElement("div", {
        className: "".concat(styles$6.containerRightScroller),
        style: {
          height: this.getTableHeight(freezeRows, 0, 20)
        },
        ref: function ref(el) {
          _this4.addTableUps(el, 1);

          _this4.addSyncedElement(el);
        },
        onScroll: this.syncScroll
      }, React.createElement("table", null, this.renderTableHeaderRow(header.slice(freezeColumns), hoveredColIndex >= freezeColumns ? hoveredColIndex - freezeColumns : undefined, fixedHeader, freezeColumns), !!freezeRows && React.createElement("tbody", null, this.renderBody(data.slice(0, freezeRows), body.slice(freezeColumns), freezeColumns))))), tableScrollProgress !== undefined && React.createElement("div", {
        className: "table-progress-bar ".concat(styles$6.containerTableProgress),
        style: {
          height: "".concat(theadRowHeight, "px"),
          backgroundImage: "linear-gradient(90deg,\n                      rgba(0,0,0,.05) ".concat(this.state.tableScrollProgress, "%,\n                      transparent ").concat(this.state.tableScrollProgress, "%\n                    )")
        }
      })), React.createElement("div", {
        ref: function ref(el) {
          _this4.containerDown = el;
        },
        className: "".concat(styles$6.containerDown),
        style: {
          marginTop: fixedHeader ? "-".concat(this.getTableHeight(freezeRows)) : '',
          maxHeight: infiniteScroll ? '100vh' : ''
        }
      }, !!freezeColumns && React.createElement("div", {
        className: "".concat(styles$6.containerLeft, " js-columns-widths-down"),
        ref: function ref(el) {
          _this4.addTableDowns(el, 0);
        }
      }, React.createElement("table", null, this.renderTableHeaderRow(header.slice(0, freezeColumns), !fixedHeader && hoveredColIndex < freezeColumns ? hoveredColIndex : undefined, fixedHeader), !infiniteScroll ? React.createElement("tbody", null, this.renderBody(data, body.slice(0, freezeColumns))) : React.createElement(reactInfiniteScroller, _extends_1({}, InfiniteScrollComponent, {
        element: "tbody",
        getScrollParent: function getScrollParent(el) {
          return el && el.closest(".".concat(styles$6.containerDown));
        },
        loader: this.getLoader(data[0], body.slice(0, freezeColumns))
      }), this.renderBody(data, body.slice(0, freezeColumns))))), React.createElement("div", {
        ref: function ref(el) {
          _this4.containerDownRight = el;
        },
        className: "".concat(styles$6.containerRight),
        style: {
          height: infiniteScroll ? this.getTableHeight(data.length, skeletonsNumber) : ''
        }
      }, React.createElement("div", {
        className: "".concat(styles$6.containerRightScroller, " js-columns-widths-down"),
        style: {
          height: infiniteScroll ? this.getTableHeight(data.length, skeletonsNumber, 20) : ''
        },
        ref: function ref(el) {
          _this4.addTableDowns(el, 1);

          _this4.addSyncedElement(el);
        },
        onScroll: this.syncScroll
      }, React.createElement("table", null, this.renderTableHeaderRow(header.slice(freezeColumns), !fixedHeader && hoveredColIndex >= freezeColumns ? hoveredColIndex - freezeColumns : undefined, fixedHeader, freezeColumns), !infiniteScroll ? React.createElement("tbody", null, this.renderBody(data, body.slice(freezeColumns), freezeColumns)) : React.createElement(reactInfiniteScroller, _extends_1({}, InfiniteScrollComponent, {
        element: "tbody",
        getScrollParent: function getScrollParent(el) {
          return el && el.closest(".".concat(styles$6.containerDown));
        },
        loader: this.getLoader(data[0], body.slice(freezeColumns))
      }), this.renderBody(data, body.slice(freezeColumns), freezeColumns)))))), infiniteScroll && React.createElement("div", {
        className: "".concat(styles$6.scroller, " ").concat(fixedXScroller && !fixScrollerAtBottom ? '_fixed' : ''),
        ref: function ref(el) {
          _this4.scroller = el;

          _this4.addSyncedElement(el);
        },
        onScroll: this.syncScroll
      }, React.createElement("div", {
        className: "".concat(styles$6.scrollerPlaceholder, " js-scroller-placeholder")
      })), windowFreeResizeEvent && React.createElement("iframe", {
        ref: function ref(el) {
          _this4.iframe = el;
        },
        className: styles$6.iframe
      }), contextMenu && enableContextMenu && React.createElement(TableContextMenu, _extends_1({}, contextMenu, {
        onClose: function onClose() {
          return _this4.setState({
            contextMenu: null
          });
        },
        onFreezeRow: this.handleFreezeRow,
        onFreezeColumn: this.handleFreezeColumn,
        unsortedDataLength: unsortedDataLength,
        hasTableCheckboxColumn: hasTableCheckboxColumn
      }))));
    }
  }, {
    key: "paging",
    get: function get() {
      return this.props.paging || this.state.paging;
    }
  }]);
  return Table;
}(Component);

Table.defaultProps = {
  paging: null,
  header: [],
  body: [],
  server: false,
  loading: false,
  fixedHeader: false,
  sorting: {
    field: null,
    direction: null
  },
  rowClickHandler: function rowClickHandler() {},
  enableContextMenu: true,
  freezeRows: 0,
  freezeColumns: 0,
  infiniteScroll: false,
  draggable: false,
  onDragEnd: function onDragEnd() {},
  windowFreeResizeEvent: false,
  fixedXScroller: false,
  skeletonRowsNumber: 5,
  tbodyRowHeight: 32,
  theadRowHeight: 32
};
Table.propTypes = {
  className: PropTypes__default.string,
  title: PropTypes__default.string,
  data: PropTypes__default.array.isRequired,
  rowKeyExtractor: PropTypes__default.func.isRequired,
  server: PropTypes__default.bool,
  loading: PropTypes__default.bool,
  onChange: PropTypes__default.func,
  fixedHeader: PropTypes__default.bool,
  offsetTop: PropTypes__default.number,
  header: tablePropTypes.header,
  sorting: tablePropTypes.sorting,
  body: tablePropTypes.body,
  paging: tablePropTypes.paging,
  rowClickHandler: PropTypes__default.func,
  enableContextMenu: PropTypes__default.bool,
  unsortedData: PropTypes__default.array,
  freezeRows: PropTypes__default.number,
  freezeColumns: PropTypes__default.number,
  infiniteScroll: PropTypes__default.bool,
  InfiniteScrollComponent: PropTypes__default.shape({
    loadMore: PropTypes__default.func,
    hasMore: PropTypes__default.bool,
    pageStart: PropTypes__default.number,
    useWindow: PropTypes__default.bool
  }),
  skeletonRowsNumber: PropTypes__default.number,
  draggable: PropTypes__default.bool,
  onDragEnd: PropTypes__default.func,
  freezeUpdateHandler: PropTypes__default.func,
  windowFreeResizeEvent: PropTypes__default.bool,
  fixedXScroller: PropTypes__default.bool,
  tbodyRowHeight: PropTypes__default.number,
  theadRowHeight: PropTypes__default.number,
  totalItemsCount: PropTypes__default.number
};
var css$t = ".form {\n  position: relative;\n  padding: 2.25rem 1rem;\n  border-radius: .5rem;\n  border: 0.0625rem solid #a2a2a2; }\n  .form__header {\n    position: absolute;\n    left: 1rem;\n    top: -.875rem;\n    padding: 0 1rem;\n    background: #fff; }\n  .form__content {\n    width: 100%; }\n";
styleInject(css$t);

var defaultSubmit = function defaultSubmit(e) {
  return e.preventDefault();
};

var Form = function Form(_ref) {
  var title = _ref.title,
      className = _ref.className,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? defaultSubmit : _ref$onSubmit,
      children = _ref.children;
  return React.createElement("form", {
    className: "form ".concat(className ? className : ''),
    onSubmit: onSubmit
  }, React.createElement("h3", {
    className: "title-form form__header"
  }, title), React.createElement("div", {
    className: "form__content"
  }, children));
};

var css$u = ".collapse__btn {\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: none; }\n  .collapse__btn:focus {\n    outline: none; }\n\n.collapse {\n  padding: 1.375rem 1.5rem 1.25rem;\n  border-radius: .5rem;\n  transition: box-shadow .3s; }\n  .collapse__btn {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    cursor: pointer;\n    font-family: 'Lato Regular', sans-serif;\n    font-weight: 400;\n    font-size: 1.375rem;\n    line-height: 1.15;\n    color: #787878;\n    text-align: left; }\n    .collapse__btn .collapse__icon {\n      fill: #787878;\n      margin-right: 1.25rem;\n      transition: transform .3s; }\n      .collapse_opened .collapse__btn .collapse__icon {\n        transform: rotate(90deg); }\n  .collapse__content {\n    margin-top: 1.25rem; }\n  .collapse_opened {\n    box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.25); }\n";
styleInject(css$u);

var Collapse = /*#__PURE__*/function (_PureComponent) {
  inherits(Collapse, _PureComponent);

  function Collapse(props) {
    var _this;

    classCallCheck(this, Collapse);
    _this = possibleConstructorReturn(this, getPrototypeOf(Collapse).call(this, props));
    defineProperty(assertThisInitialized(_this), "handleToggle", function () {
      _this.setState(function (state) {
        return {
          isOpened: !state.isOpened
        };
      });
    });
    _this.state = {
      isOpened: false
    };
    return _this;
  }

  createClass(Collapse, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          title = _this$props.title,
          children = _this$props.children;
      var isOpened = this.state.isOpened;
      var classes = ['collapse', className];

      if (isOpened) {
        classes.push('collapse_opened');
      }

      return React.createElement("div", {
        className: classes.join(' ')
      }, React.createElement("button", {
        className: "collapse__btn",
        onClick: this.handleToggle
      }, React.createElement(Icon, {
        name: "Right",
        className: "collapse__icon",
        viewBox: "4 4 14 14"
      }), title), React.createElement("div", {
        className: 'collapse__content'
      }, isOpened && children));
    }
  }]);
  return Collapse;
}(PureComponent);

Collapse.propTypes = {
  className: PropTypes__default.string,
  title: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element])
};
var interopRequireDefault = createCommonjsModule(function (module) {
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  module.exports = _interopRequireDefault;
});
unwrapExports(interopRequireDefault);
var hasClass_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = hasClass;

  function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
  }

  module.exports = exports["default"];
});
unwrapExports(hasClass_1);
var addClass_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = addClass;

  var _hasClass = interopRequireDefault(hasClass_1);

  function addClass(element, className) {
    if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
  }

  module.exports = exports["default"];
});
var addOneClass = unwrapExports(addClass_1);

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

var removeClass = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addOneClass(node, c);
  });
};

var removeClass$1 = function removeClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (node, appearing) {
      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    if (type === 'appear' && phase === 'done') {
      className += " " + this.getClassNames('enter').doneClassName;
    } // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    this.appliedClasses[type][phase] = className;

    _addClass(node, className);
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["classNames"]);

    return React.createElement(Transition, _extends$1m({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$1m({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: func
}) : {};
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps$1 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized$1(_assertThisInitialized$1(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$1m({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return React.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return React.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, React.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes__default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes__default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes__default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes__default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes__default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes__default.func
} : {};
TransitionGroup.defaultProps = defaultProps$1;
var css$v = ".transition-container__item {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  overflow: auto;\n  animation-duration: 1s;\n  animation-timing-function: ease-in-out;\n  animation-fill-mode: forwards; }\n  .transition-container__item.fade-exit {\n    animation-name: content-fade-exit; }\n  .transition-container__item.fade-enter {\n    animation-name: content-fade-enter; }\n\n.transition-container._reverse .transition-container__item.fade-exit {\n  animation-name: content-fade-exit-reverse; }\n\n.transition-container._reverse .transition-container__item.fade-enter {\n  animation-name: content-fade-enter-reverse; }\n\n.modal__overflow .transition-container__item {\n  overflow: hidden; }\n\n@keyframes content-fade-enter {\n  0% {\n    transform: translateY(100%); }\n  100% {\n    transform: translateY(0); } }\n\n@keyframes content-fade-exit {\n  0% {\n    transform: translateY(0); }\n  100% {\n    transform: translateY(-100%); } }\n\n@keyframes content-fade-enter-reverse {\n  0% {\n    transform: translateY(-100%); }\n  100% {\n    transform: translateY(0); } }\n\n@keyframes content-fade-exit-reverse {\n  0% {\n    transform: translateY(0); }\n  100% {\n    transform: translateY(100%); } }\n";
styleInject(css$v);

var RouteContainerComponent = /*#__PURE__*/function (_React$Component) {
  inherits(RouteContainerComponent, _React$Component);

  function RouteContainerComponent() {
    var _getPrototypeOf2;

    var _this;

    classCallCheck(this, RouteContainerComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(RouteContainerComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(_this), "oldPath", '');
    return _this;
  }

  createClass(RouteContainerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.oldPath = this.props.location.pathname;
    }
  }, {
    key: "getTransitionDirectionClassName",
    value: function getTransitionDirectionClassName() {
      var current = this.props.location.pathname;

      if (!this.oldPath) {
        if (current) {
          this.oldPath = current;
        }
      } else if (this.oldPath !== current) {
        var oldPathSlashesCount = this.oldPath !== "/" ? (this.oldPath.match(/\//g) || []).length : 0;
        var newPathSlashesCount = current !== "/" ? (current.match(/\//g) || []).length : 0;
        this.oldPath = current;

        if (oldPathSlashesCount > newPathSlashesCount) {
          return "_reverse";
        }
      }

      return "";
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          location = _this$props.location,
          children = _this$props.children;
      return React.createElement(TransitionGroup, {
        className: "transition-container ".concat(this.getTransitionDirectionClassName())
      }, React.createElement(CSSTransition, {
        key: location.key,
        timeout: 1000,
        classNames: "fade"
      }, children(location)));
    }
  }]);
  return RouteContainerComponent;
}(React.Component);

var RouteWrapper = function RouteWrapper(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children;
  return React.createElement("div", {
    className: "transition-container__item ".concat(className)
  }, children);
};

var RouteContainer = withRouter(RouteContainerComponent);
var css$w = ".editable-text {\n  width: 100%;\n  position: relative; }\n  .editable-text .text-field__input {\n    font-size: 0.875rem;\n    height: 100%;\n    padding: 0;\n    padding-right: 24px; }\n  .editable-text .text-field__base {\n    margin-top: 0; }\n    .editable-text .text-field__base:after, .editable-text .text-field__base:before {\n      bottom: -0.25rem; }\n    .editable-text .text-field__base:after {\n      border-color: #4d5ecc; }\n  .editable-text .svg-icon {\n    position: absolute;\n    right: 0;\n    width: 20px;\n    height: 20px;\n    fill: #4d5ecc; }\n  .editable-text._right .text-field__input {\n    text-align: right;\n    padding-right: 0;\n    padding-left: 24px; }\n  .editable-text._right .svg-icon {\n    left: 0;\n    right: auto; }\n";
styleInject(css$w);

var ActionButtons = function ActionButtons(_ref) {
  var onClose = _ref.onClose,
      onConfirm = _ref.onConfirm,
      useRemember = _ref.useRemember,
      remember = _ref.remember,
      onChange = _ref.onChange,
      actionsHelp = _ref.actionsHelp;
  var buttons = React.createElement("div", {
    className: "d-flex flex-row justify-content-between"
  }, React.createElement("div", {
    className: "d-flex"
  }, actionsHelp), React.createElement("div", {
    className: "d-flex align-items-center"
  }, React.createElement(Button, {
    className: "btn-square _conflower-blue mr-2",
    onClick: onClose
  }, "Cancel"), React.createElement(Button, {
    autoFocus: true,
    className: "btn-square _filled _conflower-blue",
    onClick: onConfirm
  }, "Apply")));
  return useRemember ? React.createElement("div", {
    className: "d-flex justify-content-between"
  }, useRemember && React.createElement(Checkbox, {
    className: "mr-3",
    label: "Don't ask me again",
    checked: remember,
    onChange: onChange
  }), buttons) : buttons;
};

var EditableText = /*#__PURE__*/function (_React$PureComponent) {
  inherits(EditableText, _React$PureComponent);

  function EditableText(props) {
    var _this;

    classCallCheck(this, EditableText);
    _this = possibleConstructorReturn(this, getPrototypeOf(EditableText).call(this, props));
    defineProperty(assertThisInitialized(_this), "handleChange", function (value) {
      var type = _this.state.type;

      if (type === 'amount') {
        var i = 0;
        value = value.replace(/[^0-9.]+/g, '').replace(/\./g, function (match) {
          i++;
          return i === 2 ? '' : match;
        });
      } else if (type === 'date') {
        var _i = 0;
        value = value.replace(/[^0-9/]+/g, '').replace(/\//g, function (match) {
          _i++;
          return _i === 3 ? '' : match;
        });
      }

      _this.setState({
        value: _this.props.onChange ? _this.props.onChange(value) : value
      });
    });
    defineProperty(assertThisInitialized(_this), "handleBlur", function () {
      var _this$state = _this.state,
          defaultValue = _this$state.defaultValue,
          value = _this$state.value;

      if (value.trim() && defaultValue !== value) {
        _this.handleShowPopup();
      } else {
        _this.setState({
          value: defaultValue
        });
      }
    });
    defineProperty(assertThisInitialized(_this), "handleSubmit", function (e) {
      var _this$state2 = _this.state,
          defaultValue = _this$state2.defaultValue,
          value = _this$state2.value,
          type = _this$state2.type;
      e.preventDefault();

      if (!value.trim() || defaultValue === value) {
        return;
      }

      if (type === 'date') {
        var dateRegex = /\d{1,2}\/\d{1,2}\/20\d{2}/g;

        if (value !== defaultValue && dateRegex.test(value) && (_this.props.isValid ? _this.props.isValid(value, defaultValue) : true)) {
          _this.handleShowPopup();
        }
      } else {
        _this.handleShowPopup();
      }
    });
    defineProperty(assertThisInitialized(_this), "handleShowPopup", function () {
      var _this$props$Popup = _this.props.Popup,
          remember = _this$props$Popup.remember,
          storageKey = _this$props$Popup.storageKey;

      if (remember && JSON.parse(window.localStorage.getItem(storageKey))) {
        _this.onConfirm();

        return;
      }

      _this.setState({
        showPopup: true
      });
    });
    defineProperty(assertThisInitialized(_this), "handleClosePopup", function () {
      _this.setState({
        showPopup: false
      });
    });
    defineProperty(assertThisInitialized(_this), "handleCancel", function () {
      _this.onCancel();
    });
    defineProperty(assertThisInitialized(_this), "handleConfirm", function () {
      if (_this.state.remember && _this.props.Popup.storageKey) {
        window.localStorage.setItem(_this.props.Popup.storageKey, JSON.stringify(true));
      }

      _this.onConfirm();
    });
    defineProperty(assertThisInitialized(_this), "onCancel", function () {
      var defaultValue = _this.state.defaultValue;

      _this.setState({
        value: defaultValue
      }, _this.handleClosePopup);

      _this.props.cancel && _this.props.cancel(_this.state.defaultValue);
    });
    defineProperty(assertThisInitialized(_this), "onConfirm", function () {
      if (_this.props.confirm) {
        var oldValue = _this.state.value;

        _this.setState({
          value: _this.props.value
        }, function () {
          return _this.props.confirm(oldValue, _this.state.defaultValue);
        });
      }

      _this.handleClosePopup();
    });
    defineProperty(assertThisInitialized(_this), "handleChangeRemember", function (value) {
      _this.setState({
        remember: value
      });
    });
    defineProperty(assertThisInitialized(_this), "renderPopup", function () {
      var _this$props$Popup2 = _this.props.Popup,
          title = _this$props$Popup2.title,
          actions = _this$props$Popup2.actions,
          remember = _this$props$Popup2.remember,
          actionsHelp = _this$props$Popup2.actionsHelp,
          modalProps = _this$props$Popup2.modalProps;
      var _this$state3 = _this.state,
          defaultValue = _this$state3.defaultValue,
          value = _this$state3.value;
      return createPortal(React.createElement(Dialog, {
        open: true,
        onClickOutside: _this.handleCancel,
        modalProps: modalProps
      }, React.createElement(DialogHeader, null, React.createElement("h5", {
        className: "title-card"
      }, title)), React.createElement(DialogContent, null, isFunction$1(_this.props.children) ? _this.props.children(defaultValue, value) : _this.props.children), React.createElement(DialogFooter, null, actions && actions() || React.createElement(ActionButtons, {
        onChange: _this.handleChangeRemember,
        useRemember: remember,
        remember: _this.state.remember,
        onClose: _this.handleCancel,
        onConfirm: _this.handleConfirm,
        actionsHelp: actionsHelp
      }))), _this.props.Popup.appendTo || document.body);
    });
    _this.state = {
      defaultValue: (props.value || '').toString(),
      value: (props.value || '').toString(),
      showPopup: false,
      remember: false,
      type: props.type || 'text'
    };
    return _this;
  }

  createClass(EditableText, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState({
          defaultValue: this.props.value,
          value: this.props.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var propsValue = this.props.value;
      var _this$state4 = this.state,
          value = _this$state4.value,
          showPopup = _this$state4.showPopup;
      var iconEl = value.trim() && "".concat(propsValue) !== "".concat(value) ? React.createElement(Icon, {
        name: "Done"
      }) : null;
      return React.createElement("form", {
        className: "editable-text ".concat(this.props.className || ''),
        onSubmit: this.handleSubmit,
        ref: function ref() {
          _this2.props.innerRef && _this2.props.innerRef(_this2);
        }
      }, React.createElement(TextField, {
        value: value,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        inputRef: function inputRef(el) {
          _this2.props.inputRef && _this2.props.inputRef(el);
        }
      }), iconEl, showPopup && this.renderPopup());
    }
  }]);
  return EditableText;
}(React.PureComponent);

EditableText.defaultProps = {
  confirm: function confirm() {},
  cancel: function cancel() {},
  Popup: {
    title: '',
    remember: false,
    storageKey: ''
  }
};
EditableText.propTypes = {
  type: PropTypes__default.string,
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  confirm: PropTypes__default.func,
  cancel: PropTypes__default.func,
  Popup: PropTypes__default.shape({
    title: PropTypes__default.oneOfType([PropTypes__default.element, PropTypes__default.elementType]),
    remember: PropTypes__default.bool,
    storageKey: PropTypes__default.string,
    appendTo: PropTypes__default.instanceOf(window.HTMLElement),
    actions: PropTypes__default.func,
    actionsHelp: PropTypes__default.element,
    modalProps: PropTypes__default.object
  }),
  innerRef: PropTypes__default.func,
  onChange: PropTypes__default.func,
  isValid: PropTypes__default.func
};
export { Button, ButtonCircle, ButtonLink, ButtonsGroup, Card, CardHoveredContent, CardHoveredSubtitle, CardSubtitle, Checkbox, Collapse, ContextMenu, ContextMenuList, ContextMenuListDivider, ContextMenuListItem, DatesPicker, Dialog, DialogButtons, DialogContent, DialogFooter, DialogHeader, DialogScrollableContent, EditableText, Form, Icon, Layout, Logo, NavigationBar, Pagination, Ripple, RouteContainer, RouteWrapper, Select, Snackbar, Switch, Table, Tabs, TextField, TextFieldWithIcon, TimePicker, Tooltip, Tumbler, audienceIcons, commonIcons, createTextField, creativeIcons, deviceIcons, withClickOutside };